/** Estados e municípios brasileiros (IBGE), usados localmente no formulário de indicação. */

export type UfLocal = {
	id: string;
	uf: string;
	descricao: string;
};

export type CidadeLocal = {
	id: string;
	ufId: string;
	descricao: string;
};

export const ESTADOS: UfLocal[] = [
	{"id":"12","uf":"AC","descricao":"Acre"},
	{"id":"27","uf":"AL","descricao":"Alagoas"},
	{"id":"13","uf":"AM","descricao":"Amazonas"},
	{"id":"16","uf":"AP","descricao":"Amapá"},
	{"id":"29","uf":"BA","descricao":"Bahia"},
	{"id":"23","uf":"CE","descricao":"Ceará"},
	{"id":"53","uf":"DF","descricao":"Distrito Federal"},
	{"id":"32","uf":"ES","descricao":"Espírito Santo"},
	{"id":"52","uf":"GO","descricao":"Goiás"},
	{"id":"21","uf":"MA","descricao":"Maranhão"},
	{"id":"31","uf":"MG","descricao":"Minas Gerais"},
	{"id":"50","uf":"MS","descricao":"Mato Grosso do Sul"},
	{"id":"51","uf":"MT","descricao":"Mato Grosso"},
	{"id":"15","uf":"PA","descricao":"Pará"},
	{"id":"25","uf":"PB","descricao":"Paraíba"},
	{"id":"26","uf":"PE","descricao":"Pernambuco"},
	{"id":"22","uf":"PI","descricao":"Piauí"},
	{"id":"41","uf":"PR","descricao":"Paraná"},
	{"id":"33","uf":"RJ","descricao":"Rio de Janeiro"},
	{"id":"24","uf":"RN","descricao":"Rio Grande do Norte"},
	{"id":"11","uf":"RO","descricao":"Rondônia"},
	{"id":"14","uf":"RR","descricao":"Roraima"},
	{"id":"43","uf":"RS","descricao":"Rio Grande do Sul"},
	{"id":"42","uf":"SC","descricao":"Santa Catarina"},
	{"id":"28","uf":"SE","descricao":"Sergipe"},
	{"id":"35","uf":"SP","descricao":"São Paulo"},
	{"id":"17","uf":"TO","descricao":"Tocantins"}
];

const CIDADES_POR_UF: Record<string, CidadeLocal[]> = {
	"11": [
		{"id":"1100015","ufId":"11","descricao":"Alta Floresta D'Oeste"},
		{"id":"1100379","ufId":"11","descricao":"Alto Alegre dos Parecis"},
		{"id":"1100403","ufId":"11","descricao":"Alto Paraíso"},
		{"id":"1100346","ufId":"11","descricao":"Alvorada D'Oeste"},
		{"id":"1100023","ufId":"11","descricao":"Ariquemes"},
		{"id":"1100452","ufId":"11","descricao":"Buritis"},
		{"id":"1100031","ufId":"11","descricao":"Cabixi"},
		{"id":"1100601","ufId":"11","descricao":"Cacaulândia"},
		{"id":"1100049","ufId":"11","descricao":"Cacoal"},
		{"id":"1100700","ufId":"11","descricao":"Campo Novo de Rondônia"},
		{"id":"1100809","ufId":"11","descricao":"Candeias do Jamari"},
		{"id":"1100908","ufId":"11","descricao":"Castanheiras"},
		{"id":"1100056","ufId":"11","descricao":"Cerejeiras"},
		{"id":"1100924","ufId":"11","descricao":"Chupinguaia"},
		{"id":"1100064","ufId":"11","descricao":"Colorado do Oeste"},
		{"id":"1100072","ufId":"11","descricao":"Corumbiara"},
		{"id":"1100080","ufId":"11","descricao":"Costa Marques"},
		{"id":"1100940","ufId":"11","descricao":"Cujubim"},
		{"id":"1100098","ufId":"11","descricao":"Espigão D'Oeste"},
		{"id":"1101005","ufId":"11","descricao":"Governador Jorge Teixeira"},
		{"id":"1100106","ufId":"11","descricao":"Guajará-Mirim"},
		{"id":"1101104","ufId":"11","descricao":"Itapuã do Oeste"},
		{"id":"1100114","ufId":"11","descricao":"Jaru"},
		{"id":"1100122","ufId":"11","descricao":"Ji-Paraná"},
		{"id":"1100130","ufId":"11","descricao":"Machadinho D'Oeste"},
		{"id":"1101203","ufId":"11","descricao":"Ministro Andreazza"},
		{"id":"1101302","ufId":"11","descricao":"Mirante da Serra"},
		{"id":"1101401","ufId":"11","descricao":"Monte Negro"},
		{"id":"1100148","ufId":"11","descricao":"Nova Brasilândia D'Oeste"},
		{"id":"1100338","ufId":"11","descricao":"Nova Mamoré"},
		{"id":"1101435","ufId":"11","descricao":"Nova União"},
		{"id":"1100502","ufId":"11","descricao":"Novo Horizonte do Oeste"},
		{"id":"1100155","ufId":"11","descricao":"Ouro Preto do Oeste"},
		{"id":"1101450","ufId":"11","descricao":"Parecis"},
		{"id":"1100189","ufId":"11","descricao":"Pimenta Bueno"},
		{"id":"1101468","ufId":"11","descricao":"Pimenteiras do Oeste"},
		{"id":"1100205","ufId":"11","descricao":"Porto Velho"},
		{"id":"1100254","ufId":"11","descricao":"Presidente Médici"},
		{"id":"1101476","ufId":"11","descricao":"Primavera de Rondônia"},
		{"id":"1100262","ufId":"11","descricao":"Rio Crespo"},
		{"id":"1100288","ufId":"11","descricao":"Rolim de Moura"},
		{"id":"1100296","ufId":"11","descricao":"Santa Luzia D'Oeste"},
		{"id":"1101484","ufId":"11","descricao":"São Felipe D'Oeste"},
		{"id":"1101492","ufId":"11","descricao":"São Francisco do Guaporé"},
		{"id":"1100320","ufId":"11","descricao":"São Miguel do Guaporé"},
		{"id":"1101500","ufId":"11","descricao":"Seringueiras"},
		{"id":"1101559","ufId":"11","descricao":"Teixeirópolis"},
		{"id":"1101609","ufId":"11","descricao":"Theobroma"},
		{"id":"1101708","ufId":"11","descricao":"Urupá"},
		{"id":"1101757","ufId":"11","descricao":"Vale do Anari"},
		{"id":"1101807","ufId":"11","descricao":"Vale do Paraíso"},
		{"id":"1100304","ufId":"11","descricao":"Vilhena"}
	],
	"12": [
		{"id":"1200013","ufId":"12","descricao":"Acrelândia"},
		{"id":"1200054","ufId":"12","descricao":"Assis Brasil"},
		{"id":"1200104","ufId":"12","descricao":"Brasiléia"},
		{"id":"1200138","ufId":"12","descricao":"Bujari"},
		{"id":"1200179","ufId":"12","descricao":"Capixaba"},
		{"id":"1200203","ufId":"12","descricao":"Cruzeiro do Sul"},
		{"id":"1200252","ufId":"12","descricao":"Epitaciolândia"},
		{"id":"1200302","ufId":"12","descricao":"Feijó"},
		{"id":"1200328","ufId":"12","descricao":"Jordão"},
		{"id":"1200336","ufId":"12","descricao":"Mâncio Lima"},
		{"id":"1200344","ufId":"12","descricao":"Manoel Urbano"},
		{"id":"1200351","ufId":"12","descricao":"Marechal Thaumaturgo"},
		{"id":"1200385","ufId":"12","descricao":"Plácido de Castro"},
		{"id":"1200807","ufId":"12","descricao":"Porto Acre"},
		{"id":"1200393","ufId":"12","descricao":"Porto Walter"},
		{"id":"1200401","ufId":"12","descricao":"Rio Branco"},
		{"id":"1200427","ufId":"12","descricao":"Rodrigues Alves"},
		{"id":"1200435","ufId":"12","descricao":"Santa Rosa do Purus"},
		{"id":"1200500","ufId":"12","descricao":"Sena Madureira"},
		{"id":"1200450","ufId":"12","descricao":"Senador Guiomard"},
		{"id":"1200609","ufId":"12","descricao":"Tarauacá"},
		{"id":"1200708","ufId":"12","descricao":"Xapuri"}
	],
	"13": [
		{"id":"1300029","ufId":"13","descricao":"Alvarães"},
		{"id":"1300060","ufId":"13","descricao":"Amaturá"},
		{"id":"1300086","ufId":"13","descricao":"Anamã"},
		{"id":"1300102","ufId":"13","descricao":"Anori"},
		{"id":"1300144","ufId":"13","descricao":"Apuí"},
		{"id":"1300201","ufId":"13","descricao":"Atalaia do Norte"},
		{"id":"1300300","ufId":"13","descricao":"Autazes"},
		{"id":"1300409","ufId":"13","descricao":"Barcelos"},
		{"id":"1300508","ufId":"13","descricao":"Barreirinha"},
		{"id":"1300607","ufId":"13","descricao":"Benjamin Constant"},
		{"id":"1300631","ufId":"13","descricao":"Beruri"},
		{"id":"1300680","ufId":"13","descricao":"Boa Vista do Ramos"},
		{"id":"1300706","ufId":"13","descricao":"Boca do Acre"},
		{"id":"1300805","ufId":"13","descricao":"Borba"},
		{"id":"1300839","ufId":"13","descricao":"Caapiranga"},
		{"id":"1300904","ufId":"13","descricao":"Canutama"},
		{"id":"1301001","ufId":"13","descricao":"Carauari"},
		{"id":"1301100","ufId":"13","descricao":"Careiro"},
		{"id":"1301159","ufId":"13","descricao":"Careiro da Várzea"},
		{"id":"1301209","ufId":"13","descricao":"Coari"},
		{"id":"1301308","ufId":"13","descricao":"Codajás"},
		{"id":"1301407","ufId":"13","descricao":"Eirunepé"},
		{"id":"1301506","ufId":"13","descricao":"Envira"},
		{"id":"1301605","ufId":"13","descricao":"Fonte Boa"},
		{"id":"1301654","ufId":"13","descricao":"Guajará"},
		{"id":"1301704","ufId":"13","descricao":"Humaitá"},
		{"id":"1301803","ufId":"13","descricao":"Ipixuna"},
		{"id":"1301852","ufId":"13","descricao":"Iranduba"},
		{"id":"1301902","ufId":"13","descricao":"Itacoatiara"},
		{"id":"1301951","ufId":"13","descricao":"Itamarati"},
		{"id":"1302009","ufId":"13","descricao":"Itapiranga"},
		{"id":"1302108","ufId":"13","descricao":"Japurá"},
		{"id":"1302207","ufId":"13","descricao":"Juruá"},
		{"id":"1302306","ufId":"13","descricao":"Jutaí"},
		{"id":"1302405","ufId":"13","descricao":"Lábrea"},
		{"id":"1302504","ufId":"13","descricao":"Manacapuru"},
		{"id":"1302553","ufId":"13","descricao":"Manaquiri"},
		{"id":"1302603","ufId":"13","descricao":"Manaus"},
		{"id":"1302702","ufId":"13","descricao":"Manicoré"},
		{"id":"1302801","ufId":"13","descricao":"Maraã"},
		{"id":"1302900","ufId":"13","descricao":"Maués"},
		{"id":"1303007","ufId":"13","descricao":"Nhamundá"},
		{"id":"1303106","ufId":"13","descricao":"Nova Olinda do Norte"},
		{"id":"1303205","ufId":"13","descricao":"Novo Airão"},
		{"id":"1303304","ufId":"13","descricao":"Novo Aripuanã"},
		{"id":"1303403","ufId":"13","descricao":"Parintins"},
		{"id":"1303502","ufId":"13","descricao":"Pauini"},
		{"id":"1303536","ufId":"13","descricao":"Presidente Figueiredo"},
		{"id":"1303569","ufId":"13","descricao":"Rio Preto da Eva"},
		{"id":"1303601","ufId":"13","descricao":"Santa Isabel do Rio Negro"},
		{"id":"1303700","ufId":"13","descricao":"Santo Antônio do Içá"},
		{"id":"1303809","ufId":"13","descricao":"São Gabriel da Cachoeira"},
		{"id":"1303908","ufId":"13","descricao":"São Paulo de Olivença"},
		{"id":"1303957","ufId":"13","descricao":"São Sebastião do Uatumã"},
		{"id":"1304005","ufId":"13","descricao":"Silves"},
		{"id":"1304062","ufId":"13","descricao":"Tabatinga"},
		{"id":"1304104","ufId":"13","descricao":"Tapauá"},
		{"id":"1304203","ufId":"13","descricao":"Tefé"},
		{"id":"1304237","ufId":"13","descricao":"Tonantins"},
		{"id":"1304260","ufId":"13","descricao":"Uarini"},
		{"id":"1304302","ufId":"13","descricao":"Urucará"},
		{"id":"1304401","ufId":"13","descricao":"Urucurituba"}
	],
	"14": [
		{"id":"1400050","ufId":"14","descricao":"Alto Alegre"},
		{"id":"1400027","ufId":"14","descricao":"Amajari"},
		{"id":"1400100","ufId":"14","descricao":"Boa Vista"},
		{"id":"1400159","ufId":"14","descricao":"Bonfim"},
		{"id":"1400175","ufId":"14","descricao":"Cantá"},
		{"id":"1400209","ufId":"14","descricao":"Caracaraí"},
		{"id":"1400233","ufId":"14","descricao":"Caroebe"},
		{"id":"1400282","ufId":"14","descricao":"Iracema"},
		{"id":"1400308","ufId":"14","descricao":"Mucajaí"},
		{"id":"1400407","ufId":"14","descricao":"Normandia"},
		{"id":"1400456","ufId":"14","descricao":"Pacaraima"},
		{"id":"1400472","ufId":"14","descricao":"Rorainópolis"},
		{"id":"1400506","ufId":"14","descricao":"São João da Baliza"},
		{"id":"1400605","ufId":"14","descricao":"São Luiz do Anauá"},
		{"id":"1400704","ufId":"14","descricao":"Uiramutã"}
	],
	"15": [
		{"id":"1500107","ufId":"15","descricao":"Abaetetuba"},
		{"id":"1500131","ufId":"15","descricao":"Abel Figueiredo"},
		{"id":"1500206","ufId":"15","descricao":"Acará"},
		{"id":"1500305","ufId":"15","descricao":"Afuá"},
		{"id":"1500347","ufId":"15","descricao":"Água Azul do Norte"},
		{"id":"1500404","ufId":"15","descricao":"Alenquer"},
		{"id":"1500503","ufId":"15","descricao":"Almeirim"},
		{"id":"1500602","ufId":"15","descricao":"Altamira"},
		{"id":"1500701","ufId":"15","descricao":"Anajás"},
		{"id":"1500800","ufId":"15","descricao":"Ananindeua"},
		{"id":"1500859","ufId":"15","descricao":"Anapu"},
		{"id":"1500909","ufId":"15","descricao":"Augusto Corrêa"},
		{"id":"1500958","ufId":"15","descricao":"Aurora do Pará"},
		{"id":"1501006","ufId":"15","descricao":"Aveiro"},
		{"id":"1501105","ufId":"15","descricao":"Bagre"},
		{"id":"1501204","ufId":"15","descricao":"Baião"},
		{"id":"1501253","ufId":"15","descricao":"Bannach"},
		{"id":"1501303","ufId":"15","descricao":"Barcarena"},
		{"id":"1501402","ufId":"15","descricao":"Belém"},
		{"id":"1501451","ufId":"15","descricao":"Belterra"},
		{"id":"1501501","ufId":"15","descricao":"Benevides"},
		{"id":"1501576","ufId":"15","descricao":"Bom Jesus do Tocantins"},
		{"id":"1501600","ufId":"15","descricao":"Bonito"},
		{"id":"1501709","ufId":"15","descricao":"Bragança"},
		{"id":"1501725","ufId":"15","descricao":"Brasil Novo"},
		{"id":"1501758","ufId":"15","descricao":"Brejo Grande do Araguaia"},
		{"id":"1501782","ufId":"15","descricao":"Breu Branco"},
		{"id":"1501808","ufId":"15","descricao":"Breves"},
		{"id":"1501907","ufId":"15","descricao":"Bujaru"},
		{"id":"1502004","ufId":"15","descricao":"Cachoeira do Arari"},
		{"id":"1501956","ufId":"15","descricao":"Cachoeira do Piriá"},
		{"id":"1502103","ufId":"15","descricao":"Cametá"},
		{"id":"1502152","ufId":"15","descricao":"Canaã dos Carajás"},
		{"id":"1502202","ufId":"15","descricao":"Capanema"},
		{"id":"1502301","ufId":"15","descricao":"Capitão Poço"},
		{"id":"1502400","ufId":"15","descricao":"Castanhal"},
		{"id":"1502509","ufId":"15","descricao":"Chaves"},
		{"id":"1502608","ufId":"15","descricao":"Colares"},
		{"id":"1502707","ufId":"15","descricao":"Conceição do Araguaia"},
		{"id":"1502756","ufId":"15","descricao":"Concórdia do Pará"},
		{"id":"1502764","ufId":"15","descricao":"Cumaru do Norte"},
		{"id":"1502772","ufId":"15","descricao":"Curionópolis"},
		{"id":"1502806","ufId":"15","descricao":"Curralinho"},
		{"id":"1502855","ufId":"15","descricao":"Curuá"},
		{"id":"1502905","ufId":"15","descricao":"Curuçá"},
		{"id":"1502939","ufId":"15","descricao":"Dom Eliseu"},
		{"id":"1502954","ufId":"15","descricao":"Eldorado do Carajás"},
		{"id":"1503002","ufId":"15","descricao":"Faro"},
		{"id":"1503044","ufId":"15","descricao":"Floresta do Araguaia"},
		{"id":"1503077","ufId":"15","descricao":"Garrafão do Norte"},
		{"id":"1503093","ufId":"15","descricao":"Goianésia do Pará"},
		{"id":"1503101","ufId":"15","descricao":"Gurupá"},
		{"id":"1503200","ufId":"15","descricao":"Igarapé-Açu"},
		{"id":"1503309","ufId":"15","descricao":"Igarapé-Miri"},
		{"id":"1503408","ufId":"15","descricao":"Inhangapi"},
		{"id":"1503457","ufId":"15","descricao":"Ipixuna do Pará"},
		{"id":"1503507","ufId":"15","descricao":"Irituia"},
		{"id":"1503606","ufId":"15","descricao":"Itaituba"},
		{"id":"1503705","ufId":"15","descricao":"Itupiranga"},
		{"id":"1503754","ufId":"15","descricao":"Jacareacanga"},
		{"id":"1503804","ufId":"15","descricao":"Jacundá"},
		{"id":"1503903","ufId":"15","descricao":"Juruti"},
		{"id":"1504000","ufId":"15","descricao":"Limoeiro do Ajuru"},
		{"id":"1504059","ufId":"15","descricao":"Mãe do Rio"},
		{"id":"1504109","ufId":"15","descricao":"Magalhães Barata"},
		{"id":"1504208","ufId":"15","descricao":"Marabá"},
		{"id":"1504307","ufId":"15","descricao":"Maracanã"},
		{"id":"1504406","ufId":"15","descricao":"Marapanim"},
		{"id":"1504422","ufId":"15","descricao":"Marituba"},
		{"id":"1504455","ufId":"15","descricao":"Medicilândia"},
		{"id":"1504505","ufId":"15","descricao":"Melgaço"},
		{"id":"1504604","ufId":"15","descricao":"Mocajuba"},
		{"id":"1504703","ufId":"15","descricao":"Moju"},
		{"id":"1504752","ufId":"15","descricao":"Mojuí dos Campos"},
		{"id":"1504802","ufId":"15","descricao":"Monte Alegre"},
		{"id":"1504901","ufId":"15","descricao":"Muaná"},
		{"id":"1504950","ufId":"15","descricao":"Nova Esperança do Piriá"},
		{"id":"1504976","ufId":"15","descricao":"Nova Ipixuna"},
		{"id":"1505007","ufId":"15","descricao":"Nova Timboteua"},
		{"id":"1505031","ufId":"15","descricao":"Novo Progresso"},
		{"id":"1505064","ufId":"15","descricao":"Novo Repartimento"},
		{"id":"1505106","ufId":"15","descricao":"Óbidos"},
		{"id":"1505205","ufId":"15","descricao":"Oeiras do Pará"},
		{"id":"1505304","ufId":"15","descricao":"Oriximiná"},
		{"id":"1505403","ufId":"15","descricao":"Ourém"},
		{"id":"1505437","ufId":"15","descricao":"Ourilândia do Norte"},
		{"id":"1505486","ufId":"15","descricao":"Pacajá"},
		{"id":"1505494","ufId":"15","descricao":"Palestina do Pará"},
		{"id":"1505502","ufId":"15","descricao":"Paragominas"},
		{"id":"1505536","ufId":"15","descricao":"Parauapebas"},
		{"id":"1505551","ufId":"15","descricao":"Pau D'Arco"},
		{"id":"1505601","ufId":"15","descricao":"Peixe-Boi"},
		{"id":"1505635","ufId":"15","descricao":"Piçarra"},
		{"id":"1505650","ufId":"15","descricao":"Placas"},
		{"id":"1505700","ufId":"15","descricao":"Ponta de Pedras"},
		{"id":"1505809","ufId":"15","descricao":"Portel"},
		{"id":"1505908","ufId":"15","descricao":"Porto de Moz"},
		{"id":"1506005","ufId":"15","descricao":"Prainha"},
		{"id":"1506104","ufId":"15","descricao":"Primavera"},
		{"id":"1506112","ufId":"15","descricao":"Quatipuru"},
		{"id":"1506138","ufId":"15","descricao":"Redenção"},
		{"id":"1506161","ufId":"15","descricao":"Rio Maria"},
		{"id":"1506187","ufId":"15","descricao":"Rondon do Pará"},
		{"id":"1506195","ufId":"15","descricao":"Rurópolis"},
		{"id":"1506203","ufId":"15","descricao":"Salinópolis"},
		{"id":"1506302","ufId":"15","descricao":"Salvaterra"},
		{"id":"1506351","ufId":"15","descricao":"Santa Bárbara do Pará"},
		{"id":"1506401","ufId":"15","descricao":"Santa Cruz do Arari"},
		{"id":"1506500","ufId":"15","descricao":"Santa Izabel do Pará"},
		{"id":"1506559","ufId":"15","descricao":"Santa Luzia do Pará"},
		{"id":"1506583","ufId":"15","descricao":"Santa Maria das Barreiras"},
		{"id":"1506609","ufId":"15","descricao":"Santa Maria do Pará"},
		{"id":"1506708","ufId":"15","descricao":"Santana do Araguaia"},
		{"id":"1506807","ufId":"15","descricao":"Santarém"},
		{"id":"1506906","ufId":"15","descricao":"Santarém Novo"},
		{"id":"1507003","ufId":"15","descricao":"Santo Antônio do Tauá"},
		{"id":"1507102","ufId":"15","descricao":"São Caetano de Odivelas"},
		{"id":"1507151","ufId":"15","descricao":"São Domingos do Araguaia"},
		{"id":"1507201","ufId":"15","descricao":"São Domingos do Capim"},
		{"id":"1507300","ufId":"15","descricao":"São Félix do Xingu"},
		{"id":"1507409","ufId":"15","descricao":"São Francisco do Pará"},
		{"id":"1507458","ufId":"15","descricao":"São Geraldo do Araguaia"},
		{"id":"1507466","ufId":"15","descricao":"São João da Ponta"},
		{"id":"1507474","ufId":"15","descricao":"São João de Pirabas"},
		{"id":"1507508","ufId":"15","descricao":"São João do Araguaia"},
		{"id":"1507607","ufId":"15","descricao":"São Miguel do Guamá"},
		{"id":"1507706","ufId":"15","descricao":"São Sebastião da Boa Vista"},
		{"id":"1507755","ufId":"15","descricao":"Sapucaia"},
		{"id":"1507805","ufId":"15","descricao":"Senador José Porfírio"},
		{"id":"1507904","ufId":"15","descricao":"Soure"},
		{"id":"1507953","ufId":"15","descricao":"Tailândia"},
		{"id":"1507961","ufId":"15","descricao":"Terra Alta"},
		{"id":"1507979","ufId":"15","descricao":"Terra Santa"},
		{"id":"1508001","ufId":"15","descricao":"Tomé-Açu"},
		{"id":"1508035","ufId":"15","descricao":"Tracuateua"},
		{"id":"1508050","ufId":"15","descricao":"Trairão"},
		{"id":"1508084","ufId":"15","descricao":"Tucumã"},
		{"id":"1508100","ufId":"15","descricao":"Tucuruí"},
		{"id":"1508126","ufId":"15","descricao":"Ulianópolis"},
		{"id":"1508159","ufId":"15","descricao":"Uruará"},
		{"id":"1508209","ufId":"15","descricao":"Vigia"},
		{"id":"1508308","ufId":"15","descricao":"Viseu"},
		{"id":"1508357","ufId":"15","descricao":"Vitória do Xingu"},
		{"id":"1508407","ufId":"15","descricao":"Xinguara"}
	],
	"16": [
		{"id":"1600105","ufId":"16","descricao":"Amapá"},
		{"id":"1600204","ufId":"16","descricao":"Calçoene"},
		{"id":"1600212","ufId":"16","descricao":"Cutias"},
		{"id":"1600238","ufId":"16","descricao":"Ferreira Gomes"},
		{"id":"1600253","ufId":"16","descricao":"Itaubal"},
		{"id":"1600279","ufId":"16","descricao":"Laranjal do Jari"},
		{"id":"1600303","ufId":"16","descricao":"Macapá"},
		{"id":"1600402","ufId":"16","descricao":"Mazagão"},
		{"id":"1600501","ufId":"16","descricao":"Oiapoque"},
		{"id":"1600154","ufId":"16","descricao":"Pedra Branca do Amapari"},
		{"id":"1600535","ufId":"16","descricao":"Porto Grande"},
		{"id":"1600550","ufId":"16","descricao":"Pracuúba"},
		{"id":"1600600","ufId":"16","descricao":"Santana"},
		{"id":"1600055","ufId":"16","descricao":"Serra do Navio"},
		{"id":"1600709","ufId":"16","descricao":"Tartarugalzinho"},
		{"id":"1600808","ufId":"16","descricao":"Vitória do Jari"}
	],
	"17": [
		{"id":"1700251","ufId":"17","descricao":"Abreulândia"},
		{"id":"1700301","ufId":"17","descricao":"Aguiarnópolis"},
		{"id":"1700350","ufId":"17","descricao":"Aliança do Tocantins"},
		{"id":"1700400","ufId":"17","descricao":"Almas"},
		{"id":"1700707","ufId":"17","descricao":"Alvorada"},
		{"id":"1701002","ufId":"17","descricao":"Ananás"},
		{"id":"1701051","ufId":"17","descricao":"Angico"},
		{"id":"1701101","ufId":"17","descricao":"Aparecida do Rio Negro"},
		{"id":"1701309","ufId":"17","descricao":"Aragominas"},
		{"id":"1701903","ufId":"17","descricao":"Araguacema"},
		{"id":"1702000","ufId":"17","descricao":"Araguaçu"},
		{"id":"1702109","ufId":"17","descricao":"Araguaína"},
		{"id":"1702158","ufId":"17","descricao":"Araguanã"},
		{"id":"1702208","ufId":"17","descricao":"Araguatins"},
		{"id":"1702307","ufId":"17","descricao":"Arapoema"},
		{"id":"1702406","ufId":"17","descricao":"Arraias"},
		{"id":"1702554","ufId":"17","descricao":"Augustinópolis"},
		{"id":"1702703","ufId":"17","descricao":"Aurora do Tocantins"},
		{"id":"1702901","ufId":"17","descricao":"Axixá do Tocantins"},
		{"id":"1703008","ufId":"17","descricao":"Babaçulândia"},
		{"id":"1703057","ufId":"17","descricao":"Bandeirantes do Tocantins"},
		{"id":"1703073","ufId":"17","descricao":"Barra do Ouro"},
		{"id":"1703107","ufId":"17","descricao":"Barrolândia"},
		{"id":"1703206","ufId":"17","descricao":"Bernardo Sayão"},
		{"id":"1703305","ufId":"17","descricao":"Bom Jesus do Tocantins"},
		{"id":"1703602","ufId":"17","descricao":"Brasilândia do Tocantins"},
		{"id":"1703701","ufId":"17","descricao":"Brejinho de Nazaré"},
		{"id":"1703800","ufId":"17","descricao":"Buriti do Tocantins"},
		{"id":"1703826","ufId":"17","descricao":"Cachoeirinha"},
		{"id":"1703842","ufId":"17","descricao":"Campos Lindos"},
		{"id":"1703867","ufId":"17","descricao":"Cariri do Tocantins"},
		{"id":"1703883","ufId":"17","descricao":"Carmolândia"},
		{"id":"1703891","ufId":"17","descricao":"Carrasco Bonito"},
		{"id":"1703909","ufId":"17","descricao":"Caseara"},
		{"id":"1704105","ufId":"17","descricao":"Centenário"},
		{"id":"1705102","ufId":"17","descricao":"Chapada da Natividade"},
		{"id":"1704600","ufId":"17","descricao":"Chapada de Areia"},
		{"id":"1705508","ufId":"17","descricao":"Colinas do Tocantins"},
		{"id":"1716703","ufId":"17","descricao":"Colméia"},
		{"id":"1705557","ufId":"17","descricao":"Combinado"},
		{"id":"1705607","ufId":"17","descricao":"Conceição do Tocantins"},
		{"id":"1706001","ufId":"17","descricao":"Couto Magalhães"},
		{"id":"1706100","ufId":"17","descricao":"Cristalândia"},
		{"id":"1706258","ufId":"17","descricao":"Crixás do Tocantins"},
		{"id":"1706506","ufId":"17","descricao":"Darcinópolis"},
		{"id":"1707009","ufId":"17","descricao":"Dianópolis"},
		{"id":"1707108","ufId":"17","descricao":"Divinópolis do Tocantins"},
		{"id":"1707207","ufId":"17","descricao":"Dois Irmãos do Tocantins"},
		{"id":"1707306","ufId":"17","descricao":"Dueré"},
		{"id":"1707405","ufId":"17","descricao":"Esperantina"},
		{"id":"1707553","ufId":"17","descricao":"Fátima"},
		{"id":"1707652","ufId":"17","descricao":"Figueirópolis"},
		{"id":"1707702","ufId":"17","descricao":"Filadélfia"},
		{"id":"1708205","ufId":"17","descricao":"Formoso do Araguaia"},
		{"id":"1708304","ufId":"17","descricao":"Goianorte"},
		{"id":"1709005","ufId":"17","descricao":"Goiatins"},
		{"id":"1709302","ufId":"17","descricao":"Guaraí"},
		{"id":"1709500","ufId":"17","descricao":"Gurupi"},
		{"id":"1709807","ufId":"17","descricao":"Ipueiras"},
		{"id":"1710508","ufId":"17","descricao":"Itacajá"},
		{"id":"1710706","ufId":"17","descricao":"Itaguatins"},
		{"id":"1710904","ufId":"17","descricao":"Itapiratins"},
		{"id":"1711100","ufId":"17","descricao":"Itaporã do Tocantins"},
		{"id":"1711506","ufId":"17","descricao":"Jaú do Tocantins"},
		{"id":"1711803","ufId":"17","descricao":"Juarina"},
		{"id":"1711902","ufId":"17","descricao":"Lagoa da Confusão"},
		{"id":"1711951","ufId":"17","descricao":"Lagoa do Tocantins"},
		{"id":"1712009","ufId":"17","descricao":"Lajeado"},
		{"id":"1712157","ufId":"17","descricao":"Lavandeira"},
		{"id":"1712405","ufId":"17","descricao":"Lizarda"},
		{"id":"1712454","ufId":"17","descricao":"Luzinópolis"},
		{"id":"1712504","ufId":"17","descricao":"Marianópolis do Tocantins"},
		{"id":"1712702","ufId":"17","descricao":"Mateiros"},
		{"id":"1712801","ufId":"17","descricao":"Maurilândia do Tocantins"},
		{"id":"1713205","ufId":"17","descricao":"Miracema do Tocantins"},
		{"id":"1713304","ufId":"17","descricao":"Miranorte"},
		{"id":"1713601","ufId":"17","descricao":"Monte do Carmo"},
		{"id":"1713700","ufId":"17","descricao":"Monte Santo do Tocantins"},
		{"id":"1713957","ufId":"17","descricao":"Muricilândia"},
		{"id":"1714203","ufId":"17","descricao":"Natividade"},
		{"id":"1714302","ufId":"17","descricao":"Nazaré"},
		{"id":"1714880","ufId":"17","descricao":"Nova Olinda"},
		{"id":"1715002","ufId":"17","descricao":"Nova Rosalândia"},
		{"id":"1715101","ufId":"17","descricao":"Novo Acordo"},
		{"id":"1715150","ufId":"17","descricao":"Novo Alegre"},
		{"id":"1715259","ufId":"17","descricao":"Novo Jardim"},
		{"id":"1715507","ufId":"17","descricao":"Oliveira de Fátima"},
		{"id":"1721000","ufId":"17","descricao":"Palmas"},
		{"id":"1715705","ufId":"17","descricao":"Palmeirante"},
		{"id":"1713809","ufId":"17","descricao":"Palmeiras do Tocantins"},
		{"id":"1715754","ufId":"17","descricao":"Palmeirópolis"},
		{"id":"1716109","ufId":"17","descricao":"Paraíso do Tocantins"},
		{"id":"1716208","ufId":"17","descricao":"Paranã"},
		{"id":"1716307","ufId":"17","descricao":"Pau D'Arco"},
		{"id":"1716505","ufId":"17","descricao":"Pedro Afonso"},
		{"id":"1716604","ufId":"17","descricao":"Peixe"},
		{"id":"1716653","ufId":"17","descricao":"Pequizeiro"},
		{"id":"1717008","ufId":"17","descricao":"Pindorama do Tocantins"},
		{"id":"1717206","ufId":"17","descricao":"Piraquê"},
		{"id":"1717503","ufId":"17","descricao":"Pium"},
		{"id":"1717800","ufId":"17","descricao":"Ponte Alta do Bom Jesus"},
		{"id":"1717909","ufId":"17","descricao":"Ponte Alta do Tocantins"},
		{"id":"1718006","ufId":"17","descricao":"Porto Alegre do Tocantins"},
		{"id":"1718204","ufId":"17","descricao":"Porto Nacional"},
		{"id":"1718303","ufId":"17","descricao":"Praia Norte"},
		{"id":"1718402","ufId":"17","descricao":"Presidente Kennedy"},
		{"id":"1718451","ufId":"17","descricao":"Pugmil"},
		{"id":"1718501","ufId":"17","descricao":"Recursolândia"},
		{"id":"1718550","ufId":"17","descricao":"Riachinho"},
		{"id":"1718659","ufId":"17","descricao":"Rio da Conceição"},
		{"id":"1718709","ufId":"17","descricao":"Rio dos Bois"},
		{"id":"1718758","ufId":"17","descricao":"Rio Sono"},
		{"id":"1718808","ufId":"17","descricao":"Sampaio"},
		{"id":"1718840","ufId":"17","descricao":"Sandolândia"},
		{"id":"1718865","ufId":"17","descricao":"Santa Fé do Araguaia"},
		{"id":"1718881","ufId":"17","descricao":"Santa Maria do Tocantins"},
		{"id":"1718899","ufId":"17","descricao":"Santa Rita do Tocantins"},
		{"id":"1718907","ufId":"17","descricao":"Santa Rosa do Tocantins"},
		{"id":"1719004","ufId":"17","descricao":"Santa Tereza do Tocantins"},
		{"id":"1720002","ufId":"17","descricao":"Santa Terezinha do Tocantins"},
		{"id":"1720101","ufId":"17","descricao":"São Bento do Tocantins"},
		{"id":"1720150","ufId":"17","descricao":"São Félix do Tocantins"},
		{"id":"1720200","ufId":"17","descricao":"São Miguel do Tocantins"},
		{"id":"1720259","ufId":"17","descricao":"São Salvador do Tocantins"},
		{"id":"1720309","ufId":"17","descricao":"São Sebastião do Tocantins"},
		{"id":"1720499","ufId":"17","descricao":"São Valério"},
		{"id":"1720655","ufId":"17","descricao":"Silvanópolis"},
		{"id":"1720804","ufId":"17","descricao":"Sítio Novo do Tocantins"},
		{"id":"1720853","ufId":"17","descricao":"Sucupira"},
		{"id":"1708254","ufId":"17","descricao":"Tabocão"},
		{"id":"1720903","ufId":"17","descricao":"Taguatinga"},
		{"id":"1720937","ufId":"17","descricao":"Taipas do Tocantins"},
		{"id":"1720978","ufId":"17","descricao":"Talismã"},
		{"id":"1721109","ufId":"17","descricao":"Tocantínia"},
		{"id":"1721208","ufId":"17","descricao":"Tocantinópolis"},
		{"id":"1721257","ufId":"17","descricao":"Tupirama"},
		{"id":"1721307","ufId":"17","descricao":"Tupiratins"},
		{"id":"1722081","ufId":"17","descricao":"Wanderlândia"},
		{"id":"1722107","ufId":"17","descricao":"Xambioá"}
	],
	"21": [
		{"id":"2100055","ufId":"21","descricao":"Açailândia"},
		{"id":"2100105","ufId":"21","descricao":"Afonso Cunha"},
		{"id":"2100154","ufId":"21","descricao":"Água Doce do Maranhão"},
		{"id":"2100204","ufId":"21","descricao":"Alcântara"},
		{"id":"2100303","ufId":"21","descricao":"Aldeias Altas"},
		{"id":"2100402","ufId":"21","descricao":"Altamira do Maranhão"},
		{"id":"2100436","ufId":"21","descricao":"Alto Alegre do Maranhão"},
		{"id":"2100477","ufId":"21","descricao":"Alto Alegre do Pindaré"},
		{"id":"2100501","ufId":"21","descricao":"Alto Parnaíba"},
		{"id":"2100550","ufId":"21","descricao":"Amapá do Maranhão"},
		{"id":"2100600","ufId":"21","descricao":"Amarante do Maranhão"},
		{"id":"2100709","ufId":"21","descricao":"Anajatuba"},
		{"id":"2100808","ufId":"21","descricao":"Anapurus"},
		{"id":"2100832","ufId":"21","descricao":"Apicum-Açu"},
		{"id":"2100873","ufId":"21","descricao":"Araguanã"},
		{"id":"2100907","ufId":"21","descricao":"Araioses"},
		{"id":"2100956","ufId":"21","descricao":"Arame"},
		{"id":"2101004","ufId":"21","descricao":"Arari"},
		{"id":"2101103","ufId":"21","descricao":"Axixá"},
		{"id":"2101202","ufId":"21","descricao":"Bacabal"},
		{"id":"2101251","ufId":"21","descricao":"Bacabeira"},
		{"id":"2101301","ufId":"21","descricao":"Bacuri"},
		{"id":"2101350","ufId":"21","descricao":"Bacurituba"},
		{"id":"2101400","ufId":"21","descricao":"Balsas"},
		{"id":"2101509","ufId":"21","descricao":"Barão de Grajaú"},
		{"id":"2101608","ufId":"21","descricao":"Barra do Corda"},
		{"id":"2101707","ufId":"21","descricao":"Barreirinhas"},
		{"id":"2101772","ufId":"21","descricao":"Bela Vista do Maranhão"},
		{"id":"2101731","ufId":"21","descricao":"Belágua"},
		{"id":"2101806","ufId":"21","descricao":"Benedito Leite"},
		{"id":"2101905","ufId":"21","descricao":"Bequimão"},
		{"id":"2101939","ufId":"21","descricao":"Bernardo do Mearim"},
		{"id":"2101970","ufId":"21","descricao":"Boa Vista do Gurupi"},
		{"id":"2102002","ufId":"21","descricao":"Bom Jardim"},
		{"id":"2102036","ufId":"21","descricao":"Bom Jesus das Selvas"},
		{"id":"2102077","ufId":"21","descricao":"Bom Lugar"},
		{"id":"2102101","ufId":"21","descricao":"Brejo"},
		{"id":"2102150","ufId":"21","descricao":"Brejo de Areia"},
		{"id":"2102200","ufId":"21","descricao":"Buriti"},
		{"id":"2102309","ufId":"21","descricao":"Buriti Bravo"},
		{"id":"2102325","ufId":"21","descricao":"Buriticupu"},
		{"id":"2102358","ufId":"21","descricao":"Buritirana"},
		{"id":"2102374","ufId":"21","descricao":"Cachoeira Grande"},
		{"id":"2102408","ufId":"21","descricao":"Cajapió"},
		{"id":"2102507","ufId":"21","descricao":"Cajari"},
		{"id":"2102556","ufId":"21","descricao":"Campestre do Maranhão"},
		{"id":"2102606","ufId":"21","descricao":"Cândido Mendes"},
		{"id":"2102705","ufId":"21","descricao":"Cantanhede"},
		{"id":"2102754","ufId":"21","descricao":"Capinzal do Norte"},
		{"id":"2102804","ufId":"21","descricao":"Carolina"},
		{"id":"2102903","ufId":"21","descricao":"Carutapera"},
		{"id":"2103000","ufId":"21","descricao":"Caxias"},
		{"id":"2103109","ufId":"21","descricao":"Cedral"},
		{"id":"2103125","ufId":"21","descricao":"Central do Maranhão"},
		{"id":"2103158","ufId":"21","descricao":"Centro do Guilherme"},
		{"id":"2103174","ufId":"21","descricao":"Centro Novo do Maranhão"},
		{"id":"2103208","ufId":"21","descricao":"Chapadinha"},
		{"id":"2103257","ufId":"21","descricao":"Cidelândia"},
		{"id":"2103307","ufId":"21","descricao":"Codó"},
		{"id":"2103406","ufId":"21","descricao":"Coelho Neto"},
		{"id":"2103505","ufId":"21","descricao":"Colinas"},
		{"id":"2103554","ufId":"21","descricao":"Conceição do Lago-Açu"},
		{"id":"2103604","ufId":"21","descricao":"Coroatá"},
		{"id":"2103703","ufId":"21","descricao":"Cururupu"},
		{"id":"2103752","ufId":"21","descricao":"Davinópolis"},
		{"id":"2103802","ufId":"21","descricao":"Dom Pedro"},
		{"id":"2103901","ufId":"21","descricao":"Duque Bacelar"},
		{"id":"2104008","ufId":"21","descricao":"Esperantinópolis"},
		{"id":"2104057","ufId":"21","descricao":"Estreito"},
		{"id":"2104073","ufId":"21","descricao":"Feira Nova do Maranhão"},
		{"id":"2104081","ufId":"21","descricao":"Fernando Falcão"},
		{"id":"2104099","ufId":"21","descricao":"Formosa da Serra Negra"},
		{"id":"2104107","ufId":"21","descricao":"Fortaleza dos Nogueiras"},
		{"id":"2104206","ufId":"21","descricao":"Fortuna"},
		{"id":"2104305","ufId":"21","descricao":"Godofredo Viana"},
		{"id":"2104404","ufId":"21","descricao":"Gonçalves Dias"},
		{"id":"2104503","ufId":"21","descricao":"Governador Archer"},
		{"id":"2104552","ufId":"21","descricao":"Governador Edison Lobão"},
		{"id":"2104602","ufId":"21","descricao":"Governador Eugênio Barros"},
		{"id":"2104628","ufId":"21","descricao":"Governador Luiz Rocha"},
		{"id":"2104651","ufId":"21","descricao":"Governador Newton Bello"},
		{"id":"2104677","ufId":"21","descricao":"Governador Nunes Freire"},
		{"id":"2104701","ufId":"21","descricao":"Graça Aranha"},
		{"id":"2104800","ufId":"21","descricao":"Grajaú"},
		{"id":"2104909","ufId":"21","descricao":"Guimarães"},
		{"id":"2105005","ufId":"21","descricao":"Humberto de Campos"},
		{"id":"2105104","ufId":"21","descricao":"Icatu"},
		{"id":"2105153","ufId":"21","descricao":"Igarapé do Meio"},
		{"id":"2105203","ufId":"21","descricao":"Igarapé Grande"},
		{"id":"2105302","ufId":"21","descricao":"Imperatriz"},
		{"id":"2105351","ufId":"21","descricao":"Itaipava do Grajaú"},
		{"id":"2105401","ufId":"21","descricao":"Itapecuru Mirim"},
		{"id":"2105427","ufId":"21","descricao":"Itinga do Maranhão"},
		{"id":"2105450","ufId":"21","descricao":"Jatobá"},
		{"id":"2105476","ufId":"21","descricao":"Jenipapo dos Vieiras"},
		{"id":"2105500","ufId":"21","descricao":"João Lisboa"},
		{"id":"2105609","ufId":"21","descricao":"Joselândia"},
		{"id":"2105658","ufId":"21","descricao":"Junco do Maranhão"},
		{"id":"2105708","ufId":"21","descricao":"Lago da Pedra"},
		{"id":"2105807","ufId":"21","descricao":"Lago do Junco"},
		{"id":"2105948","ufId":"21","descricao":"Lago dos Rodrigues"},
		{"id":"2105906","ufId":"21","descricao":"Lago Verde"},
		{"id":"2105922","ufId":"21","descricao":"Lagoa do Mato"},
		{"id":"2105963","ufId":"21","descricao":"Lagoa Grande do Maranhão"},
		{"id":"2105989","ufId":"21","descricao":"Lajeado Novo"},
		{"id":"2106003","ufId":"21","descricao":"Lima Campos"},
		{"id":"2106102","ufId":"21","descricao":"Loreto"},
		{"id":"2106201","ufId":"21","descricao":"Luís Domingues"},
		{"id":"2106300","ufId":"21","descricao":"Magalhães de Almeida"},
		{"id":"2106326","ufId":"21","descricao":"Maracaçumé"},
		{"id":"2106359","ufId":"21","descricao":"Marajá do Sena"},
		{"id":"2106375","ufId":"21","descricao":"Maranhãozinho"},
		{"id":"2106409","ufId":"21","descricao":"Mata Roma"},
		{"id":"2106508","ufId":"21","descricao":"Matinha"},
		{"id":"2106607","ufId":"21","descricao":"Matões"},
		{"id":"2106631","ufId":"21","descricao":"Matões do Norte"},
		{"id":"2106672","ufId":"21","descricao":"Milagres do Maranhão"},
		{"id":"2106706","ufId":"21","descricao":"Mirador"},
		{"id":"2106755","ufId":"21","descricao":"Miranda do Norte"},
		{"id":"2106805","ufId":"21","descricao":"Mirinzal"},
		{"id":"2106904","ufId":"21","descricao":"Monção"},
		{"id":"2107001","ufId":"21","descricao":"Montes Altos"},
		{"id":"2107100","ufId":"21","descricao":"Morros"},
		{"id":"2107209","ufId":"21","descricao":"Nina Rodrigues"},
		{"id":"2107258","ufId":"21","descricao":"Nova Colinas"},
		{"id":"2107308","ufId":"21","descricao":"Nova Iorque"},
		{"id":"2107357","ufId":"21","descricao":"Nova Olinda do Maranhão"},
		{"id":"2107407","ufId":"21","descricao":"Olho d'Água das Cunhãs"},
		{"id":"2107456","ufId":"21","descricao":"Olinda Nova do Maranhão"},
		{"id":"2107506","ufId":"21","descricao":"Paço do Lumiar"},
		{"id":"2107605","ufId":"21","descricao":"Palmeirândia"},
		{"id":"2107704","ufId":"21","descricao":"Paraibano"},
		{"id":"2107803","ufId":"21","descricao":"Parnarama"},
		{"id":"2107902","ufId":"21","descricao":"Passagem Franca"},
		{"id":"2108009","ufId":"21","descricao":"Pastos Bons"},
		{"id":"2108058","ufId":"21","descricao":"Paulino Neves"},
		{"id":"2108108","ufId":"21","descricao":"Paulo Ramos"},
		{"id":"2108207","ufId":"21","descricao":"Pedreiras"},
		{"id":"2108256","ufId":"21","descricao":"Pedro do Rosário"},
		{"id":"2108306","ufId":"21","descricao":"Penalva"},
		{"id":"2108405","ufId":"21","descricao":"Peri Mirim"},
		{"id":"2108454","ufId":"21","descricao":"Peritoró"},
		{"id":"2108504","ufId":"21","descricao":"Pindaré-Mirim"},
		{"id":"2108603","ufId":"21","descricao":"Pinheiro"},
		{"id":"2108702","ufId":"21","descricao":"Pio XII"},
		{"id":"2108801","ufId":"21","descricao":"Pirapemas"},
		{"id":"2108900","ufId":"21","descricao":"Poção de Pedras"},
		{"id":"2109007","ufId":"21","descricao":"Porto Franco"},
		{"id":"2109056","ufId":"21","descricao":"Porto Rico do Maranhão"},
		{"id":"2109106","ufId":"21","descricao":"Presidente Dutra"},
		{"id":"2109205","ufId":"21","descricao":"Presidente Juscelino"},
		{"id":"2109239","ufId":"21","descricao":"Presidente Médici"},
		{"id":"2109270","ufId":"21","descricao":"Presidente Sarney"},
		{"id":"2109304","ufId":"21","descricao":"Presidente Vargas"},
		{"id":"2109403","ufId":"21","descricao":"Primeira Cruz"},
		{"id":"2109452","ufId":"21","descricao":"Raposa"},
		{"id":"2109502","ufId":"21","descricao":"Riachão"},
		{"id":"2109551","ufId":"21","descricao":"Ribamar Fiquene"},
		{"id":"2109601","ufId":"21","descricao":"Rosário"},
		{"id":"2109700","ufId":"21","descricao":"Sambaíba"},
		{"id":"2109759","ufId":"21","descricao":"Santa Filomena do Maranhão"},
		{"id":"2109809","ufId":"21","descricao":"Santa Helena"},
		{"id":"2109908","ufId":"21","descricao":"Santa Inês"},
		{"id":"2110005","ufId":"21","descricao":"Santa Luzia"},
		{"id":"2110039","ufId":"21","descricao":"Santa Luzia do Paruá"},
		{"id":"2110104","ufId":"21","descricao":"Santa Quitéria do Maranhão"},
		{"id":"2110203","ufId":"21","descricao":"Santa Rita"},
		{"id":"2110237","ufId":"21","descricao":"Santana do Maranhão"},
		{"id":"2110278","ufId":"21","descricao":"Santo Amaro do Maranhão"},
		{"id":"2110302","ufId":"21","descricao":"Santo Antônio dos Lopes"},
		{"id":"2110401","ufId":"21","descricao":"São Benedito do Rio Preto"},
		{"id":"2110500","ufId":"21","descricao":"São Bento"},
		{"id":"2110609","ufId":"21","descricao":"São Bernardo"},
		{"id":"2110658","ufId":"21","descricao":"São Domingos do Azeitão"},
		{"id":"2110708","ufId":"21","descricao":"São Domingos do Maranhão"},
		{"id":"2110807","ufId":"21","descricao":"São Félix de Balsas"},
		{"id":"2110856","ufId":"21","descricao":"São Francisco do Brejão"},
		{"id":"2110906","ufId":"21","descricao":"São Francisco do Maranhão"},
		{"id":"2111003","ufId":"21","descricao":"São João Batista"},
		{"id":"2111029","ufId":"21","descricao":"São João do Carú"},
		{"id":"2111052","ufId":"21","descricao":"São João do Paraíso"},
		{"id":"2111078","ufId":"21","descricao":"São João do Soter"},
		{"id":"2111102","ufId":"21","descricao":"São João dos Patos"},
		{"id":"2111201","ufId":"21","descricao":"São José de Ribamar"},
		{"id":"2111250","ufId":"21","descricao":"São José dos Basílios"},
		{"id":"2111300","ufId":"21","descricao":"São Luís"},
		{"id":"2111409","ufId":"21","descricao":"São Luís Gonzaga do Maranhão"},
		{"id":"2111508","ufId":"21","descricao":"São Mateus do Maranhão"},
		{"id":"2111532","ufId":"21","descricao":"São Pedro da Água Branca"},
		{"id":"2111573","ufId":"21","descricao":"São Pedro dos Crentes"},
		{"id":"2111607","ufId":"21","descricao":"São Raimundo das Mangabeiras"},
		{"id":"2111631","ufId":"21","descricao":"São Raimundo do Doca Bezerra"},
		{"id":"2111672","ufId":"21","descricao":"São Roberto"},
		{"id":"2111706","ufId":"21","descricao":"São Vicente Ferrer"},
		{"id":"2111722","ufId":"21","descricao":"Satubinha"},
		{"id":"2111748","ufId":"21","descricao":"Senador Alexandre Costa"},
		{"id":"2111763","ufId":"21","descricao":"Senador La Rocque"},
		{"id":"2111789","ufId":"21","descricao":"Serrano do Maranhão"},
		{"id":"2111805","ufId":"21","descricao":"Sítio Novo"},
		{"id":"2111904","ufId":"21","descricao":"Sucupira do Norte"},
		{"id":"2111953","ufId":"21","descricao":"Sucupira do Riachão"},
		{"id":"2112001","ufId":"21","descricao":"Tasso Fragoso"},
		{"id":"2112100","ufId":"21","descricao":"Timbiras"},
		{"id":"2112209","ufId":"21","descricao":"Timon"},
		{"id":"2112233","ufId":"21","descricao":"Trizidela do Vale"},
		{"id":"2112274","ufId":"21","descricao":"Tufilândia"},
		{"id":"2112308","ufId":"21","descricao":"Tuntum"},
		{"id":"2112407","ufId":"21","descricao":"Turiaçu"},
		{"id":"2112456","ufId":"21","descricao":"Turilândia"},
		{"id":"2112506","ufId":"21","descricao":"Tutóia"},
		{"id":"2112605","ufId":"21","descricao":"Urbano Santos"},
		{"id":"2112704","ufId":"21","descricao":"Vargem Grande"},
		{"id":"2112803","ufId":"21","descricao":"Viana"},
		{"id":"2112852","ufId":"21","descricao":"Vila Nova dos Martírios"},
		{"id":"2112902","ufId":"21","descricao":"Vitória do Mearim"},
		{"id":"2113009","ufId":"21","descricao":"Vitorino Freire"},
		{"id":"2114007","ufId":"21","descricao":"Zé Doca"}
	],
	"22": [
		{"id":"2200053","ufId":"22","descricao":"Acauã"},
		{"id":"2200103","ufId":"22","descricao":"Agricolândia"},
		{"id":"2200202","ufId":"22","descricao":"Água Branca"},
		{"id":"2200251","ufId":"22","descricao":"Alagoinha do Piauí"},
		{"id":"2200277","ufId":"22","descricao":"Alegrete do Piauí"},
		{"id":"2200301","ufId":"22","descricao":"Alto Longá"},
		{"id":"2200400","ufId":"22","descricao":"Altos"},
		{"id":"2200459","ufId":"22","descricao":"Alvorada do Gurguéia"},
		{"id":"2200509","ufId":"22","descricao":"Amarante"},
		{"id":"2200608","ufId":"22","descricao":"Angical do Piauí"},
		{"id":"2200707","ufId":"22","descricao":"Anísio de Abreu"},
		{"id":"2200806","ufId":"22","descricao":"Antônio Almeida"},
		{"id":"2200905","ufId":"22","descricao":"Aroazes"},
		{"id":"2200954","ufId":"22","descricao":"Aroeiras do Itaim"},
		{"id":"2201002","ufId":"22","descricao":"Arraial"},
		{"id":"2201051","ufId":"22","descricao":"Assunção do Piauí"},
		{"id":"2201101","ufId":"22","descricao":"Avelino Lopes"},
		{"id":"2201150","ufId":"22","descricao":"Baixa Grande do Ribeiro"},
		{"id":"2201176","ufId":"22","descricao":"Barra D'Alcântara"},
		{"id":"2201200","ufId":"22","descricao":"Barras"},
		{"id":"2201309","ufId":"22","descricao":"Barreiras do Piauí"},
		{"id":"2201408","ufId":"22","descricao":"Barro Duro"},
		{"id":"2201507","ufId":"22","descricao":"Batalha"},
		{"id":"2201556","ufId":"22","descricao":"Bela Vista do Piauí"},
		{"id":"2201572","ufId":"22","descricao":"Belém do Piauí"},
		{"id":"2201606","ufId":"22","descricao":"Beneditinos"},
		{"id":"2201705","ufId":"22","descricao":"Bertolínia"},
		{"id":"2201739","ufId":"22","descricao":"Betânia do Piauí"},
		{"id":"2201770","ufId":"22","descricao":"Boa Hora"},
		{"id":"2201804","ufId":"22","descricao":"Bocaina"},
		{"id":"2201903","ufId":"22","descricao":"Bom Jesus"},
		{"id":"2201919","ufId":"22","descricao":"Bom Princípio do Piauí"},
		{"id":"2201929","ufId":"22","descricao":"Bonfim do Piauí"},
		{"id":"2201945","ufId":"22","descricao":"Boqueirão do Piauí"},
		{"id":"2201960","ufId":"22","descricao":"Brasileira"},
		{"id":"2201988","ufId":"22","descricao":"Brejo do Piauí"},
		{"id":"2202000","ufId":"22","descricao":"Buriti dos Lopes"},
		{"id":"2202026","ufId":"22","descricao":"Buriti dos Montes"},
		{"id":"2202059","ufId":"22","descricao":"Cabeceiras do Piauí"},
		{"id":"2202075","ufId":"22","descricao":"Cajazeiras do Piauí"},
		{"id":"2202083","ufId":"22","descricao":"Cajueiro da Praia"},
		{"id":"2202091","ufId":"22","descricao":"Caldeirão Grande do Piauí"},
		{"id":"2202109","ufId":"22","descricao":"Campinas do Piauí"},
		{"id":"2202117","ufId":"22","descricao":"Campo Alegre do Fidalgo"},
		{"id":"2202133","ufId":"22","descricao":"Campo Grande do Piauí"},
		{"id":"2202174","ufId":"22","descricao":"Campo Largo do Piauí"},
		{"id":"2202208","ufId":"22","descricao":"Campo Maior"},
		{"id":"2202251","ufId":"22","descricao":"Canavieira"},
		{"id":"2202307","ufId":"22","descricao":"Canto do Buriti"},
		{"id":"2202406","ufId":"22","descricao":"Capitão de Campos"},
		{"id":"2202455","ufId":"22","descricao":"Capitão Gervásio Oliveira"},
		{"id":"2202505","ufId":"22","descricao":"Caracol"},
		{"id":"2202539","ufId":"22","descricao":"Caraúbas do Piauí"},
		{"id":"2202554","ufId":"22","descricao":"Caridade do Piauí"},
		{"id":"2202604","ufId":"22","descricao":"Castelo do Piauí"},
		{"id":"2202653","ufId":"22","descricao":"Caxingó"},
		{"id":"2202703","ufId":"22","descricao":"Cocal"},
		{"id":"2202711","ufId":"22","descricao":"Cocal de Telha"},
		{"id":"2202729","ufId":"22","descricao":"Cocal dos Alves"},
		{"id":"2202737","ufId":"22","descricao":"Coivaras"},
		{"id":"2202752","ufId":"22","descricao":"Colônia do Gurguéia"},
		{"id":"2202778","ufId":"22","descricao":"Colônia do Piauí"},
		{"id":"2202802","ufId":"22","descricao":"Conceição do Canindé"},
		{"id":"2202851","ufId":"22","descricao":"Coronel José Dias"},
		{"id":"2202901","ufId":"22","descricao":"Corrente"},
		{"id":"2203008","ufId":"22","descricao":"Cristalândia do Piauí"},
		{"id":"2203107","ufId":"22","descricao":"Cristino Castro"},
		{"id":"2203206","ufId":"22","descricao":"Curimatá"},
		{"id":"2203230","ufId":"22","descricao":"Currais"},
		{"id":"2203271","ufId":"22","descricao":"Curral Novo do Piauí"},
		{"id":"2203255","ufId":"22","descricao":"Curralinhos"},
		{"id":"2203305","ufId":"22","descricao":"Demerval Lobão"},
		{"id":"2203354","ufId":"22","descricao":"Dirceu Arcoverde"},
		{"id":"2203404","ufId":"22","descricao":"Dom Expedito Lopes"},
		{"id":"2203453","ufId":"22","descricao":"Dom Inocêncio"},
		{"id":"2203420","ufId":"22","descricao":"Domingos Mourão"},
		{"id":"2203503","ufId":"22","descricao":"Elesbão Veloso"},
		{"id":"2203602","ufId":"22","descricao":"Eliseu Martins"},
		{"id":"2203701","ufId":"22","descricao":"Esperantina"},
		{"id":"2203750","ufId":"22","descricao":"Fartura do Piauí"},
		{"id":"2203800","ufId":"22","descricao":"Flores do Piauí"},
		{"id":"2203859","ufId":"22","descricao":"Floresta do Piauí"},
		{"id":"2203909","ufId":"22","descricao":"Floriano"},
		{"id":"2204006","ufId":"22","descricao":"Francinópolis"},
		{"id":"2204105","ufId":"22","descricao":"Francisco Ayres"},
		{"id":"2204154","ufId":"22","descricao":"Francisco Macedo"},
		{"id":"2204204","ufId":"22","descricao":"Francisco Santos"},
		{"id":"2204303","ufId":"22","descricao":"Fronteiras"},
		{"id":"2204352","ufId":"22","descricao":"Geminiano"},
		{"id":"2204402","ufId":"22","descricao":"Gilbués"},
		{"id":"2204501","ufId":"22","descricao":"Guadalupe"},
		{"id":"2204550","ufId":"22","descricao":"Guaribas"},
		{"id":"2204600","ufId":"22","descricao":"Hugo Napoleão"},
		{"id":"2204659","ufId":"22","descricao":"Ilha Grande"},
		{"id":"2204709","ufId":"22","descricao":"Inhuma"},
		{"id":"2204808","ufId":"22","descricao":"Ipiranga do Piauí"},
		{"id":"2204907","ufId":"22","descricao":"Isaías Coelho"},
		{"id":"2205003","ufId":"22","descricao":"Itainópolis"},
		{"id":"2205102","ufId":"22","descricao":"Itaueira"},
		{"id":"2205151","ufId":"22","descricao":"Jacobina do Piauí"},
		{"id":"2205201","ufId":"22","descricao":"Jaicós"},
		{"id":"2205250","ufId":"22","descricao":"Jardim do Mulato"},
		{"id":"2205276","ufId":"22","descricao":"Jatobá do Piauí"},
		{"id":"2205300","ufId":"22","descricao":"Jerumenha"},
		{"id":"2205359","ufId":"22","descricao":"João Costa"},
		{"id":"2205409","ufId":"22","descricao":"Joaquim Pires"},
		{"id":"2205458","ufId":"22","descricao":"Joca Marques"},
		{"id":"2205508","ufId":"22","descricao":"José de Freitas"},
		{"id":"2205516","ufId":"22","descricao":"Juazeiro do Piauí"},
		{"id":"2205524","ufId":"22","descricao":"Júlio Borges"},
		{"id":"2205532","ufId":"22","descricao":"Jurema"},
		{"id":"2205557","ufId":"22","descricao":"Lagoa Alegre"},
		{"id":"2205573","ufId":"22","descricao":"Lagoa de São Francisco"},
		{"id":"2205565","ufId":"22","descricao":"Lagoa do Barro do Piauí"},
		{"id":"2205581","ufId":"22","descricao":"Lagoa do Piauí"},
		{"id":"2205599","ufId":"22","descricao":"Lagoa do Sítio"},
		{"id":"2205540","ufId":"22","descricao":"Lagoinha do Piauí"},
		{"id":"2205607","ufId":"22","descricao":"Landri Sales"},
		{"id":"2205706","ufId":"22","descricao":"Luís Correia"},
		{"id":"2205805","ufId":"22","descricao":"Luzilândia"},
		{"id":"2205854","ufId":"22","descricao":"Madeiro"},
		{"id":"2205904","ufId":"22","descricao":"Manoel Emídio"},
		{"id":"2205953","ufId":"22","descricao":"Marcolândia"},
		{"id":"2206001","ufId":"22","descricao":"Marcos Parente"},
		{"id":"2206050","ufId":"22","descricao":"Massapê do Piauí"},
		{"id":"2206100","ufId":"22","descricao":"Matias Olímpio"},
		{"id":"2206209","ufId":"22","descricao":"Miguel Alves"},
		{"id":"2206308","ufId":"22","descricao":"Miguel Leão"},
		{"id":"2206357","ufId":"22","descricao":"Milton Brandão"},
		{"id":"2206407","ufId":"22","descricao":"Monsenhor Gil"},
		{"id":"2206506","ufId":"22","descricao":"Monsenhor Hipólito"},
		{"id":"2206605","ufId":"22","descricao":"Monte Alegre do Piauí"},
		{"id":"2206654","ufId":"22","descricao":"Morro Cabeça no Tempo"},
		{"id":"2206670","ufId":"22","descricao":"Morro do Chapéu do Piauí"},
		{"id":"2206696","ufId":"22","descricao":"Murici dos Portelas"},
		{"id":"2206704","ufId":"22","descricao":"Nazaré do Piauí"},
		{"id":"2206720","ufId":"22","descricao":"Nazária"},
		{"id":"2206753","ufId":"22","descricao":"Nossa Senhora de Nazaré"},
		{"id":"2206803","ufId":"22","descricao":"Nossa Senhora dos Remédios"},
		{"id":"2207959","ufId":"22","descricao":"Nova Santa Rita"},
		{"id":"2206902","ufId":"22","descricao":"Novo Oriente do Piauí"},
		{"id":"2206951","ufId":"22","descricao":"Novo Santo Antônio"},
		{"id":"2207009","ufId":"22","descricao":"Oeiras"},
		{"id":"2207108","ufId":"22","descricao":"Olho D'Água do Piauí"},
		{"id":"2207207","ufId":"22","descricao":"Padre Marcos"},
		{"id":"2207306","ufId":"22","descricao":"Paes Landim"},
		{"id":"2207355","ufId":"22","descricao":"Pajeú do Piauí"},
		{"id":"2207405","ufId":"22","descricao":"Palmeira do Piauí"},
		{"id":"2207504","ufId":"22","descricao":"Palmeirais"},
		{"id":"2207553","ufId":"22","descricao":"Paquetá"},
		{"id":"2207603","ufId":"22","descricao":"Parnaguá"},
		{"id":"2207702","ufId":"22","descricao":"Parnaíba"},
		{"id":"2207751","ufId":"22","descricao":"Passagem Franca do Piauí"},
		{"id":"2207777","ufId":"22","descricao":"Patos do Piauí"},
		{"id":"2207793","ufId":"22","descricao":"Pau D'Arco do Piauí"},
		{"id":"2207801","ufId":"22","descricao":"Paulistana"},
		{"id":"2207850","ufId":"22","descricao":"Pavussu"},
		{"id":"2207900","ufId":"22","descricao":"Pedro II"},
		{"id":"2207934","ufId":"22","descricao":"Pedro Laurentino"},
		{"id":"2208007","ufId":"22","descricao":"Picos"},
		{"id":"2208106","ufId":"22","descricao":"Pimenteiras"},
		{"id":"2208205","ufId":"22","descricao":"Pio IX"},
		{"id":"2208304","ufId":"22","descricao":"Piracuruca"},
		{"id":"2208403","ufId":"22","descricao":"Piripiri"},
		{"id":"2208502","ufId":"22","descricao":"Porto"},
		{"id":"2208551","ufId":"22","descricao":"Porto Alegre do Piauí"},
		{"id":"2208601","ufId":"22","descricao":"Prata do Piauí"},
		{"id":"2208650","ufId":"22","descricao":"Queimada Nova"},
		{"id":"2208700","ufId":"22","descricao":"Redenção do Gurguéia"},
		{"id":"2208809","ufId":"22","descricao":"Regeneração"},
		{"id":"2208858","ufId":"22","descricao":"Riacho Frio"},
		{"id":"2208874","ufId":"22","descricao":"Ribeira do Piauí"},
		{"id":"2208908","ufId":"22","descricao":"Ribeiro Gonçalves"},
		{"id":"2209005","ufId":"22","descricao":"Rio Grande do Piauí"},
		{"id":"2209104","ufId":"22","descricao":"Santa Cruz do Piauí"},
		{"id":"2209153","ufId":"22","descricao":"Santa Cruz dos Milagres"},
		{"id":"2209203","ufId":"22","descricao":"Santa Filomena"},
		{"id":"2209302","ufId":"22","descricao":"Santa Luz"},
		{"id":"2209377","ufId":"22","descricao":"Santa Rosa do Piauí"},
		{"id":"2209351","ufId":"22","descricao":"Santana do Piauí"},
		{"id":"2209401","ufId":"22","descricao":"Santo Antônio de Lisboa"},
		{"id":"2209450","ufId":"22","descricao":"Santo Antônio dos Milagres"},
		{"id":"2209500","ufId":"22","descricao":"Santo Inácio do Piauí"},
		{"id":"2209559","ufId":"22","descricao":"São Braz do Piauí"},
		{"id":"2209609","ufId":"22","descricao":"São Félix do Piauí"},
		{"id":"2209658","ufId":"22","descricao":"São Francisco de Assis do Piauí"},
		{"id":"2209708","ufId":"22","descricao":"São Francisco do Piauí"},
		{"id":"2209757","ufId":"22","descricao":"São Gonçalo do Gurguéia"},
		{"id":"2209807","ufId":"22","descricao":"São Gonçalo do Piauí"},
		{"id":"2209856","ufId":"22","descricao":"São João da Canabrava"},
		{"id":"2209872","ufId":"22","descricao":"São João da Fronteira"},
		{"id":"2209906","ufId":"22","descricao":"São João da Serra"},
		{"id":"2209955","ufId":"22","descricao":"São João da Varjota"},
		{"id":"2209971","ufId":"22","descricao":"São João do Arraial"},
		{"id":"2210003","ufId":"22","descricao":"São João do Piauí"},
		{"id":"2210052","ufId":"22","descricao":"São José do Divino"},
		{"id":"2210102","ufId":"22","descricao":"São José do Peixe"},
		{"id":"2210201","ufId":"22","descricao":"São José do Piauí"},
		{"id":"2210300","ufId":"22","descricao":"São Julião"},
		{"id":"2210359","ufId":"22","descricao":"São Lourenço do Piauí"},
		{"id":"2210375","ufId":"22","descricao":"São Luis do Piauí"},
		{"id":"2210383","ufId":"22","descricao":"São Miguel da Baixa Grande"},
		{"id":"2210391","ufId":"22","descricao":"São Miguel do Fidalgo"},
		{"id":"2210409","ufId":"22","descricao":"São Miguel do Tapuio"},
		{"id":"2210508","ufId":"22","descricao":"São Pedro do Piauí"},
		{"id":"2210607","ufId":"22","descricao":"São Raimundo Nonato"},
		{"id":"2210623","ufId":"22","descricao":"Sebastião Barros"},
		{"id":"2210631","ufId":"22","descricao":"Sebastião Leal"},
		{"id":"2210656","ufId":"22","descricao":"Sigefredo Pacheco"},
		{"id":"2210706","ufId":"22","descricao":"Simões"},
		{"id":"2210805","ufId":"22","descricao":"Simplício Mendes"},
		{"id":"2210904","ufId":"22","descricao":"Socorro do Piauí"},
		{"id":"2210938","ufId":"22","descricao":"Sussuapara"},
		{"id":"2210953","ufId":"22","descricao":"Tamboril do Piauí"},
		{"id":"2210979","ufId":"22","descricao":"Tanque do Piauí"},
		{"id":"2211001","ufId":"22","descricao":"Teresina"},
		{"id":"2211100","ufId":"22","descricao":"União"},
		{"id":"2211209","ufId":"22","descricao":"Uruçuí"},
		{"id":"2211308","ufId":"22","descricao":"Valença do Piauí"},
		{"id":"2211357","ufId":"22","descricao":"Várzea Branca"},
		{"id":"2211407","ufId":"22","descricao":"Várzea Grande"},
		{"id":"2211506","ufId":"22","descricao":"Vera Mendes"},
		{"id":"2211605","ufId":"22","descricao":"Vila Nova do Piauí"},
		{"id":"2211704","ufId":"22","descricao":"Wall Ferraz"}
	],
	"23": [
		{"id":"2300101","ufId":"23","descricao":"Abaiara"},
		{"id":"2300150","ufId":"23","descricao":"Acarape"},
		{"id":"2300200","ufId":"23","descricao":"Acaraú"},
		{"id":"2300309","ufId":"23","descricao":"Acopiara"},
		{"id":"2300408","ufId":"23","descricao":"Aiuaba"},
		{"id":"2300507","ufId":"23","descricao":"Alcântaras"},
		{"id":"2300606","ufId":"23","descricao":"Altaneira"},
		{"id":"2300705","ufId":"23","descricao":"Alto Santo"},
		{"id":"2300754","ufId":"23","descricao":"Amontada"},
		{"id":"2300804","ufId":"23","descricao":"Antonina do Norte"},
		{"id":"2300903","ufId":"23","descricao":"Apuiarés"},
		{"id":"2301000","ufId":"23","descricao":"Aquiraz"},
		{"id":"2301109","ufId":"23","descricao":"Aracati"},
		{"id":"2301208","ufId":"23","descricao":"Aracoiaba"},
		{"id":"2301257","ufId":"23","descricao":"Ararendá"},
		{"id":"2301307","ufId":"23","descricao":"Araripe"},
		{"id":"2301406","ufId":"23","descricao":"Aratuba"},
		{"id":"2301505","ufId":"23","descricao":"Arneiroz"},
		{"id":"2301604","ufId":"23","descricao":"Assaré"},
		{"id":"2301703","ufId":"23","descricao":"Aurora"},
		{"id":"2301802","ufId":"23","descricao":"Baixio"},
		{"id":"2301851","ufId":"23","descricao":"Banabuiú"},
		{"id":"2301901","ufId":"23","descricao":"Barbalha"},
		{"id":"2301950","ufId":"23","descricao":"Barreira"},
		{"id":"2302008","ufId":"23","descricao":"Barro"},
		{"id":"2302057","ufId":"23","descricao":"Barroquinha"},
		{"id":"2302107","ufId":"23","descricao":"Baturité"},
		{"id":"2302206","ufId":"23","descricao":"Beberibe"},
		{"id":"2302305","ufId":"23","descricao":"Bela Cruz"},
		{"id":"2302404","ufId":"23","descricao":"Boa Viagem"},
		{"id":"2302503","ufId":"23","descricao":"Brejo Santo"},
		{"id":"2302602","ufId":"23","descricao":"Camocim"},
		{"id":"2302701","ufId":"23","descricao":"Campos Sales"},
		{"id":"2302800","ufId":"23","descricao":"Canindé"},
		{"id":"2302909","ufId":"23","descricao":"Capistrano"},
		{"id":"2303006","ufId":"23","descricao":"Caridade"},
		{"id":"2303105","ufId":"23","descricao":"Cariré"},
		{"id":"2303204","ufId":"23","descricao":"Caririaçu"},
		{"id":"2303303","ufId":"23","descricao":"Cariús"},
		{"id":"2303402","ufId":"23","descricao":"Carnaubal"},
		{"id":"2303501","ufId":"23","descricao":"Cascavel"},
		{"id":"2303600","ufId":"23","descricao":"Catarina"},
		{"id":"2303659","ufId":"23","descricao":"Catunda"},
		{"id":"2303709","ufId":"23","descricao":"Caucaia"},
		{"id":"2303808","ufId":"23","descricao":"Cedro"},
		{"id":"2303907","ufId":"23","descricao":"Chaval"},
		{"id":"2303931","ufId":"23","descricao":"Choró"},
		{"id":"2303956","ufId":"23","descricao":"Chorozinho"},
		{"id":"2304004","ufId":"23","descricao":"Coreaú"},
		{"id":"2304103","ufId":"23","descricao":"Crateús"},
		{"id":"2304202","ufId":"23","descricao":"Crato"},
		{"id":"2304236","ufId":"23","descricao":"Croatá"},
		{"id":"2304251","ufId":"23","descricao":"Cruz"},
		{"id":"2304269","ufId":"23","descricao":"Deputado Irapuan Pinheiro"},
		{"id":"2304277","ufId":"23","descricao":"Ereré"},
		{"id":"2304285","ufId":"23","descricao":"Eusébio"},
		{"id":"2304301","ufId":"23","descricao":"Farias Brito"},
		{"id":"2304350","ufId":"23","descricao":"Forquilha"},
		{"id":"2304400","ufId":"23","descricao":"Fortaleza"},
		{"id":"2304459","ufId":"23","descricao":"Fortim"},
		{"id":"2304509","ufId":"23","descricao":"Frecheirinha"},
		{"id":"2304608","ufId":"23","descricao":"General Sampaio"},
		{"id":"2304657","ufId":"23","descricao":"Graça"},
		{"id":"2304707","ufId":"23","descricao":"Granja"},
		{"id":"2304806","ufId":"23","descricao":"Granjeiro"},
		{"id":"2304905","ufId":"23","descricao":"Groaíras"},
		{"id":"2304954","ufId":"23","descricao":"Guaiúba"},
		{"id":"2305001","ufId":"23","descricao":"Guaraciaba do Norte"},
		{"id":"2305100","ufId":"23","descricao":"Guaramiranga"},
		{"id":"2305209","ufId":"23","descricao":"Hidrolândia"},
		{"id":"2305233","ufId":"23","descricao":"Horizonte"},
		{"id":"2305266","ufId":"23","descricao":"Ibaretama"},
		{"id":"2305308","ufId":"23","descricao":"Ibiapina"},
		{"id":"2305332","ufId":"23","descricao":"Ibicuitinga"},
		{"id":"2305357","ufId":"23","descricao":"Icapuí"},
		{"id":"2305407","ufId":"23","descricao":"Icó"},
		{"id":"2305506","ufId":"23","descricao":"Iguatu"},
		{"id":"2305605","ufId":"23","descricao":"Independência"},
		{"id":"2305654","ufId":"23","descricao":"Ipaporanga"},
		{"id":"2305704","ufId":"23","descricao":"Ipaumirim"},
		{"id":"2305803","ufId":"23","descricao":"Ipu"},
		{"id":"2305902","ufId":"23","descricao":"Ipueiras"},
		{"id":"2306009","ufId":"23","descricao":"Iracema"},
		{"id":"2306108","ufId":"23","descricao":"Irauçuba"},
		{"id":"2306207","ufId":"23","descricao":"Itaiçaba"},
		{"id":"2306256","ufId":"23","descricao":"Itaitinga"},
		{"id":"2306306","ufId":"23","descricao":"Itapajé"},
		{"id":"2306405","ufId":"23","descricao":"Itapipoca"},
		{"id":"2306504","ufId":"23","descricao":"Itapiúna"},
		{"id":"2306553","ufId":"23","descricao":"Itarema"},
		{"id":"2306603","ufId":"23","descricao":"Itatira"},
		{"id":"2306702","ufId":"23","descricao":"Jaguaretama"},
		{"id":"2306801","ufId":"23","descricao":"Jaguaribara"},
		{"id":"2306900","ufId":"23","descricao":"Jaguaribe"},
		{"id":"2307007","ufId":"23","descricao":"Jaguaruana"},
		{"id":"2307106","ufId":"23","descricao":"Jardim"},
		{"id":"2307205","ufId":"23","descricao":"Jati"},
		{"id":"2307254","ufId":"23","descricao":"Jijoca de Jericoacoara"},
		{"id":"2307304","ufId":"23","descricao":"Juazeiro do Norte"},
		{"id":"2307403","ufId":"23","descricao":"Jucás"},
		{"id":"2307502","ufId":"23","descricao":"Lavras da Mangabeira"},
		{"id":"2307601","ufId":"23","descricao":"Limoeiro do Norte"},
		{"id":"2307635","ufId":"23","descricao":"Madalena"},
		{"id":"2307650","ufId":"23","descricao":"Maracanaú"},
		{"id":"2307700","ufId":"23","descricao":"Maranguape"},
		{"id":"2307809","ufId":"23","descricao":"Marco"},
		{"id":"2307908","ufId":"23","descricao":"Martinópole"},
		{"id":"2308005","ufId":"23","descricao":"Massapê"},
		{"id":"2308104","ufId":"23","descricao":"Mauriti"},
		{"id":"2308203","ufId":"23","descricao":"Meruoca"},
		{"id":"2308302","ufId":"23","descricao":"Milagres"},
		{"id":"2308351","ufId":"23","descricao":"Milhã"},
		{"id":"2308377","ufId":"23","descricao":"Miraíma"},
		{"id":"2308401","ufId":"23","descricao":"Missão Velha"},
		{"id":"2308500","ufId":"23","descricao":"Mombaça"},
		{"id":"2308609","ufId":"23","descricao":"Monsenhor Tabosa"},
		{"id":"2308708","ufId":"23","descricao":"Morada Nova"},
		{"id":"2308807","ufId":"23","descricao":"Moraújo"},
		{"id":"2308906","ufId":"23","descricao":"Morrinhos"},
		{"id":"2309003","ufId":"23","descricao":"Mucambo"},
		{"id":"2309102","ufId":"23","descricao":"Mulungu"},
		{"id":"2309201","ufId":"23","descricao":"Nova Olinda"},
		{"id":"2309300","ufId":"23","descricao":"Nova Russas"},
		{"id":"2309409","ufId":"23","descricao":"Novo Oriente"},
		{"id":"2309458","ufId":"23","descricao":"Ocara"},
		{"id":"2309508","ufId":"23","descricao":"Orós"},
		{"id":"2309607","ufId":"23","descricao":"Pacajus"},
		{"id":"2309706","ufId":"23","descricao":"Pacatuba"},
		{"id":"2309805","ufId":"23","descricao":"Pacoti"},
		{"id":"2309904","ufId":"23","descricao":"Pacujá"},
		{"id":"2310001","ufId":"23","descricao":"Palhano"},
		{"id":"2310100","ufId":"23","descricao":"Palmácia"},
		{"id":"2310209","ufId":"23","descricao":"Paracuru"},
		{"id":"2310258","ufId":"23","descricao":"Paraipaba"},
		{"id":"2310308","ufId":"23","descricao":"Parambu"},
		{"id":"2310407","ufId":"23","descricao":"Paramoti"},
		{"id":"2310506","ufId":"23","descricao":"Pedra Branca"},
		{"id":"2310605","ufId":"23","descricao":"Penaforte"},
		{"id":"2310704","ufId":"23","descricao":"Pentecoste"},
		{"id":"2310803","ufId":"23","descricao":"Pereiro"},
		{"id":"2310852","ufId":"23","descricao":"Pindoretama"},
		{"id":"2310902","ufId":"23","descricao":"Piquet Carneiro"},
		{"id":"2310951","ufId":"23","descricao":"Pires Ferreira"},
		{"id":"2311009","ufId":"23","descricao":"Poranga"},
		{"id":"2311108","ufId":"23","descricao":"Porteiras"},
		{"id":"2311207","ufId":"23","descricao":"Potengi"},
		{"id":"2311231","ufId":"23","descricao":"Potiretama"},
		{"id":"2311264","ufId":"23","descricao":"Quiterianópolis"},
		{"id":"2311306","ufId":"23","descricao":"Quixadá"},
		{"id":"2311355","ufId":"23","descricao":"Quixelô"},
		{"id":"2311405","ufId":"23","descricao":"Quixeramobim"},
		{"id":"2311504","ufId":"23","descricao":"Quixeré"},
		{"id":"2311603","ufId":"23","descricao":"Redenção"},
		{"id":"2311702","ufId":"23","descricao":"Reriutaba"},
		{"id":"2311801","ufId":"23","descricao":"Russas"},
		{"id":"2311900","ufId":"23","descricao":"Saboeiro"},
		{"id":"2311959","ufId":"23","descricao":"Salitre"},
		{"id":"2312205","ufId":"23","descricao":"Santa Quitéria"},
		{"id":"2312007","ufId":"23","descricao":"Santana do Acaraú"},
		{"id":"2312106","ufId":"23","descricao":"Santana do Cariri"},
		{"id":"2312304","ufId":"23","descricao":"São Benedito"},
		{"id":"2312403","ufId":"23","descricao":"São Gonçalo do Amarante"},
		{"id":"2312502","ufId":"23","descricao":"São João do Jaguaribe"},
		{"id":"2312601","ufId":"23","descricao":"São Luís do Curu"},
		{"id":"2312700","ufId":"23","descricao":"Senador Pompeu"},
		{"id":"2312809","ufId":"23","descricao":"Senador Sá"},
		{"id":"2312908","ufId":"23","descricao":"Sobral"},
		{"id":"2313005","ufId":"23","descricao":"Solonópole"},
		{"id":"2313104","ufId":"23","descricao":"Tabuleiro do Norte"},
		{"id":"2313203","ufId":"23","descricao":"Tamboril"},
		{"id":"2313252","ufId":"23","descricao":"Tarrafas"},
		{"id":"2313302","ufId":"23","descricao":"Tauá"},
		{"id":"2313351","ufId":"23","descricao":"Tejuçuoca"},
		{"id":"2313401","ufId":"23","descricao":"Tianguá"},
		{"id":"2313500","ufId":"23","descricao":"Trairi"},
		{"id":"2313559","ufId":"23","descricao":"Tururu"},
		{"id":"2313609","ufId":"23","descricao":"Ubajara"},
		{"id":"2313708","ufId":"23","descricao":"Umari"},
		{"id":"2313757","ufId":"23","descricao":"Umirim"},
		{"id":"2313807","ufId":"23","descricao":"Uruburetama"},
		{"id":"2313906","ufId":"23","descricao":"Uruoca"},
		{"id":"2313955","ufId":"23","descricao":"Varjota"},
		{"id":"2314003","ufId":"23","descricao":"Várzea Alegre"},
		{"id":"2314102","ufId":"23","descricao":"Viçosa do Ceará"}
	],
	"24": [
		{"id":"2400109","ufId":"24","descricao":"Acari"},
		{"id":"2400307","ufId":"24","descricao":"Afonso Bezerra"},
		{"id":"2400406","ufId":"24","descricao":"Água Nova"},
		{"id":"2400505","ufId":"24","descricao":"Alexandria"},
		{"id":"2400604","ufId":"24","descricao":"Almino Afonso"},
		{"id":"2400703","ufId":"24","descricao":"Alto do Rodrigues"},
		{"id":"2400802","ufId":"24","descricao":"Angicos"},
		{"id":"2400901","ufId":"24","descricao":"Antônio Martins"},
		{"id":"2401008","ufId":"24","descricao":"Apodi"},
		{"id":"2401107","ufId":"24","descricao":"Areia Branca"},
		{"id":"2401206","ufId":"24","descricao":"Arez"},
		{"id":"2400208","ufId":"24","descricao":"Assú"},
		{"id":"2401404","ufId":"24","descricao":"Baía Formosa"},
		{"id":"2401453","ufId":"24","descricao":"Baraúna"},
		{"id":"2401503","ufId":"24","descricao":"Barcelona"},
		{"id":"2401602","ufId":"24","descricao":"Bento Fernandes"},
		{"id":"2401651","ufId":"24","descricao":"Bodó"},
		{"id":"2401701","ufId":"24","descricao":"Bom Jesus"},
		{"id":"2401800","ufId":"24","descricao":"Brejinho"},
		{"id":"2401859","ufId":"24","descricao":"Caiçara do Norte"},
		{"id":"2401909","ufId":"24","descricao":"Caiçara do Rio do Vento"},
		{"id":"2402006","ufId":"24","descricao":"Caicó"},
		{"id":"2401305","ufId":"24","descricao":"Campo Grande"},
		{"id":"2402105","ufId":"24","descricao":"Campo Redondo"},
		{"id":"2402204","ufId":"24","descricao":"Canguaretama"},
		{"id":"2402303","ufId":"24","descricao":"Caraúbas"},
		{"id":"2402402","ufId":"24","descricao":"Carnaúba dos Dantas"},
		{"id":"2402501","ufId":"24","descricao":"Carnaubais"},
		{"id":"2402600","ufId":"24","descricao":"Ceará-Mirim"},
		{"id":"2402709","ufId":"24","descricao":"Cerro Corá"},
		{"id":"2402808","ufId":"24","descricao":"Coronel Ezequiel"},
		{"id":"2402907","ufId":"24","descricao":"Coronel João Pessoa"},
		{"id":"2403004","ufId":"24","descricao":"Cruzeta"},
		{"id":"2403103","ufId":"24","descricao":"Currais Novos"},
		{"id":"2403202","ufId":"24","descricao":"Doutor Severiano"},
		{"id":"2403301","ufId":"24","descricao":"Encanto"},
		{"id":"2403400","ufId":"24","descricao":"Equador"},
		{"id":"2403509","ufId":"24","descricao":"Espírito Santo"},
		{"id":"2403608","ufId":"24","descricao":"Extremoz"},
		{"id":"2403707","ufId":"24","descricao":"Felipe Guerra"},
		{"id":"2403756","ufId":"24","descricao":"Fernando Pedroza"},
		{"id":"2403806","ufId":"24","descricao":"Florânia"},
		{"id":"2403905","ufId":"24","descricao":"Francisco Dantas"},
		{"id":"2404002","ufId":"24","descricao":"Frutuoso Gomes"},
		{"id":"2404101","ufId":"24","descricao":"Galinhos"},
		{"id":"2404200","ufId":"24","descricao":"Goianinha"},
		{"id":"2404309","ufId":"24","descricao":"Governador Dix-Sept Rosado"},
		{"id":"2404408","ufId":"24","descricao":"Grossos"},
		{"id":"2404507","ufId":"24","descricao":"Guamaré"},
		{"id":"2404606","ufId":"24","descricao":"Ielmo Marinho"},
		{"id":"2404705","ufId":"24","descricao":"Ipanguaçu"},
		{"id":"2404804","ufId":"24","descricao":"Ipueira"},
		{"id":"2404853","ufId":"24","descricao":"Itajá"},
		{"id":"2404903","ufId":"24","descricao":"Itaú"},
		{"id":"2405009","ufId":"24","descricao":"Jaçanã"},
		{"id":"2405108","ufId":"24","descricao":"Jandaíra"},
		{"id":"2405207","ufId":"24","descricao":"Janduís"},
		{"id":"2405306","ufId":"24","descricao":"Januário Cicco"},
		{"id":"2405405","ufId":"24","descricao":"Japi"},
		{"id":"2405504","ufId":"24","descricao":"Jardim de Angicos"},
		{"id":"2405603","ufId":"24","descricao":"Jardim de Piranhas"},
		{"id":"2405702","ufId":"24","descricao":"Jardim do Seridó"},
		{"id":"2405801","ufId":"24","descricao":"João Câmara"},
		{"id":"2405900","ufId":"24","descricao":"João Dias"},
		{"id":"2406007","ufId":"24","descricao":"José da Penha"},
		{"id":"2406106","ufId":"24","descricao":"Jucurutu"},
		{"id":"2406155","ufId":"24","descricao":"Jundiá"},
		{"id":"2406205","ufId":"24","descricao":"Lagoa d'Anta"},
		{"id":"2406304","ufId":"24","descricao":"Lagoa de Pedras"},
		{"id":"2406403","ufId":"24","descricao":"Lagoa de Velhos"},
		{"id":"2406502","ufId":"24","descricao":"Lagoa Nova"},
		{"id":"2406601","ufId":"24","descricao":"Lagoa Salgada"},
		{"id":"2406700","ufId":"24","descricao":"Lajes"},
		{"id":"2406809","ufId":"24","descricao":"Lajes Pintadas"},
		{"id":"2406908","ufId":"24","descricao":"Lucrécia"},
		{"id":"2407005","ufId":"24","descricao":"Luís Gomes"},
		{"id":"2407104","ufId":"24","descricao":"Macaíba"},
		{"id":"2407203","ufId":"24","descricao":"Macau"},
		{"id":"2407252","ufId":"24","descricao":"Major Sales"},
		{"id":"2407302","ufId":"24","descricao":"Marcelino Vieira"},
		{"id":"2407401","ufId":"24","descricao":"Martins"},
		{"id":"2407500","ufId":"24","descricao":"Maxaranguape"},
		{"id":"2407609","ufId":"24","descricao":"Messias Targino"},
		{"id":"2407708","ufId":"24","descricao":"Montanhas"},
		{"id":"2407807","ufId":"24","descricao":"Monte Alegre"},
		{"id":"2407906","ufId":"24","descricao":"Monte das Gameleiras"},
		{"id":"2408003","ufId":"24","descricao":"Mossoró"},
		{"id":"2408102","ufId":"24","descricao":"Natal"},
		{"id":"2408201","ufId":"24","descricao":"Nísia Floresta"},
		{"id":"2408300","ufId":"24","descricao":"Nova Cruz"},
		{"id":"2408409","ufId":"24","descricao":"Olho d'Água do Borges"},
		{"id":"2408508","ufId":"24","descricao":"Ouro Branco"},
		{"id":"2408607","ufId":"24","descricao":"Paraná"},
		{"id":"2408706","ufId":"24","descricao":"Paraú"},
		{"id":"2408805","ufId":"24","descricao":"Parazinho"},
		{"id":"2408904","ufId":"24","descricao":"Parelhas"},
		{"id":"2403251","ufId":"24","descricao":"Parnamirim"},
		{"id":"2409100","ufId":"24","descricao":"Passa e Fica"},
		{"id":"2409209","ufId":"24","descricao":"Passagem"},
		{"id":"2409308","ufId":"24","descricao":"Patu"},
		{"id":"2409407","ufId":"24","descricao":"Pau dos Ferros"},
		{"id":"2409506","ufId":"24","descricao":"Pedra Grande"},
		{"id":"2409605","ufId":"24","descricao":"Pedra Preta"},
		{"id":"2409704","ufId":"24","descricao":"Pedro Avelino"},
		{"id":"2409803","ufId":"24","descricao":"Pedro Velho"},
		{"id":"2409902","ufId":"24","descricao":"Pendências"},
		{"id":"2410009","ufId":"24","descricao":"Pilões"},
		{"id":"2410108","ufId":"24","descricao":"Poço Branco"},
		{"id":"2410207","ufId":"24","descricao":"Portalegre"},
		{"id":"2410256","ufId":"24","descricao":"Porto do Mangue"},
		{"id":"2410405","ufId":"24","descricao":"Pureza"},
		{"id":"2410504","ufId":"24","descricao":"Rafael Fernandes"},
		{"id":"2410603","ufId":"24","descricao":"Rafael Godeiro"},
		{"id":"2410702","ufId":"24","descricao":"Riacho da Cruz"},
		{"id":"2410801","ufId":"24","descricao":"Riacho de Santana"},
		{"id":"2410900","ufId":"24","descricao":"Riachuelo"},
		{"id":"2408953","ufId":"24","descricao":"Rio do Fogo"},
		{"id":"2411007","ufId":"24","descricao":"Rodolfo Fernandes"},
		{"id":"2411106","ufId":"24","descricao":"Ruy Barbosa"},
		{"id":"2411205","ufId":"24","descricao":"Santa Cruz"},
		{"id":"2409332","ufId":"24","descricao":"Santa Maria"},
		{"id":"2411403","ufId":"24","descricao":"Santana do Matos"},
		{"id":"2411429","ufId":"24","descricao":"Santana do Seridó"},
		{"id":"2411502","ufId":"24","descricao":"Santo Antônio"},
		{"id":"2411601","ufId":"24","descricao":"São Bento do Norte"},
		{"id":"2411700","ufId":"24","descricao":"São Bento do Trairí"},
		{"id":"2411809","ufId":"24","descricao":"São Fernando"},
		{"id":"2411908","ufId":"24","descricao":"São Francisco do Oeste"},
		{"id":"2412005","ufId":"24","descricao":"São Gonçalo do Amarante"},
		{"id":"2412104","ufId":"24","descricao":"São João do Sabugi"},
		{"id":"2412203","ufId":"24","descricao":"São José de Mipibu"},
		{"id":"2412302","ufId":"24","descricao":"São José do Campestre"},
		{"id":"2412401","ufId":"24","descricao":"São José do Seridó"},
		{"id":"2412500","ufId":"24","descricao":"São Miguel"},
		{"id":"2412559","ufId":"24","descricao":"São Miguel do Gostoso"},
		{"id":"2412609","ufId":"24","descricao":"São Paulo do Potengi"},
		{"id":"2412708","ufId":"24","descricao":"São Pedro"},
		{"id":"2412807","ufId":"24","descricao":"São Rafael"},
		{"id":"2412906","ufId":"24","descricao":"São Tomé"},
		{"id":"2413003","ufId":"24","descricao":"São Vicente"},
		{"id":"2413102","ufId":"24","descricao":"Senador Elói de Souza"},
		{"id":"2413201","ufId":"24","descricao":"Senador Georgino Avelino"},
		{"id":"2410306","ufId":"24","descricao":"Serra Caiada"},
		{"id":"2413300","ufId":"24","descricao":"Serra de São Bento"},
		{"id":"2413359","ufId":"24","descricao":"Serra do Mel"},
		{"id":"2413409","ufId":"24","descricao":"Serra Negra do Norte"},
		{"id":"2413508","ufId":"24","descricao":"Serrinha"},
		{"id":"2413557","ufId":"24","descricao":"Serrinha dos Pintos"},
		{"id":"2413607","ufId":"24","descricao":"Severiano Melo"},
		{"id":"2413706","ufId":"24","descricao":"Sítio Novo"},
		{"id":"2413805","ufId":"24","descricao":"Taboleiro Grande"},
		{"id":"2413904","ufId":"24","descricao":"Taipu"},
		{"id":"2414001","ufId":"24","descricao":"Tangará"},
		{"id":"2414100","ufId":"24","descricao":"Tenente Ananias"},
		{"id":"2414159","ufId":"24","descricao":"Tenente Laurentino Cruz"},
		{"id":"2411056","ufId":"24","descricao":"Tibau"},
		{"id":"2414209","ufId":"24","descricao":"Tibau do Sul"},
		{"id":"2414308","ufId":"24","descricao":"Timbaúba dos Batistas"},
		{"id":"2414407","ufId":"24","descricao":"Touros"},
		{"id":"2414456","ufId":"24","descricao":"Triunfo Potiguar"},
		{"id":"2414506","ufId":"24","descricao":"Umarizal"},
		{"id":"2414605","ufId":"24","descricao":"Upanema"},
		{"id":"2414704","ufId":"24","descricao":"Várzea"},
		{"id":"2414753","ufId":"24","descricao":"Venha-Ver"},
		{"id":"2414803","ufId":"24","descricao":"Vera Cruz"},
		{"id":"2414902","ufId":"24","descricao":"Viçosa"},
		{"id":"2415008","ufId":"24","descricao":"Vila Flor"}
	],
	"25": [
		{"id":"2500106","ufId":"25","descricao":"Água Branca"},
		{"id":"2500205","ufId":"25","descricao":"Aguiar"},
		{"id":"2500304","ufId":"25","descricao":"Alagoa Grande"},
		{"id":"2500403","ufId":"25","descricao":"Alagoa Nova"},
		{"id":"2500502","ufId":"25","descricao":"Alagoinha"},
		{"id":"2500536","ufId":"25","descricao":"Alcantil"},
		{"id":"2500577","ufId":"25","descricao":"Algodão de Jandaíra"},
		{"id":"2500601","ufId":"25","descricao":"Alhandra"},
		{"id":"2500734","ufId":"25","descricao":"Amparo"},
		{"id":"2500775","ufId":"25","descricao":"Aparecida"},
		{"id":"2500809","ufId":"25","descricao":"Araçagi"},
		{"id":"2500908","ufId":"25","descricao":"Arara"},
		{"id":"2501005","ufId":"25","descricao":"Araruna"},
		{"id":"2501104","ufId":"25","descricao":"Areia"},
		{"id":"2501153","ufId":"25","descricao":"Areia de Baraúnas"},
		{"id":"2501203","ufId":"25","descricao":"Areial"},
		{"id":"2501302","ufId":"25","descricao":"Aroeiras"},
		{"id":"2501351","ufId":"25","descricao":"Assunção"},
		{"id":"2501401","ufId":"25","descricao":"Baía da Traição"},
		{"id":"2501500","ufId":"25","descricao":"Bananeiras"},
		{"id":"2501534","ufId":"25","descricao":"Baraúna"},
		{"id":"2501609","ufId":"25","descricao":"Barra de Santa Rosa"},
		{"id":"2501575","ufId":"25","descricao":"Barra de Santana"},
		{"id":"2501708","ufId":"25","descricao":"Barra de São Miguel"},
		{"id":"2501807","ufId":"25","descricao":"Bayeux"},
		{"id":"2501906","ufId":"25","descricao":"Belém"},
		{"id":"2502003","ufId":"25","descricao":"Belém do Brejo do Cruz"},
		{"id":"2502052","ufId":"25","descricao":"Bernardino Batista"},
		{"id":"2502102","ufId":"25","descricao":"Boa Ventura"},
		{"id":"2502151","ufId":"25","descricao":"Boa Vista"},
		{"id":"2502201","ufId":"25","descricao":"Bom Jesus"},
		{"id":"2502300","ufId":"25","descricao":"Bom Sucesso"},
		{"id":"2502409","ufId":"25","descricao":"Bonito de Santa Fé"},
		{"id":"2502508","ufId":"25","descricao":"Boqueirão"},
		{"id":"2502706","ufId":"25","descricao":"Borborema"},
		{"id":"2502805","ufId":"25","descricao":"Brejo do Cruz"},
		{"id":"2502904","ufId":"25","descricao":"Brejo dos Santos"},
		{"id":"2503001","ufId":"25","descricao":"Caaporã"},
		{"id":"2503100","ufId":"25","descricao":"Cabaceiras"},
		{"id":"2503209","ufId":"25","descricao":"Cabedelo"},
		{"id":"2503308","ufId":"25","descricao":"Cachoeira dos Índios"},
		{"id":"2503407","ufId":"25","descricao":"Cacimba de Areia"},
		{"id":"2503506","ufId":"25","descricao":"Cacimba de Dentro"},
		{"id":"2503555","ufId":"25","descricao":"Cacimbas"},
		{"id":"2503605","ufId":"25","descricao":"Caiçara"},
		{"id":"2503704","ufId":"25","descricao":"Cajazeiras"},
		{"id":"2503753","ufId":"25","descricao":"Cajazeirinhas"},
		{"id":"2503803","ufId":"25","descricao":"Caldas Brandão"},
		{"id":"2503902","ufId":"25","descricao":"Camalaú"},
		{"id":"2504009","ufId":"25","descricao":"Campina Grande"},
		{"id":"2504033","ufId":"25","descricao":"Capim"},
		{"id":"2504074","ufId":"25","descricao":"Caraúbas"},
		{"id":"2504108","ufId":"25","descricao":"Carrapateira"},
		{"id":"2504157","ufId":"25","descricao":"Casserengue"},
		{"id":"2504207","ufId":"25","descricao":"Catingueira"},
		{"id":"2504306","ufId":"25","descricao":"Catolé do Rocha"},
		{"id":"2504355","ufId":"25","descricao":"Caturité"},
		{"id":"2504405","ufId":"25","descricao":"Conceição"},
		{"id":"2504504","ufId":"25","descricao":"Condado"},
		{"id":"2504603","ufId":"25","descricao":"Conde"},
		{"id":"2504702","ufId":"25","descricao":"Congo"},
		{"id":"2504801","ufId":"25","descricao":"Coremas"},
		{"id":"2504850","ufId":"25","descricao":"Coxixola"},
		{"id":"2504900","ufId":"25","descricao":"Cruz do Espírito Santo"},
		{"id":"2505006","ufId":"25","descricao":"Cubati"},
		{"id":"2505105","ufId":"25","descricao":"Cuité"},
		{"id":"2505238","ufId":"25","descricao":"Cuité de Mamanguape"},
		{"id":"2505204","ufId":"25","descricao":"Cuitegi"},
		{"id":"2505279","ufId":"25","descricao":"Curral de Cima"},
		{"id":"2505303","ufId":"25","descricao":"Curral Velho"},
		{"id":"2505352","ufId":"25","descricao":"Damião"},
		{"id":"2505402","ufId":"25","descricao":"Desterro"},
		{"id":"2505600","ufId":"25","descricao":"Diamante"},
		{"id":"2505709","ufId":"25","descricao":"Dona Inês"},
		{"id":"2505808","ufId":"25","descricao":"Duas Estradas"},
		{"id":"2505907","ufId":"25","descricao":"Emas"},
		{"id":"2506004","ufId":"25","descricao":"Esperança"},
		{"id":"2506103","ufId":"25","descricao":"Fagundes"},
		{"id":"2506202","ufId":"25","descricao":"Frei Martinho"},
		{"id":"2506251","ufId":"25","descricao":"Gado Bravo"},
		{"id":"2506301","ufId":"25","descricao":"Guarabira"},
		{"id":"2506400","ufId":"25","descricao":"Gurinhém"},
		{"id":"2506509","ufId":"25","descricao":"Gurjão"},
		{"id":"2506608","ufId":"25","descricao":"Ibiara"},
		{"id":"2502607","ufId":"25","descricao":"Igaracy"},
		{"id":"2506707","ufId":"25","descricao":"Imaculada"},
		{"id":"2506806","ufId":"25","descricao":"Ingá"},
		{"id":"2506905","ufId":"25","descricao":"Itabaiana"},
		{"id":"2507002","ufId":"25","descricao":"Itaporanga"},
		{"id":"2507101","ufId":"25","descricao":"Itapororoca"},
		{"id":"2507200","ufId":"25","descricao":"Itatuba"},
		{"id":"2507309","ufId":"25","descricao":"Jacaraú"},
		{"id":"2507408","ufId":"25","descricao":"Jericó"},
		{"id":"2507507","ufId":"25","descricao":"João Pessoa"},
		{"id":"2513653","ufId":"25","descricao":"Joca Claudino"},
		{"id":"2507606","ufId":"25","descricao":"Juarez Távora"},
		{"id":"2507705","ufId":"25","descricao":"Juazeirinho"},
		{"id":"2507804","ufId":"25","descricao":"Junco do Seridó"},
		{"id":"2507903","ufId":"25","descricao":"Juripiranga"},
		{"id":"2508000","ufId":"25","descricao":"Juru"},
		{"id":"2508109","ufId":"25","descricao":"Lagoa"},
		{"id":"2508208","ufId":"25","descricao":"Lagoa de Dentro"},
		{"id":"2508307","ufId":"25","descricao":"Lagoa Seca"},
		{"id":"2508406","ufId":"25","descricao":"Lastro"},
		{"id":"2508505","ufId":"25","descricao":"Livramento"},
		{"id":"2508554","ufId":"25","descricao":"Logradouro"},
		{"id":"2508604","ufId":"25","descricao":"Lucena"},
		{"id":"2508703","ufId":"25","descricao":"Mãe d'Água"},
		{"id":"2508802","ufId":"25","descricao":"Malta"},
		{"id":"2508901","ufId":"25","descricao":"Mamanguape"},
		{"id":"2509008","ufId":"25","descricao":"Manaíra"},
		{"id":"2509057","ufId":"25","descricao":"Marcação"},
		{"id":"2509107","ufId":"25","descricao":"Mari"},
		{"id":"2509156","ufId":"25","descricao":"Marizópolis"},
		{"id":"2509206","ufId":"25","descricao":"Massaranduba"},
		{"id":"2509305","ufId":"25","descricao":"Mataraca"},
		{"id":"2509339","ufId":"25","descricao":"Matinhas"},
		{"id":"2509370","ufId":"25","descricao":"Mato Grosso"},
		{"id":"2509396","ufId":"25","descricao":"Maturéia"},
		{"id":"2509404","ufId":"25","descricao":"Mogeiro"},
		{"id":"2509503","ufId":"25","descricao":"Montadas"},
		{"id":"2509602","ufId":"25","descricao":"Monte Horebe"},
		{"id":"2509701","ufId":"25","descricao":"Monteiro"},
		{"id":"2509800","ufId":"25","descricao":"Mulungu"},
		{"id":"2509909","ufId":"25","descricao":"Natuba"},
		{"id":"2510006","ufId":"25","descricao":"Nazarezinho"},
		{"id":"2510105","ufId":"25","descricao":"Nova Floresta"},
		{"id":"2510204","ufId":"25","descricao":"Nova Olinda"},
		{"id":"2510303","ufId":"25","descricao":"Nova Palmeira"},
		{"id":"2510402","ufId":"25","descricao":"Olho d'Água"},
		{"id":"2510501","ufId":"25","descricao":"Olivedos"},
		{"id":"2510600","ufId":"25","descricao":"Ouro Velho"},
		{"id":"2510659","ufId":"25","descricao":"Parari"},
		{"id":"2510709","ufId":"25","descricao":"Passagem"},
		{"id":"2510808","ufId":"25","descricao":"Patos"},
		{"id":"2510907","ufId":"25","descricao":"Paulista"},
		{"id":"2511004","ufId":"25","descricao":"Pedra Branca"},
		{"id":"2511103","ufId":"25","descricao":"Pedra Lavrada"},
		{"id":"2511202","ufId":"25","descricao":"Pedras de Fogo"},
		{"id":"2512721","ufId":"25","descricao":"Pedro Régis"},
		{"id":"2511301","ufId":"25","descricao":"Piancó"},
		{"id":"2511400","ufId":"25","descricao":"Picuí"},
		{"id":"2511509","ufId":"25","descricao":"Pilar"},
		{"id":"2511608","ufId":"25","descricao":"Pilões"},
		{"id":"2511707","ufId":"25","descricao":"Pilõezinhos"},
		{"id":"2511806","ufId":"25","descricao":"Pirpirituba"},
		{"id":"2511905","ufId":"25","descricao":"Pitimbu"},
		{"id":"2512002","ufId":"25","descricao":"Pocinhos"},
		{"id":"2512036","ufId":"25","descricao":"Poço Dantas"},
		{"id":"2512077","ufId":"25","descricao":"Poço de José de Moura"},
		{"id":"2512101","ufId":"25","descricao":"Pombal"},
		{"id":"2512200","ufId":"25","descricao":"Prata"},
		{"id":"2512309","ufId":"25","descricao":"Princesa Isabel"},
		{"id":"2512408","ufId":"25","descricao":"Puxinanã"},
		{"id":"2512507","ufId":"25","descricao":"Queimadas"},
		{"id":"2512606","ufId":"25","descricao":"Quixaba"},
		{"id":"2512705","ufId":"25","descricao":"Remígio"},
		{"id":"2512747","ufId":"25","descricao":"Riachão"},
		{"id":"2512754","ufId":"25","descricao":"Riachão do Bacamarte"},
		{"id":"2512762","ufId":"25","descricao":"Riachão do Poço"},
		{"id":"2512788","ufId":"25","descricao":"Riacho de Santo Antônio"},
		{"id":"2512804","ufId":"25","descricao":"Riacho dos Cavalos"},
		{"id":"2512903","ufId":"25","descricao":"Rio Tinto"},
		{"id":"2513000","ufId":"25","descricao":"Salgadinho"},
		{"id":"2513109","ufId":"25","descricao":"Salgado de São Félix"},
		{"id":"2513158","ufId":"25","descricao":"Santa Cecília"},
		{"id":"2513208","ufId":"25","descricao":"Santa Cruz"},
		{"id":"2513307","ufId":"25","descricao":"Santa Helena"},
		{"id":"2513356","ufId":"25","descricao":"Santa Inês"},
		{"id":"2513406","ufId":"25","descricao":"Santa Luzia"},
		{"id":"2513703","ufId":"25","descricao":"Santa Rita"},
		{"id":"2513802","ufId":"25","descricao":"Santa Teresinha"},
		{"id":"2513505","ufId":"25","descricao":"Santana de Mangueira"},
		{"id":"2513604","ufId":"25","descricao":"Santana dos Garrotes"},
		{"id":"2513851","ufId":"25","descricao":"Santo André"},
		{"id":"2513927","ufId":"25","descricao":"São Bentinho"},
		{"id":"2513901","ufId":"25","descricao":"São Bento"},
		{"id":"2513968","ufId":"25","descricao":"São Domingos"},
		{"id":"2513943","ufId":"25","descricao":"São Domingos do Cariri"},
		{"id":"2513984","ufId":"25","descricao":"São Francisco"},
		{"id":"2514008","ufId":"25","descricao":"São João do Cariri"},
		{"id":"2500700","ufId":"25","descricao":"São João do Rio do Peixe"},
		{"id":"2514107","ufId":"25","descricao":"São João do Tigre"},
		{"id":"2514206","ufId":"25","descricao":"São José da Lagoa Tapada"},
		{"id":"2514305","ufId":"25","descricao":"São José de Caiana"},
		{"id":"2514404","ufId":"25","descricao":"São José de Espinharas"},
		{"id":"2514503","ufId":"25","descricao":"São José de Piranhas"},
		{"id":"2514552","ufId":"25","descricao":"São José de Princesa"},
		{"id":"2514602","ufId":"25","descricao":"São José do Bonfim"},
		{"id":"2514651","ufId":"25","descricao":"São José do Brejo do Cruz"},
		{"id":"2514701","ufId":"25","descricao":"São José do Sabugi"},
		{"id":"2514800","ufId":"25","descricao":"São José dos Cordeiros"},
		{"id":"2514453","ufId":"25","descricao":"São José dos Ramos"},
		{"id":"2514909","ufId":"25","descricao":"São Mamede"},
		{"id":"2515005","ufId":"25","descricao":"São Miguel de Taipu"},
		{"id":"2515104","ufId":"25","descricao":"São Sebastião de Lagoa de Roça"},
		{"id":"2515203","ufId":"25","descricao":"São Sebastião do Umbuzeiro"},
		{"id":"2515401","ufId":"25","descricao":"São Vicente do Seridó"},
		{"id":"2515302","ufId":"25","descricao":"Sapé"},
		{"id":"2515500","ufId":"25","descricao":"Serra Branca"},
		{"id":"2515609","ufId":"25","descricao":"Serra da Raiz"},
		{"id":"2515708","ufId":"25","descricao":"Serra Grande"},
		{"id":"2515807","ufId":"25","descricao":"Serra Redonda"},
		{"id":"2515906","ufId":"25","descricao":"Serraria"},
		{"id":"2515930","ufId":"25","descricao":"Sertãozinho"},
		{"id":"2515971","ufId":"25","descricao":"Sobrado"},
		{"id":"2516003","ufId":"25","descricao":"Solânea"},
		{"id":"2516102","ufId":"25","descricao":"Soledade"},
		{"id":"2516151","ufId":"25","descricao":"Sossêgo"},
		{"id":"2516201","ufId":"25","descricao":"Sousa"},
		{"id":"2516300","ufId":"25","descricao":"Sumé"},
		{"id":"2516409","ufId":"25","descricao":"Tacima"},
		{"id":"2516508","ufId":"25","descricao":"Taperoá"},
		{"id":"2516607","ufId":"25","descricao":"Tavares"},
		{"id":"2516706","ufId":"25","descricao":"Teixeira"},
		{"id":"2516755","ufId":"25","descricao":"Tenório"},
		{"id":"2516805","ufId":"25","descricao":"Triunfo"},
		{"id":"2516904","ufId":"25","descricao":"Uiraúna"},
		{"id":"2517001","ufId":"25","descricao":"Umbuzeiro"},
		{"id":"2517100","ufId":"25","descricao":"Várzea"},
		{"id":"2517209","ufId":"25","descricao":"Vieirópolis"},
		{"id":"2505501","ufId":"25","descricao":"Vista Serrana"},
		{"id":"2517407","ufId":"25","descricao":"Zabelê"}
	],
	"26": [
		{"id":"2600054","ufId":"26","descricao":"Abreu e Lima"},
		{"id":"2600104","ufId":"26","descricao":"Afogados da Ingazeira"},
		{"id":"2600203","ufId":"26","descricao":"Afrânio"},
		{"id":"2600302","ufId":"26","descricao":"Agrestina"},
		{"id":"2600401","ufId":"26","descricao":"Água Preta"},
		{"id":"2600500","ufId":"26","descricao":"Águas Belas"},
		{"id":"2600609","ufId":"26","descricao":"Alagoinha"},
		{"id":"2600708","ufId":"26","descricao":"Aliança"},
		{"id":"2600807","ufId":"26","descricao":"Altinho"},
		{"id":"2600906","ufId":"26","descricao":"Amaraji"},
		{"id":"2601003","ufId":"26","descricao":"Angelim"},
		{"id":"2601052","ufId":"26","descricao":"Araçoiaba"},
		{"id":"2601102","ufId":"26","descricao":"Araripina"},
		{"id":"2601201","ufId":"26","descricao":"Arcoverde"},
		{"id":"2601300","ufId":"26","descricao":"Barra de Guabiraba"},
		{"id":"2601409","ufId":"26","descricao":"Barreiros"},
		{"id":"2601508","ufId":"26","descricao":"Belém de Maria"},
		{"id":"2601607","ufId":"26","descricao":"Belém do São Francisco"},
		{"id":"2601706","ufId":"26","descricao":"Belo Jardim"},
		{"id":"2601805","ufId":"26","descricao":"Betânia"},
		{"id":"2601904","ufId":"26","descricao":"Bezerros"},
		{"id":"2602001","ufId":"26","descricao":"Bodocó"},
		{"id":"2602100","ufId":"26","descricao":"Bom Conselho"},
		{"id":"2602209","ufId":"26","descricao":"Bom Jardim"},
		{"id":"2602308","ufId":"26","descricao":"Bonito"},
		{"id":"2602407","ufId":"26","descricao":"Brejão"},
		{"id":"2602506","ufId":"26","descricao":"Brejinho"},
		{"id":"2602605","ufId":"26","descricao":"Brejo da Madre de Deus"},
		{"id":"2602704","ufId":"26","descricao":"Buenos Aires"},
		{"id":"2602803","ufId":"26","descricao":"Buíque"},
		{"id":"2602902","ufId":"26","descricao":"Cabo de Santo Agostinho"},
		{"id":"2603009","ufId":"26","descricao":"Cabrobó"},
		{"id":"2603108","ufId":"26","descricao":"Cachoeirinha"},
		{"id":"2603207","ufId":"26","descricao":"Caetés"},
		{"id":"2603306","ufId":"26","descricao":"Calçado"},
		{"id":"2603405","ufId":"26","descricao":"Calumbi"},
		{"id":"2603454","ufId":"26","descricao":"Camaragibe"},
		{"id":"2603504","ufId":"26","descricao":"Camocim de São Félix"},
		{"id":"2603603","ufId":"26","descricao":"Camutanga"},
		{"id":"2603702","ufId":"26","descricao":"Canhotinho"},
		{"id":"2603801","ufId":"26","descricao":"Capoeiras"},
		{"id":"2603900","ufId":"26","descricao":"Carnaíba"},
		{"id":"2603926","ufId":"26","descricao":"Carnaubeira da Penha"},
		{"id":"2604007","ufId":"26","descricao":"Carpina"},
		{"id":"2604106","ufId":"26","descricao":"Caruaru"},
		{"id":"2604155","ufId":"26","descricao":"Casinhas"},
		{"id":"2604205","ufId":"26","descricao":"Catende"},
		{"id":"2604304","ufId":"26","descricao":"Cedro"},
		{"id":"2604403","ufId":"26","descricao":"Chã de Alegria"},
		{"id":"2604502","ufId":"26","descricao":"Chã Grande"},
		{"id":"2604601","ufId":"26","descricao":"Condado"},
		{"id":"2604700","ufId":"26","descricao":"Correntes"},
		{"id":"2604809","ufId":"26","descricao":"Cortês"},
		{"id":"2604908","ufId":"26","descricao":"Cumaru"},
		{"id":"2605004","ufId":"26","descricao":"Cupira"},
		{"id":"2605103","ufId":"26","descricao":"Custódia"},
		{"id":"2605152","ufId":"26","descricao":"Dormentes"},
		{"id":"2605202","ufId":"26","descricao":"Escada"},
		{"id":"2605301","ufId":"26","descricao":"Exu"},
		{"id":"2605400","ufId":"26","descricao":"Feira Nova"},
		{"id":"2605459","ufId":"26","descricao":"Fernando de Noronha"},
		{"id":"2605509","ufId":"26","descricao":"Ferreiros"},
		{"id":"2605608","ufId":"26","descricao":"Flores"},
		{"id":"2605707","ufId":"26","descricao":"Floresta"},
		{"id":"2605806","ufId":"26","descricao":"Frei Miguelinho"},
		{"id":"2605905","ufId":"26","descricao":"Gameleira"},
		{"id":"2606002","ufId":"26","descricao":"Garanhuns"},
		{"id":"2606101","ufId":"26","descricao":"Glória do Goitá"},
		{"id":"2606200","ufId":"26","descricao":"Goiana"},
		{"id":"2606309","ufId":"26","descricao":"Granito"},
		{"id":"2606408","ufId":"26","descricao":"Gravatá"},
		{"id":"2606507","ufId":"26","descricao":"Iati"},
		{"id":"2606606","ufId":"26","descricao":"Ibimirim"},
		{"id":"2606705","ufId":"26","descricao":"Ibirajuba"},
		{"id":"2606804","ufId":"26","descricao":"Igarassu"},
		{"id":"2606903","ufId":"26","descricao":"Iguaracy"},
		{"id":"2607604","ufId":"26","descricao":"Ilha de Itamaracá"},
		{"id":"2607000","ufId":"26","descricao":"Inajá"},
		{"id":"2607109","ufId":"26","descricao":"Ingazeira"},
		{"id":"2607208","ufId":"26","descricao":"Ipojuca"},
		{"id":"2607307","ufId":"26","descricao":"Ipubi"},
		{"id":"2607406","ufId":"26","descricao":"Itacuruba"},
		{"id":"2607505","ufId":"26","descricao":"Itaíba"},
		{"id":"2607653","ufId":"26","descricao":"Itambé"},
		{"id":"2607703","ufId":"26","descricao":"Itapetim"},
		{"id":"2607752","ufId":"26","descricao":"Itapissuma"},
		{"id":"2607802","ufId":"26","descricao":"Itaquitinga"},
		{"id":"2607901","ufId":"26","descricao":"Jaboatão dos Guararapes"},
		{"id":"2607950","ufId":"26","descricao":"Jaqueira"},
		{"id":"2608008","ufId":"26","descricao":"Jataúba"},
		{"id":"2608057","ufId":"26","descricao":"Jatobá"},
		{"id":"2608107","ufId":"26","descricao":"João Alfredo"},
		{"id":"2608206","ufId":"26","descricao":"Joaquim Nabuco"},
		{"id":"2608255","ufId":"26","descricao":"Jucati"},
		{"id":"2608305","ufId":"26","descricao":"Jupi"},
		{"id":"2608404","ufId":"26","descricao":"Jurema"},
		{"id":"2608503","ufId":"26","descricao":"Lagoa de Itaenga"},
		{"id":"2608453","ufId":"26","descricao":"Lagoa do Carro"},
		{"id":"2608602","ufId":"26","descricao":"Lagoa do Ouro"},
		{"id":"2608701","ufId":"26","descricao":"Lagoa dos Gatos"},
		{"id":"2608750","ufId":"26","descricao":"Lagoa Grande"},
		{"id":"2608800","ufId":"26","descricao":"Lajedo"},
		{"id":"2608909","ufId":"26","descricao":"Limoeiro"},
		{"id":"2609006","ufId":"26","descricao":"Macaparana"},
		{"id":"2609105","ufId":"26","descricao":"Machados"},
		{"id":"2609154","ufId":"26","descricao":"Manari"},
		{"id":"2609204","ufId":"26","descricao":"Maraial"},
		{"id":"2609303","ufId":"26","descricao":"Mirandiba"},
		{"id":"2614303","ufId":"26","descricao":"Moreilândia"},
		{"id":"2609402","ufId":"26","descricao":"Moreno"},
		{"id":"2609501","ufId":"26","descricao":"Nazaré da Mata"},
		{"id":"2609600","ufId":"26","descricao":"Olinda"},
		{"id":"2609709","ufId":"26","descricao":"Orobó"},
		{"id":"2609808","ufId":"26","descricao":"Orocó"},
		{"id":"2609907","ufId":"26","descricao":"Ouricuri"},
		{"id":"2610004","ufId":"26","descricao":"Palmares"},
		{"id":"2610103","ufId":"26","descricao":"Palmeirina"},
		{"id":"2610202","ufId":"26","descricao":"Panelas"},
		{"id":"2610301","ufId":"26","descricao":"Paranatama"},
		{"id":"2610400","ufId":"26","descricao":"Parnamirim"},
		{"id":"2610509","ufId":"26","descricao":"Passira"},
		{"id":"2610608","ufId":"26","descricao":"Paudalho"},
		{"id":"2610707","ufId":"26","descricao":"Paulista"},
		{"id":"2610806","ufId":"26","descricao":"Pedra"},
		{"id":"2610905","ufId":"26","descricao":"Pesqueira"},
		{"id":"2611002","ufId":"26","descricao":"Petrolândia"},
		{"id":"2611101","ufId":"26","descricao":"Petrolina"},
		{"id":"2611200","ufId":"26","descricao":"Poção"},
		{"id":"2611309","ufId":"26","descricao":"Pombos"},
		{"id":"2611408","ufId":"26","descricao":"Primavera"},
		{"id":"2611507","ufId":"26","descricao":"Quipapá"},
		{"id":"2611533","ufId":"26","descricao":"Quixaba"},
		{"id":"2611606","ufId":"26","descricao":"Recife"},
		{"id":"2611705","ufId":"26","descricao":"Riacho das Almas"},
		{"id":"2611804","ufId":"26","descricao":"Ribeirão"},
		{"id":"2611903","ufId":"26","descricao":"Rio Formoso"},
		{"id":"2612000","ufId":"26","descricao":"Sairé"},
		{"id":"2612109","ufId":"26","descricao":"Salgadinho"},
		{"id":"2612208","ufId":"26","descricao":"Salgueiro"},
		{"id":"2612307","ufId":"26","descricao":"Saloá"},
		{"id":"2612406","ufId":"26","descricao":"Sanharó"},
		{"id":"2612455","ufId":"26","descricao":"Santa Cruz"},
		{"id":"2612471","ufId":"26","descricao":"Santa Cruz da Baixa Verde"},
		{"id":"2612505","ufId":"26","descricao":"Santa Cruz do Capibaribe"},
		{"id":"2612554","ufId":"26","descricao":"Santa Filomena"},
		{"id":"2612604","ufId":"26","descricao":"Santa Maria da Boa Vista"},
		{"id":"2612703","ufId":"26","descricao":"Santa Maria do Cambucá"},
		{"id":"2612802","ufId":"26","descricao":"Santa Terezinha"},
		{"id":"2612901","ufId":"26","descricao":"São Benedito do Sul"},
		{"id":"2613008","ufId":"26","descricao":"São Bento do Una"},
		{"id":"2613107","ufId":"26","descricao":"São Caitano"},
		{"id":"2613206","ufId":"26","descricao":"São João"},
		{"id":"2613305","ufId":"26","descricao":"São Joaquim do Monte"},
		{"id":"2613404","ufId":"26","descricao":"São José da Coroa Grande"},
		{"id":"2613503","ufId":"26","descricao":"São José do Belmonte"},
		{"id":"2613602","ufId":"26","descricao":"São José do Egito"},
		{"id":"2613701","ufId":"26","descricao":"São Lourenço da Mata"},
		{"id":"2613800","ufId":"26","descricao":"São Vicente Férrer"},
		{"id":"2613909","ufId":"26","descricao":"Serra Talhada"},
		{"id":"2614006","ufId":"26","descricao":"Serrita"},
		{"id":"2614105","ufId":"26","descricao":"Sertânia"},
		{"id":"2614204","ufId":"26","descricao":"Sirinhaém"},
		{"id":"2614402","ufId":"26","descricao":"Solidão"},
		{"id":"2614501","ufId":"26","descricao":"Surubim"},
		{"id":"2614600","ufId":"26","descricao":"Tabira"},
		{"id":"2614709","ufId":"26","descricao":"Tacaimbó"},
		{"id":"2614808","ufId":"26","descricao":"Tacaratu"},
		{"id":"2614857","ufId":"26","descricao":"Tamandaré"},
		{"id":"2615003","ufId":"26","descricao":"Taquaritinga do Norte"},
		{"id":"2615102","ufId":"26","descricao":"Terezinha"},
		{"id":"2615201","ufId":"26","descricao":"Terra Nova"},
		{"id":"2615300","ufId":"26","descricao":"Timbaúba"},
		{"id":"2615409","ufId":"26","descricao":"Toritama"},
		{"id":"2615508","ufId":"26","descricao":"Tracunhaém"},
		{"id":"2615607","ufId":"26","descricao":"Trindade"},
		{"id":"2615706","ufId":"26","descricao":"Triunfo"},
		{"id":"2615805","ufId":"26","descricao":"Tupanatinga"},
		{"id":"2615904","ufId":"26","descricao":"Tuparetama"},
		{"id":"2616001","ufId":"26","descricao":"Venturosa"},
		{"id":"2616100","ufId":"26","descricao":"Verdejante"},
		{"id":"2616183","ufId":"26","descricao":"Vertente do Lério"},
		{"id":"2616209","ufId":"26","descricao":"Vertentes"},
		{"id":"2616308","ufId":"26","descricao":"Vicência"},
		{"id":"2616407","ufId":"26","descricao":"Vitória de Santo Antão"},
		{"id":"2616506","ufId":"26","descricao":"Xexéu"}
	],
	"27": [
		{"id":"2700102","ufId":"27","descricao":"Água Branca"},
		{"id":"2700201","ufId":"27","descricao":"Anadia"},
		{"id":"2700300","ufId":"27","descricao":"Arapiraca"},
		{"id":"2700409","ufId":"27","descricao":"Atalaia"},
		{"id":"2700508","ufId":"27","descricao":"Barra de Santo Antônio"},
		{"id":"2700607","ufId":"27","descricao":"Barra de São Miguel"},
		{"id":"2700706","ufId":"27","descricao":"Batalha"},
		{"id":"2700805","ufId":"27","descricao":"Belém"},
		{"id":"2700904","ufId":"27","descricao":"Belo Monte"},
		{"id":"2701001","ufId":"27","descricao":"Boca da Mata"},
		{"id":"2701100","ufId":"27","descricao":"Branquinha"},
		{"id":"2701209","ufId":"27","descricao":"Cacimbinhas"},
		{"id":"2701308","ufId":"27","descricao":"Cajueiro"},
		{"id":"2701357","ufId":"27","descricao":"Campestre"},
		{"id":"2701407","ufId":"27","descricao":"Campo Alegre"},
		{"id":"2701506","ufId":"27","descricao":"Campo Grande"},
		{"id":"2701605","ufId":"27","descricao":"Canapi"},
		{"id":"2701704","ufId":"27","descricao":"Capela"},
		{"id":"2701803","ufId":"27","descricao":"Carneiros"},
		{"id":"2701902","ufId":"27","descricao":"Chã Preta"},
		{"id":"2702009","ufId":"27","descricao":"Coité do Nóia"},
		{"id":"2702108","ufId":"27","descricao":"Colônia Leopoldina"},
		{"id":"2702207","ufId":"27","descricao":"Coqueiro Seco"},
		{"id":"2702306","ufId":"27","descricao":"Coruripe"},
		{"id":"2702355","ufId":"27","descricao":"Craíbas"},
		{"id":"2702405","ufId":"27","descricao":"Delmiro Gouveia"},
		{"id":"2702504","ufId":"27","descricao":"Dois Riachos"},
		{"id":"2702553","ufId":"27","descricao":"Estrela de Alagoas"},
		{"id":"2702603","ufId":"27","descricao":"Feira Grande"},
		{"id":"2702702","ufId":"27","descricao":"Feliz Deserto"},
		{"id":"2702801","ufId":"27","descricao":"Flexeiras"},
		{"id":"2702900","ufId":"27","descricao":"Girau do Ponciano"},
		{"id":"2703007","ufId":"27","descricao":"Ibateguara"},
		{"id":"2703106","ufId":"27","descricao":"Igaci"},
		{"id":"2703205","ufId":"27","descricao":"Igreja Nova"},
		{"id":"2703304","ufId":"27","descricao":"Inhapi"},
		{"id":"2703403","ufId":"27","descricao":"Jacaré dos Homens"},
		{"id":"2703502","ufId":"27","descricao":"Jacuípe"},
		{"id":"2703601","ufId":"27","descricao":"Japaratinga"},
		{"id":"2703700","ufId":"27","descricao":"Jaramataia"},
		{"id":"2703759","ufId":"27","descricao":"Jequiá da Praia"},
		{"id":"2703809","ufId":"27","descricao":"Joaquim Gomes"},
		{"id":"2703908","ufId":"27","descricao":"Jundiá"},
		{"id":"2704005","ufId":"27","descricao":"Junqueiro"},
		{"id":"2704104","ufId":"27","descricao":"Lagoa da Canoa"},
		{"id":"2704203","ufId":"27","descricao":"Limoeiro de Anadia"},
		{"id":"2704302","ufId":"27","descricao":"Maceió"},
		{"id":"2704401","ufId":"27","descricao":"Major Isidoro"},
		{"id":"2704906","ufId":"27","descricao":"Mar Vermelho"},
		{"id":"2704500","ufId":"27","descricao":"Maragogi"},
		{"id":"2704609","ufId":"27","descricao":"Maravilha"},
		{"id":"2704708","ufId":"27","descricao":"Marechal Deodoro"},
		{"id":"2704807","ufId":"27","descricao":"Maribondo"},
		{"id":"2705002","ufId":"27","descricao":"Mata Grande"},
		{"id":"2705101","ufId":"27","descricao":"Matriz de Camaragibe"},
		{"id":"2705200","ufId":"27","descricao":"Messias"},
		{"id":"2705309","ufId":"27","descricao":"Minador do Negrão"},
		{"id":"2705408","ufId":"27","descricao":"Monteirópolis"},
		{"id":"2705507","ufId":"27","descricao":"Murici"},
		{"id":"2705606","ufId":"27","descricao":"Novo Lino"},
		{"id":"2705705","ufId":"27","descricao":"Olho d'Água das Flores"},
		{"id":"2705804","ufId":"27","descricao":"Olho d'Água do Casado"},
		{"id":"2705903","ufId":"27","descricao":"Olho d'Água Grande"},
		{"id":"2706000","ufId":"27","descricao":"Olivença"},
		{"id":"2706109","ufId":"27","descricao":"Ouro Branco"},
		{"id":"2706208","ufId":"27","descricao":"Palestina"},
		{"id":"2706307","ufId":"27","descricao":"Palmeira dos Índios"},
		{"id":"2706406","ufId":"27","descricao":"Pão de Açúcar"},
		{"id":"2706422","ufId":"27","descricao":"Pariconha"},
		{"id":"2706448","ufId":"27","descricao":"Paripueira"},
		{"id":"2706505","ufId":"27","descricao":"Passo de Camaragibe"},
		{"id":"2706604","ufId":"27","descricao":"Paulo Jacinto"},
		{"id":"2706703","ufId":"27","descricao":"Penedo"},
		{"id":"2706802","ufId":"27","descricao":"Piaçabuçu"},
		{"id":"2706901","ufId":"27","descricao":"Pilar"},
		{"id":"2707008","ufId":"27","descricao":"Pindoba"},
		{"id":"2707107","ufId":"27","descricao":"Piranhas"},
		{"id":"2707206","ufId":"27","descricao":"Poço das Trincheiras"},
		{"id":"2707305","ufId":"27","descricao":"Porto Calvo"},
		{"id":"2707404","ufId":"27","descricao":"Porto de Pedras"},
		{"id":"2707503","ufId":"27","descricao":"Porto Real do Colégio"},
		{"id":"2707602","ufId":"27","descricao":"Quebrangulo"},
		{"id":"2707701","ufId":"27","descricao":"Rio Largo"},
		{"id":"2707800","ufId":"27","descricao":"Roteiro"},
		{"id":"2707909","ufId":"27","descricao":"Santa Luzia do Norte"},
		{"id":"2708006","ufId":"27","descricao":"Santana do Ipanema"},
		{"id":"2708105","ufId":"27","descricao":"Santana do Mundaú"},
		{"id":"2708204","ufId":"27","descricao":"São Brás"},
		{"id":"2708303","ufId":"27","descricao":"São José da Laje"},
		{"id":"2708402","ufId":"27","descricao":"São José da Tapera"},
		{"id":"2708501","ufId":"27","descricao":"São Luís do Quitunde"},
		{"id":"2708600","ufId":"27","descricao":"São Miguel dos Campos"},
		{"id":"2708709","ufId":"27","descricao":"São Miguel dos Milagres"},
		{"id":"2708808","ufId":"27","descricao":"São Sebastião"},
		{"id":"2708907","ufId":"27","descricao":"Satuba"},
		{"id":"2708956","ufId":"27","descricao":"Senador Rui Palmeira"},
		{"id":"2709004","ufId":"27","descricao":"Tanque d'Arca"},
		{"id":"2709103","ufId":"27","descricao":"Taquarana"},
		{"id":"2709152","ufId":"27","descricao":"Teotônio Vilela"},
		{"id":"2709202","ufId":"27","descricao":"Traipu"},
		{"id":"2709301","ufId":"27","descricao":"União dos Palmares"},
		{"id":"2709400","ufId":"27","descricao":"Viçosa"}
	],
	"28": [
		{"id":"2800100","ufId":"28","descricao":"Amparo do São Francisco"},
		{"id":"2800209","ufId":"28","descricao":"Aquidabã"},
		{"id":"2800308","ufId":"28","descricao":"Aracaju"},
		{"id":"2800407","ufId":"28","descricao":"Arauá"},
		{"id":"2800506","ufId":"28","descricao":"Areia Branca"},
		{"id":"2800605","ufId":"28","descricao":"Barra dos Coqueiros"},
		{"id":"2800670","ufId":"28","descricao":"Boquim"},
		{"id":"2800704","ufId":"28","descricao":"Brejo Grande"},
		{"id":"2801009","ufId":"28","descricao":"Campo do Brito"},
		{"id":"2801108","ufId":"28","descricao":"Canhoba"},
		{"id":"2801207","ufId":"28","descricao":"Canindé de São Francisco"},
		{"id":"2801306","ufId":"28","descricao":"Capela"},
		{"id":"2801405","ufId":"28","descricao":"Carira"},
		{"id":"2801504","ufId":"28","descricao":"Carmópolis"},
		{"id":"2801603","ufId":"28","descricao":"Cedro de São João"},
		{"id":"2801702","ufId":"28","descricao":"Cristinápolis"},
		{"id":"2801900","ufId":"28","descricao":"Cumbe"},
		{"id":"2802007","ufId":"28","descricao":"Divina Pastora"},
		{"id":"2802106","ufId":"28","descricao":"Estância"},
		{"id":"2802205","ufId":"28","descricao":"Feira Nova"},
		{"id":"2802304","ufId":"28","descricao":"Frei Paulo"},
		{"id":"2802403","ufId":"28","descricao":"Gararu"},
		{"id":"2802502","ufId":"28","descricao":"General Maynard"},
		{"id":"2802601","ufId":"28","descricao":"Graccho Cardoso"},
		{"id":"2802700","ufId":"28","descricao":"Ilha das Flores"},
		{"id":"2802809","ufId":"28","descricao":"Indiaroba"},
		{"id":"2802908","ufId":"28","descricao":"Itabaiana"},
		{"id":"2803005","ufId":"28","descricao":"Itabaianinha"},
		{"id":"2803104","ufId":"28","descricao":"Itabi"},
		{"id":"2803203","ufId":"28","descricao":"Itaporanga d'Ajuda"},
		{"id":"2803302","ufId":"28","descricao":"Japaratuba"},
		{"id":"2803401","ufId":"28","descricao":"Japoatã"},
		{"id":"2803500","ufId":"28","descricao":"Lagarto"},
		{"id":"2803609","ufId":"28","descricao":"Laranjeiras"},
		{"id":"2803708","ufId":"28","descricao":"Macambira"},
		{"id":"2803807","ufId":"28","descricao":"Malhada dos Bois"},
		{"id":"2803906","ufId":"28","descricao":"Malhador"},
		{"id":"2804003","ufId":"28","descricao":"Maruim"},
		{"id":"2804102","ufId":"28","descricao":"Moita Bonita"},
		{"id":"2804201","ufId":"28","descricao":"Monte Alegre de Sergipe"},
		{"id":"2804300","ufId":"28","descricao":"Muribeca"},
		{"id":"2804409","ufId":"28","descricao":"Neópolis"},
		{"id":"2804458","ufId":"28","descricao":"Nossa Senhora Aparecida"},
		{"id":"2804508","ufId":"28","descricao":"Nossa Senhora da Glória"},
		{"id":"2804607","ufId":"28","descricao":"Nossa Senhora das Dores"},
		{"id":"2804706","ufId":"28","descricao":"Nossa Senhora de Lourdes"},
		{"id":"2804805","ufId":"28","descricao":"Nossa Senhora do Socorro"},
		{"id":"2804904","ufId":"28","descricao":"Pacatuba"},
		{"id":"2805000","ufId":"28","descricao":"Pedra Mole"},
		{"id":"2805109","ufId":"28","descricao":"Pedrinhas"},
		{"id":"2805208","ufId":"28","descricao":"Pinhão"},
		{"id":"2805307","ufId":"28","descricao":"Pirambu"},
		{"id":"2805406","ufId":"28","descricao":"Poço Redondo"},
		{"id":"2805505","ufId":"28","descricao":"Poço Verde"},
		{"id":"2805604","ufId":"28","descricao":"Porto da Folha"},
		{"id":"2805703","ufId":"28","descricao":"Propriá"},
		{"id":"2805802","ufId":"28","descricao":"Riachão do Dantas"},
		{"id":"2805901","ufId":"28","descricao":"Riachuelo"},
		{"id":"2806008","ufId":"28","descricao":"Ribeirópolis"},
		{"id":"2806107","ufId":"28","descricao":"Rosário do Catete"},
		{"id":"2806206","ufId":"28","descricao":"Salgado"},
		{"id":"2806305","ufId":"28","descricao":"Santa Luzia do Itanhy"},
		{"id":"2806503","ufId":"28","descricao":"Santa Rosa de Lima"},
		{"id":"2806404","ufId":"28","descricao":"Santana do São Francisco"},
		{"id":"2806602","ufId":"28","descricao":"Santo Amaro das Brotas"},
		{"id":"2806701","ufId":"28","descricao":"São Cristóvão"},
		{"id":"2806800","ufId":"28","descricao":"São Domingos"},
		{"id":"2806909","ufId":"28","descricao":"São Francisco"},
		{"id":"2807006","ufId":"28","descricao":"São Miguel do Aleixo"},
		{"id":"2807105","ufId":"28","descricao":"Simão Dias"},
		{"id":"2807204","ufId":"28","descricao":"Siriri"},
		{"id":"2807303","ufId":"28","descricao":"Telha"},
		{"id":"2807402","ufId":"28","descricao":"Tobias Barreto"},
		{"id":"2807501","ufId":"28","descricao":"Tomar do Geru"},
		{"id":"2807600","ufId":"28","descricao":"Umbaúba"}
	],
	"29": [
		{"id":"2900108","ufId":"29","descricao":"Abaíra"},
		{"id":"2900207","ufId":"29","descricao":"Abaré"},
		{"id":"2900306","ufId":"29","descricao":"Acajutiba"},
		{"id":"2900355","ufId":"29","descricao":"Adustina"},
		{"id":"2900405","ufId":"29","descricao":"Água Fria"},
		{"id":"2900603","ufId":"29","descricao":"Aiquara"},
		{"id":"2900702","ufId":"29","descricao":"Alagoinhas"},
		{"id":"2900801","ufId":"29","descricao":"Alcobaça"},
		{"id":"2900900","ufId":"29","descricao":"Almadina"},
		{"id":"2901007","ufId":"29","descricao":"Amargosa"},
		{"id":"2901106","ufId":"29","descricao":"Amélia Rodrigues"},
		{"id":"2901155","ufId":"29","descricao":"América Dourada"},
		{"id":"2901205","ufId":"29","descricao":"Anagé"},
		{"id":"2901304","ufId":"29","descricao":"Andaraí"},
		{"id":"2901353","ufId":"29","descricao":"Andorinha"},
		{"id":"2901403","ufId":"29","descricao":"Angical"},
		{"id":"2901502","ufId":"29","descricao":"Anguera"},
		{"id":"2901601","ufId":"29","descricao":"Antas"},
		{"id":"2901700","ufId":"29","descricao":"Antônio Cardoso"},
		{"id":"2901809","ufId":"29","descricao":"Antônio Gonçalves"},
		{"id":"2901908","ufId":"29","descricao":"Aporá"},
		{"id":"2901957","ufId":"29","descricao":"Apuarema"},
		{"id":"2902054","ufId":"29","descricao":"Araçás"},
		{"id":"2902005","ufId":"29","descricao":"Aracatu"},
		{"id":"2902104","ufId":"29","descricao":"Araci"},
		{"id":"2902203","ufId":"29","descricao":"Aramari"},
		{"id":"2902252","ufId":"29","descricao":"Arataca"},
		{"id":"2902302","ufId":"29","descricao":"Aratuípe"},
		{"id":"2902401","ufId":"29","descricao":"Aurelino Leal"},
		{"id":"2902500","ufId":"29","descricao":"Baianópolis"},
		{"id":"2902609","ufId":"29","descricao":"Baixa Grande"},
		{"id":"2902658","ufId":"29","descricao":"Banzaê"},
		{"id":"2902708","ufId":"29","descricao":"Barra"},
		{"id":"2902807","ufId":"29","descricao":"Barra da Estiva"},
		{"id":"2902906","ufId":"29","descricao":"Barra do Choça"},
		{"id":"2903003","ufId":"29","descricao":"Barra do Mendes"},
		{"id":"2903102","ufId":"29","descricao":"Barra do Rocha"},
		{"id":"2903201","ufId":"29","descricao":"Barreiras"},
		{"id":"2903235","ufId":"29","descricao":"Barro Alto"},
		{"id":"2903300","ufId":"29","descricao":"Barro Preto"},
		{"id":"2903276","ufId":"29","descricao":"Barrocas"},
		{"id":"2903409","ufId":"29","descricao":"Belmonte"},
		{"id":"2903508","ufId":"29","descricao":"Belo Campo"},
		{"id":"2903607","ufId":"29","descricao":"Biritinga"},
		{"id":"2903706","ufId":"29","descricao":"Boa Nova"},
		{"id":"2903805","ufId":"29","descricao":"Boa Vista do Tupim"},
		{"id":"2903904","ufId":"29","descricao":"Bom Jesus da Lapa"},
		{"id":"2903953","ufId":"29","descricao":"Bom Jesus da Serra"},
		{"id":"2904001","ufId":"29","descricao":"Boninal"},
		{"id":"2904050","ufId":"29","descricao":"Bonito"},
		{"id":"2904100","ufId":"29","descricao":"Boquira"},
		{"id":"2904209","ufId":"29","descricao":"Botuporã"},
		{"id":"2904308","ufId":"29","descricao":"Brejões"},
		{"id":"2904407","ufId":"29","descricao":"Brejolândia"},
		{"id":"2904506","ufId":"29","descricao":"Brotas de Macaúbas"},
		{"id":"2904605","ufId":"29","descricao":"Brumado"},
		{"id":"2904704","ufId":"29","descricao":"Buerarema"},
		{"id":"2904753","ufId":"29","descricao":"Buritirama"},
		{"id":"2904803","ufId":"29","descricao":"Caatiba"},
		{"id":"2904852","ufId":"29","descricao":"Cabaceiras do Paraguaçu"},
		{"id":"2904902","ufId":"29","descricao":"Cachoeira"},
		{"id":"2905008","ufId":"29","descricao":"Caculé"},
		{"id":"2905107","ufId":"29","descricao":"Caém"},
		{"id":"2905156","ufId":"29","descricao":"Caetanos"},
		{"id":"2905206","ufId":"29","descricao":"Caetité"},
		{"id":"2905305","ufId":"29","descricao":"Cafarnaum"},
		{"id":"2905404","ufId":"29","descricao":"Cairu"},
		{"id":"2905503","ufId":"29","descricao":"Caldeirão Grande"},
		{"id":"2905602","ufId":"29","descricao":"Camacan"},
		{"id":"2905701","ufId":"29","descricao":"Camaçari"},
		{"id":"2905800","ufId":"29","descricao":"Camamu"},
		{"id":"2905909","ufId":"29","descricao":"Campo Alegre de Lourdes"},
		{"id":"2906006","ufId":"29","descricao":"Campo Formoso"},
		{"id":"2906105","ufId":"29","descricao":"Canápolis"},
		{"id":"2906204","ufId":"29","descricao":"Canarana"},
		{"id":"2906303","ufId":"29","descricao":"Canavieiras"},
		{"id":"2906402","ufId":"29","descricao":"Candeal"},
		{"id":"2906501","ufId":"29","descricao":"Candeias"},
		{"id":"2906600","ufId":"29","descricao":"Candiba"},
		{"id":"2906709","ufId":"29","descricao":"Cândido Sales"},
		{"id":"2906808","ufId":"29","descricao":"Cansanção"},
		{"id":"2906824","ufId":"29","descricao":"Canudos"},
		{"id":"2906857","ufId":"29","descricao":"Capela do Alto Alegre"},
		{"id":"2906873","ufId":"29","descricao":"Capim Grosso"},
		{"id":"2906899","ufId":"29","descricao":"Caraíbas"},
		{"id":"2906907","ufId":"29","descricao":"Caravelas"},
		{"id":"2907004","ufId":"29","descricao":"Cardeal da Silva"},
		{"id":"2907103","ufId":"29","descricao":"Carinhanha"},
		{"id":"2907202","ufId":"29","descricao":"Casa Nova"},
		{"id":"2907301","ufId":"29","descricao":"Castro Alves"},
		{"id":"2907400","ufId":"29","descricao":"Catolândia"},
		{"id":"2907509","ufId":"29","descricao":"Catu"},
		{"id":"2907558","ufId":"29","descricao":"Caturama"},
		{"id":"2907608","ufId":"29","descricao":"Central"},
		{"id":"2907707","ufId":"29","descricao":"Chorrochó"},
		{"id":"2907806","ufId":"29","descricao":"Cícero Dantas"},
		{"id":"2907905","ufId":"29","descricao":"Cipó"},
		{"id":"2908002","ufId":"29","descricao":"Coaraci"},
		{"id":"2908101","ufId":"29","descricao":"Cocos"},
		{"id":"2908200","ufId":"29","descricao":"Conceição da Feira"},
		{"id":"2908309","ufId":"29","descricao":"Conceição do Almeida"},
		{"id":"2908408","ufId":"29","descricao":"Conceição do Coité"},
		{"id":"2908507","ufId":"29","descricao":"Conceição do Jacuípe"},
		{"id":"2908606","ufId":"29","descricao":"Conde"},
		{"id":"2908705","ufId":"29","descricao":"Condeúba"},
		{"id":"2908804","ufId":"29","descricao":"Contendas do Sincorá"},
		{"id":"2908903","ufId":"29","descricao":"Coração de Maria"},
		{"id":"2909000","ufId":"29","descricao":"Cordeiros"},
		{"id":"2909109","ufId":"29","descricao":"Coribe"},
		{"id":"2909208","ufId":"29","descricao":"Coronel João Sá"},
		{"id":"2909307","ufId":"29","descricao":"Correntina"},
		{"id":"2909406","ufId":"29","descricao":"Cotegipe"},
		{"id":"2909505","ufId":"29","descricao":"Cravolândia"},
		{"id":"2909604","ufId":"29","descricao":"Crisópolis"},
		{"id":"2909703","ufId":"29","descricao":"Cristópolis"},
		{"id":"2909802","ufId":"29","descricao":"Cruz das Almas"},
		{"id":"2909901","ufId":"29","descricao":"Curaçá"},
		{"id":"2910008","ufId":"29","descricao":"Dário Meira"},
		{"id":"2910057","ufId":"29","descricao":"Dias d'Ávila"},
		{"id":"2910107","ufId":"29","descricao":"Dom Basílio"},
		{"id":"2910206","ufId":"29","descricao":"Dom Macedo Costa"},
		{"id":"2910305","ufId":"29","descricao":"Elísio Medrado"},
		{"id":"2910404","ufId":"29","descricao":"Encruzilhada"},
		{"id":"2910503","ufId":"29","descricao":"Entre Rios"},
		{"id":"2900504","ufId":"29","descricao":"Érico Cardoso"},
		{"id":"2910602","ufId":"29","descricao":"Esplanada"},
		{"id":"2910701","ufId":"29","descricao":"Euclides da Cunha"},
		{"id":"2910727","ufId":"29","descricao":"Eunápolis"},
		{"id":"2910750","ufId":"29","descricao":"Fátima"},
		{"id":"2910776","ufId":"29","descricao":"Feira da Mata"},
		{"id":"2910800","ufId":"29","descricao":"Feira de Santana"},
		{"id":"2910859","ufId":"29","descricao":"Filadélfia"},
		{"id":"2910909","ufId":"29","descricao":"Firmino Alves"},
		{"id":"2911006","ufId":"29","descricao":"Floresta Azul"},
		{"id":"2911105","ufId":"29","descricao":"Formosa do Rio Preto"},
		{"id":"2911204","ufId":"29","descricao":"Gandu"},
		{"id":"2911253","ufId":"29","descricao":"Gavião"},
		{"id":"2911303","ufId":"29","descricao":"Gentio do Ouro"},
		{"id":"2911402","ufId":"29","descricao":"Glória"},
		{"id":"2911501","ufId":"29","descricao":"Gongogi"},
		{"id":"2911600","ufId":"29","descricao":"Governador Mangabeira"},
		{"id":"2911659","ufId":"29","descricao":"Guajeru"},
		{"id":"2911709","ufId":"29","descricao":"Guanambi"},
		{"id":"2911808","ufId":"29","descricao":"Guaratinga"},
		{"id":"2911857","ufId":"29","descricao":"Heliópolis"},
		{"id":"2911907","ufId":"29","descricao":"Iaçu"},
		{"id":"2912004","ufId":"29","descricao":"Ibiassucê"},
		{"id":"2912103","ufId":"29","descricao":"Ibicaraí"},
		{"id":"2912202","ufId":"29","descricao":"Ibicoara"},
		{"id":"2912301","ufId":"29","descricao":"Ibicuí"},
		{"id":"2912400","ufId":"29","descricao":"Ibipeba"},
		{"id":"2912509","ufId":"29","descricao":"Ibipitanga"},
		{"id":"2912608","ufId":"29","descricao":"Ibiquera"},
		{"id":"2912707","ufId":"29","descricao":"Ibirapitanga"},
		{"id":"2912806","ufId":"29","descricao":"Ibirapuã"},
		{"id":"2912905","ufId":"29","descricao":"Ibirataia"},
		{"id":"2913002","ufId":"29","descricao":"Ibitiara"},
		{"id":"2913101","ufId":"29","descricao":"Ibititá"},
		{"id":"2913200","ufId":"29","descricao":"Ibotirama"},
		{"id":"2913309","ufId":"29","descricao":"Ichu"},
		{"id":"2913408","ufId":"29","descricao":"Igaporã"},
		{"id":"2913457","ufId":"29","descricao":"Igrapiúna"},
		{"id":"2913507","ufId":"29","descricao":"Iguaí"},
		{"id":"2913606","ufId":"29","descricao":"Ilhéus"},
		{"id":"2913705","ufId":"29","descricao":"Inhambupe"},
		{"id":"2913804","ufId":"29","descricao":"Ipecaetá"},
		{"id":"2913903","ufId":"29","descricao":"Ipiaú"},
		{"id":"2914000","ufId":"29","descricao":"Ipirá"},
		{"id":"2914109","ufId":"29","descricao":"Ipupiara"},
		{"id":"2914208","ufId":"29","descricao":"Irajuba"},
		{"id":"2914307","ufId":"29","descricao":"Iramaia"},
		{"id":"2914406","ufId":"29","descricao":"Iraquara"},
		{"id":"2914505","ufId":"29","descricao":"Irará"},
		{"id":"2914604","ufId":"29","descricao":"Irecê"},
		{"id":"2914653","ufId":"29","descricao":"Itabela"},
		{"id":"2914703","ufId":"29","descricao":"Itaberaba"},
		{"id":"2914802","ufId":"29","descricao":"Itabuna"},
		{"id":"2914901","ufId":"29","descricao":"Itacaré"},
		{"id":"2915007","ufId":"29","descricao":"Itaeté"},
		{"id":"2915106","ufId":"29","descricao":"Itagi"},
		{"id":"2915205","ufId":"29","descricao":"Itagibá"},
		{"id":"2915304","ufId":"29","descricao":"Itagimirim"},
		{"id":"2915353","ufId":"29","descricao":"Itaguaçu da Bahia"},
		{"id":"2915403","ufId":"29","descricao":"Itaju do Colônia"},
		{"id":"2915502","ufId":"29","descricao":"Itajuípe"},
		{"id":"2915601","ufId":"29","descricao":"Itamaraju"},
		{"id":"2915700","ufId":"29","descricao":"Itamari"},
		{"id":"2915809","ufId":"29","descricao":"Itambé"},
		{"id":"2915908","ufId":"29","descricao":"Itanagra"},
		{"id":"2916005","ufId":"29","descricao":"Itanhém"},
		{"id":"2916104","ufId":"29","descricao":"Itaparica"},
		{"id":"2916203","ufId":"29","descricao":"Itapé"},
		{"id":"2916302","ufId":"29","descricao":"Itapebi"},
		{"id":"2916401","ufId":"29","descricao":"Itapetinga"},
		{"id":"2916500","ufId":"29","descricao":"Itapicuru"},
		{"id":"2916609","ufId":"29","descricao":"Itapitanga"},
		{"id":"2916708","ufId":"29","descricao":"Itaquara"},
		{"id":"2916807","ufId":"29","descricao":"Itarantim"},
		{"id":"2916856","ufId":"29","descricao":"Itatim"},
		{"id":"2916906","ufId":"29","descricao":"Itiruçu"},
		{"id":"2917003","ufId":"29","descricao":"Itiúba"},
		{"id":"2917102","ufId":"29","descricao":"Itororó"},
		{"id":"2917201","ufId":"29","descricao":"Ituaçu"},
		{"id":"2917300","ufId":"29","descricao":"Ituberá"},
		{"id":"2917334","ufId":"29","descricao":"Iuiu"},
		{"id":"2917359","ufId":"29","descricao":"Jaborandi"},
		{"id":"2917409","ufId":"29","descricao":"Jacaraci"},
		{"id":"2917508","ufId":"29","descricao":"Jacobina"},
		{"id":"2917607","ufId":"29","descricao":"Jaguaquara"},
		{"id":"2917706","ufId":"29","descricao":"Jaguarari"},
		{"id":"2917805","ufId":"29","descricao":"Jaguaripe"},
		{"id":"2917904","ufId":"29","descricao":"Jandaíra"},
		{"id":"2918001","ufId":"29","descricao":"Jequié"},
		{"id":"2918100","ufId":"29","descricao":"Jeremoabo"},
		{"id":"2918209","ufId":"29","descricao":"Jiquiriçá"},
		{"id":"2918308","ufId":"29","descricao":"Jitaúna"},
		{"id":"2918357","ufId":"29","descricao":"João Dourado"},
		{"id":"2918407","ufId":"29","descricao":"Juazeiro"},
		{"id":"2918456","ufId":"29","descricao":"Jucuruçu"},
		{"id":"2918506","ufId":"29","descricao":"Jussara"},
		{"id":"2918555","ufId":"29","descricao":"Jussari"},
		{"id":"2918605","ufId":"29","descricao":"Jussiape"},
		{"id":"2918704","ufId":"29","descricao":"Lafaiete Coutinho"},
		{"id":"2918753","ufId":"29","descricao":"Lagoa Real"},
		{"id":"2918803","ufId":"29","descricao":"Laje"},
		{"id":"2918902","ufId":"29","descricao":"Lajedão"},
		{"id":"2919009","ufId":"29","descricao":"Lajedinho"},
		{"id":"2919058","ufId":"29","descricao":"Lajedo do Tabocal"},
		{"id":"2919108","ufId":"29","descricao":"Lamarão"},
		{"id":"2919157","ufId":"29","descricao":"Lapão"},
		{"id":"2919207","ufId":"29","descricao":"Lauro de Freitas"},
		{"id":"2919306","ufId":"29","descricao":"Lençóis"},
		{"id":"2919405","ufId":"29","descricao":"Licínio de Almeida"},
		{"id":"2919504","ufId":"29","descricao":"Livramento de Nossa Senhora"},
		{"id":"2919553","ufId":"29","descricao":"Luís Eduardo Magalhães"},
		{"id":"2919603","ufId":"29","descricao":"Macajuba"},
		{"id":"2919702","ufId":"29","descricao":"Macarani"},
		{"id":"2919801","ufId":"29","descricao":"Macaúbas"},
		{"id":"2919900","ufId":"29","descricao":"Macururé"},
		{"id":"2919926","ufId":"29","descricao":"Madre de Deus"},
		{"id":"2919959","ufId":"29","descricao":"Maetinga"},
		{"id":"2920007","ufId":"29","descricao":"Maiquinique"},
		{"id":"2920106","ufId":"29","descricao":"Mairi"},
		{"id":"2920205","ufId":"29","descricao":"Malhada"},
		{"id":"2920304","ufId":"29","descricao":"Malhada de Pedras"},
		{"id":"2920403","ufId":"29","descricao":"Manoel Vitorino"},
		{"id":"2920452","ufId":"29","descricao":"Mansidão"},
		{"id":"2920502","ufId":"29","descricao":"Maracás"},
		{"id":"2920601","ufId":"29","descricao":"Maragogipe"},
		{"id":"2920700","ufId":"29","descricao":"Maraú"},
		{"id":"2920809","ufId":"29","descricao":"Marcionílio Souza"},
		{"id":"2920908","ufId":"29","descricao":"Mascote"},
		{"id":"2921005","ufId":"29","descricao":"Mata de São João"},
		{"id":"2921054","ufId":"29","descricao":"Matina"},
		{"id":"2921104","ufId":"29","descricao":"Medeiros Neto"},
		{"id":"2921203","ufId":"29","descricao":"Miguel Calmon"},
		{"id":"2921302","ufId":"29","descricao":"Milagres"},
		{"id":"2921401","ufId":"29","descricao":"Mirangaba"},
		{"id":"2921450","ufId":"29","descricao":"Mirante"},
		{"id":"2921500","ufId":"29","descricao":"Monte Santo"},
		{"id":"2921609","ufId":"29","descricao":"Morpará"},
		{"id":"2921708","ufId":"29","descricao":"Morro do Chapéu"},
		{"id":"2921807","ufId":"29","descricao":"Mortugaba"},
		{"id":"2921906","ufId":"29","descricao":"Mucugê"},
		{"id":"2922003","ufId":"29","descricao":"Mucuri"},
		{"id":"2922052","ufId":"29","descricao":"Mulungu do Morro"},
		{"id":"2922102","ufId":"29","descricao":"Mundo Novo"},
		{"id":"2922201","ufId":"29","descricao":"Muniz Ferreira"},
		{"id":"2922250","ufId":"29","descricao":"Muquém do São Francisco"},
		{"id":"2922300","ufId":"29","descricao":"Muritiba"},
		{"id":"2922409","ufId":"29","descricao":"Mutuípe"},
		{"id":"2922508","ufId":"29","descricao":"Nazaré"},
		{"id":"2922607","ufId":"29","descricao":"Nilo Peçanha"},
		{"id":"2922656","ufId":"29","descricao":"Nordestina"},
		{"id":"2922706","ufId":"29","descricao":"Nova Canaã"},
		{"id":"2922730","ufId":"29","descricao":"Nova Fátima"},
		{"id":"2922755","ufId":"29","descricao":"Nova Ibiá"},
		{"id":"2922805","ufId":"29","descricao":"Nova Itarana"},
		{"id":"2922854","ufId":"29","descricao":"Nova Redenção"},
		{"id":"2922904","ufId":"29","descricao":"Nova Soure"},
		{"id":"2923001","ufId":"29","descricao":"Nova Viçosa"},
		{"id":"2923035","ufId":"29","descricao":"Novo Horizonte"},
		{"id":"2923050","ufId":"29","descricao":"Novo Triunfo"},
		{"id":"2923100","ufId":"29","descricao":"Olindina"},
		{"id":"2923209","ufId":"29","descricao":"Oliveira dos Brejinhos"},
		{"id":"2923308","ufId":"29","descricao":"Ouriçangas"},
		{"id":"2923357","ufId":"29","descricao":"Ourolândia"},
		{"id":"2923407","ufId":"29","descricao":"Palmas de Monte Alto"},
		{"id":"2923506","ufId":"29","descricao":"Palmeiras"},
		{"id":"2923605","ufId":"29","descricao":"Paramirim"},
		{"id":"2923704","ufId":"29","descricao":"Paratinga"},
		{"id":"2923803","ufId":"29","descricao":"Paripiranga"},
		{"id":"2923902","ufId":"29","descricao":"Pau Brasil"},
		{"id":"2924009","ufId":"29","descricao":"Paulo Afonso"},
		{"id":"2924058","ufId":"29","descricao":"Pé de Serra"},
		{"id":"2924108","ufId":"29","descricao":"Pedrão"},
		{"id":"2924207","ufId":"29","descricao":"Pedro Alexandre"},
		{"id":"2924306","ufId":"29","descricao":"Piatã"},
		{"id":"2924405","ufId":"29","descricao":"Pilão Arcado"},
		{"id":"2924504","ufId":"29","descricao":"Pindaí"},
		{"id":"2924603","ufId":"29","descricao":"Pindobaçu"},
		{"id":"2924652","ufId":"29","descricao":"Pintadas"},
		{"id":"2924678","ufId":"29","descricao":"Piraí do Norte"},
		{"id":"2924702","ufId":"29","descricao":"Piripá"},
		{"id":"2924801","ufId":"29","descricao":"Piritiba"},
		{"id":"2924900","ufId":"29","descricao":"Planaltino"},
		{"id":"2925006","ufId":"29","descricao":"Planalto"},
		{"id":"2925105","ufId":"29","descricao":"Poções"},
		{"id":"2925204","ufId":"29","descricao":"Pojuca"},
		{"id":"2925253","ufId":"29","descricao":"Ponto Novo"},
		{"id":"2925303","ufId":"29","descricao":"Porto Seguro"},
		{"id":"2925402","ufId":"29","descricao":"Potiraguá"},
		{"id":"2925501","ufId":"29","descricao":"Prado"},
		{"id":"2925600","ufId":"29","descricao":"Presidente Dutra"},
		{"id":"2925709","ufId":"29","descricao":"Presidente Jânio Quadros"},
		{"id":"2925758","ufId":"29","descricao":"Presidente Tancredo Neves"},
		{"id":"2925808","ufId":"29","descricao":"Queimadas"},
		{"id":"2925907","ufId":"29","descricao":"Quijingue"},
		{"id":"2925931","ufId":"29","descricao":"Quixabeira"},
		{"id":"2925956","ufId":"29","descricao":"Rafael Jambeiro"},
		{"id":"2926004","ufId":"29","descricao":"Remanso"},
		{"id":"2926103","ufId":"29","descricao":"Retirolândia"},
		{"id":"2926202","ufId":"29","descricao":"Riachão das Neves"},
		{"id":"2926301","ufId":"29","descricao":"Riachão do Jacuípe"},
		{"id":"2926400","ufId":"29","descricao":"Riacho de Santana"},
		{"id":"2926509","ufId":"29","descricao":"Ribeira do Amparo"},
		{"id":"2926608","ufId":"29","descricao":"Ribeira do Pombal"},
		{"id":"2926657","ufId":"29","descricao":"Ribeirão do Largo"},
		{"id":"2926707","ufId":"29","descricao":"Rio de Contas"},
		{"id":"2926806","ufId":"29","descricao":"Rio do Antônio"},
		{"id":"2926905","ufId":"29","descricao":"Rio do Pires"},
		{"id":"2927002","ufId":"29","descricao":"Rio Real"},
		{"id":"2927101","ufId":"29","descricao":"Rodelas"},
		{"id":"2927200","ufId":"29","descricao":"Ruy Barbosa"},
		{"id":"2927309","ufId":"29","descricao":"Salinas da Margarida"},
		{"id":"2927408","ufId":"29","descricao":"Salvador"},
		{"id":"2927507","ufId":"29","descricao":"Santa Bárbara"},
		{"id":"2927606","ufId":"29","descricao":"Santa Brígida"},
		{"id":"2927705","ufId":"29","descricao":"Santa Cruz Cabrália"},
		{"id":"2927804","ufId":"29","descricao":"Santa Cruz da Vitória"},
		{"id":"2927903","ufId":"29","descricao":"Santa Inês"},
		{"id":"2928059","ufId":"29","descricao":"Santa Luzia"},
		{"id":"2928109","ufId":"29","descricao":"Santa Maria da Vitória"},
		{"id":"2928406","ufId":"29","descricao":"Santa Rita de Cássia"},
		{"id":"2928505","ufId":"29","descricao":"Santa Terezinha"},
		{"id":"2928000","ufId":"29","descricao":"Santaluz"},
		{"id":"2928208","ufId":"29","descricao":"Santana"},
		{"id":"2928307","ufId":"29","descricao":"Santanópolis"},
		{"id":"2928604","ufId":"29","descricao":"Santo Amaro"},
		{"id":"2928703","ufId":"29","descricao":"Santo Antônio de Jesus"},
		{"id":"2928802","ufId":"29","descricao":"Santo Estêvão"},
		{"id":"2928901","ufId":"29","descricao":"São Desidério"},
		{"id":"2928950","ufId":"29","descricao":"São Domingos"},
		{"id":"2929107","ufId":"29","descricao":"São Felipe"},
		{"id":"2929008","ufId":"29","descricao":"São Félix"},
		{"id":"2929057","ufId":"29","descricao":"São Félix do Coribe"},
		{"id":"2929206","ufId":"29","descricao":"São Francisco do Conde"},
		{"id":"2929255","ufId":"29","descricao":"São Gabriel"},
		{"id":"2929305","ufId":"29","descricao":"São Gonçalo dos Campos"},
		{"id":"2929354","ufId":"29","descricao":"São José da Vitória"},
		{"id":"2929370","ufId":"29","descricao":"São José do Jacuípe"},
		{"id":"2929404","ufId":"29","descricao":"São Miguel das Matas"},
		{"id":"2929503","ufId":"29","descricao":"São Sebastião do Passé"},
		{"id":"2929602","ufId":"29","descricao":"Sapeaçu"},
		{"id":"2929701","ufId":"29","descricao":"Sátiro Dias"},
		{"id":"2929750","ufId":"29","descricao":"Saubara"},
		{"id":"2929800","ufId":"29","descricao":"Saúde"},
		{"id":"2929909","ufId":"29","descricao":"Seabra"},
		{"id":"2930006","ufId":"29","descricao":"Sebastião Laranjeiras"},
		{"id":"2930105","ufId":"29","descricao":"Senhor do Bonfim"},
		{"id":"2930204","ufId":"29","descricao":"Sento Sé"},
		{"id":"2930154","ufId":"29","descricao":"Serra do Ramalho"},
		{"id":"2930303","ufId":"29","descricao":"Serra Dourada"},
		{"id":"2930402","ufId":"29","descricao":"Serra Preta"},
		{"id":"2930501","ufId":"29","descricao":"Serrinha"},
		{"id":"2930600","ufId":"29","descricao":"Serrolândia"},
		{"id":"2930709","ufId":"29","descricao":"Simões Filho"},
		{"id":"2930758","ufId":"29","descricao":"Sítio do Mato"},
		{"id":"2930766","ufId":"29","descricao":"Sítio do Quinto"},
		{"id":"2930774","ufId":"29","descricao":"Sobradinho"},
		{"id":"2930808","ufId":"29","descricao":"Souto Soares"},
		{"id":"2930907","ufId":"29","descricao":"Tabocas do Brejo Velho"},
		{"id":"2931004","ufId":"29","descricao":"Tanhaçu"},
		{"id":"2931053","ufId":"29","descricao":"Tanque Novo"},
		{"id":"2931103","ufId":"29","descricao":"Tanquinho"},
		{"id":"2931202","ufId":"29","descricao":"Taperoá"},
		{"id":"2931301","ufId":"29","descricao":"Tapiramutá"},
		{"id":"2931350","ufId":"29","descricao":"Teixeira de Freitas"},
		{"id":"2931400","ufId":"29","descricao":"Teodoro Sampaio"},
		{"id":"2931509","ufId":"29","descricao":"Teofilândia"},
		{"id":"2931608","ufId":"29","descricao":"Teolândia"},
		{"id":"2931707","ufId":"29","descricao":"Terra Nova"},
		{"id":"2931806","ufId":"29","descricao":"Tremedal"},
		{"id":"2931905","ufId":"29","descricao":"Tucano"},
		{"id":"2932002","ufId":"29","descricao":"Uauá"},
		{"id":"2932101","ufId":"29","descricao":"Ubaíra"},
		{"id":"2932200","ufId":"29","descricao":"Ubaitaba"},
		{"id":"2932309","ufId":"29","descricao":"Ubatã"},
		{"id":"2932408","ufId":"29","descricao":"Uibaí"},
		{"id":"2932457","ufId":"29","descricao":"Umburanas"},
		{"id":"2932507","ufId":"29","descricao":"Una"},
		{"id":"2932606","ufId":"29","descricao":"Urandi"},
		{"id":"2932705","ufId":"29","descricao":"Uruçuca"},
		{"id":"2932804","ufId":"29","descricao":"Utinga"},
		{"id":"2932903","ufId":"29","descricao":"Valença"},
		{"id":"2933000","ufId":"29","descricao":"Valente"},
		{"id":"2933059","ufId":"29","descricao":"Várzea da Roça"},
		{"id":"2933109","ufId":"29","descricao":"Várzea do Poço"},
		{"id":"2933158","ufId":"29","descricao":"Várzea Nova"},
		{"id":"2933174","ufId":"29","descricao":"Varzedo"},
		{"id":"2933208","ufId":"29","descricao":"Vera Cruz"},
		{"id":"2933257","ufId":"29","descricao":"Vereda"},
		{"id":"2933307","ufId":"29","descricao":"Vitória da Conquista"},
		{"id":"2933406","ufId":"29","descricao":"Wagner"},
		{"id":"2933455","ufId":"29","descricao":"Wanderley"},
		{"id":"2933505","ufId":"29","descricao":"Wenceslau Guimarães"},
		{"id":"2933604","ufId":"29","descricao":"Xique-Xique"}
	],
	"31": [
		{"id":"3100104","ufId":"31","descricao":"Abadia dos Dourados"},
		{"id":"3100203","ufId":"31","descricao":"Abaeté"},
		{"id":"3100302","ufId":"31","descricao":"Abre Campo"},
		{"id":"3100401","ufId":"31","descricao":"Acaiaca"},
		{"id":"3100500","ufId":"31","descricao":"Açucena"},
		{"id":"3100609","ufId":"31","descricao":"Água Boa"},
		{"id":"3100708","ufId":"31","descricao":"Água Comprida"},
		{"id":"3100807","ufId":"31","descricao":"Aguanil"},
		{"id":"3100906","ufId":"31","descricao":"Águas Formosas"},
		{"id":"3101003","ufId":"31","descricao":"Águas Vermelhas"},
		{"id":"3101102","ufId":"31","descricao":"Aimorés"},
		{"id":"3101201","ufId":"31","descricao":"Aiuruoca"},
		{"id":"3101300","ufId":"31","descricao":"Alagoa"},
		{"id":"3101409","ufId":"31","descricao":"Albertina"},
		{"id":"3101508","ufId":"31","descricao":"Além Paraíba"},
		{"id":"3101607","ufId":"31","descricao":"Alfenas"},
		{"id":"3101631","ufId":"31","descricao":"Alfredo Vasconcelos"},
		{"id":"3101706","ufId":"31","descricao":"Almenara"},
		{"id":"3101805","ufId":"31","descricao":"Alpercata"},
		{"id":"3101904","ufId":"31","descricao":"Alpinópolis"},
		{"id":"3102001","ufId":"31","descricao":"Alterosa"},
		{"id":"3102050","ufId":"31","descricao":"Alto Caparaó"},
		{"id":"3153509","ufId":"31","descricao":"Alto Jequitibá"},
		{"id":"3102100","ufId":"31","descricao":"Alto Rio Doce"},
		{"id":"3102209","ufId":"31","descricao":"Alvarenga"},
		{"id":"3102308","ufId":"31","descricao":"Alvinópolis"},
		{"id":"3102407","ufId":"31","descricao":"Alvorada de Minas"},
		{"id":"3102506","ufId":"31","descricao":"Amparo do Serra"},
		{"id":"3102605","ufId":"31","descricao":"Andradas"},
		{"id":"3102803","ufId":"31","descricao":"Andrelândia"},
		{"id":"3102852","ufId":"31","descricao":"Angelândia"},
		{"id":"3102902","ufId":"31","descricao":"Antônio Carlos"},
		{"id":"3103009","ufId":"31","descricao":"Antônio Dias"},
		{"id":"3103108","ufId":"31","descricao":"Antônio Prado de Minas"},
		{"id":"3103207","ufId":"31","descricao":"Araçaí"},
		{"id":"3103306","ufId":"31","descricao":"Aracitaba"},
		{"id":"3103405","ufId":"31","descricao":"Araçuaí"},
		{"id":"3103504","ufId":"31","descricao":"Araguari"},
		{"id":"3103603","ufId":"31","descricao":"Arantina"},
		{"id":"3103702","ufId":"31","descricao":"Araponga"},
		{"id":"3103751","ufId":"31","descricao":"Araporã"},
		{"id":"3103801","ufId":"31","descricao":"Arapuá"},
		{"id":"3103900","ufId":"31","descricao":"Araújos"},
		{"id":"3104007","ufId":"31","descricao":"Araxá"},
		{"id":"3104106","ufId":"31","descricao":"Arceburgo"},
		{"id":"3104205","ufId":"31","descricao":"Arcos"},
		{"id":"3104304","ufId":"31","descricao":"Areado"},
		{"id":"3104403","ufId":"31","descricao":"Argirita"},
		{"id":"3104452","ufId":"31","descricao":"Aricanduva"},
		{"id":"3104502","ufId":"31","descricao":"Arinos"},
		{"id":"3104601","ufId":"31","descricao":"Astolfo Dutra"},
		{"id":"3104700","ufId":"31","descricao":"Ataléia"},
		{"id":"3104809","ufId":"31","descricao":"Augusto de Lima"},
		{"id":"3104908","ufId":"31","descricao":"Baependi"},
		{"id":"3105004","ufId":"31","descricao":"Baldim"},
		{"id":"3105103","ufId":"31","descricao":"Bambuí"},
		{"id":"3105202","ufId":"31","descricao":"Bandeira"},
		{"id":"3105301","ufId":"31","descricao":"Bandeira do Sul"},
		{"id":"3105400","ufId":"31","descricao":"Barão de Cocais"},
		{"id":"3105509","ufId":"31","descricao":"Barão do Monte Alto"},
		{"id":"3105608","ufId":"31","descricao":"Barbacena"},
		{"id":"3105707","ufId":"31","descricao":"Barra Longa"},
		{"id":"3105905","ufId":"31","descricao":"Barroso"},
		{"id":"3106002","ufId":"31","descricao":"Bela Vista de Minas"},
		{"id":"3106101","ufId":"31","descricao":"Belmiro Braga"},
		{"id":"3106200","ufId":"31","descricao":"Belo Horizonte"},
		{"id":"3106309","ufId":"31","descricao":"Belo Oriente"},
		{"id":"3106408","ufId":"31","descricao":"Belo Vale"},
		{"id":"3106507","ufId":"31","descricao":"Berilo"},
		{"id":"3106655","ufId":"31","descricao":"Berizal"},
		{"id":"3106606","ufId":"31","descricao":"Bertópolis"},
		{"id":"3106705","ufId":"31","descricao":"Betim"},
		{"id":"3106804","ufId":"31","descricao":"Bias Fortes"},
		{"id":"3106903","ufId":"31","descricao":"Bicas"},
		{"id":"3107000","ufId":"31","descricao":"Biquinhas"},
		{"id":"3107109","ufId":"31","descricao":"Boa Esperança"},
		{"id":"3107208","ufId":"31","descricao":"Bocaina de Minas"},
		{"id":"3107307","ufId":"31","descricao":"Bocaiúva"},
		{"id":"3107406","ufId":"31","descricao":"Bom Despacho"},
		{"id":"3107505","ufId":"31","descricao":"Bom Jardim de Minas"},
		{"id":"3107604","ufId":"31","descricao":"Bom Jesus da Penha"},
		{"id":"3107703","ufId":"31","descricao":"Bom Jesus do Amparo"},
		{"id":"3107802","ufId":"31","descricao":"Bom Jesus do Galho"},
		{"id":"3107901","ufId":"31","descricao":"Bom Repouso"},
		{"id":"3108008","ufId":"31","descricao":"Bom Sucesso"},
		{"id":"3108107","ufId":"31","descricao":"Bonfim"},
		{"id":"3108206","ufId":"31","descricao":"Bonfinópolis de Minas"},
		{"id":"3108255","ufId":"31","descricao":"Bonito de Minas"},
		{"id":"3108305","ufId":"31","descricao":"Borda da Mata"},
		{"id":"3108404","ufId":"31","descricao":"Botelhos"},
		{"id":"3108503","ufId":"31","descricao":"Botumirim"},
		{"id":"3108701","ufId":"31","descricao":"Brás Pires"},
		{"id":"3108552","ufId":"31","descricao":"Brasilândia de Minas"},
		{"id":"3108602","ufId":"31","descricao":"Brasília de Minas"},
		{"id":"3108800","ufId":"31","descricao":"Braúnas"},
		{"id":"3108909","ufId":"31","descricao":"Brazópolis"},
		{"id":"3109006","ufId":"31","descricao":"Brumadinho"},
		{"id":"3109105","ufId":"31","descricao":"Bueno Brandão"},
		{"id":"3109204","ufId":"31","descricao":"Buenópolis"},
		{"id":"3109253","ufId":"31","descricao":"Bugre"},
		{"id":"3109303","ufId":"31","descricao":"Buritis"},
		{"id":"3109402","ufId":"31","descricao":"Buritizeiro"},
		{"id":"3109451","ufId":"31","descricao":"Cabeceira Grande"},
		{"id":"3109501","ufId":"31","descricao":"Cabo Verde"},
		{"id":"3109600","ufId":"31","descricao":"Cachoeira da Prata"},
		{"id":"3109709","ufId":"31","descricao":"Cachoeira de Minas"},
		{"id":"3102704","ufId":"31","descricao":"Cachoeira de Pajeú"},
		{"id":"3109808","ufId":"31","descricao":"Cachoeira Dourada"},
		{"id":"3109907","ufId":"31","descricao":"Caetanópolis"},
		{"id":"3110004","ufId":"31","descricao":"Caeté"},
		{"id":"3110103","ufId":"31","descricao":"Caiana"},
		{"id":"3110202","ufId":"31","descricao":"Cajuri"},
		{"id":"3110301","ufId":"31","descricao":"Caldas"},
		{"id":"3110400","ufId":"31","descricao":"Camacho"},
		{"id":"3110509","ufId":"31","descricao":"Camanducaia"},
		{"id":"3110608","ufId":"31","descricao":"Cambuí"},
		{"id":"3110707","ufId":"31","descricao":"Cambuquira"},
		{"id":"3110806","ufId":"31","descricao":"Campanário"},
		{"id":"3110905","ufId":"31","descricao":"Campanha"},
		{"id":"3111002","ufId":"31","descricao":"Campestre"},
		{"id":"3111101","ufId":"31","descricao":"Campina Verde"},
		{"id":"3111150","ufId":"31","descricao":"Campo Azul"},
		{"id":"3111200","ufId":"31","descricao":"Campo Belo"},
		{"id":"3111309","ufId":"31","descricao":"Campo do Meio"},
		{"id":"3111408","ufId":"31","descricao":"Campo Florido"},
		{"id":"3111507","ufId":"31","descricao":"Campos Altos"},
		{"id":"3111606","ufId":"31","descricao":"Campos Gerais"},
		{"id":"3111903","ufId":"31","descricao":"Cana Verde"},
		{"id":"3111705","ufId":"31","descricao":"Canaã"},
		{"id":"3111804","ufId":"31","descricao":"Canápolis"},
		{"id":"3112000","ufId":"31","descricao":"Candeias"},
		{"id":"3112059","ufId":"31","descricao":"Cantagalo"},
		{"id":"3112109","ufId":"31","descricao":"Caparaó"},
		{"id":"3112208","ufId":"31","descricao":"Capela Nova"},
		{"id":"3112307","ufId":"31","descricao":"Capelinha"},
		{"id":"3112406","ufId":"31","descricao":"Capetinga"},
		{"id":"3112505","ufId":"31","descricao":"Capim Branco"},
		{"id":"3112604","ufId":"31","descricao":"Capinópolis"},
		{"id":"3112653","ufId":"31","descricao":"Capitão Andrade"},
		{"id":"3112703","ufId":"31","descricao":"Capitão Enéas"},
		{"id":"3112802","ufId":"31","descricao":"Capitólio"},
		{"id":"3112901","ufId":"31","descricao":"Caputira"},
		{"id":"3113008","ufId":"31","descricao":"Caraí"},
		{"id":"3113107","ufId":"31","descricao":"Caranaíba"},
		{"id":"3113206","ufId":"31","descricao":"Carandaí"},
		{"id":"3113305","ufId":"31","descricao":"Carangola"},
		{"id":"3113404","ufId":"31","descricao":"Caratinga"},
		{"id":"3113503","ufId":"31","descricao":"Carbonita"},
		{"id":"3113602","ufId":"31","descricao":"Careaçu"},
		{"id":"3113701","ufId":"31","descricao":"Carlos Chagas"},
		{"id":"3113800","ufId":"31","descricao":"Carmésia"},
		{"id":"3113909","ufId":"31","descricao":"Carmo da Cachoeira"},
		{"id":"3114006","ufId":"31","descricao":"Carmo da Mata"},
		{"id":"3114105","ufId":"31","descricao":"Carmo de Minas"},
		{"id":"3114204","ufId":"31","descricao":"Carmo do Cajuru"},
		{"id":"3114303","ufId":"31","descricao":"Carmo do Paranaíba"},
		{"id":"3114402","ufId":"31","descricao":"Carmo do Rio Claro"},
		{"id":"3114501","ufId":"31","descricao":"Carmópolis de Minas"},
		{"id":"3114550","ufId":"31","descricao":"Carneirinho"},
		{"id":"3114600","ufId":"31","descricao":"Carrancas"},
		{"id":"3114709","ufId":"31","descricao":"Carvalhópolis"},
		{"id":"3114808","ufId":"31","descricao":"Carvalhos"},
		{"id":"3114907","ufId":"31","descricao":"Casa Grande"},
		{"id":"3115003","ufId":"31","descricao":"Cascalho Rico"},
		{"id":"3115102","ufId":"31","descricao":"Cássia"},
		{"id":"3115300","ufId":"31","descricao":"Cataguases"},
		{"id":"3115359","ufId":"31","descricao":"Catas Altas"},
		{"id":"3115409","ufId":"31","descricao":"Catas Altas da Noruega"},
		{"id":"3115458","ufId":"31","descricao":"Catuji"},
		{"id":"3115474","ufId":"31","descricao":"Catuti"},
		{"id":"3115508","ufId":"31","descricao":"Caxambu"},
		{"id":"3115607","ufId":"31","descricao":"Cedro do Abaeté"},
		{"id":"3115706","ufId":"31","descricao":"Central de Minas"},
		{"id":"3115805","ufId":"31","descricao":"Centralina"},
		{"id":"3115904","ufId":"31","descricao":"Chácara"},
		{"id":"3116001","ufId":"31","descricao":"Chalé"},
		{"id":"3116100","ufId":"31","descricao":"Chapada do Norte"},
		{"id":"3116159","ufId":"31","descricao":"Chapada Gaúcha"},
		{"id":"3116209","ufId":"31","descricao":"Chiador"},
		{"id":"3116308","ufId":"31","descricao":"Cipotânea"},
		{"id":"3116407","ufId":"31","descricao":"Claraval"},
		{"id":"3116506","ufId":"31","descricao":"Claro dos Poções"},
		{"id":"3116605","ufId":"31","descricao":"Cláudio"},
		{"id":"3116704","ufId":"31","descricao":"Coimbra"},
		{"id":"3116803","ufId":"31","descricao":"Coluna"},
		{"id":"3116902","ufId":"31","descricao":"Comendador Gomes"},
		{"id":"3117009","ufId":"31","descricao":"Comercinho"},
		{"id":"3117108","ufId":"31","descricao":"Conceição da Aparecida"},
		{"id":"3115201","ufId":"31","descricao":"Conceição da Barra de Minas"},
		{"id":"3117306","ufId":"31","descricao":"Conceição das Alagoas"},
		{"id":"3117207","ufId":"31","descricao":"Conceição das Pedras"},
		{"id":"3117405","ufId":"31","descricao":"Conceição de Ipanema"},
		{"id":"3117504","ufId":"31","descricao":"Conceição do Mato Dentro"},
		{"id":"3117603","ufId":"31","descricao":"Conceição do Pará"},
		{"id":"3117702","ufId":"31","descricao":"Conceição do Rio Verde"},
		{"id":"3117801","ufId":"31","descricao":"Conceição dos Ouros"},
		{"id":"3117836","ufId":"31","descricao":"Cônego Marinho"},
		{"id":"3117876","ufId":"31","descricao":"Confins"},
		{"id":"3117900","ufId":"31","descricao":"Congonhal"},
		{"id":"3118007","ufId":"31","descricao":"Congonhas"},
		{"id":"3118106","ufId":"31","descricao":"Congonhas do Norte"},
		{"id":"3118205","ufId":"31","descricao":"Conquista"},
		{"id":"3118304","ufId":"31","descricao":"Conselheiro Lafaiete"},
		{"id":"3118403","ufId":"31","descricao":"Conselheiro Pena"},
		{"id":"3118502","ufId":"31","descricao":"Consolação"},
		{"id":"3118601","ufId":"31","descricao":"Contagem"},
		{"id":"3118700","ufId":"31","descricao":"Coqueiral"},
		{"id":"3118809","ufId":"31","descricao":"Coração de Jesus"},
		{"id":"3118908","ufId":"31","descricao":"Cordisburgo"},
		{"id":"3119005","ufId":"31","descricao":"Cordislândia"},
		{"id":"3119104","ufId":"31","descricao":"Corinto"},
		{"id":"3119203","ufId":"31","descricao":"Coroaci"},
		{"id":"3119302","ufId":"31","descricao":"Coromandel"},
		{"id":"3119401","ufId":"31","descricao":"Coronel Fabriciano"},
		{"id":"3119500","ufId":"31","descricao":"Coronel Murta"},
		{"id":"3119609","ufId":"31","descricao":"Coronel Pacheco"},
		{"id":"3119708","ufId":"31","descricao":"Coronel Xavier Chaves"},
		{"id":"3119807","ufId":"31","descricao":"Córrego Danta"},
		{"id":"3119906","ufId":"31","descricao":"Córrego do Bom Jesus"},
		{"id":"3119955","ufId":"31","descricao":"Córrego Fundo"},
		{"id":"3120003","ufId":"31","descricao":"Córrego Novo"},
		{"id":"3120102","ufId":"31","descricao":"Couto de Magalhães de Minas"},
		{"id":"3120151","ufId":"31","descricao":"Crisólita"},
		{"id":"3120201","ufId":"31","descricao":"Cristais"},
		{"id":"3120300","ufId":"31","descricao":"Cristália"},
		{"id":"3120409","ufId":"31","descricao":"Cristiano Otoni"},
		{"id":"3120508","ufId":"31","descricao":"Cristina"},
		{"id":"3120607","ufId":"31","descricao":"Crucilândia"},
		{"id":"3120706","ufId":"31","descricao":"Cruzeiro da Fortaleza"},
		{"id":"3120805","ufId":"31","descricao":"Cruzília"},
		{"id":"3120839","ufId":"31","descricao":"Cuparaque"},
		{"id":"3120870","ufId":"31","descricao":"Curral de Dentro"},
		{"id":"3120904","ufId":"31","descricao":"Curvelo"},
		{"id":"3121001","ufId":"31","descricao":"Datas"},
		{"id":"3121100","ufId":"31","descricao":"Delfim Moreira"},
		{"id":"3121209","ufId":"31","descricao":"Delfinópolis"},
		{"id":"3121258","ufId":"31","descricao":"Delta"},
		{"id":"3121308","ufId":"31","descricao":"Descoberto"},
		{"id":"3121407","ufId":"31","descricao":"Desterro de Entre Rios"},
		{"id":"3121506","ufId":"31","descricao":"Desterro do Melo"},
		{"id":"3121605","ufId":"31","descricao":"Diamantina"},
		{"id":"3121704","ufId":"31","descricao":"Diogo de Vasconcelos"},
		{"id":"3121803","ufId":"31","descricao":"Dionísio"},
		{"id":"3121902","ufId":"31","descricao":"Divinésia"},
		{"id":"3122009","ufId":"31","descricao":"Divino"},
		{"id":"3122108","ufId":"31","descricao":"Divino das Laranjeiras"},
		{"id":"3122207","ufId":"31","descricao":"Divinolândia de Minas"},
		{"id":"3122306","ufId":"31","descricao":"Divinópolis"},
		{"id":"3122355","ufId":"31","descricao":"Divisa Alegre"},
		{"id":"3122405","ufId":"31","descricao":"Divisa Nova"},
		{"id":"3122454","ufId":"31","descricao":"Divisópolis"},
		{"id":"3122470","ufId":"31","descricao":"Dom Bosco"},
		{"id":"3122504","ufId":"31","descricao":"Dom Cavati"},
		{"id":"3122603","ufId":"31","descricao":"Dom Joaquim"},
		{"id":"3122702","ufId":"31","descricao":"Dom Silvério"},
		{"id":"3122801","ufId":"31","descricao":"Dom Viçoso"},
		{"id":"3122900","ufId":"31","descricao":"Dona Euzébia"},
		{"id":"3123007","ufId":"31","descricao":"Dores de Campos"},
		{"id":"3123106","ufId":"31","descricao":"Dores de Guanhães"},
		{"id":"3123205","ufId":"31","descricao":"Dores do Indaiá"},
		{"id":"3123304","ufId":"31","descricao":"Dores do Turvo"},
		{"id":"3123403","ufId":"31","descricao":"Doresópolis"},
		{"id":"3123502","ufId":"31","descricao":"Douradoquara"},
		{"id":"3123528","ufId":"31","descricao":"Durandé"},
		{"id":"3123601","ufId":"31","descricao":"Elói Mendes"},
		{"id":"3123700","ufId":"31","descricao":"Engenheiro Caldas"},
		{"id":"3123809","ufId":"31","descricao":"Engenheiro Navarro"},
		{"id":"3123858","ufId":"31","descricao":"Entre Folhas"},
		{"id":"3123908","ufId":"31","descricao":"Entre Rios de Minas"},
		{"id":"3124005","ufId":"31","descricao":"Ervália"},
		{"id":"3124104","ufId":"31","descricao":"Esmeraldas"},
		{"id":"3124203","ufId":"31","descricao":"Espera Feliz"},
		{"id":"3124302","ufId":"31","descricao":"Espinosa"},
		{"id":"3124401","ufId":"31","descricao":"Espírito Santo do Dourado"},
		{"id":"3124500","ufId":"31","descricao":"Estiva"},
		{"id":"3124609","ufId":"31","descricao":"Estrela Dalva"},
		{"id":"3124708","ufId":"31","descricao":"Estrela do Indaiá"},
		{"id":"3124807","ufId":"31","descricao":"Estrela do Sul"},
		{"id":"3124906","ufId":"31","descricao":"Eugenópolis"},
		{"id":"3125002","ufId":"31","descricao":"Ewbank da Câmara"},
		{"id":"3125101","ufId":"31","descricao":"Extrema"},
		{"id":"3125200","ufId":"31","descricao":"Fama"},
		{"id":"3125309","ufId":"31","descricao":"Faria Lemos"},
		{"id":"3125408","ufId":"31","descricao":"Felício dos Santos"},
		{"id":"3125606","ufId":"31","descricao":"Felisburgo"},
		{"id":"3125705","ufId":"31","descricao":"Felixlândia"},
		{"id":"3125804","ufId":"31","descricao":"Fernandes Tourinho"},
		{"id":"3125903","ufId":"31","descricao":"Ferros"},
		{"id":"3125952","ufId":"31","descricao":"Fervedouro"},
		{"id":"3126000","ufId":"31","descricao":"Florestal"},
		{"id":"3126109","ufId":"31","descricao":"Formiga"},
		{"id":"3126208","ufId":"31","descricao":"Formoso"},
		{"id":"3126307","ufId":"31","descricao":"Fortaleza de Minas"},
		{"id":"3126406","ufId":"31","descricao":"Fortuna de Minas"},
		{"id":"3126505","ufId":"31","descricao":"Francisco Badaró"},
		{"id":"3126604","ufId":"31","descricao":"Francisco Dumont"},
		{"id":"3126703","ufId":"31","descricao":"Francisco Sá"},
		{"id":"3126752","ufId":"31","descricao":"Franciscópolis"},
		{"id":"3126802","ufId":"31","descricao":"Frei Gaspar"},
		{"id":"3126901","ufId":"31","descricao":"Frei Inocêncio"},
		{"id":"3126950","ufId":"31","descricao":"Frei Lagonegro"},
		{"id":"3127008","ufId":"31","descricao":"Fronteira"},
		{"id":"3127057","ufId":"31","descricao":"Fronteira dos Vales"},
		{"id":"3127073","ufId":"31","descricao":"Fruta de Leite"},
		{"id":"3127107","ufId":"31","descricao":"Frutal"},
		{"id":"3127206","ufId":"31","descricao":"Funilândia"},
		{"id":"3127305","ufId":"31","descricao":"Galiléia"},
		{"id":"3127339","ufId":"31","descricao":"Gameleiras"},
		{"id":"3127354","ufId":"31","descricao":"Glaucilândia"},
		{"id":"3127370","ufId":"31","descricao":"Goiabeira"},
		{"id":"3127388","ufId":"31","descricao":"Goianá"},
		{"id":"3127404","ufId":"31","descricao":"Gonçalves"},
		{"id":"3127503","ufId":"31","descricao":"Gonzaga"},
		{"id":"3127602","ufId":"31","descricao":"Gouveia"},
		{"id":"3127701","ufId":"31","descricao":"Governador Valadares"},
		{"id":"3127800","ufId":"31","descricao":"Grão Mogol"},
		{"id":"3127909","ufId":"31","descricao":"Grupiara"},
		{"id":"3128006","ufId":"31","descricao":"Guanhães"},
		{"id":"3128105","ufId":"31","descricao":"Guapé"},
		{"id":"3128204","ufId":"31","descricao":"Guaraciaba"},
		{"id":"3128253","ufId":"31","descricao":"Guaraciama"},
		{"id":"3128303","ufId":"31","descricao":"Guaranésia"},
		{"id":"3128402","ufId":"31","descricao":"Guarani"},
		{"id":"3128501","ufId":"31","descricao":"Guarará"},
		{"id":"3128600","ufId":"31","descricao":"Guarda-Mor"},
		{"id":"3128709","ufId":"31","descricao":"Guaxupé"},
		{"id":"3128808","ufId":"31","descricao":"Guidoval"},
		{"id":"3128907","ufId":"31","descricao":"Guimarânia"},
		{"id":"3129004","ufId":"31","descricao":"Guiricema"},
		{"id":"3129103","ufId":"31","descricao":"Gurinhatã"},
		{"id":"3129202","ufId":"31","descricao":"Heliodora"},
		{"id":"3129301","ufId":"31","descricao":"Iapu"},
		{"id":"3129400","ufId":"31","descricao":"Ibertioga"},
		{"id":"3129509","ufId":"31","descricao":"Ibiá"},
		{"id":"3129608","ufId":"31","descricao":"Ibiaí"},
		{"id":"3129657","ufId":"31","descricao":"Ibiracatu"},
		{"id":"3129707","ufId":"31","descricao":"Ibiraci"},
		{"id":"3129806","ufId":"31","descricao":"Ibirité"},
		{"id":"3129905","ufId":"31","descricao":"Ibitiúra de Minas"},
		{"id":"3130002","ufId":"31","descricao":"Ibituruna"},
		{"id":"3130051","ufId":"31","descricao":"Icaraí de Minas"},
		{"id":"3130101","ufId":"31","descricao":"Igarapé"},
		{"id":"3130200","ufId":"31","descricao":"Igaratinga"},
		{"id":"3130309","ufId":"31","descricao":"Iguatama"},
		{"id":"3130408","ufId":"31","descricao":"Ijaci"},
		{"id":"3130507","ufId":"31","descricao":"Ilicínea"},
		{"id":"3130556","ufId":"31","descricao":"Imbé de Minas"},
		{"id":"3130606","ufId":"31","descricao":"Inconfidentes"},
		{"id":"3130655","ufId":"31","descricao":"Indaiabira"},
		{"id":"3130705","ufId":"31","descricao":"Indianópolis"},
		{"id":"3130804","ufId":"31","descricao":"Ingaí"},
		{"id":"3130903","ufId":"31","descricao":"Inhapim"},
		{"id":"3131000","ufId":"31","descricao":"Inhaúma"},
		{"id":"3131109","ufId":"31","descricao":"Inimutaba"},
		{"id":"3131158","ufId":"31","descricao":"Ipaba"},
		{"id":"3131208","ufId":"31","descricao":"Ipanema"},
		{"id":"3131307","ufId":"31","descricao":"Ipatinga"},
		{"id":"3131406","ufId":"31","descricao":"Ipiaçu"},
		{"id":"3131505","ufId":"31","descricao":"Ipuiúna"},
		{"id":"3131604","ufId":"31","descricao":"Iraí de Minas"},
		{"id":"3131703","ufId":"31","descricao":"Itabira"},
		{"id":"3131802","ufId":"31","descricao":"Itabirinha"},
		{"id":"3131901","ufId":"31","descricao":"Itabirito"},
		{"id":"3132008","ufId":"31","descricao":"Itacambira"},
		{"id":"3132107","ufId":"31","descricao":"Itacarambi"},
		{"id":"3132206","ufId":"31","descricao":"Itaguara"},
		{"id":"3132305","ufId":"31","descricao":"Itaipé"},
		{"id":"3132404","ufId":"31","descricao":"Itajubá"},
		{"id":"3132503","ufId":"31","descricao":"Itamarandiba"},
		{"id":"3132602","ufId":"31","descricao":"Itamarati de Minas"},
		{"id":"3132701","ufId":"31","descricao":"Itambacuri"},
		{"id":"3132800","ufId":"31","descricao":"Itambé do Mato Dentro"},
		{"id":"3132909","ufId":"31","descricao":"Itamogi"},
		{"id":"3133006","ufId":"31","descricao":"Itamonte"},
		{"id":"3133105","ufId":"31","descricao":"Itanhandu"},
		{"id":"3133204","ufId":"31","descricao":"Itanhomi"},
		{"id":"3133303","ufId":"31","descricao":"Itaobim"},
		{"id":"3133402","ufId":"31","descricao":"Itapagipe"},
		{"id":"3133501","ufId":"31","descricao":"Itapecerica"},
		{"id":"3133600","ufId":"31","descricao":"Itapeva"},
		{"id":"3133709","ufId":"31","descricao":"Itatiaiuçu"},
		{"id":"3133758","ufId":"31","descricao":"Itaú de Minas"},
		{"id":"3133808","ufId":"31","descricao":"Itaúna"},
		{"id":"3133907","ufId":"31","descricao":"Itaverava"},
		{"id":"3134004","ufId":"31","descricao":"Itinga"},
		{"id":"3134103","ufId":"31","descricao":"Itueta"},
		{"id":"3134202","ufId":"31","descricao":"Ituiutaba"},
		{"id":"3134301","ufId":"31","descricao":"Itumirim"},
		{"id":"3134400","ufId":"31","descricao":"Iturama"},
		{"id":"3134509","ufId":"31","descricao":"Itutinga"},
		{"id":"3134608","ufId":"31","descricao":"Jaboticatubas"},
		{"id":"3134707","ufId":"31","descricao":"Jacinto"},
		{"id":"3134806","ufId":"31","descricao":"Jacuí"},
		{"id":"3134905","ufId":"31","descricao":"Jacutinga"},
		{"id":"3135001","ufId":"31","descricao":"Jaguaraçu"},
		{"id":"3135050","ufId":"31","descricao":"Jaíba"},
		{"id":"3135076","ufId":"31","descricao":"Jampruca"},
		{"id":"3135100","ufId":"31","descricao":"Janaúba"},
		{"id":"3135209","ufId":"31","descricao":"Januária"},
		{"id":"3135308","ufId":"31","descricao":"Japaraíba"},
		{"id":"3135357","ufId":"31","descricao":"Japonvar"},
		{"id":"3135407","ufId":"31","descricao":"Jeceaba"},
		{"id":"3135456","ufId":"31","descricao":"Jenipapo de Minas"},
		{"id":"3135506","ufId":"31","descricao":"Jequeri"},
		{"id":"3135605","ufId":"31","descricao":"Jequitaí"},
		{"id":"3135704","ufId":"31","descricao":"Jequitibá"},
		{"id":"3135803","ufId":"31","descricao":"Jequitinhonha"},
		{"id":"3135902","ufId":"31","descricao":"Jesuânia"},
		{"id":"3136009","ufId":"31","descricao":"Joaíma"},
		{"id":"3136108","ufId":"31","descricao":"Joanésia"},
		{"id":"3136207","ufId":"31","descricao":"João Monlevade"},
		{"id":"3136306","ufId":"31","descricao":"João Pinheiro"},
		{"id":"3136405","ufId":"31","descricao":"Joaquim Felício"},
		{"id":"3136504","ufId":"31","descricao":"Jordânia"},
		{"id":"3136520","ufId":"31","descricao":"José Gonçalves de Minas"},
		{"id":"3136553","ufId":"31","descricao":"José Raydan"},
		{"id":"3136579","ufId":"31","descricao":"Josenópolis"},
		{"id":"3136652","ufId":"31","descricao":"Juatuba"},
		{"id":"3136702","ufId":"31","descricao":"Juiz de Fora"},
		{"id":"3136801","ufId":"31","descricao":"Juramento"},
		{"id":"3136900","ufId":"31","descricao":"Juruaia"},
		{"id":"3136959","ufId":"31","descricao":"Juvenília"},
		{"id":"3137007","ufId":"31","descricao":"Ladainha"},
		{"id":"3137106","ufId":"31","descricao":"Lagamar"},
		{"id":"3137205","ufId":"31","descricao":"Lagoa da Prata"},
		{"id":"3137304","ufId":"31","descricao":"Lagoa dos Patos"},
		{"id":"3137403","ufId":"31","descricao":"Lagoa Dourada"},
		{"id":"3137502","ufId":"31","descricao":"Lagoa Formosa"},
		{"id":"3137536","ufId":"31","descricao":"Lagoa Grande"},
		{"id":"3137601","ufId":"31","descricao":"Lagoa Santa"},
		{"id":"3137700","ufId":"31","descricao":"Lajinha"},
		{"id":"3137809","ufId":"31","descricao":"Lambari"},
		{"id":"3137908","ufId":"31","descricao":"Lamim"},
		{"id":"3138005","ufId":"31","descricao":"Laranjal"},
		{"id":"3138104","ufId":"31","descricao":"Lassance"},
		{"id":"3138203","ufId":"31","descricao":"Lavras"},
		{"id":"3138302","ufId":"31","descricao":"Leandro Ferreira"},
		{"id":"3138351","ufId":"31","descricao":"Leme do Prado"},
		{"id":"3138401","ufId":"31","descricao":"Leopoldina"},
		{"id":"3138500","ufId":"31","descricao":"Liberdade"},
		{"id":"3138609","ufId":"31","descricao":"Lima Duarte"},
		{"id":"3138625","ufId":"31","descricao":"Limeira do Oeste"},
		{"id":"3138658","ufId":"31","descricao":"Lontra"},
		{"id":"3138674","ufId":"31","descricao":"Luisburgo"},
		{"id":"3138682","ufId":"31","descricao":"Luislândia"},
		{"id":"3138708","ufId":"31","descricao":"Luminárias"},
		{"id":"3138807","ufId":"31","descricao":"Luz"},
		{"id":"3138906","ufId":"31","descricao":"Machacalis"},
		{"id":"3139003","ufId":"31","descricao":"Machado"},
		{"id":"3139102","ufId":"31","descricao":"Madre de Deus de Minas"},
		{"id":"3139201","ufId":"31","descricao":"Malacacheta"},
		{"id":"3139250","ufId":"31","descricao":"Mamonas"},
		{"id":"3139300","ufId":"31","descricao":"Manga"},
		{"id":"3139409","ufId":"31","descricao":"Manhuaçu"},
		{"id":"3139508","ufId":"31","descricao":"Manhumirim"},
		{"id":"3139607","ufId":"31","descricao":"Mantena"},
		{"id":"3139805","ufId":"31","descricao":"Mar de Espanha"},
		{"id":"3139706","ufId":"31","descricao":"Maravilhas"},
		{"id":"3139904","ufId":"31","descricao":"Maria da Fé"},
		{"id":"3140001","ufId":"31","descricao":"Mariana"},
		{"id":"3140100","ufId":"31","descricao":"Marilac"},
		{"id":"3140159","ufId":"31","descricao":"Mário Campos"},
		{"id":"3140209","ufId":"31","descricao":"Maripá de Minas"},
		{"id":"3140308","ufId":"31","descricao":"Marliéria"},
		{"id":"3140407","ufId":"31","descricao":"Marmelópolis"},
		{"id":"3140506","ufId":"31","descricao":"Martinho Campos"},
		{"id":"3140530","ufId":"31","descricao":"Martins Soares"},
		{"id":"3140555","ufId":"31","descricao":"Mata Verde"},
		{"id":"3140605","ufId":"31","descricao":"Materlândia"},
		{"id":"3140704","ufId":"31","descricao":"Mateus Leme"},
		{"id":"3171501","ufId":"31","descricao":"Mathias Lobato"},
		{"id":"3140803","ufId":"31","descricao":"Matias Barbosa"},
		{"id":"3140852","ufId":"31","descricao":"Matias Cardoso"},
		{"id":"3140902","ufId":"31","descricao":"Matipó"},
		{"id":"3141009","ufId":"31","descricao":"Mato Verde"},
		{"id":"3141108","ufId":"31","descricao":"Matozinhos"},
		{"id":"3141207","ufId":"31","descricao":"Matutina"},
		{"id":"3141306","ufId":"31","descricao":"Medeiros"},
		{"id":"3141405","ufId":"31","descricao":"Medina"},
		{"id":"3141504","ufId":"31","descricao":"Mendes Pimentel"},
		{"id":"3141603","ufId":"31","descricao":"Mercês"},
		{"id":"3141702","ufId":"31","descricao":"Mesquita"},
		{"id":"3141801","ufId":"31","descricao":"Minas Novas"},
		{"id":"3141900","ufId":"31","descricao":"Minduri"},
		{"id":"3142007","ufId":"31","descricao":"Mirabela"},
		{"id":"3142106","ufId":"31","descricao":"Miradouro"},
		{"id":"3142205","ufId":"31","descricao":"Miraí"},
		{"id":"3142254","ufId":"31","descricao":"Miravânia"},
		{"id":"3142304","ufId":"31","descricao":"Moeda"},
		{"id":"3142403","ufId":"31","descricao":"Moema"},
		{"id":"3142502","ufId":"31","descricao":"Monjolos"},
		{"id":"3142601","ufId":"31","descricao":"Monsenhor Paulo"},
		{"id":"3142700","ufId":"31","descricao":"Montalvânia"},
		{"id":"3142809","ufId":"31","descricao":"Monte Alegre de Minas"},
		{"id":"3142908","ufId":"31","descricao":"Monte Azul"},
		{"id":"3143005","ufId":"31","descricao":"Monte Belo"},
		{"id":"3143104","ufId":"31","descricao":"Monte Carmelo"},
		{"id":"3143153","ufId":"31","descricao":"Monte Formoso"},
		{"id":"3143203","ufId":"31","descricao":"Monte Santo de Minas"},
		{"id":"3143401","ufId":"31","descricao":"Monte Sião"},
		{"id":"3143302","ufId":"31","descricao":"Montes Claros"},
		{"id":"3143450","ufId":"31","descricao":"Montezuma"},
		{"id":"3143500","ufId":"31","descricao":"Morada Nova de Minas"},
		{"id":"3143609","ufId":"31","descricao":"Morro da Garça"},
		{"id":"3143708","ufId":"31","descricao":"Morro do Pilar"},
		{"id":"3143807","ufId":"31","descricao":"Munhoz"},
		{"id":"3143906","ufId":"31","descricao":"Muriaé"},
		{"id":"3144003","ufId":"31","descricao":"Mutum"},
		{"id":"3144102","ufId":"31","descricao":"Muzambinho"},
		{"id":"3144201","ufId":"31","descricao":"Nacip Raydan"},
		{"id":"3144300","ufId":"31","descricao":"Nanuque"},
		{"id":"3144359","ufId":"31","descricao":"Naque"},
		{"id":"3144375","ufId":"31","descricao":"Natalândia"},
		{"id":"3144409","ufId":"31","descricao":"Natércia"},
		{"id":"3144508","ufId":"31","descricao":"Nazareno"},
		{"id":"3144607","ufId":"31","descricao":"Nepomuceno"},
		{"id":"3144656","ufId":"31","descricao":"Ninheira"},
		{"id":"3144672","ufId":"31","descricao":"Nova Belém"},
		{"id":"3144706","ufId":"31","descricao":"Nova Era"},
		{"id":"3144805","ufId":"31","descricao":"Nova Lima"},
		{"id":"3144904","ufId":"31","descricao":"Nova Módica"},
		{"id":"3145000","ufId":"31","descricao":"Nova Ponte"},
		{"id":"3145059","ufId":"31","descricao":"Nova Porteirinha"},
		{"id":"3145109","ufId":"31","descricao":"Nova Resende"},
		{"id":"3145208","ufId":"31","descricao":"Nova Serrana"},
		{"id":"3136603","ufId":"31","descricao":"Nova União"},
		{"id":"3145307","ufId":"31","descricao":"Novo Cruzeiro"},
		{"id":"3145356","ufId":"31","descricao":"Novo Oriente de Minas"},
		{"id":"3145372","ufId":"31","descricao":"Novorizonte"},
		{"id":"3145406","ufId":"31","descricao":"Olaria"},
		{"id":"3145455","ufId":"31","descricao":"Olhos-d'Água"},
		{"id":"3145505","ufId":"31","descricao":"Olímpio Noronha"},
		{"id":"3145604","ufId":"31","descricao":"Oliveira"},
		{"id":"3145703","ufId":"31","descricao":"Oliveira Fortes"},
		{"id":"3145802","ufId":"31","descricao":"Onça de Pitangui"},
		{"id":"3145851","ufId":"31","descricao":"Oratórios"},
		{"id":"3145877","ufId":"31","descricao":"Orizânia"},
		{"id":"3145901","ufId":"31","descricao":"Ouro Branco"},
		{"id":"3146008","ufId":"31","descricao":"Ouro Fino"},
		{"id":"3146107","ufId":"31","descricao":"Ouro Preto"},
		{"id":"3146206","ufId":"31","descricao":"Ouro Verde de Minas"},
		{"id":"3146255","ufId":"31","descricao":"Padre Carvalho"},
		{"id":"3146305","ufId":"31","descricao":"Padre Paraíso"},
		{"id":"3146552","ufId":"31","descricao":"Pai Pedro"},
		{"id":"3146404","ufId":"31","descricao":"Paineiras"},
		{"id":"3146503","ufId":"31","descricao":"Pains"},
		{"id":"3146602","ufId":"31","descricao":"Paiva"},
		{"id":"3146701","ufId":"31","descricao":"Palma"},
		{"id":"3146750","ufId":"31","descricao":"Palmópolis"},
		{"id":"3146909","ufId":"31","descricao":"Papagaios"},
		{"id":"3147105","ufId":"31","descricao":"Pará de Minas"},
		{"id":"3147006","ufId":"31","descricao":"Paracatu"},
		{"id":"3147204","ufId":"31","descricao":"Paraguaçu"},
		{"id":"3147303","ufId":"31","descricao":"Paraisópolis"},
		{"id":"3147402","ufId":"31","descricao":"Paraopeba"},
		{"id":"3147600","ufId":"31","descricao":"Passa Quatro"},
		{"id":"3147709","ufId":"31","descricao":"Passa Tempo"},
		{"id":"3147808","ufId":"31","descricao":"Passa Vinte"},
		{"id":"3147501","ufId":"31","descricao":"Passabém"},
		{"id":"3147907","ufId":"31","descricao":"Passos"},
		{"id":"3147956","ufId":"31","descricao":"Patis"},
		{"id":"3148004","ufId":"31","descricao":"Patos de Minas"},
		{"id":"3148103","ufId":"31","descricao":"Patrocínio"},
		{"id":"3148202","ufId":"31","descricao":"Patrocínio do Muriaé"},
		{"id":"3148301","ufId":"31","descricao":"Paula Cândido"},
		{"id":"3148400","ufId":"31","descricao":"Paulistas"},
		{"id":"3148509","ufId":"31","descricao":"Pavão"},
		{"id":"3148608","ufId":"31","descricao":"Peçanha"},
		{"id":"3148707","ufId":"31","descricao":"Pedra Azul"},
		{"id":"3148756","ufId":"31","descricao":"Pedra Bonita"},
		{"id":"3148806","ufId":"31","descricao":"Pedra do Anta"},
		{"id":"3148905","ufId":"31","descricao":"Pedra do Indaiá"},
		{"id":"3149002","ufId":"31","descricao":"Pedra Dourada"},
		{"id":"3149101","ufId":"31","descricao":"Pedralva"},
		{"id":"3149150","ufId":"31","descricao":"Pedras de Maria da Cruz"},
		{"id":"3149200","ufId":"31","descricao":"Pedrinópolis"},
		{"id":"3149309","ufId":"31","descricao":"Pedro Leopoldo"},
		{"id":"3149408","ufId":"31","descricao":"Pedro Teixeira"},
		{"id":"3149507","ufId":"31","descricao":"Pequeri"},
		{"id":"3149606","ufId":"31","descricao":"Pequi"},
		{"id":"3149705","ufId":"31","descricao":"Perdigão"},
		{"id":"3149804","ufId":"31","descricao":"Perdizes"},
		{"id":"3149903","ufId":"31","descricao":"Perdões"},
		{"id":"3149952","ufId":"31","descricao":"Periquito"},
		{"id":"3150000","ufId":"31","descricao":"Pescador"},
		{"id":"3150109","ufId":"31","descricao":"Piau"},
		{"id":"3150158","ufId":"31","descricao":"Piedade de Caratinga"},
		{"id":"3150208","ufId":"31","descricao":"Piedade de Ponte Nova"},
		{"id":"3150307","ufId":"31","descricao":"Piedade do Rio Grande"},
		{"id":"3150406","ufId":"31","descricao":"Piedade dos Gerais"},
		{"id":"3150505","ufId":"31","descricao":"Pimenta"},
		{"id":"3150539","ufId":"31","descricao":"Pingo-d'Água"},
		{"id":"3150570","ufId":"31","descricao":"Pintópolis"},
		{"id":"3150604","ufId":"31","descricao":"Piracema"},
		{"id":"3150703","ufId":"31","descricao":"Pirajuba"},
		{"id":"3150802","ufId":"31","descricao":"Piranga"},
		{"id":"3150901","ufId":"31","descricao":"Piranguçu"},
		{"id":"3151008","ufId":"31","descricao":"Piranguinho"},
		{"id":"3151107","ufId":"31","descricao":"Pirapetinga"},
		{"id":"3151206","ufId":"31","descricao":"Pirapora"},
		{"id":"3151305","ufId":"31","descricao":"Piraúba"},
		{"id":"3151404","ufId":"31","descricao":"Pitangui"},
		{"id":"3151503","ufId":"31","descricao":"Piumhi"},
		{"id":"3151602","ufId":"31","descricao":"Planura"},
		{"id":"3151701","ufId":"31","descricao":"Poço Fundo"},
		{"id":"3151800","ufId":"31","descricao":"Poços de Caldas"},
		{"id":"3151909","ufId":"31","descricao":"Pocrane"},
		{"id":"3152006","ufId":"31","descricao":"Pompéu"},
		{"id":"3152105","ufId":"31","descricao":"Ponte Nova"},
		{"id":"3152131","ufId":"31","descricao":"Ponto Chique"},
		{"id":"3152170","ufId":"31","descricao":"Ponto dos Volantes"},
		{"id":"3152204","ufId":"31","descricao":"Porteirinha"},
		{"id":"3152303","ufId":"31","descricao":"Porto Firme"},
		{"id":"3152402","ufId":"31","descricao":"Poté"},
		{"id":"3152501","ufId":"31","descricao":"Pouso Alegre"},
		{"id":"3152600","ufId":"31","descricao":"Pouso Alto"},
		{"id":"3152709","ufId":"31","descricao":"Prados"},
		{"id":"3152808","ufId":"31","descricao":"Prata"},
		{"id":"3152907","ufId":"31","descricao":"Pratápolis"},
		{"id":"3153004","ufId":"31","descricao":"Pratinha"},
		{"id":"3153103","ufId":"31","descricao":"Presidente Bernardes"},
		{"id":"3153202","ufId":"31","descricao":"Presidente Juscelino"},
		{"id":"3153301","ufId":"31","descricao":"Presidente Kubitschek"},
		{"id":"3153400","ufId":"31","descricao":"Presidente Olegário"},
		{"id":"3153608","ufId":"31","descricao":"Prudente de Morais"},
		{"id":"3153707","ufId":"31","descricao":"Quartel Geral"},
		{"id":"3153806","ufId":"31","descricao":"Queluzito"},
		{"id":"3153905","ufId":"31","descricao":"Raposos"},
		{"id":"3154002","ufId":"31","descricao":"Raul Soares"},
		{"id":"3154101","ufId":"31","descricao":"Recreio"},
		{"id":"3154150","ufId":"31","descricao":"Reduto"},
		{"id":"3154200","ufId":"31","descricao":"Resende Costa"},
		{"id":"3154309","ufId":"31","descricao":"Resplendor"},
		{"id":"3154408","ufId":"31","descricao":"Ressaquinha"},
		{"id":"3154457","ufId":"31","descricao":"Riachinho"},
		{"id":"3154507","ufId":"31","descricao":"Riacho dos Machados"},
		{"id":"3154606","ufId":"31","descricao":"Ribeirão das Neves"},
		{"id":"3154705","ufId":"31","descricao":"Ribeirão Vermelho"},
		{"id":"3154804","ufId":"31","descricao":"Rio Acima"},
		{"id":"3154903","ufId":"31","descricao":"Rio Casca"},
		{"id":"3155108","ufId":"31","descricao":"Rio do Prado"},
		{"id":"3155009","ufId":"31","descricao":"Rio Doce"},
		{"id":"3155207","ufId":"31","descricao":"Rio Espera"},
		{"id":"3155306","ufId":"31","descricao":"Rio Manso"},
		{"id":"3155405","ufId":"31","descricao":"Rio Novo"},
		{"id":"3155504","ufId":"31","descricao":"Rio Paranaíba"},
		{"id":"3155603","ufId":"31","descricao":"Rio Pardo de Minas"},
		{"id":"3155702","ufId":"31","descricao":"Rio Piracicaba"},
		{"id":"3155801","ufId":"31","descricao":"Rio Pomba"},
		{"id":"3155900","ufId":"31","descricao":"Rio Preto"},
		{"id":"3156007","ufId":"31","descricao":"Rio Vermelho"},
		{"id":"3156106","ufId":"31","descricao":"Ritápolis"},
		{"id":"3156205","ufId":"31","descricao":"Rochedo de Minas"},
		{"id":"3156304","ufId":"31","descricao":"Rodeiro"},
		{"id":"3156403","ufId":"31","descricao":"Romaria"},
		{"id":"3156452","ufId":"31","descricao":"Rosário da Limeira"},
		{"id":"3156502","ufId":"31","descricao":"Rubelita"},
		{"id":"3156601","ufId":"31","descricao":"Rubim"},
		{"id":"3156700","ufId":"31","descricao":"Sabará"},
		{"id":"3156809","ufId":"31","descricao":"Sabinópolis"},
		{"id":"3156908","ufId":"31","descricao":"Sacramento"},
		{"id":"3157005","ufId":"31","descricao":"Salinas"},
		{"id":"3157104","ufId":"31","descricao":"Salto da Divisa"},
		{"id":"3157203","ufId":"31","descricao":"Santa Bárbara"},
		{"id":"3157252","ufId":"31","descricao":"Santa Bárbara do Leste"},
		{"id":"3157278","ufId":"31","descricao":"Santa Bárbara do Monte Verde"},
		{"id":"3157302","ufId":"31","descricao":"Santa Bárbara do Tugúrio"},
		{"id":"3157336","ufId":"31","descricao":"Santa Cruz de Minas"},
		{"id":"3157377","ufId":"31","descricao":"Santa Cruz de Salinas"},
		{"id":"3157401","ufId":"31","descricao":"Santa Cruz do Escalvado"},
		{"id":"3157500","ufId":"31","descricao":"Santa Efigênia de Minas"},
		{"id":"3157609","ufId":"31","descricao":"Santa Fé de Minas"},
		{"id":"3157658","ufId":"31","descricao":"Santa Helena de Minas"},
		{"id":"3157708","ufId":"31","descricao":"Santa Juliana"},
		{"id":"3157807","ufId":"31","descricao":"Santa Luzia"},
		{"id":"3157906","ufId":"31","descricao":"Santa Margarida"},
		{"id":"3158003","ufId":"31","descricao":"Santa Maria de Itabira"},
		{"id":"3158102","ufId":"31","descricao":"Santa Maria do Salto"},
		{"id":"3158201","ufId":"31","descricao":"Santa Maria do Suaçuí"},
		{"id":"3159209","ufId":"31","descricao":"Santa Rita de Caldas"},
		{"id":"3159407","ufId":"31","descricao":"Santa Rita de Ibitipoca"},
		{"id":"3159308","ufId":"31","descricao":"Santa Rita de Jacutinga"},
		{"id":"3159357","ufId":"31","descricao":"Santa Rita de Minas"},
		{"id":"3159506","ufId":"31","descricao":"Santa Rita do Itueto"},
		{"id":"3159605","ufId":"31","descricao":"Santa Rita do Sapucaí"},
		{"id":"3159704","ufId":"31","descricao":"Santa Rosa da Serra"},
		{"id":"3159803","ufId":"31","descricao":"Santa Vitória"},
		{"id":"3158300","ufId":"31","descricao":"Santana da Vargem"},
		{"id":"3158409","ufId":"31","descricao":"Santana de Cataguases"},
		{"id":"3158508","ufId":"31","descricao":"Santana de Pirapama"},
		{"id":"3158607","ufId":"31","descricao":"Santana do Deserto"},
		{"id":"3158706","ufId":"31","descricao":"Santana do Garambéu"},
		{"id":"3158805","ufId":"31","descricao":"Santana do Jacaré"},
		{"id":"3158904","ufId":"31","descricao":"Santana do Manhuaçu"},
		{"id":"3158953","ufId":"31","descricao":"Santana do Paraíso"},
		{"id":"3159001","ufId":"31","descricao":"Santana do Riacho"},
		{"id":"3159100","ufId":"31","descricao":"Santana dos Montes"},
		{"id":"3159902","ufId":"31","descricao":"Santo Antônio do Amparo"},
		{"id":"3160009","ufId":"31","descricao":"Santo Antônio do Aventureiro"},
		{"id":"3160108","ufId":"31","descricao":"Santo Antônio do Grama"},
		{"id":"3160207","ufId":"31","descricao":"Santo Antônio do Itambé"},
		{"id":"3160306","ufId":"31","descricao":"Santo Antônio do Jacinto"},
		{"id":"3160405","ufId":"31","descricao":"Santo Antônio do Monte"},
		{"id":"3160454","ufId":"31","descricao":"Santo Antônio do Retiro"},
		{"id":"3160504","ufId":"31","descricao":"Santo Antônio do Rio Abaixo"},
		{"id":"3160603","ufId":"31","descricao":"Santo Hipólito"},
		{"id":"3160702","ufId":"31","descricao":"Santos Dumont"},
		{"id":"3160801","ufId":"31","descricao":"São Bento Abade"},
		{"id":"3160900","ufId":"31","descricao":"São Brás do Suaçuí"},
		{"id":"3160959","ufId":"31","descricao":"São Domingos das Dores"},
		{"id":"3161007","ufId":"31","descricao":"São Domingos do Prata"},
		{"id":"3161056","ufId":"31","descricao":"São Félix de Minas"},
		{"id":"3161106","ufId":"31","descricao":"São Francisco"},
		{"id":"3161205","ufId":"31","descricao":"São Francisco de Paula"},
		{"id":"3161304","ufId":"31","descricao":"São Francisco de Sales"},
		{"id":"3161403","ufId":"31","descricao":"São Francisco do Glória"},
		{"id":"3161502","ufId":"31","descricao":"São Geraldo"},
		{"id":"3161601","ufId":"31","descricao":"São Geraldo da Piedade"},
		{"id":"3161650","ufId":"31","descricao":"São Geraldo do Baixio"},
		{"id":"3161700","ufId":"31","descricao":"São Gonçalo do Abaeté"},
		{"id":"3161809","ufId":"31","descricao":"São Gonçalo do Pará"},
		{"id":"3161908","ufId":"31","descricao":"São Gonçalo do Rio Abaixo"},
		{"id":"3125507","ufId":"31","descricao":"São Gonçalo do Rio Preto"},
		{"id":"3162005","ufId":"31","descricao":"São Gonçalo do Sapucaí"},
		{"id":"3162104","ufId":"31","descricao":"São Gotardo"},
		{"id":"3162203","ufId":"31","descricao":"São João Batista do Glória"},
		{"id":"3162252","ufId":"31","descricao":"São João da Lagoa"},
		{"id":"3162302","ufId":"31","descricao":"São João da Mata"},
		{"id":"3162401","ufId":"31","descricao":"São João da Ponte"},
		{"id":"3162450","ufId":"31","descricao":"São João das Missões"},
		{"id":"3162500","ufId":"31","descricao":"São João del Rei"},
		{"id":"3162559","ufId":"31","descricao":"São João do Manhuaçu"},
		{"id":"3162575","ufId":"31","descricao":"São João do Manteninha"},
		{"id":"3162609","ufId":"31","descricao":"São João do Oriente"},
		{"id":"3162658","ufId":"31","descricao":"São João do Pacuí"},
		{"id":"3162708","ufId":"31","descricao":"São João do Paraíso"},
		{"id":"3162807","ufId":"31","descricao":"São João Evangelista"},
		{"id":"3162906","ufId":"31","descricao":"São João Nepomuceno"},
		{"id":"3162922","ufId":"31","descricao":"São Joaquim de Bicas"},
		{"id":"3162948","ufId":"31","descricao":"São José da Barra"},
		{"id":"3162955","ufId":"31","descricao":"São José da Lapa"},
		{"id":"3163003","ufId":"31","descricao":"São José da Safira"},
		{"id":"3163102","ufId":"31","descricao":"São José da Varginha"},
		{"id":"3163201","ufId":"31","descricao":"São José do Alegre"},
		{"id":"3163300","ufId":"31","descricao":"São José do Divino"},
		{"id":"3163409","ufId":"31","descricao":"São José do Goiabal"},
		{"id":"3163508","ufId":"31","descricao":"São José do Jacuri"},
		{"id":"3163607","ufId":"31","descricao":"São José do Mantimento"},
		{"id":"3163706","ufId":"31","descricao":"São Lourenço"},
		{"id":"3163805","ufId":"31","descricao":"São Miguel do Anta"},
		{"id":"3163904","ufId":"31","descricao":"São Pedro da União"},
		{"id":"3164100","ufId":"31","descricao":"São Pedro do Suaçuí"},
		{"id":"3164001","ufId":"31","descricao":"São Pedro dos Ferros"},
		{"id":"3164209","ufId":"31","descricao":"São Romão"},
		{"id":"3164308","ufId":"31","descricao":"São Roque de Minas"},
		{"id":"3164407","ufId":"31","descricao":"São Sebastião da Bela Vista"},
		{"id":"3164431","ufId":"31","descricao":"São Sebastião da Vargem Alegre"},
		{"id":"3164472","ufId":"31","descricao":"São Sebastião do Anta"},
		{"id":"3164506","ufId":"31","descricao":"São Sebastião do Maranhão"},
		{"id":"3164605","ufId":"31","descricao":"São Sebastião do Oeste"},
		{"id":"3164704","ufId":"31","descricao":"São Sebastião do Paraíso"},
		{"id":"3164803","ufId":"31","descricao":"São Sebastião do Rio Preto"},
		{"id":"3164902","ufId":"31","descricao":"São Sebastião do Rio Verde"},
		{"id":"3165008","ufId":"31","descricao":"São Tiago"},
		{"id":"3165107","ufId":"31","descricao":"São Tomás de Aquino"},
		{"id":"3165206","ufId":"31","descricao":"São Tomé das Letras"},
		{"id":"3165305","ufId":"31","descricao":"São Vicente de Minas"},
		{"id":"3165404","ufId":"31","descricao":"Sapucaí-Mirim"},
		{"id":"3165503","ufId":"31","descricao":"Sardoá"},
		{"id":"3165537","ufId":"31","descricao":"Sarzedo"},
		{"id":"3165560","ufId":"31","descricao":"Sem-Peixe"},
		{"id":"3165578","ufId":"31","descricao":"Senador Amaral"},
		{"id":"3165602","ufId":"31","descricao":"Senador Cortes"},
		{"id":"3165701","ufId":"31","descricao":"Senador Firmino"},
		{"id":"3165800","ufId":"31","descricao":"Senador José Bento"},
		{"id":"3165909","ufId":"31","descricao":"Senador Modestino Gonçalves"},
		{"id":"3166006","ufId":"31","descricao":"Senhora de Oliveira"},
		{"id":"3166105","ufId":"31","descricao":"Senhora do Porto"},
		{"id":"3166204","ufId":"31","descricao":"Senhora dos Remédios"},
		{"id":"3166303","ufId":"31","descricao":"Sericita"},
		{"id":"3166402","ufId":"31","descricao":"Seritinga"},
		{"id":"3166501","ufId":"31","descricao":"Serra Azul de Minas"},
		{"id":"3166600","ufId":"31","descricao":"Serra da Saudade"},
		{"id":"3166808","ufId":"31","descricao":"Serra do Salitre"},
		{"id":"3166709","ufId":"31","descricao":"Serra dos Aimorés"},
		{"id":"3166907","ufId":"31","descricao":"Serrania"},
		{"id":"3166956","ufId":"31","descricao":"Serranópolis de Minas"},
		{"id":"3167004","ufId":"31","descricao":"Serranos"},
		{"id":"3167103","ufId":"31","descricao":"Serro"},
		{"id":"3167202","ufId":"31","descricao":"Sete Lagoas"},
		{"id":"3165552","ufId":"31","descricao":"Setubinha"},
		{"id":"3167301","ufId":"31","descricao":"Silveirânia"},
		{"id":"3167400","ufId":"31","descricao":"Silvianópolis"},
		{"id":"3167509","ufId":"31","descricao":"Simão Pereira"},
		{"id":"3167608","ufId":"31","descricao":"Simonésia"},
		{"id":"3167707","ufId":"31","descricao":"Sobrália"},
		{"id":"3167806","ufId":"31","descricao":"Soledade de Minas"},
		{"id":"3167905","ufId":"31","descricao":"Tabuleiro"},
		{"id":"3168002","ufId":"31","descricao":"Taiobeiras"},
		{"id":"3168051","ufId":"31","descricao":"Taparuba"},
		{"id":"3168101","ufId":"31","descricao":"Tapira"},
		{"id":"3168200","ufId":"31","descricao":"Tapiraí"},
		{"id":"3168309","ufId":"31","descricao":"Taquaraçu de Minas"},
		{"id":"3168408","ufId":"31","descricao":"Tarumirim"},
		{"id":"3168507","ufId":"31","descricao":"Teixeiras"},
		{"id":"3168606","ufId":"31","descricao":"Teófilo Otoni"},
		{"id":"3168705","ufId":"31","descricao":"Timóteo"},
		{"id":"3168804","ufId":"31","descricao":"Tiradentes"},
		{"id":"3168903","ufId":"31","descricao":"Tiros"},
		{"id":"3169000","ufId":"31","descricao":"Tocantins"},
		{"id":"3169059","ufId":"31","descricao":"Tocos do Moji"},
		{"id":"3169109","ufId":"31","descricao":"Toledo"},
		{"id":"3169208","ufId":"31","descricao":"Tombos"},
		{"id":"3169307","ufId":"31","descricao":"Três Corações"},
		{"id":"3169356","ufId":"31","descricao":"Três Marias"},
		{"id":"3169406","ufId":"31","descricao":"Três Pontas"},
		{"id":"3169505","ufId":"31","descricao":"Tumiritinga"},
		{"id":"3169604","ufId":"31","descricao":"Tupaciguara"},
		{"id":"3169703","ufId":"31","descricao":"Turmalina"},
		{"id":"3169802","ufId":"31","descricao":"Turvolândia"},
		{"id":"3169901","ufId":"31","descricao":"Ubá"},
		{"id":"3170008","ufId":"31","descricao":"Ubaí"},
		{"id":"3170057","ufId":"31","descricao":"Ubaporanga"},
		{"id":"3170107","ufId":"31","descricao":"Uberaba"},
		{"id":"3170206","ufId":"31","descricao":"Uberlândia"},
		{"id":"3170305","ufId":"31","descricao":"Umburatiba"},
		{"id":"3170404","ufId":"31","descricao":"Unaí"},
		{"id":"3170438","ufId":"31","descricao":"União de Minas"},
		{"id":"3170479","ufId":"31","descricao":"Uruana de Minas"},
		{"id":"3170503","ufId":"31","descricao":"Urucânia"},
		{"id":"3170529","ufId":"31","descricao":"Urucuia"},
		{"id":"3170578","ufId":"31","descricao":"Vargem Alegre"},
		{"id":"3170602","ufId":"31","descricao":"Vargem Bonita"},
		{"id":"3170651","ufId":"31","descricao":"Vargem Grande do Rio Pardo"},
		{"id":"3170701","ufId":"31","descricao":"Varginha"},
		{"id":"3170750","ufId":"31","descricao":"Varjão de Minas"},
		{"id":"3170800","ufId":"31","descricao":"Várzea da Palma"},
		{"id":"3170909","ufId":"31","descricao":"Varzelândia"},
		{"id":"3171006","ufId":"31","descricao":"Vazante"},
		{"id":"3171030","ufId":"31","descricao":"Verdelândia"},
		{"id":"3171071","ufId":"31","descricao":"Veredinha"},
		{"id":"3171105","ufId":"31","descricao":"Veríssimo"},
		{"id":"3171154","ufId":"31","descricao":"Vermelho Novo"},
		{"id":"3171204","ufId":"31","descricao":"Vespasiano"},
		{"id":"3171303","ufId":"31","descricao":"Viçosa"},
		{"id":"3171402","ufId":"31","descricao":"Vieiras"},
		{"id":"3171600","ufId":"31","descricao":"Virgem da Lapa"},
		{"id":"3171709","ufId":"31","descricao":"Virgínia"},
		{"id":"3171808","ufId":"31","descricao":"Virginópolis"},
		{"id":"3171907","ufId":"31","descricao":"Virgolândia"},
		{"id":"3172004","ufId":"31","descricao":"Visconde do Rio Branco"},
		{"id":"3172103","ufId":"31","descricao":"Volta Grande"},
		{"id":"3172202","ufId":"31","descricao":"Wenceslau Braz"}
	],
	"32": [
		{"id":"3200102","ufId":"32","descricao":"Afonso Cláudio"},
		{"id":"3200169","ufId":"32","descricao":"Água Doce do Norte"},
		{"id":"3200136","ufId":"32","descricao":"Águia Branca"},
		{"id":"3200201","ufId":"32","descricao":"Alegre"},
		{"id":"3200300","ufId":"32","descricao":"Alfredo Chaves"},
		{"id":"3200359","ufId":"32","descricao":"Alto Rio Novo"},
		{"id":"3200409","ufId":"32","descricao":"Anchieta"},
		{"id":"3200508","ufId":"32","descricao":"Apiacá"},
		{"id":"3200607","ufId":"32","descricao":"Aracruz"},
		{"id":"3200706","ufId":"32","descricao":"Atílio Vivácqua"},
		{"id":"3200805","ufId":"32","descricao":"Baixo Guandu"},
		{"id":"3200904","ufId":"32","descricao":"Barra de São Francisco"},
		{"id":"3201001","ufId":"32","descricao":"Boa Esperança"},
		{"id":"3201100","ufId":"32","descricao":"Bom Jesus do Norte"},
		{"id":"3201159","ufId":"32","descricao":"Brejetuba"},
		{"id":"3201209","ufId":"32","descricao":"Cachoeiro de Itapemirim"},
		{"id":"3201308","ufId":"32","descricao":"Cariacica"},
		{"id":"3201407","ufId":"32","descricao":"Castelo"},
		{"id":"3201506","ufId":"32","descricao":"Colatina"},
		{"id":"3201605","ufId":"32","descricao":"Conceição da Barra"},
		{"id":"3201704","ufId":"32","descricao":"Conceição do Castelo"},
		{"id":"3201803","ufId":"32","descricao":"Divino de São Lourenço"},
		{"id":"3201902","ufId":"32","descricao":"Domingos Martins"},
		{"id":"3202009","ufId":"32","descricao":"Dores do Rio Preto"},
		{"id":"3202108","ufId":"32","descricao":"Ecoporanga"},
		{"id":"3202207","ufId":"32","descricao":"Fundão"},
		{"id":"3202256","ufId":"32","descricao":"Governador Lindenberg"},
		{"id":"3202306","ufId":"32","descricao":"Guaçuí"},
		{"id":"3202405","ufId":"32","descricao":"Guarapari"},
		{"id":"3202454","ufId":"32","descricao":"Ibatiba"},
		{"id":"3202504","ufId":"32","descricao":"Ibiraçu"},
		{"id":"3202553","ufId":"32","descricao":"Ibitirama"},
		{"id":"3202603","ufId":"32","descricao":"Iconha"},
		{"id":"3202652","ufId":"32","descricao":"Irupi"},
		{"id":"3202702","ufId":"32","descricao":"Itaguaçu"},
		{"id":"3202801","ufId":"32","descricao":"Itapemirim"},
		{"id":"3202900","ufId":"32","descricao":"Itarana"},
		{"id":"3203007","ufId":"32","descricao":"Iúna"},
		{"id":"3203056","ufId":"32","descricao":"Jaguaré"},
		{"id":"3203106","ufId":"32","descricao":"Jerônimo Monteiro"},
		{"id":"3203130","ufId":"32","descricao":"João Neiva"},
		{"id":"3203163","ufId":"32","descricao":"Laranja da Terra"},
		{"id":"3203205","ufId":"32","descricao":"Linhares"},
		{"id":"3203304","ufId":"32","descricao":"Mantenópolis"},
		{"id":"3203320","ufId":"32","descricao":"Marataízes"},
		{"id":"3203346","ufId":"32","descricao":"Marechal Floriano"},
		{"id":"3203353","ufId":"32","descricao":"Marilândia"},
		{"id":"3203403","ufId":"32","descricao":"Mimoso do Sul"},
		{"id":"3203502","ufId":"32","descricao":"Montanha"},
		{"id":"3203601","ufId":"32","descricao":"Mucurici"},
		{"id":"3203700","ufId":"32","descricao":"Muniz Freire"},
		{"id":"3203809","ufId":"32","descricao":"Muqui"},
		{"id":"3203908","ufId":"32","descricao":"Nova Venécia"},
		{"id":"3204005","ufId":"32","descricao":"Pancas"},
		{"id":"3204054","ufId":"32","descricao":"Pedro Canário"},
		{"id":"3204104","ufId":"32","descricao":"Pinheiros"},
		{"id":"3204203","ufId":"32","descricao":"Piúma"},
		{"id":"3204252","ufId":"32","descricao":"Ponto Belo"},
		{"id":"3204302","ufId":"32","descricao":"Presidente Kennedy"},
		{"id":"3204351","ufId":"32","descricao":"Rio Bananal"},
		{"id":"3204401","ufId":"32","descricao":"Rio Novo do Sul"},
		{"id":"3204500","ufId":"32","descricao":"Santa Leopoldina"},
		{"id":"3204559","ufId":"32","descricao":"Santa Maria de Jetibá"},
		{"id":"3204609","ufId":"32","descricao":"Santa Teresa"},
		{"id":"3204658","ufId":"32","descricao":"São Domingos do Norte"},
		{"id":"3204708","ufId":"32","descricao":"São Gabriel da Palha"},
		{"id":"3204807","ufId":"32","descricao":"São José do Calçado"},
		{"id":"3204906","ufId":"32","descricao":"São Mateus"},
		{"id":"3204955","ufId":"32","descricao":"São Roque do Canaã"},
		{"id":"3205002","ufId":"32","descricao":"Serra"},
		{"id":"3205010","ufId":"32","descricao":"Sooretama"},
		{"id":"3205036","ufId":"32","descricao":"Vargem Alta"},
		{"id":"3205069","ufId":"32","descricao":"Venda Nova do Imigrante"},
		{"id":"3205101","ufId":"32","descricao":"Viana"},
		{"id":"3205150","ufId":"32","descricao":"Vila Pavão"},
		{"id":"3205176","ufId":"32","descricao":"Vila Valério"},
		{"id":"3205200","ufId":"32","descricao":"Vila Velha"},
		{"id":"3205309","ufId":"32","descricao":"Vitória"}
	],
	"33": [
		{"id":"3300100","ufId":"33","descricao":"Angra dos Reis"},
		{"id":"3300159","ufId":"33","descricao":"Aperibé"},
		{"id":"3300209","ufId":"33","descricao":"Araruama"},
		{"id":"3300225","ufId":"33","descricao":"Areal"},
		{"id":"3300233","ufId":"33","descricao":"Armação dos Búzios"},
		{"id":"3300258","ufId":"33","descricao":"Arraial do Cabo"},
		{"id":"3300308","ufId":"33","descricao":"Barra do Piraí"},
		{"id":"3300407","ufId":"33","descricao":"Barra Mansa"},
		{"id":"3300456","ufId":"33","descricao":"Belford Roxo"},
		{"id":"3300506","ufId":"33","descricao":"Bom Jardim"},
		{"id":"3300605","ufId":"33","descricao":"Bom Jesus do Itabapoana"},
		{"id":"3300704","ufId":"33","descricao":"Cabo Frio"},
		{"id":"3300803","ufId":"33","descricao":"Cachoeiras de Macacu"},
		{"id":"3300902","ufId":"33","descricao":"Cambuci"},
		{"id":"3301009","ufId":"33","descricao":"Campos dos Goytacazes"},
		{"id":"3301108","ufId":"33","descricao":"Cantagalo"},
		{"id":"3300936","ufId":"33","descricao":"Carapebus"},
		{"id":"3301157","ufId":"33","descricao":"Cardoso Moreira"},
		{"id":"3301207","ufId":"33","descricao":"Carmo"},
		{"id":"3301306","ufId":"33","descricao":"Casimiro de Abreu"},
		{"id":"3300951","ufId":"33","descricao":"Comendador Levy Gasparian"},
		{"id":"3301405","ufId":"33","descricao":"Conceição de Macabu"},
		{"id":"3301504","ufId":"33","descricao":"Cordeiro"},
		{"id":"3301603","ufId":"33","descricao":"Duas Barras"},
		{"id":"3301702","ufId":"33","descricao":"Duque de Caxias"},
		{"id":"3301801","ufId":"33","descricao":"Engenheiro Paulo de Frontin"},
		{"id":"3301850","ufId":"33","descricao":"Guapimirim"},
		{"id":"3301876","ufId":"33","descricao":"Iguaba Grande"},
		{"id":"3301900","ufId":"33","descricao":"Itaboraí"},
		{"id":"3302007","ufId":"33","descricao":"Itaguaí"},
		{"id":"3302056","ufId":"33","descricao":"Italva"},
		{"id":"3302106","ufId":"33","descricao":"Itaocara"},
		{"id":"3302205","ufId":"33","descricao":"Itaperuna"},
		{"id":"3302254","ufId":"33","descricao":"Itatiaia"},
		{"id":"3302270","ufId":"33","descricao":"Japeri"},
		{"id":"3302304","ufId":"33","descricao":"Laje do Muriaé"},
		{"id":"3302403","ufId":"33","descricao":"Macaé"},
		{"id":"3302452","ufId":"33","descricao":"Macuco"},
		{"id":"3302502","ufId":"33","descricao":"Magé"},
		{"id":"3302601","ufId":"33","descricao":"Mangaratiba"},
		{"id":"3302700","ufId":"33","descricao":"Maricá"},
		{"id":"3302809","ufId":"33","descricao":"Mendes"},
		{"id":"3302858","ufId":"33","descricao":"Mesquita"},
		{"id":"3302908","ufId":"33","descricao":"Miguel Pereira"},
		{"id":"3303005","ufId":"33","descricao":"Miracema"},
		{"id":"3303104","ufId":"33","descricao":"Natividade"},
		{"id":"3303203","ufId":"33","descricao":"Nilópolis"},
		{"id":"3303302","ufId":"33","descricao":"Niterói"},
		{"id":"3303401","ufId":"33","descricao":"Nova Friburgo"},
		{"id":"3303500","ufId":"33","descricao":"Nova Iguaçu"},
		{"id":"3303609","ufId":"33","descricao":"Paracambi"},
		{"id":"3303708","ufId":"33","descricao":"Paraíba do Sul"},
		{"id":"3303807","ufId":"33","descricao":"Paraty"},
		{"id":"3303856","ufId":"33","descricao":"Paty do Alferes"},
		{"id":"3303906","ufId":"33","descricao":"Petrópolis"},
		{"id":"3303955","ufId":"33","descricao":"Pinheiral"},
		{"id":"3304003","ufId":"33","descricao":"Piraí"},
		{"id":"3304102","ufId":"33","descricao":"Porciúncula"},
		{"id":"3304110","ufId":"33","descricao":"Porto Real"},
		{"id":"3304128","ufId":"33","descricao":"Quatis"},
		{"id":"3304144","ufId":"33","descricao":"Queimados"},
		{"id":"3304151","ufId":"33","descricao":"Quissamã"},
		{"id":"3304201","ufId":"33","descricao":"Resende"},
		{"id":"3304300","ufId":"33","descricao":"Rio Bonito"},
		{"id":"3304409","ufId":"33","descricao":"Rio Claro"},
		{"id":"3304508","ufId":"33","descricao":"Rio das Flores"},
		{"id":"3304524","ufId":"33","descricao":"Rio das Ostras"},
		{"id":"3304557","ufId":"33","descricao":"Rio de Janeiro"},
		{"id":"3304607","ufId":"33","descricao":"Santa Maria Madalena"},
		{"id":"3304706","ufId":"33","descricao":"Santo Antônio de Pádua"},
		{"id":"3304805","ufId":"33","descricao":"São Fidélis"},
		{"id":"3304755","ufId":"33","descricao":"São Francisco de Itabapoana"},
		{"id":"3304904","ufId":"33","descricao":"São Gonçalo"},
		{"id":"3305000","ufId":"33","descricao":"São João da Barra"},
		{"id":"3305109","ufId":"33","descricao":"São João de Meriti"},
		{"id":"3305133","ufId":"33","descricao":"São José de Ubá"},
		{"id":"3305158","ufId":"33","descricao":"São José do Vale do Rio Preto"},
		{"id":"3305208","ufId":"33","descricao":"São Pedro da Aldeia"},
		{"id":"3305307","ufId":"33","descricao":"São Sebastião do Alto"},
		{"id":"3305406","ufId":"33","descricao":"Sapucaia"},
		{"id":"3305505","ufId":"33","descricao":"Saquarema"},
		{"id":"3305554","ufId":"33","descricao":"Seropédica"},
		{"id":"3305604","ufId":"33","descricao":"Silva Jardim"},
		{"id":"3305703","ufId":"33","descricao":"Sumidouro"},
		{"id":"3305752","ufId":"33","descricao":"Tanguá"},
		{"id":"3305802","ufId":"33","descricao":"Teresópolis"},
		{"id":"3305901","ufId":"33","descricao":"Trajano de Moraes"},
		{"id":"3306008","ufId":"33","descricao":"Três Rios"},
		{"id":"3306107","ufId":"33","descricao":"Valença"},
		{"id":"3306156","ufId":"33","descricao":"Varre-Sai"},
		{"id":"3306206","ufId":"33","descricao":"Vassouras"},
		{"id":"3306305","ufId":"33","descricao":"Volta Redonda"}
	],
	"35": [
		{"id":"3500105","ufId":"35","descricao":"Adamantina"},
		{"id":"3500204","ufId":"35","descricao":"Adolfo"},
		{"id":"3500303","ufId":"35","descricao":"Aguaí"},
		{"id":"3500402","ufId":"35","descricao":"Águas da Prata"},
		{"id":"3500501","ufId":"35","descricao":"Águas de Lindóia"},
		{"id":"3500550","ufId":"35","descricao":"Águas de Santa Bárbara"},
		{"id":"3500600","ufId":"35","descricao":"Águas de São Pedro"},
		{"id":"3500709","ufId":"35","descricao":"Agudos"},
		{"id":"3500758","ufId":"35","descricao":"Alambari"},
		{"id":"3500808","ufId":"35","descricao":"Alfredo Marcondes"},
		{"id":"3500907","ufId":"35","descricao":"Altair"},
		{"id":"3501004","ufId":"35","descricao":"Altinópolis"},
		{"id":"3501103","ufId":"35","descricao":"Alto Alegre"},
		{"id":"3501152","ufId":"35","descricao":"Alumínio"},
		{"id":"3501202","ufId":"35","descricao":"Álvares Florence"},
		{"id":"3501301","ufId":"35","descricao":"Álvares Machado"},
		{"id":"3501400","ufId":"35","descricao":"Álvaro de Carvalho"},
		{"id":"3501509","ufId":"35","descricao":"Alvinlândia"},
		{"id":"3501608","ufId":"35","descricao":"Americana"},
		{"id":"3501707","ufId":"35","descricao":"Américo Brasiliense"},
		{"id":"3501806","ufId":"35","descricao":"Américo de Campos"},
		{"id":"3501905","ufId":"35","descricao":"Amparo"},
		{"id":"3502002","ufId":"35","descricao":"Analândia"},
		{"id":"3502101","ufId":"35","descricao":"Andradina"},
		{"id":"3502200","ufId":"35","descricao":"Angatuba"},
		{"id":"3502309","ufId":"35","descricao":"Anhembi"},
		{"id":"3502408","ufId":"35","descricao":"Anhumas"},
		{"id":"3502507","ufId":"35","descricao":"Aparecida"},
		{"id":"3502606","ufId":"35","descricao":"Aparecida d'Oeste"},
		{"id":"3502705","ufId":"35","descricao":"Apiaí"},
		{"id":"3502754","ufId":"35","descricao":"Araçariguama"},
		{"id":"3502804","ufId":"35","descricao":"Araçatuba"},
		{"id":"3502903","ufId":"35","descricao":"Araçoiaba da Serra"},
		{"id":"3503000","ufId":"35","descricao":"Aramina"},
		{"id":"3503109","ufId":"35","descricao":"Arandu"},
		{"id":"3503158","ufId":"35","descricao":"Arapeí"},
		{"id":"3503208","ufId":"35","descricao":"Araraquara"},
		{"id":"3503307","ufId":"35","descricao":"Araras"},
		{"id":"3503356","ufId":"35","descricao":"Arco-Íris"},
		{"id":"3503406","ufId":"35","descricao":"Arealva"},
		{"id":"3503505","ufId":"35","descricao":"Areias"},
		{"id":"3503604","ufId":"35","descricao":"Areiópolis"},
		{"id":"3503703","ufId":"35","descricao":"Ariranha"},
		{"id":"3503802","ufId":"35","descricao":"Artur Nogueira"},
		{"id":"3503901","ufId":"35","descricao":"Arujá"},
		{"id":"3503950","ufId":"35","descricao":"Aspásia"},
		{"id":"3504008","ufId":"35","descricao":"Assis"},
		{"id":"3504107","ufId":"35","descricao":"Atibaia"},
		{"id":"3504206","ufId":"35","descricao":"Auriflama"},
		{"id":"3504305","ufId":"35","descricao":"Avaí"},
		{"id":"3504404","ufId":"35","descricao":"Avanhandava"},
		{"id":"3504503","ufId":"35","descricao":"Avaré"},
		{"id":"3504602","ufId":"35","descricao":"Bady Bassitt"},
		{"id":"3504701","ufId":"35","descricao":"Balbinos"},
		{"id":"3504800","ufId":"35","descricao":"Bálsamo"},
		{"id":"3504909","ufId":"35","descricao":"Bananal"},
		{"id":"3505005","ufId":"35","descricao":"Barão de Antonina"},
		{"id":"3505104","ufId":"35","descricao":"Barbosa"},
		{"id":"3505203","ufId":"35","descricao":"Bariri"},
		{"id":"3505302","ufId":"35","descricao":"Barra Bonita"},
		{"id":"3505351","ufId":"35","descricao":"Barra do Chapéu"},
		{"id":"3505401","ufId":"35","descricao":"Barra do Turvo"},
		{"id":"3505500","ufId":"35","descricao":"Barretos"},
		{"id":"3505609","ufId":"35","descricao":"Barrinha"},
		{"id":"3505708","ufId":"35","descricao":"Barueri"},
		{"id":"3505807","ufId":"35","descricao":"Bastos"},
		{"id":"3505906","ufId":"35","descricao":"Batatais"},
		{"id":"3506003","ufId":"35","descricao":"Bauru"},
		{"id":"3506102","ufId":"35","descricao":"Bebedouro"},
		{"id":"3506201","ufId":"35","descricao":"Bento de Abreu"},
		{"id":"3506300","ufId":"35","descricao":"Bernardino de Campos"},
		{"id":"3506359","ufId":"35","descricao":"Bertioga"},
		{"id":"3506409","ufId":"35","descricao":"Bilac"},
		{"id":"3506508","ufId":"35","descricao":"Birigui"},
		{"id":"3506607","ufId":"35","descricao":"Biritiba Mirim"},
		{"id":"3506706","ufId":"35","descricao":"Boa Esperança do Sul"},
		{"id":"3506805","ufId":"35","descricao":"Bocaina"},
		{"id":"3506904","ufId":"35","descricao":"Bofete"},
		{"id":"3507001","ufId":"35","descricao":"Boituva"},
		{"id":"3507100","ufId":"35","descricao":"Bom Jesus dos Perdões"},
		{"id":"3507159","ufId":"35","descricao":"Bom Sucesso de Itararé"},
		{"id":"3507209","ufId":"35","descricao":"Borá"},
		{"id":"3507308","ufId":"35","descricao":"Boracéia"},
		{"id":"3507407","ufId":"35","descricao":"Borborema"},
		{"id":"3507456","ufId":"35","descricao":"Borebi"},
		{"id":"3507506","ufId":"35","descricao":"Botucatu"},
		{"id":"3507605","ufId":"35","descricao":"Bragança Paulista"},
		{"id":"3507704","ufId":"35","descricao":"Braúna"},
		{"id":"3507753","ufId":"35","descricao":"Brejo Alegre"},
		{"id":"3507803","ufId":"35","descricao":"Brodowski"},
		{"id":"3507902","ufId":"35","descricao":"Brotas"},
		{"id":"3508009","ufId":"35","descricao":"Buri"},
		{"id":"3508108","ufId":"35","descricao":"Buritama"},
		{"id":"3508207","ufId":"35","descricao":"Buritizal"},
		{"id":"3508306","ufId":"35","descricao":"Cabrália Paulista"},
		{"id":"3508405","ufId":"35","descricao":"Cabreúva"},
		{"id":"3508504","ufId":"35","descricao":"Caçapava"},
		{"id":"3508603","ufId":"35","descricao":"Cachoeira Paulista"},
		{"id":"3508702","ufId":"35","descricao":"Caconde"},
		{"id":"3508801","ufId":"35","descricao":"Cafelândia"},
		{"id":"3508900","ufId":"35","descricao":"Caiabu"},
		{"id":"3509007","ufId":"35","descricao":"Caieiras"},
		{"id":"3509106","ufId":"35","descricao":"Caiuá"},
		{"id":"3509205","ufId":"35","descricao":"Cajamar"},
		{"id":"3509254","ufId":"35","descricao":"Cajati"},
		{"id":"3509304","ufId":"35","descricao":"Cajobi"},
		{"id":"3509403","ufId":"35","descricao":"Cajuru"},
		{"id":"3509452","ufId":"35","descricao":"Campina do Monte Alegre"},
		{"id":"3509502","ufId":"35","descricao":"Campinas"},
		{"id":"3509601","ufId":"35","descricao":"Campo Limpo Paulista"},
		{"id":"3509700","ufId":"35","descricao":"Campos do Jordão"},
		{"id":"3509809","ufId":"35","descricao":"Campos Novos Paulista"},
		{"id":"3509908","ufId":"35","descricao":"Cananéia"},
		{"id":"3509957","ufId":"35","descricao":"Canas"},
		{"id":"3510005","ufId":"35","descricao":"Cândido Mota"},
		{"id":"3510104","ufId":"35","descricao":"Cândido Rodrigues"},
		{"id":"3510153","ufId":"35","descricao":"Canitar"},
		{"id":"3510203","ufId":"35","descricao":"Capão Bonito"},
		{"id":"3510302","ufId":"35","descricao":"Capela do Alto"},
		{"id":"3510401","ufId":"35","descricao":"Capivari"},
		{"id":"3510500","ufId":"35","descricao":"Caraguatatuba"},
		{"id":"3510609","ufId":"35","descricao":"Carapicuíba"},
		{"id":"3510708","ufId":"35","descricao":"Cardoso"},
		{"id":"3510807","ufId":"35","descricao":"Casa Branca"},
		{"id":"3510906","ufId":"35","descricao":"Cássia dos Coqueiros"},
		{"id":"3511003","ufId":"35","descricao":"Castilho"},
		{"id":"3511102","ufId":"35","descricao":"Catanduva"},
		{"id":"3511201","ufId":"35","descricao":"Catiguá"},
		{"id":"3511300","ufId":"35","descricao":"Cedral"},
		{"id":"3511409","ufId":"35","descricao":"Cerqueira César"},
		{"id":"3511508","ufId":"35","descricao":"Cerquilho"},
		{"id":"3511607","ufId":"35","descricao":"Cesário Lange"},
		{"id":"3511706","ufId":"35","descricao":"Charqueada"},
		{"id":"3557204","ufId":"35","descricao":"Chavantes"},
		{"id":"3511904","ufId":"35","descricao":"Clementina"},
		{"id":"3512001","ufId":"35","descricao":"Colina"},
		{"id":"3512100","ufId":"35","descricao":"Colômbia"},
		{"id":"3512209","ufId":"35","descricao":"Conchal"},
		{"id":"3512308","ufId":"35","descricao":"Conchas"},
		{"id":"3512407","ufId":"35","descricao":"Cordeirópolis"},
		{"id":"3512506","ufId":"35","descricao":"Coroados"},
		{"id":"3512605","ufId":"35","descricao":"Coronel Macedo"},
		{"id":"3512704","ufId":"35","descricao":"Corumbataí"},
		{"id":"3512803","ufId":"35","descricao":"Cosmópolis"},
		{"id":"3512902","ufId":"35","descricao":"Cosmorama"},
		{"id":"3513009","ufId":"35","descricao":"Cotia"},
		{"id":"3513108","ufId":"35","descricao":"Cravinhos"},
		{"id":"3513207","ufId":"35","descricao":"Cristais Paulista"},
		{"id":"3513306","ufId":"35","descricao":"Cruzália"},
		{"id":"3513405","ufId":"35","descricao":"Cruzeiro"},
		{"id":"3513504","ufId":"35","descricao":"Cubatão"},
		{"id":"3513603","ufId":"35","descricao":"Cunha"},
		{"id":"3513702","ufId":"35","descricao":"Descalvado"},
		{"id":"3513801","ufId":"35","descricao":"Diadema"},
		{"id":"3513850","ufId":"35","descricao":"Dirce Reis"},
		{"id":"3513900","ufId":"35","descricao":"Divinolândia"},
		{"id":"3514007","ufId":"35","descricao":"Dobrada"},
		{"id":"3514106","ufId":"35","descricao":"Dois Córregos"},
		{"id":"3514205","ufId":"35","descricao":"Dolcinópolis"},
		{"id":"3514304","ufId":"35","descricao":"Dourado"},
		{"id":"3514403","ufId":"35","descricao":"Dracena"},
		{"id":"3514502","ufId":"35","descricao":"Duartina"},
		{"id":"3514601","ufId":"35","descricao":"Dumont"},
		{"id":"3514700","ufId":"35","descricao":"Echaporã"},
		{"id":"3514809","ufId":"35","descricao":"Eldorado"},
		{"id":"3514908","ufId":"35","descricao":"Elias Fausto"},
		{"id":"3514924","ufId":"35","descricao":"Elisiário"},
		{"id":"3514957","ufId":"35","descricao":"Embaúba"},
		{"id":"3515004","ufId":"35","descricao":"Embu das Artes"},
		{"id":"3515103","ufId":"35","descricao":"Embu-Guaçu"},
		{"id":"3515129","ufId":"35","descricao":"Emilianópolis"},
		{"id":"3515152","ufId":"35","descricao":"Engenheiro Coelho"},
		{"id":"3515186","ufId":"35","descricao":"Espírito Santo do Pinhal"},
		{"id":"3515194","ufId":"35","descricao":"Espírito Santo do Turvo"},
		{"id":"3557303","ufId":"35","descricao":"Estiva Gerbi"},
		{"id":"3515202","ufId":"35","descricao":"Estrela d'Oeste"},
		{"id":"3515301","ufId":"35","descricao":"Estrela do Norte"},
		{"id":"3515350","ufId":"35","descricao":"Euclides da Cunha Paulista"},
		{"id":"3515400","ufId":"35","descricao":"Fartura"},
		{"id":"3515608","ufId":"35","descricao":"Fernando Prestes"},
		{"id":"3515509","ufId":"35","descricao":"Fernandópolis"},
		{"id":"3515657","ufId":"35","descricao":"Fernão"},
		{"id":"3515707","ufId":"35","descricao":"Ferraz de Vasconcelos"},
		{"id":"3515806","ufId":"35","descricao":"Flora Rica"},
		{"id":"3515905","ufId":"35","descricao":"Floreal"},
		{"id":"3516002","ufId":"35","descricao":"Flórida Paulista"},
		{"id":"3516101","ufId":"35","descricao":"Florínea"},
		{"id":"3516200","ufId":"35","descricao":"Franca"},
		{"id":"3516309","ufId":"35","descricao":"Francisco Morato"},
		{"id":"3516408","ufId":"35","descricao":"Franco da Rocha"},
		{"id":"3516507","ufId":"35","descricao":"Gabriel Monteiro"},
		{"id":"3516606","ufId":"35","descricao":"Gália"},
		{"id":"3516705","ufId":"35","descricao":"Garça"},
		{"id":"3516804","ufId":"35","descricao":"Gastão Vidigal"},
		{"id":"3516853","ufId":"35","descricao":"Gavião Peixoto"},
		{"id":"3516903","ufId":"35","descricao":"General Salgado"},
		{"id":"3517000","ufId":"35","descricao":"Getulina"},
		{"id":"3517109","ufId":"35","descricao":"Glicério"},
		{"id":"3517208","ufId":"35","descricao":"Guaiçara"},
		{"id":"3517307","ufId":"35","descricao":"Guaimbê"},
		{"id":"3517406","ufId":"35","descricao":"Guaíra"},
		{"id":"3517505","ufId":"35","descricao":"Guapiaçu"},
		{"id":"3517604","ufId":"35","descricao":"Guapiara"},
		{"id":"3517703","ufId":"35","descricao":"Guará"},
		{"id":"3517802","ufId":"35","descricao":"Guaraçaí"},
		{"id":"3517901","ufId":"35","descricao":"Guaraci"},
		{"id":"3518008","ufId":"35","descricao":"Guarani d'Oeste"},
		{"id":"3518107","ufId":"35","descricao":"Guarantã"},
		{"id":"3518206","ufId":"35","descricao":"Guararapes"},
		{"id":"3518305","ufId":"35","descricao":"Guararema"},
		{"id":"3518404","ufId":"35","descricao":"Guaratinguetá"},
		{"id":"3518503","ufId":"35","descricao":"Guareí"},
		{"id":"3518602","ufId":"35","descricao":"Guariba"},
		{"id":"3518701","ufId":"35","descricao":"Guarujá"},
		{"id":"3518800","ufId":"35","descricao":"Guarulhos"},
		{"id":"3518859","ufId":"35","descricao":"Guatapará"},
		{"id":"3518909","ufId":"35","descricao":"Guzolândia"},
		{"id":"3519006","ufId":"35","descricao":"Herculândia"},
		{"id":"3519055","ufId":"35","descricao":"Holambra"},
		{"id":"3519071","ufId":"35","descricao":"Hortolândia"},
		{"id":"3519105","ufId":"35","descricao":"Iacanga"},
		{"id":"3519204","ufId":"35","descricao":"Iacri"},
		{"id":"3519253","ufId":"35","descricao":"Iaras"},
		{"id":"3519303","ufId":"35","descricao":"Ibaté"},
		{"id":"3519402","ufId":"35","descricao":"Ibirá"},
		{"id":"3519501","ufId":"35","descricao":"Ibirarema"},
		{"id":"3519600","ufId":"35","descricao":"Ibitinga"},
		{"id":"3519709","ufId":"35","descricao":"Ibiúna"},
		{"id":"3519808","ufId":"35","descricao":"Icém"},
		{"id":"3519907","ufId":"35","descricao":"Iepê"},
		{"id":"3520004","ufId":"35","descricao":"Igaraçu do Tietê"},
		{"id":"3520103","ufId":"35","descricao":"Igarapava"},
		{"id":"3520202","ufId":"35","descricao":"Igaratá"},
		{"id":"3520301","ufId":"35","descricao":"Iguape"},
		{"id":"3520426","ufId":"35","descricao":"Ilha Comprida"},
		{"id":"3520442","ufId":"35","descricao":"Ilha Solteira"},
		{"id":"3520400","ufId":"35","descricao":"Ilhabela"},
		{"id":"3520509","ufId":"35","descricao":"Indaiatuba"},
		{"id":"3520608","ufId":"35","descricao":"Indiana"},
		{"id":"3520707","ufId":"35","descricao":"Indiaporã"},
		{"id":"3520806","ufId":"35","descricao":"Inúbia Paulista"},
		{"id":"3520905","ufId":"35","descricao":"Ipaussu"},
		{"id":"3521002","ufId":"35","descricao":"Iperó"},
		{"id":"3521101","ufId":"35","descricao":"Ipeúna"},
		{"id":"3521150","ufId":"35","descricao":"Ipiguá"},
		{"id":"3521200","ufId":"35","descricao":"Iporanga"},
		{"id":"3521309","ufId":"35","descricao":"Ipuã"},
		{"id":"3521408","ufId":"35","descricao":"Iracemápolis"},
		{"id":"3521507","ufId":"35","descricao":"Irapuã"},
		{"id":"3521606","ufId":"35","descricao":"Irapuru"},
		{"id":"3521705","ufId":"35","descricao":"Itaberá"},
		{"id":"3521804","ufId":"35","descricao":"Itaí"},
		{"id":"3521903","ufId":"35","descricao":"Itajobi"},
		{"id":"3522000","ufId":"35","descricao":"Itaju"},
		{"id":"3522109","ufId":"35","descricao":"Itanhaém"},
		{"id":"3522158","ufId":"35","descricao":"Itaoca"},
		{"id":"3522208","ufId":"35","descricao":"Itapecerica da Serra"},
		{"id":"3522307","ufId":"35","descricao":"Itapetininga"},
		{"id":"3522406","ufId":"35","descricao":"Itapeva"},
		{"id":"3522505","ufId":"35","descricao":"Itapevi"},
		{"id":"3522604","ufId":"35","descricao":"Itapira"},
		{"id":"3522653","ufId":"35","descricao":"Itapirapuã Paulista"},
		{"id":"3522703","ufId":"35","descricao":"Itápolis"},
		{"id":"3522802","ufId":"35","descricao":"Itaporanga"},
		{"id":"3522901","ufId":"35","descricao":"Itapuí"},
		{"id":"3523008","ufId":"35","descricao":"Itapura"},
		{"id":"3523107","ufId":"35","descricao":"Itaquaquecetuba"},
		{"id":"3523206","ufId":"35","descricao":"Itararé"},
		{"id":"3523305","ufId":"35","descricao":"Itariri"},
		{"id":"3523404","ufId":"35","descricao":"Itatiba"},
		{"id":"3523503","ufId":"35","descricao":"Itatinga"},
		{"id":"3523602","ufId":"35","descricao":"Itirapina"},
		{"id":"3523701","ufId":"35","descricao":"Itirapuã"},
		{"id":"3523800","ufId":"35","descricao":"Itobi"},
		{"id":"3523909","ufId":"35","descricao":"Itu"},
		{"id":"3524006","ufId":"35","descricao":"Itupeva"},
		{"id":"3524105","ufId":"35","descricao":"Ituverava"},
		{"id":"3524204","ufId":"35","descricao":"Jaborandi"},
		{"id":"3524303","ufId":"35","descricao":"Jaboticabal"},
		{"id":"3524402","ufId":"35","descricao":"Jacareí"},
		{"id":"3524501","ufId":"35","descricao":"Jaci"},
		{"id":"3524600","ufId":"35","descricao":"Jacupiranga"},
		{"id":"3524709","ufId":"35","descricao":"Jaguariúna"},
		{"id":"3524808","ufId":"35","descricao":"Jales"},
		{"id":"3524907","ufId":"35","descricao":"Jambeiro"},
		{"id":"3525003","ufId":"35","descricao":"Jandira"},
		{"id":"3525102","ufId":"35","descricao":"Jardinópolis"},
		{"id":"3525201","ufId":"35","descricao":"Jarinu"},
		{"id":"3525300","ufId":"35","descricao":"Jaú"},
		{"id":"3525409","ufId":"35","descricao":"Jeriquara"},
		{"id":"3525508","ufId":"35","descricao":"Joanópolis"},
		{"id":"3525607","ufId":"35","descricao":"João Ramalho"},
		{"id":"3525706","ufId":"35","descricao":"José Bonifácio"},
		{"id":"3525805","ufId":"35","descricao":"Júlio Mesquita"},
		{"id":"3525854","ufId":"35","descricao":"Jumirim"},
		{"id":"3525904","ufId":"35","descricao":"Jundiaí"},
		{"id":"3526001","ufId":"35","descricao":"Junqueirópolis"},
		{"id":"3526100","ufId":"35","descricao":"Juquiá"},
		{"id":"3526209","ufId":"35","descricao":"Juquitiba"},
		{"id":"3526308","ufId":"35","descricao":"Lagoinha"},
		{"id":"3526407","ufId":"35","descricao":"Laranjal Paulista"},
		{"id":"3526506","ufId":"35","descricao":"Lavínia"},
		{"id":"3526605","ufId":"35","descricao":"Lavrinhas"},
		{"id":"3526704","ufId":"35","descricao":"Leme"},
		{"id":"3526803","ufId":"35","descricao":"Lençóis Paulista"},
		{"id":"3526902","ufId":"35","descricao":"Limeira"},
		{"id":"3527009","ufId":"35","descricao":"Lindóia"},
		{"id":"3527108","ufId":"35","descricao":"Lins"},
		{"id":"3527207","ufId":"35","descricao":"Lorena"},
		{"id":"3527256","ufId":"35","descricao":"Lourdes"},
		{"id":"3527306","ufId":"35","descricao":"Louveira"},
		{"id":"3527405","ufId":"35","descricao":"Lucélia"},
		{"id":"3527504","ufId":"35","descricao":"Lucianópolis"},
		{"id":"3527603","ufId":"35","descricao":"Luís Antônio"},
		{"id":"3527702","ufId":"35","descricao":"Luiziânia"},
		{"id":"3527801","ufId":"35","descricao":"Lupércio"},
		{"id":"3527900","ufId":"35","descricao":"Lutécia"},
		{"id":"3528007","ufId":"35","descricao":"Macatuba"},
		{"id":"3528106","ufId":"35","descricao":"Macaubal"},
		{"id":"3528205","ufId":"35","descricao":"Macedônia"},
		{"id":"3528304","ufId":"35","descricao":"Magda"},
		{"id":"3528403","ufId":"35","descricao":"Mairinque"},
		{"id":"3528502","ufId":"35","descricao":"Mairiporã"},
		{"id":"3528601","ufId":"35","descricao":"Manduri"},
		{"id":"3528700","ufId":"35","descricao":"Marabá Paulista"},
		{"id":"3528809","ufId":"35","descricao":"Maracaí"},
		{"id":"3528858","ufId":"35","descricao":"Marapoama"},
		{"id":"3528908","ufId":"35","descricao":"Mariápolis"},
		{"id":"3529005","ufId":"35","descricao":"Marília"},
		{"id":"3529104","ufId":"35","descricao":"Marinópolis"},
		{"id":"3529203","ufId":"35","descricao":"Martinópolis"},
		{"id":"3529302","ufId":"35","descricao":"Matão"},
		{"id":"3529401","ufId":"35","descricao":"Mauá"},
		{"id":"3529500","ufId":"35","descricao":"Mendonça"},
		{"id":"3529609","ufId":"35","descricao":"Meridiano"},
		{"id":"3529658","ufId":"35","descricao":"Mesópolis"},
		{"id":"3529708","ufId":"35","descricao":"Miguelópolis"},
		{"id":"3529807","ufId":"35","descricao":"Mineiros do Tietê"},
		{"id":"3530003","ufId":"35","descricao":"Mira Estrela"},
		{"id":"3529906","ufId":"35","descricao":"Miracatu"},
		{"id":"3530102","ufId":"35","descricao":"Mirandópolis"},
		{"id":"3530201","ufId":"35","descricao":"Mirante do Paranapanema"},
		{"id":"3530300","ufId":"35","descricao":"Mirassol"},
		{"id":"3530409","ufId":"35","descricao":"Mirassolândia"},
		{"id":"3530508","ufId":"35","descricao":"Mococa"},
		{"id":"3530607","ufId":"35","descricao":"Mogi das Cruzes"},
		{"id":"3530706","ufId":"35","descricao":"Mogi Guaçu"},
		{"id":"3530805","ufId":"35","descricao":"Mogi Mirim"},
		{"id":"3530904","ufId":"35","descricao":"Mombuca"},
		{"id":"3531001","ufId":"35","descricao":"Monções"},
		{"id":"3531100","ufId":"35","descricao":"Mongaguá"},
		{"id":"3531209","ufId":"35","descricao":"Monte Alegre do Sul"},
		{"id":"3531308","ufId":"35","descricao":"Monte Alto"},
		{"id":"3531407","ufId":"35","descricao":"Monte Aprazível"},
		{"id":"3531506","ufId":"35","descricao":"Monte Azul Paulista"},
		{"id":"3531605","ufId":"35","descricao":"Monte Castelo"},
		{"id":"3531803","ufId":"35","descricao":"Monte Mor"},
		{"id":"3531704","ufId":"35","descricao":"Monteiro Lobato"},
		{"id":"3531902","ufId":"35","descricao":"Morro Agudo"},
		{"id":"3532009","ufId":"35","descricao":"Morungaba"},
		{"id":"3532058","ufId":"35","descricao":"Motuca"},
		{"id":"3532108","ufId":"35","descricao":"Murutinga do Sul"},
		{"id":"3532157","ufId":"35","descricao":"Nantes"},
		{"id":"3532207","ufId":"35","descricao":"Narandiba"},
		{"id":"3532306","ufId":"35","descricao":"Natividade da Serra"},
		{"id":"3532405","ufId":"35","descricao":"Nazaré Paulista"},
		{"id":"3532504","ufId":"35","descricao":"Neves Paulista"},
		{"id":"3532603","ufId":"35","descricao":"Nhandeara"},
		{"id":"3532702","ufId":"35","descricao":"Nipoã"},
		{"id":"3532801","ufId":"35","descricao":"Nova Aliança"},
		{"id":"3532827","ufId":"35","descricao":"Nova Campina"},
		{"id":"3532843","ufId":"35","descricao":"Nova Canaã Paulista"},
		{"id":"3532868","ufId":"35","descricao":"Nova Castilho"},
		{"id":"3532900","ufId":"35","descricao":"Nova Europa"},
		{"id":"3533007","ufId":"35","descricao":"Nova Granada"},
		{"id":"3533106","ufId":"35","descricao":"Nova Guataporanga"},
		{"id":"3533205","ufId":"35","descricao":"Nova Independência"},
		{"id":"3533304","ufId":"35","descricao":"Nova Luzitânia"},
		{"id":"3533403","ufId":"35","descricao":"Nova Odessa"},
		{"id":"3533254","ufId":"35","descricao":"Novais"},
		{"id":"3533502","ufId":"35","descricao":"Novo Horizonte"},
		{"id":"3533601","ufId":"35","descricao":"Nuporanga"},
		{"id":"3533700","ufId":"35","descricao":"Ocauçu"},
		{"id":"3533809","ufId":"35","descricao":"Óleo"},
		{"id":"3533908","ufId":"35","descricao":"Olímpia"},
		{"id":"3534005","ufId":"35","descricao":"Onda Verde"},
		{"id":"3534104","ufId":"35","descricao":"Oriente"},
		{"id":"3534203","ufId":"35","descricao":"Orindiúva"},
		{"id":"3534302","ufId":"35","descricao":"Orlândia"},
		{"id":"3534401","ufId":"35","descricao":"Osasco"},
		{"id":"3534500","ufId":"35","descricao":"Oscar Bressane"},
		{"id":"3534609","ufId":"35","descricao":"Osvaldo Cruz"},
		{"id":"3534708","ufId":"35","descricao":"Ourinhos"},
		{"id":"3534807","ufId":"35","descricao":"Ouro Verde"},
		{"id":"3534757","ufId":"35","descricao":"Ouroeste"},
		{"id":"3534906","ufId":"35","descricao":"Pacaembu"},
		{"id":"3535002","ufId":"35","descricao":"Palestina"},
		{"id":"3535101","ufId":"35","descricao":"Palmares Paulista"},
		{"id":"3535200","ufId":"35","descricao":"Palmeira d'Oeste"},
		{"id":"3535309","ufId":"35","descricao":"Palmital"},
		{"id":"3535408","ufId":"35","descricao":"Panorama"},
		{"id":"3535507","ufId":"35","descricao":"Paraguaçu Paulista"},
		{"id":"3535606","ufId":"35","descricao":"Paraibuna"},
		{"id":"3535705","ufId":"35","descricao":"Paraíso"},
		{"id":"3535804","ufId":"35","descricao":"Paranapanema"},
		{"id":"3535903","ufId":"35","descricao":"Paranapuã"},
		{"id":"3536000","ufId":"35","descricao":"Parapuã"},
		{"id":"3536109","ufId":"35","descricao":"Pardinho"},
		{"id":"3536208","ufId":"35","descricao":"Pariquera-Açu"},
		{"id":"3536257","ufId":"35","descricao":"Parisi"},
		{"id":"3536307","ufId":"35","descricao":"Patrocínio Paulista"},
		{"id":"3536406","ufId":"35","descricao":"Paulicéia"},
		{"id":"3536505","ufId":"35","descricao":"Paulínia"},
		{"id":"3536570","ufId":"35","descricao":"Paulistânia"},
		{"id":"3536604","ufId":"35","descricao":"Paulo de Faria"},
		{"id":"3536703","ufId":"35","descricao":"Pederneiras"},
		{"id":"3536802","ufId":"35","descricao":"Pedra Bela"},
		{"id":"3536901","ufId":"35","descricao":"Pedranópolis"},
		{"id":"3537008","ufId":"35","descricao":"Pedregulho"},
		{"id":"3537107","ufId":"35","descricao":"Pedreira"},
		{"id":"3537156","ufId":"35","descricao":"Pedrinhas Paulista"},
		{"id":"3537206","ufId":"35","descricao":"Pedro de Toledo"},
		{"id":"3537305","ufId":"35","descricao":"Penápolis"},
		{"id":"3537404","ufId":"35","descricao":"Pereira Barreto"},
		{"id":"3537503","ufId":"35","descricao":"Pereiras"},
		{"id":"3537602","ufId":"35","descricao":"Peruíbe"},
		{"id":"3537701","ufId":"35","descricao":"Piacatu"},
		{"id":"3537800","ufId":"35","descricao":"Piedade"},
		{"id":"3537909","ufId":"35","descricao":"Pilar do Sul"},
		{"id":"3538006","ufId":"35","descricao":"Pindamonhangaba"},
		{"id":"3538105","ufId":"35","descricao":"Pindorama"},
		{"id":"3538204","ufId":"35","descricao":"Pinhalzinho"},
		{"id":"3538303","ufId":"35","descricao":"Piquerobi"},
		{"id":"3538501","ufId":"35","descricao":"Piquete"},
		{"id":"3538600","ufId":"35","descricao":"Piracaia"},
		{"id":"3538709","ufId":"35","descricao":"Piracicaba"},
		{"id":"3538808","ufId":"35","descricao":"Piraju"},
		{"id":"3538907","ufId":"35","descricao":"Pirajuí"},
		{"id":"3539004","ufId":"35","descricao":"Pirangi"},
		{"id":"3539103","ufId":"35","descricao":"Pirapora do Bom Jesus"},
		{"id":"3539202","ufId":"35","descricao":"Pirapozinho"},
		{"id":"3539301","ufId":"35","descricao":"Pirassununga"},
		{"id":"3539400","ufId":"35","descricao":"Piratininga"},
		{"id":"3539509","ufId":"35","descricao":"Pitangueiras"},
		{"id":"3539608","ufId":"35","descricao":"Planalto"},
		{"id":"3539707","ufId":"35","descricao":"Platina"},
		{"id":"3539806","ufId":"35","descricao":"Poá"},
		{"id":"3539905","ufId":"35","descricao":"Poloni"},
		{"id":"3540002","ufId":"35","descricao":"Pompéia"},
		{"id":"3540101","ufId":"35","descricao":"Pongaí"},
		{"id":"3540200","ufId":"35","descricao":"Pontal"},
		{"id":"3540259","ufId":"35","descricao":"Pontalinda"},
		{"id":"3540309","ufId":"35","descricao":"Pontes Gestal"},
		{"id":"3540408","ufId":"35","descricao":"Populina"},
		{"id":"3540507","ufId":"35","descricao":"Porangaba"},
		{"id":"3540606","ufId":"35","descricao":"Porto Feliz"},
		{"id":"3540705","ufId":"35","descricao":"Porto Ferreira"},
		{"id":"3540754","ufId":"35","descricao":"Potim"},
		{"id":"3540804","ufId":"35","descricao":"Potirendaba"},
		{"id":"3540853","ufId":"35","descricao":"Pracinha"},
		{"id":"3540903","ufId":"35","descricao":"Pradópolis"},
		{"id":"3541000","ufId":"35","descricao":"Praia Grande"},
		{"id":"3541059","ufId":"35","descricao":"Pratânia"},
		{"id":"3541109","ufId":"35","descricao":"Presidente Alves"},
		{"id":"3541208","ufId":"35","descricao":"Presidente Bernardes"},
		{"id":"3541307","ufId":"35","descricao":"Presidente Epitácio"},
		{"id":"3541406","ufId":"35","descricao":"Presidente Prudente"},
		{"id":"3541505","ufId":"35","descricao":"Presidente Venceslau"},
		{"id":"3541604","ufId":"35","descricao":"Promissão"},
		{"id":"3541653","ufId":"35","descricao":"Quadra"},
		{"id":"3541703","ufId":"35","descricao":"Quatá"},
		{"id":"3541802","ufId":"35","descricao":"Queiroz"},
		{"id":"3541901","ufId":"35","descricao":"Queluz"},
		{"id":"3542008","ufId":"35","descricao":"Quintana"},
		{"id":"3542107","ufId":"35","descricao":"Rafard"},
		{"id":"3542206","ufId":"35","descricao":"Rancharia"},
		{"id":"3542305","ufId":"35","descricao":"Redenção da Serra"},
		{"id":"3542404","ufId":"35","descricao":"Regente Feijó"},
		{"id":"3542503","ufId":"35","descricao":"Reginópolis"},
		{"id":"3542602","ufId":"35","descricao":"Registro"},
		{"id":"3542701","ufId":"35","descricao":"Restinga"},
		{"id":"3542800","ufId":"35","descricao":"Ribeira"},
		{"id":"3542909","ufId":"35","descricao":"Ribeirão Bonito"},
		{"id":"3543006","ufId":"35","descricao":"Ribeirão Branco"},
		{"id":"3543105","ufId":"35","descricao":"Ribeirão Corrente"},
		{"id":"3543204","ufId":"35","descricao":"Ribeirão do Sul"},
		{"id":"3543238","ufId":"35","descricao":"Ribeirão dos Índios"},
		{"id":"3543253","ufId":"35","descricao":"Ribeirão Grande"},
		{"id":"3543303","ufId":"35","descricao":"Ribeirão Pires"},
		{"id":"3543402","ufId":"35","descricao":"Ribeirão Preto"},
		{"id":"3543600","ufId":"35","descricao":"Rifaina"},
		{"id":"3543709","ufId":"35","descricao":"Rincão"},
		{"id":"3543808","ufId":"35","descricao":"Rinópolis"},
		{"id":"3543907","ufId":"35","descricao":"Rio Claro"},
		{"id":"3544004","ufId":"35","descricao":"Rio das Pedras"},
		{"id":"3544103","ufId":"35","descricao":"Rio Grande da Serra"},
		{"id":"3544202","ufId":"35","descricao":"Riolândia"},
		{"id":"3543501","ufId":"35","descricao":"Riversul"},
		{"id":"3544251","ufId":"35","descricao":"Rosana"},
		{"id":"3544301","ufId":"35","descricao":"Roseira"},
		{"id":"3544400","ufId":"35","descricao":"Rubiácea"},
		{"id":"3544509","ufId":"35","descricao":"Rubinéia"},
		{"id":"3544608","ufId":"35","descricao":"Sabino"},
		{"id":"3544707","ufId":"35","descricao":"Sagres"},
		{"id":"3544806","ufId":"35","descricao":"Sales"},
		{"id":"3544905","ufId":"35","descricao":"Sales Oliveira"},
		{"id":"3545001","ufId":"35","descricao":"Salesópolis"},
		{"id":"3545100","ufId":"35","descricao":"Salmourão"},
		{"id":"3545159","ufId":"35","descricao":"Saltinho"},
		{"id":"3545209","ufId":"35","descricao":"Salto"},
		{"id":"3545308","ufId":"35","descricao":"Salto de Pirapora"},
		{"id":"3545407","ufId":"35","descricao":"Salto Grande"},
		{"id":"3545506","ufId":"35","descricao":"Sandovalina"},
		{"id":"3545605","ufId":"35","descricao":"Santa Adélia"},
		{"id":"3545704","ufId":"35","descricao":"Santa Albertina"},
		{"id":"3545803","ufId":"35","descricao":"Santa Bárbara d'Oeste"},
		{"id":"3546009","ufId":"35","descricao":"Santa Branca"},
		{"id":"3546108","ufId":"35","descricao":"Santa Clara d'Oeste"},
		{"id":"3546207","ufId":"35","descricao":"Santa Cruz da Conceição"},
		{"id":"3546256","ufId":"35","descricao":"Santa Cruz da Esperança"},
		{"id":"3546306","ufId":"35","descricao":"Santa Cruz das Palmeiras"},
		{"id":"3546405","ufId":"35","descricao":"Santa Cruz do Rio Pardo"},
		{"id":"3546504","ufId":"35","descricao":"Santa Ernestina"},
		{"id":"3546603","ufId":"35","descricao":"Santa Fé do Sul"},
		{"id":"3546702","ufId":"35","descricao":"Santa Gertrudes"},
		{"id":"3546801","ufId":"35","descricao":"Santa Isabel"},
		{"id":"3546900","ufId":"35","descricao":"Santa Lúcia"},
		{"id":"3547007","ufId":"35","descricao":"Santa Maria da Serra"},
		{"id":"3547106","ufId":"35","descricao":"Santa Mercedes"},
		{"id":"3547403","ufId":"35","descricao":"Santa Rita d'Oeste"},
		{"id":"3547502","ufId":"35","descricao":"Santa Rita do Passa Quatro"},
		{"id":"3547601","ufId":"35","descricao":"Santa Rosa de Viterbo"},
		{"id":"3547650","ufId":"35","descricao":"Santa Salete"},
		{"id":"3547205","ufId":"35","descricao":"Santana da Ponte Pensa"},
		{"id":"3547304","ufId":"35","descricao":"Santana de Parnaíba"},
		{"id":"3547700","ufId":"35","descricao":"Santo Anastácio"},
		{"id":"3547809","ufId":"35","descricao":"Santo André"},
		{"id":"3547908","ufId":"35","descricao":"Santo Antônio da Alegria"},
		{"id":"3548005","ufId":"35","descricao":"Santo Antônio de Posse"},
		{"id":"3548054","ufId":"35","descricao":"Santo Antônio do Aracanguá"},
		{"id":"3548104","ufId":"35","descricao":"Santo Antônio do Jardim"},
		{"id":"3548203","ufId":"35","descricao":"Santo Antônio do Pinhal"},
		{"id":"3548302","ufId":"35","descricao":"Santo Expedito"},
		{"id":"3548401","ufId":"35","descricao":"Santópolis do Aguapeí"},
		{"id":"3548500","ufId":"35","descricao":"Santos"},
		{"id":"3548609","ufId":"35","descricao":"São Bento do Sapucaí"},
		{"id":"3548708","ufId":"35","descricao":"São Bernardo do Campo"},
		{"id":"3548807","ufId":"35","descricao":"São Caetano do Sul"},
		{"id":"3548906","ufId":"35","descricao":"São Carlos"},
		{"id":"3549003","ufId":"35","descricao":"São Francisco"},
		{"id":"3549102","ufId":"35","descricao":"São João da Boa Vista"},
		{"id":"3549201","ufId":"35","descricao":"São João das Duas Pontes"},
		{"id":"3549250","ufId":"35","descricao":"São João de Iracema"},
		{"id":"3549300","ufId":"35","descricao":"São João do Pau d'Alho"},
		{"id":"3549409","ufId":"35","descricao":"São Joaquim da Barra"},
		{"id":"3549508","ufId":"35","descricao":"São José da Bela Vista"},
		{"id":"3549607","ufId":"35","descricao":"São José do Barreiro"},
		{"id":"3549706","ufId":"35","descricao":"São José do Rio Pardo"},
		{"id":"3549805","ufId":"35","descricao":"São José do Rio Preto"},
		{"id":"3549904","ufId":"35","descricao":"São José dos Campos"},
		{"id":"3549953","ufId":"35","descricao":"São Lourenço da Serra"},
		{"id":"3550001","ufId":"35","descricao":"São Luiz do Paraitinga"},
		{"id":"3550100","ufId":"35","descricao":"São Manuel"},
		{"id":"3550209","ufId":"35","descricao":"São Miguel Arcanjo"},
		{"id":"3550308","ufId":"35","descricao":"São Paulo"},
		{"id":"3550407","ufId":"35","descricao":"São Pedro"},
		{"id":"3550506","ufId":"35","descricao":"São Pedro do Turvo"},
		{"id":"3550605","ufId":"35","descricao":"São Roque"},
		{"id":"3550704","ufId":"35","descricao":"São Sebastião"},
		{"id":"3550803","ufId":"35","descricao":"São Sebastião da Grama"},
		{"id":"3550902","ufId":"35","descricao":"São Simão"},
		{"id":"3551009","ufId":"35","descricao":"São Vicente"},
		{"id":"3551108","ufId":"35","descricao":"Sarapuí"},
		{"id":"3551207","ufId":"35","descricao":"Sarutaiá"},
		{"id":"3551306","ufId":"35","descricao":"Sebastianópolis do Sul"},
		{"id":"3551405","ufId":"35","descricao":"Serra Azul"},
		{"id":"3551603","ufId":"35","descricao":"Serra Negra"},
		{"id":"3551504","ufId":"35","descricao":"Serrana"},
		{"id":"3551702","ufId":"35","descricao":"Sertãozinho"},
		{"id":"3551801","ufId":"35","descricao":"Sete Barras"},
		{"id":"3551900","ufId":"35","descricao":"Severínia"},
		{"id":"3552007","ufId":"35","descricao":"Silveiras"},
		{"id":"3552106","ufId":"35","descricao":"Socorro"},
		{"id":"3552205","ufId":"35","descricao":"Sorocaba"},
		{"id":"3552304","ufId":"35","descricao":"Sud Mennucci"},
		{"id":"3552403","ufId":"35","descricao":"Sumaré"},
		{"id":"3552551","ufId":"35","descricao":"Suzanápolis"},
		{"id":"3552502","ufId":"35","descricao":"Suzano"},
		{"id":"3552601","ufId":"35","descricao":"Tabapuã"},
		{"id":"3552700","ufId":"35","descricao":"Tabatinga"},
		{"id":"3552809","ufId":"35","descricao":"Taboão da Serra"},
		{"id":"3552908","ufId":"35","descricao":"Taciba"},
		{"id":"3553005","ufId":"35","descricao":"Taguaí"},
		{"id":"3553104","ufId":"35","descricao":"Taiaçu"},
		{"id":"3553203","ufId":"35","descricao":"Taiúva"},
		{"id":"3553302","ufId":"35","descricao":"Tambaú"},
		{"id":"3553401","ufId":"35","descricao":"Tanabi"},
		{"id":"3553500","ufId":"35","descricao":"Tapiraí"},
		{"id":"3553609","ufId":"35","descricao":"Tapiratiba"},
		{"id":"3553658","ufId":"35","descricao":"Taquaral"},
		{"id":"3553708","ufId":"35","descricao":"Taquaritinga"},
		{"id":"3553807","ufId":"35","descricao":"Taquarituba"},
		{"id":"3553856","ufId":"35","descricao":"Taquarivaí"},
		{"id":"3553906","ufId":"35","descricao":"Tarabai"},
		{"id":"3553955","ufId":"35","descricao":"Tarumã"},
		{"id":"3554003","ufId":"35","descricao":"Tatuí"},
		{"id":"3554102","ufId":"35","descricao":"Taubaté"},
		{"id":"3554201","ufId":"35","descricao":"Tejupá"},
		{"id":"3554300","ufId":"35","descricao":"Teodoro Sampaio"},
		{"id":"3554409","ufId":"35","descricao":"Terra Roxa"},
		{"id":"3554508","ufId":"35","descricao":"Tietê"},
		{"id":"3554607","ufId":"35","descricao":"Timburi"},
		{"id":"3554656","ufId":"35","descricao":"Torre de Pedra"},
		{"id":"3554706","ufId":"35","descricao":"Torrinha"},
		{"id":"3554755","ufId":"35","descricao":"Trabiju"},
		{"id":"3554805","ufId":"35","descricao":"Tremembé"},
		{"id":"3554904","ufId":"35","descricao":"Três Fronteiras"},
		{"id":"3554953","ufId":"35","descricao":"Tuiuti"},
		{"id":"3555000","ufId":"35","descricao":"Tupã"},
		{"id":"3555109","ufId":"35","descricao":"Tupi Paulista"},
		{"id":"3555208","ufId":"35","descricao":"Turiúba"},
		{"id":"3555307","ufId":"35","descricao":"Turmalina"},
		{"id":"3555356","ufId":"35","descricao":"Ubarana"},
		{"id":"3555406","ufId":"35","descricao":"Ubatuba"},
		{"id":"3555505","ufId":"35","descricao":"Ubirajara"},
		{"id":"3555604","ufId":"35","descricao":"Uchoa"},
		{"id":"3555703","ufId":"35","descricao":"União Paulista"},
		{"id":"3555802","ufId":"35","descricao":"Urânia"},
		{"id":"3555901","ufId":"35","descricao":"Uru"},
		{"id":"3556008","ufId":"35","descricao":"Urupês"},
		{"id":"3556107","ufId":"35","descricao":"Valentim Gentil"},
		{"id":"3556206","ufId":"35","descricao":"Valinhos"},
		{"id":"3556305","ufId":"35","descricao":"Valparaíso"},
		{"id":"3556354","ufId":"35","descricao":"Vargem"},
		{"id":"3556404","ufId":"35","descricao":"Vargem Grande do Sul"},
		{"id":"3556453","ufId":"35","descricao":"Vargem Grande Paulista"},
		{"id":"3556503","ufId":"35","descricao":"Várzea Paulista"},
		{"id":"3556602","ufId":"35","descricao":"Vera Cruz"},
		{"id":"3556701","ufId":"35","descricao":"Vinhedo"},
		{"id":"3556800","ufId":"35","descricao":"Viradouro"},
		{"id":"3556909","ufId":"35","descricao":"Vista Alegre do Alto"},
		{"id":"3556958","ufId":"35","descricao":"Vitória Brasil"},
		{"id":"3557006","ufId":"35","descricao":"Votorantim"},
		{"id":"3557105","ufId":"35","descricao":"Votuporanga"},
		{"id":"3557154","ufId":"35","descricao":"Zacarias"}
	],
	"41": [
		{"id":"4100103","ufId":"41","descricao":"Abatiá"},
		{"id":"4100202","ufId":"41","descricao":"Adrianópolis"},
		{"id":"4100301","ufId":"41","descricao":"Agudos do Sul"},
		{"id":"4100400","ufId":"41","descricao":"Almirante Tamandaré"},
		{"id":"4100459","ufId":"41","descricao":"Altamira do Paraná"},
		{"id":"4128625","ufId":"41","descricao":"Alto Paraíso"},
		{"id":"4100608","ufId":"41","descricao":"Alto Paraná"},
		{"id":"4100707","ufId":"41","descricao":"Alto Piquiri"},
		{"id":"4100509","ufId":"41","descricao":"Altônia"},
		{"id":"4100806","ufId":"41","descricao":"Alvorada do Sul"},
		{"id":"4100905","ufId":"41","descricao":"Amaporã"},
		{"id":"4101002","ufId":"41","descricao":"Ampére"},
		{"id":"4101051","ufId":"41","descricao":"Anahy"},
		{"id":"4101101","ufId":"41","descricao":"Andirá"},
		{"id":"4101150","ufId":"41","descricao":"Ângulo"},
		{"id":"4101200","ufId":"41","descricao":"Antonina"},
		{"id":"4101309","ufId":"41","descricao":"Antônio Olinto"},
		{"id":"4101408","ufId":"41","descricao":"Apucarana"},
		{"id":"4101507","ufId":"41","descricao":"Arapongas"},
		{"id":"4101606","ufId":"41","descricao":"Arapoti"},
		{"id":"4101655","ufId":"41","descricao":"Arapuã"},
		{"id":"4101705","ufId":"41","descricao":"Araruna"},
		{"id":"4101804","ufId":"41","descricao":"Araucária"},
		{"id":"4101853","ufId":"41","descricao":"Ariranha do Ivaí"},
		{"id":"4101903","ufId":"41","descricao":"Assaí"},
		{"id":"4102000","ufId":"41","descricao":"Assis Chateaubriand"},
		{"id":"4102109","ufId":"41","descricao":"Astorga"},
		{"id":"4102208","ufId":"41","descricao":"Atalaia"},
		{"id":"4102307","ufId":"41","descricao":"Balsa Nova"},
		{"id":"4102406","ufId":"41","descricao":"Bandeirantes"},
		{"id":"4102505","ufId":"41","descricao":"Barbosa Ferraz"},
		{"id":"4102703","ufId":"41","descricao":"Barra do Jacaré"},
		{"id":"4102604","ufId":"41","descricao":"Barracão"},
		{"id":"4102752","ufId":"41","descricao":"Bela Vista da Caroba"},
		{"id":"4102802","ufId":"41","descricao":"Bela Vista do Paraíso"},
		{"id":"4102901","ufId":"41","descricao":"Bituruna"},
		{"id":"4103008","ufId":"41","descricao":"Boa Esperança"},
		{"id":"4103024","ufId":"41","descricao":"Boa Esperança do Iguaçu"},
		{"id":"4103040","ufId":"41","descricao":"Boa Ventura de São Roque"},
		{"id":"4103057","ufId":"41","descricao":"Boa Vista da Aparecida"},
		{"id":"4103107","ufId":"41","descricao":"Bocaiúva do Sul"},
		{"id":"4103156","ufId":"41","descricao":"Bom Jesus do Sul"},
		{"id":"4103206","ufId":"41","descricao":"Bom Sucesso"},
		{"id":"4103222","ufId":"41","descricao":"Bom Sucesso do Sul"},
		{"id":"4103305","ufId":"41","descricao":"Borrazópolis"},
		{"id":"4103354","ufId":"41","descricao":"Braganey"},
		{"id":"4103370","ufId":"41","descricao":"Brasilândia do Sul"},
		{"id":"4103404","ufId":"41","descricao":"Cafeara"},
		{"id":"4103453","ufId":"41","descricao":"Cafelândia"},
		{"id":"4103479","ufId":"41","descricao":"Cafezal do Sul"},
		{"id":"4103503","ufId":"41","descricao":"Califórnia"},
		{"id":"4103602","ufId":"41","descricao":"Cambará"},
		{"id":"4103701","ufId":"41","descricao":"Cambé"},
		{"id":"4103800","ufId":"41","descricao":"Cambira"},
		{"id":"4103909","ufId":"41","descricao":"Campina da Lagoa"},
		{"id":"4103958","ufId":"41","descricao":"Campina do Simão"},
		{"id":"4104006","ufId":"41","descricao":"Campina Grande do Sul"},
		{"id":"4104055","ufId":"41","descricao":"Campo Bonito"},
		{"id":"4104105","ufId":"41","descricao":"Campo do Tenente"},
		{"id":"4104204","ufId":"41","descricao":"Campo Largo"},
		{"id":"4104253","ufId":"41","descricao":"Campo Magro"},
		{"id":"4104303","ufId":"41","descricao":"Campo Mourão"},
		{"id":"4104402","ufId":"41","descricao":"Cândido de Abreu"},
		{"id":"4104428","ufId":"41","descricao":"Candói"},
		{"id":"4104451","ufId":"41","descricao":"Cantagalo"},
		{"id":"4104501","ufId":"41","descricao":"Capanema"},
		{"id":"4104600","ufId":"41","descricao":"Capitão Leônidas Marques"},
		{"id":"4104659","ufId":"41","descricao":"Carambeí"},
		{"id":"4104709","ufId":"41","descricao":"Carlópolis"},
		{"id":"4104808","ufId":"41","descricao":"Cascavel"},
		{"id":"4104907","ufId":"41","descricao":"Castro"},
		{"id":"4105003","ufId":"41","descricao":"Catanduvas"},
		{"id":"4105102","ufId":"41","descricao":"Centenário do Sul"},
		{"id":"4105201","ufId":"41","descricao":"Cerro Azul"},
		{"id":"4105300","ufId":"41","descricao":"Céu Azul"},
		{"id":"4105409","ufId":"41","descricao":"Chopinzinho"},
		{"id":"4105508","ufId":"41","descricao":"Cianorte"},
		{"id":"4105607","ufId":"41","descricao":"Cidade Gaúcha"},
		{"id":"4105706","ufId":"41","descricao":"Clevelândia"},
		{"id":"4105805","ufId":"41","descricao":"Colombo"},
		{"id":"4105904","ufId":"41","descricao":"Colorado"},
		{"id":"4106001","ufId":"41","descricao":"Congonhinhas"},
		{"id":"4106100","ufId":"41","descricao":"Conselheiro Mairinck"},
		{"id":"4106209","ufId":"41","descricao":"Contenda"},
		{"id":"4106308","ufId":"41","descricao":"Corbélia"},
		{"id":"4106407","ufId":"41","descricao":"Cornélio Procópio"},
		{"id":"4106456","ufId":"41","descricao":"Coronel Domingos Soares"},
		{"id":"4106506","ufId":"41","descricao":"Coronel Vivida"},
		{"id":"4106555","ufId":"41","descricao":"Corumbataí do Sul"},
		{"id":"4106803","ufId":"41","descricao":"Cruz Machado"},
		{"id":"4106571","ufId":"41","descricao":"Cruzeiro do Iguaçu"},
		{"id":"4106605","ufId":"41","descricao":"Cruzeiro do Oeste"},
		{"id":"4106704","ufId":"41","descricao":"Cruzeiro do Sul"},
		{"id":"4106852","ufId":"41","descricao":"Cruzmaltina"},
		{"id":"4106902","ufId":"41","descricao":"Curitiba"},
		{"id":"4107009","ufId":"41","descricao":"Curiúva"},
		{"id":"4107157","ufId":"41","descricao":"Diamante D'Oeste"},
		{"id":"4107108","ufId":"41","descricao":"Diamante do Norte"},
		{"id":"4107124","ufId":"41","descricao":"Diamante do Sul"},
		{"id":"4107207","ufId":"41","descricao":"Dois Vizinhos"},
		{"id":"4107256","ufId":"41","descricao":"Douradina"},
		{"id":"4107306","ufId":"41","descricao":"Doutor Camargo"},
		{"id":"4128633","ufId":"41","descricao":"Doutor Ulysses"},
		{"id":"4107405","ufId":"41","descricao":"Enéas Marques"},
		{"id":"4107504","ufId":"41","descricao":"Engenheiro Beltrão"},
		{"id":"4107538","ufId":"41","descricao":"Entre Rios do Oeste"},
		{"id":"4107520","ufId":"41","descricao":"Esperança Nova"},
		{"id":"4107546","ufId":"41","descricao":"Espigão Alto do Iguaçu"},
		{"id":"4107553","ufId":"41","descricao":"Farol"},
		{"id":"4107603","ufId":"41","descricao":"Faxinal"},
		{"id":"4107652","ufId":"41","descricao":"Fazenda Rio Grande"},
		{"id":"4107702","ufId":"41","descricao":"Fênix"},
		{"id":"4107736","ufId":"41","descricao":"Fernandes Pinheiro"},
		{"id":"4107751","ufId":"41","descricao":"Figueira"},
		{"id":"4107850","ufId":"41","descricao":"Flor da Serra do Sul"},
		{"id":"4107801","ufId":"41","descricao":"Floraí"},
		{"id":"4107900","ufId":"41","descricao":"Floresta"},
		{"id":"4108007","ufId":"41","descricao":"Florestópolis"},
		{"id":"4108106","ufId":"41","descricao":"Flórida"},
		{"id":"4108205","ufId":"41","descricao":"Formosa do Oeste"},
		{"id":"4108304","ufId":"41","descricao":"Foz do Iguaçu"},
		{"id":"4108452","ufId":"41","descricao":"Foz do Jordão"},
		{"id":"4108320","ufId":"41","descricao":"Francisco Alves"},
		{"id":"4108403","ufId":"41","descricao":"Francisco Beltrão"},
		{"id":"4108502","ufId":"41","descricao":"General Carneiro"},
		{"id":"4108551","ufId":"41","descricao":"Godoy Moreira"},
		{"id":"4108601","ufId":"41","descricao":"Goioerê"},
		{"id":"4108650","ufId":"41","descricao":"Goioxim"},
		{"id":"4108700","ufId":"41","descricao":"Grandes Rios"},
		{"id":"4108809","ufId":"41","descricao":"Guaíra"},
		{"id":"4108908","ufId":"41","descricao":"Guairaçá"},
		{"id":"4108957","ufId":"41","descricao":"Guamiranga"},
		{"id":"4109005","ufId":"41","descricao":"Guapirama"},
		{"id":"4109104","ufId":"41","descricao":"Guaporema"},
		{"id":"4109203","ufId":"41","descricao":"Guaraci"},
		{"id":"4109302","ufId":"41","descricao":"Guaraniaçu"},
		{"id":"4109401","ufId":"41","descricao":"Guarapuava"},
		{"id":"4109500","ufId":"41","descricao":"Guaraqueçaba"},
		{"id":"4109609","ufId":"41","descricao":"Guaratuba"},
		{"id":"4109658","ufId":"41","descricao":"Honório Serpa"},
		{"id":"4109708","ufId":"41","descricao":"Ibaiti"},
		{"id":"4109757","ufId":"41","descricao":"Ibema"},
		{"id":"4109807","ufId":"41","descricao":"Ibiporã"},
		{"id":"4109906","ufId":"41","descricao":"Icaraíma"},
		{"id":"4110003","ufId":"41","descricao":"Iguaraçu"},
		{"id":"4110052","ufId":"41","descricao":"Iguatu"},
		{"id":"4110078","ufId":"41","descricao":"Imbaú"},
		{"id":"4110102","ufId":"41","descricao":"Imbituva"},
		{"id":"4110201","ufId":"41","descricao":"Inácio Martins"},
		{"id":"4110300","ufId":"41","descricao":"Inajá"},
		{"id":"4110409","ufId":"41","descricao":"Indianópolis"},
		{"id":"4110508","ufId":"41","descricao":"Ipiranga"},
		{"id":"4110607","ufId":"41","descricao":"Iporã"},
		{"id":"4110656","ufId":"41","descricao":"Iracema do Oeste"},
		{"id":"4110706","ufId":"41","descricao":"Irati"},
		{"id":"4110805","ufId":"41","descricao":"Iretama"},
		{"id":"4110904","ufId":"41","descricao":"Itaguajé"},
		{"id":"4110953","ufId":"41","descricao":"Itaipulândia"},
		{"id":"4111001","ufId":"41","descricao":"Itambaracá"},
		{"id":"4111100","ufId":"41","descricao":"Itambé"},
		{"id":"4111209","ufId":"41","descricao":"Itapejara d'Oeste"},
		{"id":"4111258","ufId":"41","descricao":"Itaperuçu"},
		{"id":"4111308","ufId":"41","descricao":"Itaúna do Sul"},
		{"id":"4111407","ufId":"41","descricao":"Ivaí"},
		{"id":"4111506","ufId":"41","descricao":"Ivaiporã"},
		{"id":"4111555","ufId":"41","descricao":"Ivaté"},
		{"id":"4111605","ufId":"41","descricao":"Ivatuba"},
		{"id":"4111704","ufId":"41","descricao":"Jaboti"},
		{"id":"4111803","ufId":"41","descricao":"Jacarezinho"},
		{"id":"4111902","ufId":"41","descricao":"Jaguapitã"},
		{"id":"4112009","ufId":"41","descricao":"Jaguariaíva"},
		{"id":"4112108","ufId":"41","descricao":"Jandaia do Sul"},
		{"id":"4112207","ufId":"41","descricao":"Janiópolis"},
		{"id":"4112306","ufId":"41","descricao":"Japira"},
		{"id":"4112405","ufId":"41","descricao":"Japurá"},
		{"id":"4112504","ufId":"41","descricao":"Jardim Alegre"},
		{"id":"4112603","ufId":"41","descricao":"Jardim Olinda"},
		{"id":"4112702","ufId":"41","descricao":"Jataizinho"},
		{"id":"4112751","ufId":"41","descricao":"Jesuítas"},
		{"id":"4112801","ufId":"41","descricao":"Joaquim Távora"},
		{"id":"4112900","ufId":"41","descricao":"Jundiaí do Sul"},
		{"id":"4112959","ufId":"41","descricao":"Juranda"},
		{"id":"4113007","ufId":"41","descricao":"Jussara"},
		{"id":"4113106","ufId":"41","descricao":"Kaloré"},
		{"id":"4113205","ufId":"41","descricao":"Lapa"},
		{"id":"4113254","ufId":"41","descricao":"Laranjal"},
		{"id":"4113304","ufId":"41","descricao":"Laranjeiras do Sul"},
		{"id":"4113403","ufId":"41","descricao":"Leópolis"},
		{"id":"4113429","ufId":"41","descricao":"Lidianópolis"},
		{"id":"4113452","ufId":"41","descricao":"Lindoeste"},
		{"id":"4113502","ufId":"41","descricao":"Loanda"},
		{"id":"4113601","ufId":"41","descricao":"Lobato"},
		{"id":"4113700","ufId":"41","descricao":"Londrina"},
		{"id":"4113734","ufId":"41","descricao":"Luiziana"},
		{"id":"4113759","ufId":"41","descricao":"Lunardelli"},
		{"id":"4113809","ufId":"41","descricao":"Lupionópolis"},
		{"id":"4113908","ufId":"41","descricao":"Mallet"},
		{"id":"4114005","ufId":"41","descricao":"Mamborê"},
		{"id":"4114104","ufId":"41","descricao":"Mandaguaçu"},
		{"id":"4114203","ufId":"41","descricao":"Mandaguari"},
		{"id":"4114302","ufId":"41","descricao":"Mandirituba"},
		{"id":"4114351","ufId":"41","descricao":"Manfrinópolis"},
		{"id":"4114401","ufId":"41","descricao":"Mangueirinha"},
		{"id":"4114500","ufId":"41","descricao":"Manoel Ribas"},
		{"id":"4114609","ufId":"41","descricao":"Marechal Cândido Rondon"},
		{"id":"4114708","ufId":"41","descricao":"Maria Helena"},
		{"id":"4114807","ufId":"41","descricao":"Marialva"},
		{"id":"4114906","ufId":"41","descricao":"Marilândia do Sul"},
		{"id":"4115002","ufId":"41","descricao":"Marilena"},
		{"id":"4115101","ufId":"41","descricao":"Mariluz"},
		{"id":"4115200","ufId":"41","descricao":"Maringá"},
		{"id":"4115309","ufId":"41","descricao":"Mariópolis"},
		{"id":"4115358","ufId":"41","descricao":"Maripá"},
		{"id":"4115408","ufId":"41","descricao":"Marmeleiro"},
		{"id":"4115457","ufId":"41","descricao":"Marquinho"},
		{"id":"4115507","ufId":"41","descricao":"Marumbi"},
		{"id":"4115606","ufId":"41","descricao":"Matelândia"},
		{"id":"4115705","ufId":"41","descricao":"Matinhos"},
		{"id":"4115739","ufId":"41","descricao":"Mato Rico"},
		{"id":"4115754","ufId":"41","descricao":"Mauá da Serra"},
		{"id":"4115804","ufId":"41","descricao":"Medianeira"},
		{"id":"4115853","ufId":"41","descricao":"Mercedes"},
		{"id":"4115903","ufId":"41","descricao":"Mirador"},
		{"id":"4116000","ufId":"41","descricao":"Miraselva"},
		{"id":"4116059","ufId":"41","descricao":"Missal"},
		{"id":"4116109","ufId":"41","descricao":"Moreira Sales"},
		{"id":"4116208","ufId":"41","descricao":"Morretes"},
		{"id":"4116307","ufId":"41","descricao":"Munhoz de Melo"},
		{"id":"4116406","ufId":"41","descricao":"Nossa Senhora das Graças"},
		{"id":"4116505","ufId":"41","descricao":"Nova Aliança do Ivaí"},
		{"id":"4116604","ufId":"41","descricao":"Nova América da Colina"},
		{"id":"4116703","ufId":"41","descricao":"Nova Aurora"},
		{"id":"4116802","ufId":"41","descricao":"Nova Cantu"},
		{"id":"4116901","ufId":"41","descricao":"Nova Esperança"},
		{"id":"4116950","ufId":"41","descricao":"Nova Esperança do Sudoeste"},
		{"id":"4117008","ufId":"41","descricao":"Nova Fátima"},
		{"id":"4117057","ufId":"41","descricao":"Nova Laranjeiras"},
		{"id":"4117107","ufId":"41","descricao":"Nova Londrina"},
		{"id":"4117206","ufId":"41","descricao":"Nova Olímpia"},
		{"id":"4117255","ufId":"41","descricao":"Nova Prata do Iguaçu"},
		{"id":"4117214","ufId":"41","descricao":"Nova Santa Bárbara"},
		{"id":"4117222","ufId":"41","descricao":"Nova Santa Rosa"},
		{"id":"4117271","ufId":"41","descricao":"Nova Tebas"},
		{"id":"4117297","ufId":"41","descricao":"Novo Itacolomi"},
		{"id":"4117305","ufId":"41","descricao":"Ortigueira"},
		{"id":"4117404","ufId":"41","descricao":"Ourizona"},
		{"id":"4117453","ufId":"41","descricao":"Ouro Verde do Oeste"},
		{"id":"4117503","ufId":"41","descricao":"Paiçandu"},
		{"id":"4117602","ufId":"41","descricao":"Palmas"},
		{"id":"4117701","ufId":"41","descricao":"Palmeira"},
		{"id":"4117800","ufId":"41","descricao":"Palmital"},
		{"id":"4117909","ufId":"41","descricao":"Palotina"},
		{"id":"4118006","ufId":"41","descricao":"Paraíso do Norte"},
		{"id":"4118105","ufId":"41","descricao":"Paranacity"},
		{"id":"4118204","ufId":"41","descricao":"Paranaguá"},
		{"id":"4118303","ufId":"41","descricao":"Paranapoema"},
		{"id":"4118402","ufId":"41","descricao":"Paranavaí"},
		{"id":"4118451","ufId":"41","descricao":"Pato Bragado"},
		{"id":"4118501","ufId":"41","descricao":"Pato Branco"},
		{"id":"4118600","ufId":"41","descricao":"Paula Freitas"},
		{"id":"4118709","ufId":"41","descricao":"Paulo Frontin"},
		{"id":"4118808","ufId":"41","descricao":"Peabiru"},
		{"id":"4118857","ufId":"41","descricao":"Perobal"},
		{"id":"4118907","ufId":"41","descricao":"Pérola"},
		{"id":"4119004","ufId":"41","descricao":"Pérola d'Oeste"},
		{"id":"4119103","ufId":"41","descricao":"Piên"},
		{"id":"4119152","ufId":"41","descricao":"Pinhais"},
		{"id":"4119251","ufId":"41","descricao":"Pinhal de São Bento"},
		{"id":"4119202","ufId":"41","descricao":"Pinhalão"},
		{"id":"4119301","ufId":"41","descricao":"Pinhão"},
		{"id":"4119400","ufId":"41","descricao":"Piraí do Sul"},
		{"id":"4119509","ufId":"41","descricao":"Piraquara"},
		{"id":"4119608","ufId":"41","descricao":"Pitanga"},
		{"id":"4119657","ufId":"41","descricao":"Pitangueiras"},
		{"id":"4119707","ufId":"41","descricao":"Planaltina do Paraná"},
		{"id":"4119806","ufId":"41","descricao":"Planalto"},
		{"id":"4119905","ufId":"41","descricao":"Ponta Grossa"},
		{"id":"4119954","ufId":"41","descricao":"Pontal do Paraná"},
		{"id":"4120002","ufId":"41","descricao":"Porecatu"},
		{"id":"4120101","ufId":"41","descricao":"Porto Amazonas"},
		{"id":"4120150","ufId":"41","descricao":"Porto Barreiro"},
		{"id":"4120200","ufId":"41","descricao":"Porto Rico"},
		{"id":"4120309","ufId":"41","descricao":"Porto Vitória"},
		{"id":"4120333","ufId":"41","descricao":"Prado Ferreira"},
		{"id":"4120358","ufId":"41","descricao":"Pranchita"},
		{"id":"4120408","ufId":"41","descricao":"Presidente Castelo Branco"},
		{"id":"4120507","ufId":"41","descricao":"Primeiro de Maio"},
		{"id":"4120606","ufId":"41","descricao":"Prudentópolis"},
		{"id":"4120655","ufId":"41","descricao":"Quarto Centenário"},
		{"id":"4120705","ufId":"41","descricao":"Quatiguá"},
		{"id":"4120804","ufId":"41","descricao":"Quatro Barras"},
		{"id":"4120853","ufId":"41","descricao":"Quatro Pontes"},
		{"id":"4120903","ufId":"41","descricao":"Quedas do Iguaçu"},
		{"id":"4121000","ufId":"41","descricao":"Querência do Norte"},
		{"id":"4121109","ufId":"41","descricao":"Quinta do Sol"},
		{"id":"4121208","ufId":"41","descricao":"Quitandinha"},
		{"id":"4121257","ufId":"41","descricao":"Ramilândia"},
		{"id":"4121307","ufId":"41","descricao":"Rancho Alegre"},
		{"id":"4121356","ufId":"41","descricao":"Rancho Alegre D'Oeste"},
		{"id":"4121406","ufId":"41","descricao":"Realeza"},
		{"id":"4121505","ufId":"41","descricao":"Rebouças"},
		{"id":"4121604","ufId":"41","descricao":"Renascença"},
		{"id":"4121703","ufId":"41","descricao":"Reserva"},
		{"id":"4121752","ufId":"41","descricao":"Reserva do Iguaçu"},
		{"id":"4121802","ufId":"41","descricao":"Ribeirão Claro"},
		{"id":"4121901","ufId":"41","descricao":"Ribeirão do Pinhal"},
		{"id":"4122008","ufId":"41","descricao":"Rio Azul"},
		{"id":"4122107","ufId":"41","descricao":"Rio Bom"},
		{"id":"4122156","ufId":"41","descricao":"Rio Bonito do Iguaçu"},
		{"id":"4122172","ufId":"41","descricao":"Rio Branco do Ivaí"},
		{"id":"4122206","ufId":"41","descricao":"Rio Branco do Sul"},
		{"id":"4122305","ufId":"41","descricao":"Rio Negro"},
		{"id":"4122404","ufId":"41","descricao":"Rolândia"},
		{"id":"4122503","ufId":"41","descricao":"Roncador"},
		{"id":"4122602","ufId":"41","descricao":"Rondon"},
		{"id":"4122651","ufId":"41","descricao":"Rosário do Ivaí"},
		{"id":"4122701","ufId":"41","descricao":"Sabáudia"},
		{"id":"4122800","ufId":"41","descricao":"Salgado Filho"},
		{"id":"4122909","ufId":"41","descricao":"Salto do Itararé"},
		{"id":"4123006","ufId":"41","descricao":"Salto do Lontra"},
		{"id":"4123105","ufId":"41","descricao":"Santa Amélia"},
		{"id":"4123204","ufId":"41","descricao":"Santa Cecília do Pavão"},
		{"id":"4123303","ufId":"41","descricao":"Santa Cruz de Monte Castelo"},
		{"id":"4123402","ufId":"41","descricao":"Santa Fé"},
		{"id":"4123501","ufId":"41","descricao":"Santa Helena"},
		{"id":"4123600","ufId":"41","descricao":"Santa Inês"},
		{"id":"4123709","ufId":"41","descricao":"Santa Isabel do Ivaí"},
		{"id":"4123808","ufId":"41","descricao":"Santa Izabel do Oeste"},
		{"id":"4123824","ufId":"41","descricao":"Santa Lúcia"},
		{"id":"4123857","ufId":"41","descricao":"Santa Maria do Oeste"},
		{"id":"4123907","ufId":"41","descricao":"Santa Mariana"},
		{"id":"4123956","ufId":"41","descricao":"Santa Mônica"},
		{"id":"4124020","ufId":"41","descricao":"Santa Tereza do Oeste"},
		{"id":"4124053","ufId":"41","descricao":"Santa Terezinha de Itaipu"},
		{"id":"4124004","ufId":"41","descricao":"Santana do Itararé"},
		{"id":"4124103","ufId":"41","descricao":"Santo Antônio da Platina"},
		{"id":"4124202","ufId":"41","descricao":"Santo Antônio do Caiuá"},
		{"id":"4124301","ufId":"41","descricao":"Santo Antônio do Paraíso"},
		{"id":"4124400","ufId":"41","descricao":"Santo Antônio do Sudoeste"},
		{"id":"4124509","ufId":"41","descricao":"Santo Inácio"},
		{"id":"4124608","ufId":"41","descricao":"São Carlos do Ivaí"},
		{"id":"4124707","ufId":"41","descricao":"São Jerônimo da Serra"},
		{"id":"4124806","ufId":"41","descricao":"São João"},
		{"id":"4124905","ufId":"41","descricao":"São João do Caiuá"},
		{"id":"4125001","ufId":"41","descricao":"São João do Ivaí"},
		{"id":"4125100","ufId":"41","descricao":"São João do Triunfo"},
		{"id":"4125209","ufId":"41","descricao":"São Jorge d'Oeste"},
		{"id":"4125308","ufId":"41","descricao":"São Jorge do Ivaí"},
		{"id":"4125357","ufId":"41","descricao":"São Jorge do Patrocínio"},
		{"id":"4125407","ufId":"41","descricao":"São José da Boa Vista"},
		{"id":"4125456","ufId":"41","descricao":"São José das Palmeiras"},
		{"id":"4125506","ufId":"41","descricao":"São José dos Pinhais"},
		{"id":"4125555","ufId":"41","descricao":"São Manoel do Paraná"},
		{"id":"4125605","ufId":"41","descricao":"São Mateus do Sul"},
		{"id":"4125704","ufId":"41","descricao":"São Miguel do Iguaçu"},
		{"id":"4125753","ufId":"41","descricao":"São Pedro do Iguaçu"},
		{"id":"4125803","ufId":"41","descricao":"São Pedro do Ivaí"},
		{"id":"4125902","ufId":"41","descricao":"São Pedro do Paraná"},
		{"id":"4126009","ufId":"41","descricao":"São Sebastião da Amoreira"},
		{"id":"4126108","ufId":"41","descricao":"São Tomé"},
		{"id":"4126207","ufId":"41","descricao":"Sapopema"},
		{"id":"4126256","ufId":"41","descricao":"Sarandi"},
		{"id":"4126272","ufId":"41","descricao":"Saudade do Iguaçu"},
		{"id":"4126306","ufId":"41","descricao":"Sengés"},
		{"id":"4126355","ufId":"41","descricao":"Serranópolis do Iguaçu"},
		{"id":"4126405","ufId":"41","descricao":"Sertaneja"},
		{"id":"4126504","ufId":"41","descricao":"Sertanópolis"},
		{"id":"4126603","ufId":"41","descricao":"Siqueira Campos"},
		{"id":"4126652","ufId":"41","descricao":"Sulina"},
		{"id":"4126678","ufId":"41","descricao":"Tamarana"},
		{"id":"4126702","ufId":"41","descricao":"Tamboara"},
		{"id":"4126801","ufId":"41","descricao":"Tapejara"},
		{"id":"4126900","ufId":"41","descricao":"Tapira"},
		{"id":"4127007","ufId":"41","descricao":"Teixeira Soares"},
		{"id":"4127106","ufId":"41","descricao":"Telêmaco Borba"},
		{"id":"4127205","ufId":"41","descricao":"Terra Boa"},
		{"id":"4127304","ufId":"41","descricao":"Terra Rica"},
		{"id":"4127403","ufId":"41","descricao":"Terra Roxa"},
		{"id":"4127502","ufId":"41","descricao":"Tibagi"},
		{"id":"4127601","ufId":"41","descricao":"Tijucas do Sul"},
		{"id":"4127700","ufId":"41","descricao":"Toledo"},
		{"id":"4127809","ufId":"41","descricao":"Tomazina"},
		{"id":"4127858","ufId":"41","descricao":"Três Barras do Paraná"},
		{"id":"4127882","ufId":"41","descricao":"Tunas do Paraná"},
		{"id":"4127908","ufId":"41","descricao":"Tuneiras do Oeste"},
		{"id":"4127957","ufId":"41","descricao":"Tupãssi"},
		{"id":"4127965","ufId":"41","descricao":"Turvo"},
		{"id":"4128005","ufId":"41","descricao":"Ubiratã"},
		{"id":"4128104","ufId":"41","descricao":"Umuarama"},
		{"id":"4128203","ufId":"41","descricao":"União da Vitória"},
		{"id":"4128302","ufId":"41","descricao":"Uniflor"},
		{"id":"4128401","ufId":"41","descricao":"Uraí"},
		{"id":"4128534","ufId":"41","descricao":"Ventania"},
		{"id":"4128559","ufId":"41","descricao":"Vera Cruz do Oeste"},
		{"id":"4128609","ufId":"41","descricao":"Verê"},
		{"id":"4128658","ufId":"41","descricao":"Virmond"},
		{"id":"4128708","ufId":"41","descricao":"Vitorino"},
		{"id":"4128500","ufId":"41","descricao":"Wenceslau Braz"},
		{"id":"4128807","ufId":"41","descricao":"Xambrê"}
	],
	"42": [
		{"id":"4200051","ufId":"42","descricao":"Abdon Batista"},
		{"id":"4200101","ufId":"42","descricao":"Abelardo Luz"},
		{"id":"4200200","ufId":"42","descricao":"Agrolândia"},
		{"id":"4200309","ufId":"42","descricao":"Agronômica"},
		{"id":"4200408","ufId":"42","descricao":"Água Doce"},
		{"id":"4200507","ufId":"42","descricao":"Águas de Chapecó"},
		{"id":"4200556","ufId":"42","descricao":"Águas Frias"},
		{"id":"4200606","ufId":"42","descricao":"Águas Mornas"},
		{"id":"4200705","ufId":"42","descricao":"Alfredo Wagner"},
		{"id":"4200754","ufId":"42","descricao":"Alto Bela Vista"},
		{"id":"4200804","ufId":"42","descricao":"Anchieta"},
		{"id":"4200903","ufId":"42","descricao":"Angelina"},
		{"id":"4201000","ufId":"42","descricao":"Anita Garibaldi"},
		{"id":"4201109","ufId":"42","descricao":"Anitápolis"},
		{"id":"4201208","ufId":"42","descricao":"Antônio Carlos"},
		{"id":"4201257","ufId":"42","descricao":"Apiúna"},
		{"id":"4201273","ufId":"42","descricao":"Arabutã"},
		{"id":"4201307","ufId":"42","descricao":"Araquari"},
		{"id":"4201406","ufId":"42","descricao":"Araranguá"},
		{"id":"4201505","ufId":"42","descricao":"Armazém"},
		{"id":"4201604","ufId":"42","descricao":"Arroio Trinta"},
		{"id":"4201653","ufId":"42","descricao":"Arvoredo"},
		{"id":"4201703","ufId":"42","descricao":"Ascurra"},
		{"id":"4201802","ufId":"42","descricao":"Atalanta"},
		{"id":"4201901","ufId":"42","descricao":"Aurora"},
		{"id":"4201950","ufId":"42","descricao":"Balneário Arroio do Silva"},
		{"id":"4202057","ufId":"42","descricao":"Balneário Barra do Sul"},
		{"id":"4202008","ufId":"42","descricao":"Balneário Camboriú"},
		{"id":"4202073","ufId":"42","descricao":"Balneário Gaivota"},
		{"id":"4212809","ufId":"42","descricao":"Balneário Piçarras"},
		{"id":"4220000","ufId":"42","descricao":"Balneário Rincão"},
		{"id":"4202081","ufId":"42","descricao":"Bandeirante"},
		{"id":"4202099","ufId":"42","descricao":"Barra Bonita"},
		{"id":"4202107","ufId":"42","descricao":"Barra Velha"},
		{"id":"4202131","ufId":"42","descricao":"Bela Vista do Toldo"},
		{"id":"4202156","ufId":"42","descricao":"Belmonte"},
		{"id":"4202206","ufId":"42","descricao":"Benedito Novo"},
		{"id":"4202305","ufId":"42","descricao":"Biguaçu"},
		{"id":"4202404","ufId":"42","descricao":"Blumenau"},
		{"id":"4202438","ufId":"42","descricao":"Bocaina do Sul"},
		{"id":"4202503","ufId":"42","descricao":"Bom Jardim da Serra"},
		{"id":"4202537","ufId":"42","descricao":"Bom Jesus"},
		{"id":"4202578","ufId":"42","descricao":"Bom Jesus do Oeste"},
		{"id":"4202602","ufId":"42","descricao":"Bom Retiro"},
		{"id":"4202453","ufId":"42","descricao":"Bombinhas"},
		{"id":"4202701","ufId":"42","descricao":"Botuverá"},
		{"id":"4202800","ufId":"42","descricao":"Braço do Norte"},
		{"id":"4202859","ufId":"42","descricao":"Braço do Trombudo"},
		{"id":"4202875","ufId":"42","descricao":"Brunópolis"},
		{"id":"4202909","ufId":"42","descricao":"Brusque"},
		{"id":"4203006","ufId":"42","descricao":"Caçador"},
		{"id":"4203105","ufId":"42","descricao":"Caibi"},
		{"id":"4203154","ufId":"42","descricao":"Calmon"},
		{"id":"4203204","ufId":"42","descricao":"Camboriú"},
		{"id":"4203303","ufId":"42","descricao":"Campo Alegre"},
		{"id":"4203402","ufId":"42","descricao":"Campo Belo do Sul"},
		{"id":"4203501","ufId":"42","descricao":"Campo Erê"},
		{"id":"4203600","ufId":"42","descricao":"Campos Novos"},
		{"id":"4203709","ufId":"42","descricao":"Canelinha"},
		{"id":"4203808","ufId":"42","descricao":"Canoinhas"},
		{"id":"4203253","ufId":"42","descricao":"Capão Alto"},
		{"id":"4203907","ufId":"42","descricao":"Capinzal"},
		{"id":"4203956","ufId":"42","descricao":"Capivari de Baixo"},
		{"id":"4204004","ufId":"42","descricao":"Catanduvas"},
		{"id":"4204103","ufId":"42","descricao":"Caxambu do Sul"},
		{"id":"4204152","ufId":"42","descricao":"Celso Ramos"},
		{"id":"4204178","ufId":"42","descricao":"Cerro Negro"},
		{"id":"4204194","ufId":"42","descricao":"Chapadão do Lageado"},
		{"id":"4204202","ufId":"42","descricao":"Chapecó"},
		{"id":"4204251","ufId":"42","descricao":"Cocal do Sul"},
		{"id":"4204301","ufId":"42","descricao":"Concórdia"},
		{"id":"4204350","ufId":"42","descricao":"Cordilheira Alta"},
		{"id":"4204400","ufId":"42","descricao":"Coronel Freitas"},
		{"id":"4204459","ufId":"42","descricao":"Coronel Martins"},
		{"id":"4204558","ufId":"42","descricao":"Correia Pinto"},
		{"id":"4204509","ufId":"42","descricao":"Corupá"},
		{"id":"4204608","ufId":"42","descricao":"Criciúma"},
		{"id":"4204707","ufId":"42","descricao":"Cunha Porã"},
		{"id":"4204756","ufId":"42","descricao":"Cunhataí"},
		{"id":"4204806","ufId":"42","descricao":"Curitibanos"},
		{"id":"4204905","ufId":"42","descricao":"Descanso"},
		{"id":"4205001","ufId":"42","descricao":"Dionísio Cerqueira"},
		{"id":"4205100","ufId":"42","descricao":"Dona Emma"},
		{"id":"4205159","ufId":"42","descricao":"Doutor Pedrinho"},
		{"id":"4205175","ufId":"42","descricao":"Entre Rios"},
		{"id":"4205191","ufId":"42","descricao":"Ermo"},
		{"id":"4205209","ufId":"42","descricao":"Erval Velho"},
		{"id":"4205308","ufId":"42","descricao":"Faxinal dos Guedes"},
		{"id":"4205357","ufId":"42","descricao":"Flor do Sertão"},
		{"id":"4205407","ufId":"42","descricao":"Florianópolis"},
		{"id":"4205431","ufId":"42","descricao":"Formosa do Sul"},
		{"id":"4205456","ufId":"42","descricao":"Forquilhinha"},
		{"id":"4205506","ufId":"42","descricao":"Fraiburgo"},
		{"id":"4205555","ufId":"42","descricao":"Frei Rogério"},
		{"id":"4205605","ufId":"42","descricao":"Galvão"},
		{"id":"4205704","ufId":"42","descricao":"Garopaba"},
		{"id":"4205803","ufId":"42","descricao":"Garuva"},
		{"id":"4205902","ufId":"42","descricao":"Gaspar"},
		{"id":"4206009","ufId":"42","descricao":"Governador Celso Ramos"},
		{"id":"4206108","ufId":"42","descricao":"Grão-Pará"},
		{"id":"4206207","ufId":"42","descricao":"Gravatal"},
		{"id":"4206306","ufId":"42","descricao":"Guabiruba"},
		{"id":"4206405","ufId":"42","descricao":"Guaraciaba"},
		{"id":"4206504","ufId":"42","descricao":"Guaramirim"},
		{"id":"4206603","ufId":"42","descricao":"Guarujá do Sul"},
		{"id":"4206652","ufId":"42","descricao":"Guatambú"},
		{"id":"4206702","ufId":"42","descricao":"Herval d'Oeste"},
		{"id":"4206751","ufId":"42","descricao":"Ibiam"},
		{"id":"4206801","ufId":"42","descricao":"Ibicaré"},
		{"id":"4206900","ufId":"42","descricao":"Ibirama"},
		{"id":"4207007","ufId":"42","descricao":"Içara"},
		{"id":"4207106","ufId":"42","descricao":"Ilhota"},
		{"id":"4207205","ufId":"42","descricao":"Imaruí"},
		{"id":"4207304","ufId":"42","descricao":"Imbituba"},
		{"id":"4207403","ufId":"42","descricao":"Imbuia"},
		{"id":"4207502","ufId":"42","descricao":"Indaial"},
		{"id":"4207577","ufId":"42","descricao":"Iomerê"},
		{"id":"4207601","ufId":"42","descricao":"Ipira"},
		{"id":"4207650","ufId":"42","descricao":"Iporã do Oeste"},
		{"id":"4207684","ufId":"42","descricao":"Ipuaçu"},
		{"id":"4207700","ufId":"42","descricao":"Ipumirim"},
		{"id":"4207759","ufId":"42","descricao":"Iraceminha"},
		{"id":"4207809","ufId":"42","descricao":"Irani"},
		{"id":"4207858","ufId":"42","descricao":"Irati"},
		{"id":"4207908","ufId":"42","descricao":"Irineópolis"},
		{"id":"4208005","ufId":"42","descricao":"Itá"},
		{"id":"4208104","ufId":"42","descricao":"Itaiópolis"},
		{"id":"4208203","ufId":"42","descricao":"Itajaí"},
		{"id":"4208302","ufId":"42","descricao":"Itapema"},
		{"id":"4208401","ufId":"42","descricao":"Itapiranga"},
		{"id":"4208450","ufId":"42","descricao":"Itapoá"},
		{"id":"4208500","ufId":"42","descricao":"Ituporanga"},
		{"id":"4208609","ufId":"42","descricao":"Jaborá"},
		{"id":"4208708","ufId":"42","descricao":"Jacinto Machado"},
		{"id":"4208807","ufId":"42","descricao":"Jaguaruna"},
		{"id":"4208906","ufId":"42","descricao":"Jaraguá do Sul"},
		{"id":"4208955","ufId":"42","descricao":"Jardinópolis"},
		{"id":"4209003","ufId":"42","descricao":"Joaçaba"},
		{"id":"4209102","ufId":"42","descricao":"Joinville"},
		{"id":"4209151","ufId":"42","descricao":"José Boiteux"},
		{"id":"4209177","ufId":"42","descricao":"Jupiá"},
		{"id":"4209201","ufId":"42","descricao":"Lacerdópolis"},
		{"id":"4209300","ufId":"42","descricao":"Lages"},
		{"id":"4209409","ufId":"42","descricao":"Laguna"},
		{"id":"4209458","ufId":"42","descricao":"Lajeado Grande"},
		{"id":"4209508","ufId":"42","descricao":"Laurentino"},
		{"id":"4209607","ufId":"42","descricao":"Lauro Müller"},
		{"id":"4209706","ufId":"42","descricao":"Lebon Régis"},
		{"id":"4209805","ufId":"42","descricao":"Leoberto Leal"},
		{"id":"4209854","ufId":"42","descricao":"Lindóia do Sul"},
		{"id":"4209904","ufId":"42","descricao":"Lontras"},
		{"id":"4210001","ufId":"42","descricao":"Luiz Alves"},
		{"id":"4210035","ufId":"42","descricao":"Luzerna"},
		{"id":"4210050","ufId":"42","descricao":"Macieira"},
		{"id":"4210100","ufId":"42","descricao":"Mafra"},
		{"id":"4210209","ufId":"42","descricao":"Major Gercino"},
		{"id":"4210308","ufId":"42","descricao":"Major Vieira"},
		{"id":"4210407","ufId":"42","descricao":"Maracajá"},
		{"id":"4210506","ufId":"42","descricao":"Maravilha"},
		{"id":"4210555","ufId":"42","descricao":"Marema"},
		{"id":"4210605","ufId":"42","descricao":"Massaranduba"},
		{"id":"4210704","ufId":"42","descricao":"Matos Costa"},
		{"id":"4210803","ufId":"42","descricao":"Meleiro"},
		{"id":"4210852","ufId":"42","descricao":"Mirim Doce"},
		{"id":"4210902","ufId":"42","descricao":"Modelo"},
		{"id":"4211009","ufId":"42","descricao":"Mondaí"},
		{"id":"4211058","ufId":"42","descricao":"Monte Carlo"},
		{"id":"4211108","ufId":"42","descricao":"Monte Castelo"},
		{"id":"4211207","ufId":"42","descricao":"Morro da Fumaça"},
		{"id":"4211256","ufId":"42","descricao":"Morro Grande"},
		{"id":"4211306","ufId":"42","descricao":"Navegantes"},
		{"id":"4211405","ufId":"42","descricao":"Nova Erechim"},
		{"id":"4211454","ufId":"42","descricao":"Nova Itaberaba"},
		{"id":"4211504","ufId":"42","descricao":"Nova Trento"},
		{"id":"4211603","ufId":"42","descricao":"Nova Veneza"},
		{"id":"4211652","ufId":"42","descricao":"Novo Horizonte"},
		{"id":"4211702","ufId":"42","descricao":"Orleans"},
		{"id":"4211751","ufId":"42","descricao":"Otacílio Costa"},
		{"id":"4211801","ufId":"42","descricao":"Ouro"},
		{"id":"4211850","ufId":"42","descricao":"Ouro Verde"},
		{"id":"4211876","ufId":"42","descricao":"Paial"},
		{"id":"4211892","ufId":"42","descricao":"Painel"},
		{"id":"4211900","ufId":"42","descricao":"Palhoça"},
		{"id":"4212007","ufId":"42","descricao":"Palma Sola"},
		{"id":"4212056","ufId":"42","descricao":"Palmeira"},
		{"id":"4212106","ufId":"42","descricao":"Palmitos"},
		{"id":"4212205","ufId":"42","descricao":"Papanduva"},
		{"id":"4212239","ufId":"42","descricao":"Paraíso"},
		{"id":"4212254","ufId":"42","descricao":"Passo de Torres"},
		{"id":"4212270","ufId":"42","descricao":"Passos Maia"},
		{"id":"4212304","ufId":"42","descricao":"Paulo Lopes"},
		{"id":"4212403","ufId":"42","descricao":"Pedras Grandes"},
		{"id":"4212502","ufId":"42","descricao":"Penha"},
		{"id":"4212601","ufId":"42","descricao":"Peritiba"},
		{"id":"4212650","ufId":"42","descricao":"Pescaria Brava"},
		{"id":"4212700","ufId":"42","descricao":"Petrolândia"},
		{"id":"4212908","ufId":"42","descricao":"Pinhalzinho"},
		{"id":"4213005","ufId":"42","descricao":"Pinheiro Preto"},
		{"id":"4213104","ufId":"42","descricao":"Piratuba"},
		{"id":"4213153","ufId":"42","descricao":"Planalto Alegre"},
		{"id":"4213203","ufId":"42","descricao":"Pomerode"},
		{"id":"4213302","ufId":"42","descricao":"Ponte Alta"},
		{"id":"4213351","ufId":"42","descricao":"Ponte Alta do Norte"},
		{"id":"4213401","ufId":"42","descricao":"Ponte Serrada"},
		{"id":"4213500","ufId":"42","descricao":"Porto Belo"},
		{"id":"4213609","ufId":"42","descricao":"Porto União"},
		{"id":"4213708","ufId":"42","descricao":"Pouso Redondo"},
		{"id":"4213807","ufId":"42","descricao":"Praia Grande"},
		{"id":"4213906","ufId":"42","descricao":"Presidente Castello Branco"},
		{"id":"4214003","ufId":"42","descricao":"Presidente Getúlio"},
		{"id":"4214102","ufId":"42","descricao":"Presidente Nereu"},
		{"id":"4214151","ufId":"42","descricao":"Princesa"},
		{"id":"4214201","ufId":"42","descricao":"Quilombo"},
		{"id":"4214300","ufId":"42","descricao":"Rancho Queimado"},
		{"id":"4214409","ufId":"42","descricao":"Rio das Antas"},
		{"id":"4214508","ufId":"42","descricao":"Rio do Campo"},
		{"id":"4214607","ufId":"42","descricao":"Rio do Oeste"},
		{"id":"4214805","ufId":"42","descricao":"Rio do Sul"},
		{"id":"4214706","ufId":"42","descricao":"Rio dos Cedros"},
		{"id":"4214904","ufId":"42","descricao":"Rio Fortuna"},
		{"id":"4215000","ufId":"42","descricao":"Rio Negrinho"},
		{"id":"4215059","ufId":"42","descricao":"Rio Rufino"},
		{"id":"4215075","ufId":"42","descricao":"Riqueza"},
		{"id":"4215109","ufId":"42","descricao":"Rodeio"},
		{"id":"4215208","ufId":"42","descricao":"Romelândia"},
		{"id":"4215307","ufId":"42","descricao":"Salete"},
		{"id":"4215356","ufId":"42","descricao":"Saltinho"},
		{"id":"4215406","ufId":"42","descricao":"Salto Veloso"},
		{"id":"4215455","ufId":"42","descricao":"Sangão"},
		{"id":"4215505","ufId":"42","descricao":"Santa Cecília"},
		{"id":"4215554","ufId":"42","descricao":"Santa Helena"},
		{"id":"4215604","ufId":"42","descricao":"Santa Rosa de Lima"},
		{"id":"4215653","ufId":"42","descricao":"Santa Rosa do Sul"},
		{"id":"4215679","ufId":"42","descricao":"Santa Terezinha"},
		{"id":"4215687","ufId":"42","descricao":"Santa Terezinha do Progresso"},
		{"id":"4215695","ufId":"42","descricao":"Santiago do Sul"},
		{"id":"4215703","ufId":"42","descricao":"Santo Amaro da Imperatriz"},
		{"id":"4215802","ufId":"42","descricao":"São Bento do Sul"},
		{"id":"4215752","ufId":"42","descricao":"São Bernardino"},
		{"id":"4215901","ufId":"42","descricao":"São Bonifácio"},
		{"id":"4216008","ufId":"42","descricao":"São Carlos"},
		{"id":"4216057","ufId":"42","descricao":"São Cristóvão do Sul"},
		{"id":"4216107","ufId":"42","descricao":"São Domingos"},
		{"id":"4216206","ufId":"42","descricao":"São Francisco do Sul"},
		{"id":"4216305","ufId":"42","descricao":"São João Batista"},
		{"id":"4216354","ufId":"42","descricao":"São João do Itaperiú"},
		{"id":"4216255","ufId":"42","descricao":"São João do Oeste"},
		{"id":"4216404","ufId":"42","descricao":"São João do Sul"},
		{"id":"4216503","ufId":"42","descricao":"São Joaquim"},
		{"id":"4216602","ufId":"42","descricao":"São José"},
		{"id":"4216701","ufId":"42","descricao":"São José do Cedro"},
		{"id":"4216800","ufId":"42","descricao":"São José do Cerrito"},
		{"id":"4216909","ufId":"42","descricao":"São Lourenço do Oeste"},
		{"id":"4217006","ufId":"42","descricao":"São Ludgero"},
		{"id":"4217105","ufId":"42","descricao":"São Martinho"},
		{"id":"4217154","ufId":"42","descricao":"São Miguel da Boa Vista"},
		{"id":"4217204","ufId":"42","descricao":"São Miguel do Oeste"},
		{"id":"4217253","ufId":"42","descricao":"São Pedro de Alcântara"},
		{"id":"4217303","ufId":"42","descricao":"Saudades"},
		{"id":"4217402","ufId":"42","descricao":"Schroeder"},
		{"id":"4217501","ufId":"42","descricao":"Seara"},
		{"id":"4217550","ufId":"42","descricao":"Serra Alta"},
		{"id":"4217600","ufId":"42","descricao":"Siderópolis"},
		{"id":"4217709","ufId":"42","descricao":"Sombrio"},
		{"id":"4217758","ufId":"42","descricao":"Sul Brasil"},
		{"id":"4217808","ufId":"42","descricao":"Taió"},
		{"id":"4217907","ufId":"42","descricao":"Tangará"},
		{"id":"4217956","ufId":"42","descricao":"Tigrinhos"},
		{"id":"4218004","ufId":"42","descricao":"Tijucas"},
		{"id":"4218103","ufId":"42","descricao":"Timbé do Sul"},
		{"id":"4218202","ufId":"42","descricao":"Timbó"},
		{"id":"4218251","ufId":"42","descricao":"Timbó Grande"},
		{"id":"4218301","ufId":"42","descricao":"Três Barras"},
		{"id":"4218350","ufId":"42","descricao":"Treviso"},
		{"id":"4218400","ufId":"42","descricao":"Treze de Maio"},
		{"id":"4218509","ufId":"42","descricao":"Treze Tílias"},
		{"id":"4218608","ufId":"42","descricao":"Trombudo Central"},
		{"id":"4218707","ufId":"42","descricao":"Tubarão"},
		{"id":"4218756","ufId":"42","descricao":"Tunápolis"},
		{"id":"4218806","ufId":"42","descricao":"Turvo"},
		{"id":"4218855","ufId":"42","descricao":"União do Oeste"},
		{"id":"4218905","ufId":"42","descricao":"Urubici"},
		{"id":"4218954","ufId":"42","descricao":"Urupema"},
		{"id":"4219002","ufId":"42","descricao":"Urussanga"},
		{"id":"4219101","ufId":"42","descricao":"Vargeão"},
		{"id":"4219150","ufId":"42","descricao":"Vargem"},
		{"id":"4219176","ufId":"42","descricao":"Vargem Bonita"},
		{"id":"4219200","ufId":"42","descricao":"Vidal Ramos"},
		{"id":"4219309","ufId":"42","descricao":"Videira"},
		{"id":"4219358","ufId":"42","descricao":"Vitor Meireles"},
		{"id":"4219408","ufId":"42","descricao":"Witmarsum"},
		{"id":"4219507","ufId":"42","descricao":"Xanxerê"},
		{"id":"4219606","ufId":"42","descricao":"Xavantina"},
		{"id":"4219705","ufId":"42","descricao":"Xaxim"},
		{"id":"4219853","ufId":"42","descricao":"Zortéa"}
	],
	"43": [
		{"id":"4300034","ufId":"43","descricao":"Aceguá"},
		{"id":"4300059","ufId":"43","descricao":"Água Santa"},
		{"id":"4300109","ufId":"43","descricao":"Agudo"},
		{"id":"4300208","ufId":"43","descricao":"Ajuricaba"},
		{"id":"4300307","ufId":"43","descricao":"Alecrim"},
		{"id":"4300406","ufId":"43","descricao":"Alegrete"},
		{"id":"4300455","ufId":"43","descricao":"Alegria"},
		{"id":"4300471","ufId":"43","descricao":"Almirante Tamandaré do Sul"},
		{"id":"4300505","ufId":"43","descricao":"Alpestre"},
		{"id":"4300554","ufId":"43","descricao":"Alto Alegre"},
		{"id":"4300570","ufId":"43","descricao":"Alto Feliz"},
		{"id":"4300604","ufId":"43","descricao":"Alvorada"},
		{"id":"4300638","ufId":"43","descricao":"Amaral Ferrador"},
		{"id":"4300646","ufId":"43","descricao":"Ametista do Sul"},
		{"id":"4300661","ufId":"43","descricao":"André da Rocha"},
		{"id":"4300703","ufId":"43","descricao":"Anta Gorda"},
		{"id":"4300802","ufId":"43","descricao":"Antônio Prado"},
		{"id":"4300851","ufId":"43","descricao":"Arambaré"},
		{"id":"4300877","ufId":"43","descricao":"Araricá"},
		{"id":"4300901","ufId":"43","descricao":"Aratiba"},
		{"id":"4301008","ufId":"43","descricao":"Arroio do Meio"},
		{"id":"4301073","ufId":"43","descricao":"Arroio do Padre"},
		{"id":"4301057","ufId":"43","descricao":"Arroio do Sal"},
		{"id":"4301206","ufId":"43","descricao":"Arroio do Tigre"},
		{"id":"4301107","ufId":"43","descricao":"Arroio dos Ratos"},
		{"id":"4301305","ufId":"43","descricao":"Arroio Grande"},
		{"id":"4301404","ufId":"43","descricao":"Arvorezinha"},
		{"id":"4301503","ufId":"43","descricao":"Augusto Pestana"},
		{"id":"4301552","ufId":"43","descricao":"Áurea"},
		{"id":"4301602","ufId":"43","descricao":"Bagé"},
		{"id":"4301636","ufId":"43","descricao":"Balneário Pinhal"},
		{"id":"4301651","ufId":"43","descricao":"Barão"},
		{"id":"4301701","ufId":"43","descricao":"Barão de Cotegipe"},
		{"id":"4301750","ufId":"43","descricao":"Barão do Triunfo"},
		{"id":"4301859","ufId":"43","descricao":"Barra do Guarita"},
		{"id":"4301875","ufId":"43","descricao":"Barra do Quaraí"},
		{"id":"4301909","ufId":"43","descricao":"Barra do Ribeiro"},
		{"id":"4301925","ufId":"43","descricao":"Barra do Rio Azul"},
		{"id":"4301958","ufId":"43","descricao":"Barra Funda"},
		{"id":"4301800","ufId":"43","descricao":"Barracão"},
		{"id":"4302006","ufId":"43","descricao":"Barros Cassal"},
		{"id":"4302055","ufId":"43","descricao":"Benjamin Constant do Sul"},
		{"id":"4302105","ufId":"43","descricao":"Bento Gonçalves"},
		{"id":"4302154","ufId":"43","descricao":"Boa Vista das Missões"},
		{"id":"4302204","ufId":"43","descricao":"Boa Vista do Buricá"},
		{"id":"4302220","ufId":"43","descricao":"Boa Vista do Cadeado"},
		{"id":"4302238","ufId":"43","descricao":"Boa Vista do Incra"},
		{"id":"4302253","ufId":"43","descricao":"Boa Vista do Sul"},
		{"id":"4302303","ufId":"43","descricao":"Bom Jesus"},
		{"id":"4302352","ufId":"43","descricao":"Bom Princípio"},
		{"id":"4302378","ufId":"43","descricao":"Bom Progresso"},
		{"id":"4302402","ufId":"43","descricao":"Bom Retiro do Sul"},
		{"id":"4302451","ufId":"43","descricao":"Boqueirão do Leão"},
		{"id":"4302501","ufId":"43","descricao":"Bossoroca"},
		{"id":"4302584","ufId":"43","descricao":"Bozano"},
		{"id":"4302600","ufId":"43","descricao":"Braga"},
		{"id":"4302659","ufId":"43","descricao":"Brochier"},
		{"id":"4302709","ufId":"43","descricao":"Butiá"},
		{"id":"4302808","ufId":"43","descricao":"Caçapava do Sul"},
		{"id":"4302907","ufId":"43","descricao":"Cacequi"},
		{"id":"4303004","ufId":"43","descricao":"Cachoeira do Sul"},
		{"id":"4303103","ufId":"43","descricao":"Cachoeirinha"},
		{"id":"4303202","ufId":"43","descricao":"Cacique Doble"},
		{"id":"4303301","ufId":"43","descricao":"Caibaté"},
		{"id":"4303400","ufId":"43","descricao":"Caiçara"},
		{"id":"4303509","ufId":"43","descricao":"Camaquã"},
		{"id":"4303558","ufId":"43","descricao":"Camargo"},
		{"id":"4303608","ufId":"43","descricao":"Cambará do Sul"},
		{"id":"4303673","ufId":"43","descricao":"Campestre da Serra"},
		{"id":"4303707","ufId":"43","descricao":"Campina das Missões"},
		{"id":"4303806","ufId":"43","descricao":"Campinas do Sul"},
		{"id":"4303905","ufId":"43","descricao":"Campo Bom"},
		{"id":"4304002","ufId":"43","descricao":"Campo Novo"},
		{"id":"4304101","ufId":"43","descricao":"Campos Borges"},
		{"id":"4304200","ufId":"43","descricao":"Candelária"},
		{"id":"4304309","ufId":"43","descricao":"Cândido Godói"},
		{"id":"4304358","ufId":"43","descricao":"Candiota"},
		{"id":"4304408","ufId":"43","descricao":"Canela"},
		{"id":"4304507","ufId":"43","descricao":"Canguçu"},
		{"id":"4304606","ufId":"43","descricao":"Canoas"},
		{"id":"4304614","ufId":"43","descricao":"Canudos do Vale"},
		{"id":"4304622","ufId":"43","descricao":"Capão Bonito do Sul"},
		{"id":"4304630","ufId":"43","descricao":"Capão da Canoa"},
		{"id":"4304655","ufId":"43","descricao":"Capão do Cipó"},
		{"id":"4304663","ufId":"43","descricao":"Capão do Leão"},
		{"id":"4304689","ufId":"43","descricao":"Capela de Santana"},
		{"id":"4304697","ufId":"43","descricao":"Capitão"},
		{"id":"4304671","ufId":"43","descricao":"Capivari do Sul"},
		{"id":"4304713","ufId":"43","descricao":"Caraá"},
		{"id":"4304705","ufId":"43","descricao":"Carazinho"},
		{"id":"4304804","ufId":"43","descricao":"Carlos Barbosa"},
		{"id":"4304853","ufId":"43","descricao":"Carlos Gomes"},
		{"id":"4304903","ufId":"43","descricao":"Casca"},
		{"id":"4304952","ufId":"43","descricao":"Caseiros"},
		{"id":"4305009","ufId":"43","descricao":"Catuípe"},
		{"id":"4305108","ufId":"43","descricao":"Caxias do Sul"},
		{"id":"4305116","ufId":"43","descricao":"Centenário"},
		{"id":"4305124","ufId":"43","descricao":"Cerrito"},
		{"id":"4305132","ufId":"43","descricao":"Cerro Branco"},
		{"id":"4305157","ufId":"43","descricao":"Cerro Grande"},
		{"id":"4305173","ufId":"43","descricao":"Cerro Grande do Sul"},
		{"id":"4305207","ufId":"43","descricao":"Cerro Largo"},
		{"id":"4305306","ufId":"43","descricao":"Chapada"},
		{"id":"4305355","ufId":"43","descricao":"Charqueadas"},
		{"id":"4305371","ufId":"43","descricao":"Charrua"},
		{"id":"4305405","ufId":"43","descricao":"Chiapetta"},
		{"id":"4305439","ufId":"43","descricao":"Chuí"},
		{"id":"4305447","ufId":"43","descricao":"Chuvisca"},
		{"id":"4305454","ufId":"43","descricao":"Cidreira"},
		{"id":"4305504","ufId":"43","descricao":"Ciríaco"},
		{"id":"4305587","ufId":"43","descricao":"Colinas"},
		{"id":"4305603","ufId":"43","descricao":"Colorado"},
		{"id":"4305702","ufId":"43","descricao":"Condor"},
		{"id":"4305801","ufId":"43","descricao":"Constantina"},
		{"id":"4305835","ufId":"43","descricao":"Coqueiro Baixo"},
		{"id":"4305850","ufId":"43","descricao":"Coqueiros do Sul"},
		{"id":"4305871","ufId":"43","descricao":"Coronel Barros"},
		{"id":"4305900","ufId":"43","descricao":"Coronel Bicaco"},
		{"id":"4305934","ufId":"43","descricao":"Coronel Pilar"},
		{"id":"4305959","ufId":"43","descricao":"Cotiporã"},
		{"id":"4305975","ufId":"43","descricao":"Coxilha"},
		{"id":"4306007","ufId":"43","descricao":"Crissiumal"},
		{"id":"4306056","ufId":"43","descricao":"Cristal"},
		{"id":"4306072","ufId":"43","descricao":"Cristal do Sul"},
		{"id":"4306106","ufId":"43","descricao":"Cruz Alta"},
		{"id":"4306130","ufId":"43","descricao":"Cruzaltense"},
		{"id":"4306205","ufId":"43","descricao":"Cruzeiro do Sul"},
		{"id":"4306304","ufId":"43","descricao":"David Canabarro"},
		{"id":"4306320","ufId":"43","descricao":"Derrubadas"},
		{"id":"4306353","ufId":"43","descricao":"Dezesseis de Novembro"},
		{"id":"4306379","ufId":"43","descricao":"Dilermando de Aguiar"},
		{"id":"4306403","ufId":"43","descricao":"Dois Irmãos"},
		{"id":"4306429","ufId":"43","descricao":"Dois Irmãos das Missões"},
		{"id":"4306452","ufId":"43","descricao":"Dois Lajeados"},
		{"id":"4306502","ufId":"43","descricao":"Dom Feliciano"},
		{"id":"4306601","ufId":"43","descricao":"Dom Pedrito"},
		{"id":"4306551","ufId":"43","descricao":"Dom Pedro de Alcântara"},
		{"id":"4306700","ufId":"43","descricao":"Dona Francisca"},
		{"id":"4306734","ufId":"43","descricao":"Doutor Maurício Cardoso"},
		{"id":"4306759","ufId":"43","descricao":"Doutor Ricardo"},
		{"id":"4306767","ufId":"43","descricao":"Eldorado do Sul"},
		{"id":"4306809","ufId":"43","descricao":"Encantado"},
		{"id":"4306908","ufId":"43","descricao":"Encruzilhada do Sul"},
		{"id":"4306924","ufId":"43","descricao":"Engenho Velho"},
		{"id":"4306957","ufId":"43","descricao":"Entre Rios do Sul"},
		{"id":"4306932","ufId":"43","descricao":"Entre-Ijuís"},
		{"id":"4306973","ufId":"43","descricao":"Erebango"},
		{"id":"4307005","ufId":"43","descricao":"Erechim"},
		{"id":"4307054","ufId":"43","descricao":"Ernestina"},
		{"id":"4307203","ufId":"43","descricao":"Erval Grande"},
		{"id":"4307302","ufId":"43","descricao":"Erval Seco"},
		{"id":"4307401","ufId":"43","descricao":"Esmeralda"},
		{"id":"4307450","ufId":"43","descricao":"Esperança do Sul"},
		{"id":"4307500","ufId":"43","descricao":"Espumoso"},
		{"id":"4307559","ufId":"43","descricao":"Estação"},
		{"id":"4307609","ufId":"43","descricao":"Estância Velha"},
		{"id":"4307708","ufId":"43","descricao":"Esteio"},
		{"id":"4307807","ufId":"43","descricao":"Estrela"},
		{"id":"4307815","ufId":"43","descricao":"Estrela Velha"},
		{"id":"4307831","ufId":"43","descricao":"Eugênio de Castro"},
		{"id":"4307864","ufId":"43","descricao":"Fagundes Varela"},
		{"id":"4307906","ufId":"43","descricao":"Farroupilha"},
		{"id":"4308003","ufId":"43","descricao":"Faxinal do Soturno"},
		{"id":"4308052","ufId":"43","descricao":"Faxinalzinho"},
		{"id":"4308078","ufId":"43","descricao":"Fazenda Vilanova"},
		{"id":"4308102","ufId":"43","descricao":"Feliz"},
		{"id":"4308201","ufId":"43","descricao":"Flores da Cunha"},
		{"id":"4308250","ufId":"43","descricao":"Floriano Peixoto"},
		{"id":"4308300","ufId":"43","descricao":"Fontoura Xavier"},
		{"id":"4308409","ufId":"43","descricao":"Formigueiro"},
		{"id":"4308433","ufId":"43","descricao":"Forquetinha"},
		{"id":"4308458","ufId":"43","descricao":"Fortaleza dos Valos"},
		{"id":"4308508","ufId":"43","descricao":"Frederico Westphalen"},
		{"id":"4308607","ufId":"43","descricao":"Garibaldi"},
		{"id":"4308656","ufId":"43","descricao":"Garruchos"},
		{"id":"4308706","ufId":"43","descricao":"Gaurama"},
		{"id":"4308805","ufId":"43","descricao":"General Câmara"},
		{"id":"4308854","ufId":"43","descricao":"Gentil"},
		{"id":"4308904","ufId":"43","descricao":"Getúlio Vargas"},
		{"id":"4309001","ufId":"43","descricao":"Giruá"},
		{"id":"4309050","ufId":"43","descricao":"Glorinha"},
		{"id":"4309100","ufId":"43","descricao":"Gramado"},
		{"id":"4309126","ufId":"43","descricao":"Gramado dos Loureiros"},
		{"id":"4309159","ufId":"43","descricao":"Gramado Xavier"},
		{"id":"4309209","ufId":"43","descricao":"Gravataí"},
		{"id":"4309258","ufId":"43","descricao":"Guabiju"},
		{"id":"4309308","ufId":"43","descricao":"Guaíba"},
		{"id":"4309407","ufId":"43","descricao":"Guaporé"},
		{"id":"4309506","ufId":"43","descricao":"Guarani das Missões"},
		{"id":"4309555","ufId":"43","descricao":"Harmonia"},
		{"id":"4307104","ufId":"43","descricao":"Herval"},
		{"id":"4309571","ufId":"43","descricao":"Herveiras"},
		{"id":"4309605","ufId":"43","descricao":"Horizontina"},
		{"id":"4309654","ufId":"43","descricao":"Hulha Negra"},
		{"id":"4309704","ufId":"43","descricao":"Humaitá"},
		{"id":"4309753","ufId":"43","descricao":"Ibarama"},
		{"id":"4309803","ufId":"43","descricao":"Ibiaçá"},
		{"id":"4309902","ufId":"43","descricao":"Ibiraiaras"},
		{"id":"4309951","ufId":"43","descricao":"Ibirapuitã"},
		{"id":"4310009","ufId":"43","descricao":"Ibirubá"},
		{"id":"4310108","ufId":"43","descricao":"Igrejinha"},
		{"id":"4310207","ufId":"43","descricao":"Ijuí"},
		{"id":"4310306","ufId":"43","descricao":"Ilópolis"},
		{"id":"4310330","ufId":"43","descricao":"Imbé"},
		{"id":"4310363","ufId":"43","descricao":"Imigrante"},
		{"id":"4310405","ufId":"43","descricao":"Independência"},
		{"id":"4310413","ufId":"43","descricao":"Inhacorá"},
		{"id":"4310439","ufId":"43","descricao":"Ipê"},
		{"id":"4310462","ufId":"43","descricao":"Ipiranga do Sul"},
		{"id":"4310504","ufId":"43","descricao":"Iraí"},
		{"id":"4310538","ufId":"43","descricao":"Itaara"},
		{"id":"4310553","ufId":"43","descricao":"Itacurubi"},
		{"id":"4310579","ufId":"43","descricao":"Itapuca"},
		{"id":"4310603","ufId":"43","descricao":"Itaqui"},
		{"id":"4310652","ufId":"43","descricao":"Itati"},
		{"id":"4310702","ufId":"43","descricao":"Itatiba do Sul"},
		{"id":"4310751","ufId":"43","descricao":"Ivorá"},
		{"id":"4310801","ufId":"43","descricao":"Ivoti"},
		{"id":"4310850","ufId":"43","descricao":"Jaboticaba"},
		{"id":"4310876","ufId":"43","descricao":"Jacuizinho"},
		{"id":"4310900","ufId":"43","descricao":"Jacutinga"},
		{"id":"4311007","ufId":"43","descricao":"Jaguarão"},
		{"id":"4311106","ufId":"43","descricao":"Jaguari"},
		{"id":"4311122","ufId":"43","descricao":"Jaquirana"},
		{"id":"4311130","ufId":"43","descricao":"Jari"},
		{"id":"4311155","ufId":"43","descricao":"Jóia"},
		{"id":"4311205","ufId":"43","descricao":"Júlio de Castilhos"},
		{"id":"4311239","ufId":"43","descricao":"Lagoa Bonita do Sul"},
		{"id":"4311270","ufId":"43","descricao":"Lagoa dos Três Cantos"},
		{"id":"4311304","ufId":"43","descricao":"Lagoa Vermelha"},
		{"id":"4311254","ufId":"43","descricao":"Lagoão"},
		{"id":"4311403","ufId":"43","descricao":"Lajeado"},
		{"id":"4311429","ufId":"43","descricao":"Lajeado do Bugre"},
		{"id":"4311502","ufId":"43","descricao":"Lavras do Sul"},
		{"id":"4311601","ufId":"43","descricao":"Liberato Salzano"},
		{"id":"4311627","ufId":"43","descricao":"Lindolfo Collor"},
		{"id":"4311643","ufId":"43","descricao":"Linha Nova"},
		{"id":"4311718","ufId":"43","descricao":"Maçambará"},
		{"id":"4311700","ufId":"43","descricao":"Machadinho"},
		{"id":"4311734","ufId":"43","descricao":"Mampituba"},
		{"id":"4311759","ufId":"43","descricao":"Manoel Viana"},
		{"id":"4311775","ufId":"43","descricao":"Maquiné"},
		{"id":"4311791","ufId":"43","descricao":"Maratá"},
		{"id":"4311809","ufId":"43","descricao":"Marau"},
		{"id":"4311908","ufId":"43","descricao":"Marcelino Ramos"},
		{"id":"4311981","ufId":"43","descricao":"Mariana Pimentel"},
		{"id":"4312005","ufId":"43","descricao":"Mariano Moro"},
		{"id":"4312054","ufId":"43","descricao":"Marques de Souza"},
		{"id":"4312104","ufId":"43","descricao":"Mata"},
		{"id":"4312138","ufId":"43","descricao":"Mato Castelhano"},
		{"id":"4312153","ufId":"43","descricao":"Mato Leitão"},
		{"id":"4312179","ufId":"43","descricao":"Mato Queimado"},
		{"id":"4312203","ufId":"43","descricao":"Maximiliano de Almeida"},
		{"id":"4312252","ufId":"43","descricao":"Minas do Leão"},
		{"id":"4312302","ufId":"43","descricao":"Miraguaí"},
		{"id":"4312351","ufId":"43","descricao":"Montauri"},
		{"id":"4312377","ufId":"43","descricao":"Monte Alegre dos Campos"},
		{"id":"4312385","ufId":"43","descricao":"Monte Belo do Sul"},
		{"id":"4312401","ufId":"43","descricao":"Montenegro"},
		{"id":"4312427","ufId":"43","descricao":"Mormaço"},
		{"id":"4312443","ufId":"43","descricao":"Morrinhos do Sul"},
		{"id":"4312450","ufId":"43","descricao":"Morro Redondo"},
		{"id":"4312476","ufId":"43","descricao":"Morro Reuter"},
		{"id":"4312500","ufId":"43","descricao":"Mostardas"},
		{"id":"4312609","ufId":"43","descricao":"Muçum"},
		{"id":"4312617","ufId":"43","descricao":"Muitos Capões"},
		{"id":"4312625","ufId":"43","descricao":"Muliterno"},
		{"id":"4312658","ufId":"43","descricao":"Não-Me-Toque"},
		{"id":"4312674","ufId":"43","descricao":"Nicolau Vergueiro"},
		{"id":"4312708","ufId":"43","descricao":"Nonoai"},
		{"id":"4312757","ufId":"43","descricao":"Nova Alvorada"},
		{"id":"4312807","ufId":"43","descricao":"Nova Araçá"},
		{"id":"4312906","ufId":"43","descricao":"Nova Bassano"},
		{"id":"4312955","ufId":"43","descricao":"Nova Boa Vista"},
		{"id":"4313003","ufId":"43","descricao":"Nova Bréscia"},
		{"id":"4313011","ufId":"43","descricao":"Nova Candelária"},
		{"id":"4313037","ufId":"43","descricao":"Nova Esperança do Sul"},
		{"id":"4313060","ufId":"43","descricao":"Nova Hartz"},
		{"id":"4313086","ufId":"43","descricao":"Nova Pádua"},
		{"id":"4313102","ufId":"43","descricao":"Nova Palma"},
		{"id":"4313201","ufId":"43","descricao":"Nova Petrópolis"},
		{"id":"4313300","ufId":"43","descricao":"Nova Prata"},
		{"id":"4313334","ufId":"43","descricao":"Nova Ramada"},
		{"id":"4313359","ufId":"43","descricao":"Nova Roma do Sul"},
		{"id":"4313375","ufId":"43","descricao":"Nova Santa Rita"},
		{"id":"4313490","ufId":"43","descricao":"Novo Barreiro"},
		{"id":"4313391","ufId":"43","descricao":"Novo Cabrais"},
		{"id":"4313409","ufId":"43","descricao":"Novo Hamburgo"},
		{"id":"4313425","ufId":"43","descricao":"Novo Machado"},
		{"id":"4313441","ufId":"43","descricao":"Novo Tiradentes"},
		{"id":"4313466","ufId":"43","descricao":"Novo Xingu"},
		{"id":"4313508","ufId":"43","descricao":"Osório"},
		{"id":"4313607","ufId":"43","descricao":"Paim Filho"},
		{"id":"4313656","ufId":"43","descricao":"Palmares do Sul"},
		{"id":"4313706","ufId":"43","descricao":"Palmeira das Missões"},
		{"id":"4313805","ufId":"43","descricao":"Palmitinho"},
		{"id":"4313904","ufId":"43","descricao":"Panambi"},
		{"id":"4313953","ufId":"43","descricao":"Pantano Grande"},
		{"id":"4314001","ufId":"43","descricao":"Paraí"},
		{"id":"4314027","ufId":"43","descricao":"Paraíso do Sul"},
		{"id":"4314035","ufId":"43","descricao":"Pareci Novo"},
		{"id":"4314050","ufId":"43","descricao":"Parobé"},
		{"id":"4314068","ufId":"43","descricao":"Passa Sete"},
		{"id":"4314076","ufId":"43","descricao":"Passo do Sobrado"},
		{"id":"4314100","ufId":"43","descricao":"Passo Fundo"},
		{"id":"4314134","ufId":"43","descricao":"Paulo Bento"},
		{"id":"4314159","ufId":"43","descricao":"Paverama"},
		{"id":"4314175","ufId":"43","descricao":"Pedras Altas"},
		{"id":"4314209","ufId":"43","descricao":"Pedro Osório"},
		{"id":"4314308","ufId":"43","descricao":"Pejuçara"},
		{"id":"4314407","ufId":"43","descricao":"Pelotas"},
		{"id":"4314423","ufId":"43","descricao":"Picada Café"},
		{"id":"4314456","ufId":"43","descricao":"Pinhal"},
		{"id":"4314464","ufId":"43","descricao":"Pinhal da Serra"},
		{"id":"4314472","ufId":"43","descricao":"Pinhal Grande"},
		{"id":"4314498","ufId":"43","descricao":"Pinheirinho do Vale"},
		{"id":"4314506","ufId":"43","descricao":"Pinheiro Machado"},
		{"id":"4314548","ufId":"43","descricao":"Pinto Bandeira"},
		{"id":"4314555","ufId":"43","descricao":"Pirapó"},
		{"id":"4314605","ufId":"43","descricao":"Piratini"},
		{"id":"4314704","ufId":"43","descricao":"Planalto"},
		{"id":"4314753","ufId":"43","descricao":"Poço das Antas"},
		{"id":"4314779","ufId":"43","descricao":"Pontão"},
		{"id":"4314787","ufId":"43","descricao":"Ponte Preta"},
		{"id":"4314803","ufId":"43","descricao":"Portão"},
		{"id":"4314902","ufId":"43","descricao":"Porto Alegre"},
		{"id":"4315008","ufId":"43","descricao":"Porto Lucena"},
		{"id":"4315057","ufId":"43","descricao":"Porto Mauá"},
		{"id":"4315073","ufId":"43","descricao":"Porto Vera Cruz"},
		{"id":"4315107","ufId":"43","descricao":"Porto Xavier"},
		{"id":"4315131","ufId":"43","descricao":"Pouso Novo"},
		{"id":"4315149","ufId":"43","descricao":"Presidente Lucena"},
		{"id":"4315156","ufId":"43","descricao":"Progresso"},
		{"id":"4315172","ufId":"43","descricao":"Protásio Alves"},
		{"id":"4315206","ufId":"43","descricao":"Putinga"},
		{"id":"4315305","ufId":"43","descricao":"Quaraí"},
		{"id":"4315313","ufId":"43","descricao":"Quatro Irmãos"},
		{"id":"4315321","ufId":"43","descricao":"Quevedos"},
		{"id":"4315354","ufId":"43","descricao":"Quinze de Novembro"},
		{"id":"4315404","ufId":"43","descricao":"Redentora"},
		{"id":"4315453","ufId":"43","descricao":"Relvado"},
		{"id":"4315503","ufId":"43","descricao":"Restinga Sêca"},
		{"id":"4315552","ufId":"43","descricao":"Rio dos Índios"},
		{"id":"4315602","ufId":"43","descricao":"Rio Grande"},
		{"id":"4315701","ufId":"43","descricao":"Rio Pardo"},
		{"id":"4315750","ufId":"43","descricao":"Riozinho"},
		{"id":"4315800","ufId":"43","descricao":"Roca Sales"},
		{"id":"4315909","ufId":"43","descricao":"Rodeio Bonito"},
		{"id":"4315958","ufId":"43","descricao":"Rolador"},
		{"id":"4316006","ufId":"43","descricao":"Rolante"},
		{"id":"4316105","ufId":"43","descricao":"Ronda Alta"},
		{"id":"4316204","ufId":"43","descricao":"Rondinha"},
		{"id":"4316303","ufId":"43","descricao":"Roque Gonzales"},
		{"id":"4316402","ufId":"43","descricao":"Rosário do Sul"},
		{"id":"4316428","ufId":"43","descricao":"Sagrada Família"},
		{"id":"4316436","ufId":"43","descricao":"Saldanha Marinho"},
		{"id":"4316451","ufId":"43","descricao":"Salto do Jacuí"},
		{"id":"4316477","ufId":"43","descricao":"Salvador das Missões"},
		{"id":"4316501","ufId":"43","descricao":"Salvador do Sul"},
		{"id":"4316600","ufId":"43","descricao":"Sananduva"},
		{"id":"4317103","ufId":"43","descricao":"Sant'Ana do Livramento"},
		{"id":"4316709","ufId":"43","descricao":"Santa Bárbara do Sul"},
		{"id":"4316733","ufId":"43","descricao":"Santa Cecília do Sul"},
		{"id":"4316758","ufId":"43","descricao":"Santa Clara do Sul"},
		{"id":"4316808","ufId":"43","descricao":"Santa Cruz do Sul"},
		{"id":"4316972","ufId":"43","descricao":"Santa Margarida do Sul"},
		{"id":"4316907","ufId":"43","descricao":"Santa Maria"},
		{"id":"4316956","ufId":"43","descricao":"Santa Maria do Herval"},
		{"id":"4317202","ufId":"43","descricao":"Santa Rosa"},
		{"id":"4317251","ufId":"43","descricao":"Santa Tereza"},
		{"id":"4317301","ufId":"43","descricao":"Santa Vitória do Palmar"},
		{"id":"4317004","ufId":"43","descricao":"Santana da Boa Vista"},
		{"id":"4317400","ufId":"43","descricao":"Santiago"},
		{"id":"4317509","ufId":"43","descricao":"Santo Ângelo"},
		{"id":"4317608","ufId":"43","descricao":"Santo Antônio da Patrulha"},
		{"id":"4317707","ufId":"43","descricao":"Santo Antônio das Missões"},
		{"id":"4317558","ufId":"43","descricao":"Santo Antônio do Palma"},
		{"id":"4317756","ufId":"43","descricao":"Santo Antônio do Planalto"},
		{"id":"4317806","ufId":"43","descricao":"Santo Augusto"},
		{"id":"4317905","ufId":"43","descricao":"Santo Cristo"},
		{"id":"4317954","ufId":"43","descricao":"Santo Expedito do Sul"},
		{"id":"4318002","ufId":"43","descricao":"São Borja"},
		{"id":"4318051","ufId":"43","descricao":"São Domingos do Sul"},
		{"id":"4318101","ufId":"43","descricao":"São Francisco de Assis"},
		{"id":"4318200","ufId":"43","descricao":"São Francisco de Paula"},
		{"id":"4318309","ufId":"43","descricao":"São Gabriel"},
		{"id":"4318408","ufId":"43","descricao":"São Jerônimo"},
		{"id":"4318424","ufId":"43","descricao":"São João da Urtiga"},
		{"id":"4318432","ufId":"43","descricao":"São João do Polêsine"},
		{"id":"4318440","ufId":"43","descricao":"São Jorge"},
		{"id":"4318457","ufId":"43","descricao":"São José das Missões"},
		{"id":"4318465","ufId":"43","descricao":"São José do Herval"},
		{"id":"4318481","ufId":"43","descricao":"São José do Hortêncio"},
		{"id":"4318499","ufId":"43","descricao":"São José do Inhacorá"},
		{"id":"4318507","ufId":"43","descricao":"São José do Norte"},
		{"id":"4318606","ufId":"43","descricao":"São José do Ouro"},
		{"id":"4318614","ufId":"43","descricao":"São José do Sul"},
		{"id":"4318622","ufId":"43","descricao":"São José dos Ausentes"},
		{"id":"4318705","ufId":"43","descricao":"São Leopoldo"},
		{"id":"4318804","ufId":"43","descricao":"São Lourenço do Sul"},
		{"id":"4318903","ufId":"43","descricao":"São Luiz Gonzaga"},
		{"id":"4319000","ufId":"43","descricao":"São Marcos"},
		{"id":"4319109","ufId":"43","descricao":"São Martinho"},
		{"id":"4319125","ufId":"43","descricao":"São Martinho da Serra"},
		{"id":"4319158","ufId":"43","descricao":"São Miguel das Missões"},
		{"id":"4319208","ufId":"43","descricao":"São Nicolau"},
		{"id":"4319307","ufId":"43","descricao":"São Paulo das Missões"},
		{"id":"4319356","ufId":"43","descricao":"São Pedro da Serra"},
		{"id":"4319364","ufId":"43","descricao":"São Pedro das Missões"},
		{"id":"4319372","ufId":"43","descricao":"São Pedro do Butiá"},
		{"id":"4319406","ufId":"43","descricao":"São Pedro do Sul"},
		{"id":"4319505","ufId":"43","descricao":"São Sebastião do Caí"},
		{"id":"4319604","ufId":"43","descricao":"São Sepé"},
		{"id":"4319703","ufId":"43","descricao":"São Valentim"},
		{"id":"4319711","ufId":"43","descricao":"São Valentim do Sul"},
		{"id":"4319737","ufId":"43","descricao":"São Valério do Sul"},
		{"id":"4319752","ufId":"43","descricao":"São Vendelino"},
		{"id":"4319802","ufId":"43","descricao":"São Vicente do Sul"},
		{"id":"4319901","ufId":"43","descricao":"Sapiranga"},
		{"id":"4320008","ufId":"43","descricao":"Sapucaia do Sul"},
		{"id":"4320107","ufId":"43","descricao":"Sarandi"},
		{"id":"4320206","ufId":"43","descricao":"Seberi"},
		{"id":"4320230","ufId":"43","descricao":"Sede Nova"},
		{"id":"4320263","ufId":"43","descricao":"Segredo"},
		{"id":"4320305","ufId":"43","descricao":"Selbach"},
		{"id":"4320321","ufId":"43","descricao":"Senador Salgado Filho"},
		{"id":"4320354","ufId":"43","descricao":"Sentinela do Sul"},
		{"id":"4320404","ufId":"43","descricao":"Serafina Corrêa"},
		{"id":"4320453","ufId":"43","descricao":"Sério"},
		{"id":"4320503","ufId":"43","descricao":"Sertão"},
		{"id":"4320552","ufId":"43","descricao":"Sertão Santana"},
		{"id":"4320578","ufId":"43","descricao":"Sete de Setembro"},
		{"id":"4320602","ufId":"43","descricao":"Severiano de Almeida"},
		{"id":"4320651","ufId":"43","descricao":"Silveira Martins"},
		{"id":"4320677","ufId":"43","descricao":"Sinimbu"},
		{"id":"4320701","ufId":"43","descricao":"Sobradinho"},
		{"id":"4320800","ufId":"43","descricao":"Soledade"},
		{"id":"4320859","ufId":"43","descricao":"Tabaí"},
		{"id":"4320909","ufId":"43","descricao":"Tapejara"},
		{"id":"4321006","ufId":"43","descricao":"Tapera"},
		{"id":"4321105","ufId":"43","descricao":"Tapes"},
		{"id":"4321204","ufId":"43","descricao":"Taquara"},
		{"id":"4321303","ufId":"43","descricao":"Taquari"},
		{"id":"4321329","ufId":"43","descricao":"Taquaruçu do Sul"},
		{"id":"4321352","ufId":"43","descricao":"Tavares"},
		{"id":"4321402","ufId":"43","descricao":"Tenente Portela"},
		{"id":"4321436","ufId":"43","descricao":"Terra de Areia"},
		{"id":"4321451","ufId":"43","descricao":"Teutônia"},
		{"id":"4321469","ufId":"43","descricao":"Tio Hugo"},
		{"id":"4321477","ufId":"43","descricao":"Tiradentes do Sul"},
		{"id":"4321493","ufId":"43","descricao":"Toropi"},
		{"id":"4321501","ufId":"43","descricao":"Torres"},
		{"id":"4321600","ufId":"43","descricao":"Tramandaí"},
		{"id":"4321626","ufId":"43","descricao":"Travesseiro"},
		{"id":"4321634","ufId":"43","descricao":"Três Arroios"},
		{"id":"4321667","ufId":"43","descricao":"Três Cachoeiras"},
		{"id":"4321709","ufId":"43","descricao":"Três Coroas"},
		{"id":"4321808","ufId":"43","descricao":"Três de Maio"},
		{"id":"4321832","ufId":"43","descricao":"Três Forquilhas"},
		{"id":"4321857","ufId":"43","descricao":"Três Palmeiras"},
		{"id":"4321907","ufId":"43","descricao":"Três Passos"},
		{"id":"4321956","ufId":"43","descricao":"Trindade do Sul"},
		{"id":"4322004","ufId":"43","descricao":"Triunfo"},
		{"id":"4322103","ufId":"43","descricao":"Tucunduva"},
		{"id":"4322152","ufId":"43","descricao":"Tunas"},
		{"id":"4322186","ufId":"43","descricao":"Tupanci do Sul"},
		{"id":"4322202","ufId":"43","descricao":"Tupanciretã"},
		{"id":"4322251","ufId":"43","descricao":"Tupandi"},
		{"id":"4322301","ufId":"43","descricao":"Tuparendi"},
		{"id":"4322327","ufId":"43","descricao":"Turuçu"},
		{"id":"4322343","ufId":"43","descricao":"Ubiretama"},
		{"id":"4322350","ufId":"43","descricao":"União da Serra"},
		{"id":"4322376","ufId":"43","descricao":"Unistalda"},
		{"id":"4322400","ufId":"43","descricao":"Uruguaiana"},
		{"id":"4322509","ufId":"43","descricao":"Vacaria"},
		{"id":"4322533","ufId":"43","descricao":"Vale do Sol"},
		{"id":"4322541","ufId":"43","descricao":"Vale Real"},
		{"id":"4322525","ufId":"43","descricao":"Vale Verde"},
		{"id":"4322558","ufId":"43","descricao":"Vanini"},
		{"id":"4322608","ufId":"43","descricao":"Venâncio Aires"},
		{"id":"4322707","ufId":"43","descricao":"Vera Cruz"},
		{"id":"4322806","ufId":"43","descricao":"Veranópolis"},
		{"id":"4322855","ufId":"43","descricao":"Vespasiano Corrêa"},
		{"id":"4322905","ufId":"43","descricao":"Viadutos"},
		{"id":"4323002","ufId":"43","descricao":"Viamão"},
		{"id":"4323101","ufId":"43","descricao":"Vicente Dutra"},
		{"id":"4323200","ufId":"43","descricao":"Victor Graeff"},
		{"id":"4323309","ufId":"43","descricao":"Vila Flores"},
		{"id":"4323358","ufId":"43","descricao":"Vila Lângaro"},
		{"id":"4323408","ufId":"43","descricao":"Vila Maria"},
		{"id":"4323457","ufId":"43","descricao":"Vila Nova do Sul"},
		{"id":"4323507","ufId":"43","descricao":"Vista Alegre"},
		{"id":"4323606","ufId":"43","descricao":"Vista Alegre do Prata"},
		{"id":"4323705","ufId":"43","descricao":"Vista Gaúcha"},
		{"id":"4323754","ufId":"43","descricao":"Vitória das Missões"},
		{"id":"4323770","ufId":"43","descricao":"Westfália"},
		{"id":"4323804","ufId":"43","descricao":"Xangri-lá"}
	],
	"50": [
		{"id":"5000203","ufId":"50","descricao":"Água Clara"},
		{"id":"5000252","ufId":"50","descricao":"Alcinópolis"},
		{"id":"5000609","ufId":"50","descricao":"Amambai"},
		{"id":"5000708","ufId":"50","descricao":"Anastácio"},
		{"id":"5000807","ufId":"50","descricao":"Anaurilândia"},
		{"id":"5000856","ufId":"50","descricao":"Angélica"},
		{"id":"5000906","ufId":"50","descricao":"Antônio João"},
		{"id":"5001003","ufId":"50","descricao":"Aparecida do Taboado"},
		{"id":"5001102","ufId":"50","descricao":"Aquidauana"},
		{"id":"5001243","ufId":"50","descricao":"Aral Moreira"},
		{"id":"5001508","ufId":"50","descricao":"Bandeirantes"},
		{"id":"5001904","ufId":"50","descricao":"Bataguassu"},
		{"id":"5002001","ufId":"50","descricao":"Batayporã"},
		{"id":"5002100","ufId":"50","descricao":"Bela Vista"},
		{"id":"5002159","ufId":"50","descricao":"Bodoquena"},
		{"id":"5002209","ufId":"50","descricao":"Bonito"},
		{"id":"5002308","ufId":"50","descricao":"Brasilândia"},
		{"id":"5002407","ufId":"50","descricao":"Caarapó"},
		{"id":"5002605","ufId":"50","descricao":"Camapuã"},
		{"id":"5002704","ufId":"50","descricao":"Campo Grande"},
		{"id":"5002803","ufId":"50","descricao":"Caracol"},
		{"id":"5002902","ufId":"50","descricao":"Cassilândia"},
		{"id":"5002951","ufId":"50","descricao":"Chapadão do Sul"},
		{"id":"5003108","ufId":"50","descricao":"Corguinho"},
		{"id":"5003157","ufId":"50","descricao":"Coronel Sapucaia"},
		{"id":"5003207","ufId":"50","descricao":"Corumbá"},
		{"id":"5003256","ufId":"50","descricao":"Costa Rica"},
		{"id":"5003306","ufId":"50","descricao":"Coxim"},
		{"id":"5003454","ufId":"50","descricao":"Deodápolis"},
		{"id":"5003488","ufId":"50","descricao":"Dois Irmãos do Buriti"},
		{"id":"5003504","ufId":"50","descricao":"Douradina"},
		{"id":"5003702","ufId":"50","descricao":"Dourados"},
		{"id":"5003751","ufId":"50","descricao":"Eldorado"},
		{"id":"5003801","ufId":"50","descricao":"Fátima do Sul"},
		{"id":"5003900","ufId":"50","descricao":"Figueirão"},
		{"id":"5004007","ufId":"50","descricao":"Glória de Dourados"},
		{"id":"5004106","ufId":"50","descricao":"Guia Lopes da Laguna"},
		{"id":"5004304","ufId":"50","descricao":"Iguatemi"},
		{"id":"5004403","ufId":"50","descricao":"Inocência"},
		{"id":"5004502","ufId":"50","descricao":"Itaporã"},
		{"id":"5004601","ufId":"50","descricao":"Itaquiraí"},
		{"id":"5004700","ufId":"50","descricao":"Ivinhema"},
		{"id":"5004809","ufId":"50","descricao":"Japorã"},
		{"id":"5004908","ufId":"50","descricao":"Jaraguari"},
		{"id":"5005004","ufId":"50","descricao":"Jardim"},
		{"id":"5005103","ufId":"50","descricao":"Jateí"},
		{"id":"5005152","ufId":"50","descricao":"Juti"},
		{"id":"5005202","ufId":"50","descricao":"Ladário"},
		{"id":"5005251","ufId":"50","descricao":"Laguna Carapã"},
		{"id":"5005400","ufId":"50","descricao":"Maracaju"},
		{"id":"5005608","ufId":"50","descricao":"Miranda"},
		{"id":"5005681","ufId":"50","descricao":"Mundo Novo"},
		{"id":"5005707","ufId":"50","descricao":"Naviraí"},
		{"id":"5005806","ufId":"50","descricao":"Nioaque"},
		{"id":"5006002","ufId":"50","descricao":"Nova Alvorada do Sul"},
		{"id":"5006200","ufId":"50","descricao":"Nova Andradina"},
		{"id":"5006259","ufId":"50","descricao":"Novo Horizonte do Sul"},
		{"id":"5006275","ufId":"50","descricao":"Paraíso das Águas"},
		{"id":"5006309","ufId":"50","descricao":"Paranaíba"},
		{"id":"5006358","ufId":"50","descricao":"Paranhos"},
		{"id":"5006408","ufId":"50","descricao":"Pedro Gomes"},
		{"id":"5006606","ufId":"50","descricao":"Ponta Porã"},
		{"id":"5006903","ufId":"50","descricao":"Porto Murtinho"},
		{"id":"5007109","ufId":"50","descricao":"Ribas do Rio Pardo"},
		{"id":"5007208","ufId":"50","descricao":"Rio Brilhante"},
		{"id":"5007307","ufId":"50","descricao":"Rio Negro"},
		{"id":"5007406","ufId":"50","descricao":"Rio Verde de Mato Grosso"},
		{"id":"5007505","ufId":"50","descricao":"Rochedo"},
		{"id":"5007554","ufId":"50","descricao":"Santa Rita do Pardo"},
		{"id":"5007695","ufId":"50","descricao":"São Gabriel do Oeste"},
		{"id":"5007802","ufId":"50","descricao":"Selvíria"},
		{"id":"5007703","ufId":"50","descricao":"Sete Quedas"},
		{"id":"5007901","ufId":"50","descricao":"Sidrolândia"},
		{"id":"5007935","ufId":"50","descricao":"Sonora"},
		{"id":"5007950","ufId":"50","descricao":"Tacuru"},
		{"id":"5007976","ufId":"50","descricao":"Taquarussu"},
		{"id":"5008008","ufId":"50","descricao":"Terenos"},
		{"id":"5008305","ufId":"50","descricao":"Três Lagoas"},
		{"id":"5008404","ufId":"50","descricao":"Vicentina"}
	],
	"51": [
		{"id":"5100102","ufId":"51","descricao":"Acorizal"},
		{"id":"5100201","ufId":"51","descricao":"Água Boa"},
		{"id":"5100250","ufId":"51","descricao":"Alta Floresta"},
		{"id":"5100300","ufId":"51","descricao":"Alto Araguaia"},
		{"id":"5100359","ufId":"51","descricao":"Alto Boa Vista"},
		{"id":"5100409","ufId":"51","descricao":"Alto Garças"},
		{"id":"5100508","ufId":"51","descricao":"Alto Paraguai"},
		{"id":"5100607","ufId":"51","descricao":"Alto Taquari"},
		{"id":"5100805","ufId":"51","descricao":"Apiacás"},
		{"id":"5101001","ufId":"51","descricao":"Araguaiana"},
		{"id":"5101209","ufId":"51","descricao":"Araguainha"},
		{"id":"5101258","ufId":"51","descricao":"Araputanga"},
		{"id":"5101308","ufId":"51","descricao":"Arenápolis"},
		{"id":"5101407","ufId":"51","descricao":"Aripuanã"},
		{"id":"5101605","ufId":"51","descricao":"Barão de Melgaço"},
		{"id":"5101704","ufId":"51","descricao":"Barra do Bugres"},
		{"id":"5101803","ufId":"51","descricao":"Barra do Garças"},
		{"id":"5101837","ufId":"51","descricao":"Boa Esperança do Norte"},
		{"id":"5101852","ufId":"51","descricao":"Bom Jesus do Araguaia"},
		{"id":"5101902","ufId":"51","descricao":"Brasnorte"},
		{"id":"5102504","ufId":"51","descricao":"Cáceres"},
		{"id":"5102603","ufId":"51","descricao":"Campinápolis"},
		{"id":"5102637","ufId":"51","descricao":"Campo Novo do Parecis"},
		{"id":"5102678","ufId":"51","descricao":"Campo Verde"},
		{"id":"5102686","ufId":"51","descricao":"Campos de Júlio"},
		{"id":"5102694","ufId":"51","descricao":"Canabrava do Norte"},
		{"id":"5102702","ufId":"51","descricao":"Canarana"},
		{"id":"5102793","ufId":"51","descricao":"Carlinda"},
		{"id":"5102850","ufId":"51","descricao":"Castanheira"},
		{"id":"5103007","ufId":"51","descricao":"Chapada dos Guimarães"},
		{"id":"5103056","ufId":"51","descricao":"Cláudia"},
		{"id":"5103106","ufId":"51","descricao":"Cocalinho"},
		{"id":"5103205","ufId":"51","descricao":"Colíder"},
		{"id":"5103254","ufId":"51","descricao":"Colniza"},
		{"id":"5103304","ufId":"51","descricao":"Comodoro"},
		{"id":"5103353","ufId":"51","descricao":"Confresa"},
		{"id":"5103361","ufId":"51","descricao":"Conquista D'Oeste"},
		{"id":"5103379","ufId":"51","descricao":"Cotriguaçu"},
		{"id":"5103403","ufId":"51","descricao":"Cuiabá"},
		{"id":"5103437","ufId":"51","descricao":"Curvelândia"},
		{"id":"5103452","ufId":"51","descricao":"Denise"},
		{"id":"5103502","ufId":"51","descricao":"Diamantino"},
		{"id":"5103601","ufId":"51","descricao":"Dom Aquino"},
		{"id":"5103700","ufId":"51","descricao":"Feliz Natal"},
		{"id":"5103809","ufId":"51","descricao":"Figueirópolis D'Oeste"},
		{"id":"5103858","ufId":"51","descricao":"Gaúcha do Norte"},
		{"id":"5103908","ufId":"51","descricao":"General Carneiro"},
		{"id":"5103957","ufId":"51","descricao":"Glória D'Oeste"},
		{"id":"5104104","ufId":"51","descricao":"Guarantã do Norte"},
		{"id":"5104203","ufId":"51","descricao":"Guiratinga"},
		{"id":"5104500","ufId":"51","descricao":"Indiavaí"},
		{"id":"5104526","ufId":"51","descricao":"Ipiranga do Norte"},
		{"id":"5104542","ufId":"51","descricao":"Itanhangá"},
		{"id":"5104559","ufId":"51","descricao":"Itaúba"},
		{"id":"5104609","ufId":"51","descricao":"Itiquira"},
		{"id":"5104807","ufId":"51","descricao":"Jaciara"},
		{"id":"5104906","ufId":"51","descricao":"Jangada"},
		{"id":"5105002","ufId":"51","descricao":"Jauru"},
		{"id":"5105101","ufId":"51","descricao":"Juara"},
		{"id":"5105150","ufId":"51","descricao":"Juína"},
		{"id":"5105176","ufId":"51","descricao":"Juruena"},
		{"id":"5105200","ufId":"51","descricao":"Juscimeira"},
		{"id":"5105234","ufId":"51","descricao":"Lambari D'Oeste"},
		{"id":"5105259","ufId":"51","descricao":"Lucas do Rio Verde"},
		{"id":"5105309","ufId":"51","descricao":"Luciara"},
		{"id":"5105580","ufId":"51","descricao":"Marcelândia"},
		{"id":"5105606","ufId":"51","descricao":"Matupá"},
		{"id":"5105622","ufId":"51","descricao":"Mirassol d'Oeste"},
		{"id":"5105903","ufId":"51","descricao":"Nobres"},
		{"id":"5106000","ufId":"51","descricao":"Nortelândia"},
		{"id":"5106109","ufId":"51","descricao":"Nossa Senhora do Livramento"},
		{"id":"5106158","ufId":"51","descricao":"Nova Bandeirantes"},
		{"id":"5106208","ufId":"51","descricao":"Nova Brasilândia"},
		{"id":"5106216","ufId":"51","descricao":"Nova Canaã do Norte"},
		{"id":"5108808","ufId":"51","descricao":"Nova Guarita"},
		{"id":"5106182","ufId":"51","descricao":"Nova Lacerda"},
		{"id":"5108857","ufId":"51","descricao":"Nova Marilândia"},
		{"id":"5108907","ufId":"51","descricao":"Nova Maringá"},
		{"id":"5108956","ufId":"51","descricao":"Nova Monte Verde"},
		{"id":"5106224","ufId":"51","descricao":"Nova Mutum"},
		{"id":"5106174","ufId":"51","descricao":"Nova Nazaré"},
		{"id":"5106232","ufId":"51","descricao":"Nova Olímpia"},
		{"id":"5106190","ufId":"51","descricao":"Nova Santa Helena"},
		{"id":"5106240","ufId":"51","descricao":"Nova Ubiratã"},
		{"id":"5106257","ufId":"51","descricao":"Nova Xavantina"},
		{"id":"5106273","ufId":"51","descricao":"Novo Horizonte do Norte"},
		{"id":"5106265","ufId":"51","descricao":"Novo Mundo"},
		{"id":"5106315","ufId":"51","descricao":"Novo Santo Antônio"},
		{"id":"5106281","ufId":"51","descricao":"Novo São Joaquim"},
		{"id":"5106299","ufId":"51","descricao":"Paranaíta"},
		{"id":"5106307","ufId":"51","descricao":"Paranatinga"},
		{"id":"5106372","ufId":"51","descricao":"Pedra Preta"},
		{"id":"5106422","ufId":"51","descricao":"Peixoto de Azevedo"},
		{"id":"5106455","ufId":"51","descricao":"Planalto da Serra"},
		{"id":"5106505","ufId":"51","descricao":"Poconé"},
		{"id":"5106653","ufId":"51","descricao":"Pontal do Araguaia"},
		{"id":"5106703","ufId":"51","descricao":"Ponte Branca"},
		{"id":"5106752","ufId":"51","descricao":"Pontes e Lacerda"},
		{"id":"5106778","ufId":"51","descricao":"Porto Alegre do Norte"},
		{"id":"5106802","ufId":"51","descricao":"Porto dos Gaúchos"},
		{"id":"5106828","ufId":"51","descricao":"Porto Esperidião"},
		{"id":"5106851","ufId":"51","descricao":"Porto Estrela"},
		{"id":"5107008","ufId":"51","descricao":"Poxoréu"},
		{"id":"5107040","ufId":"51","descricao":"Primavera do Leste"},
		{"id":"5107065","ufId":"51","descricao":"Querência"},
		{"id":"5107156","ufId":"51","descricao":"Reserva do Cabaçal"},
		{"id":"5107180","ufId":"51","descricao":"Ribeirão Cascalheira"},
		{"id":"5107198","ufId":"51","descricao":"Ribeirãozinho"},
		{"id":"5107206","ufId":"51","descricao":"Rio Branco"},
		{"id":"5107578","ufId":"51","descricao":"Rondolândia"},
		{"id":"5107602","ufId":"51","descricao":"Rondonópolis"},
		{"id":"5107701","ufId":"51","descricao":"Rosário Oeste"},
		{"id":"5107750","ufId":"51","descricao":"Salto do Céu"},
		{"id":"5107248","ufId":"51","descricao":"Santa Carmem"},
		{"id":"5107743","ufId":"51","descricao":"Santa Cruz do Xingu"},
		{"id":"5107768","ufId":"51","descricao":"Santa Rita do Trivelato"},
		{"id":"5107776","ufId":"51","descricao":"Santa Terezinha"},
		{"id":"5107263","ufId":"51","descricao":"Santo Afonso"},
		{"id":"5107800","ufId":"51","descricao":"Santo Antônio de Leverger"},
		{"id":"5107792","ufId":"51","descricao":"Santo Antônio do Leste"},
		{"id":"5107859","ufId":"51","descricao":"São Félix do Araguaia"},
		{"id":"5107297","ufId":"51","descricao":"São José do Povo"},
		{"id":"5107305","ufId":"51","descricao":"São José do Rio Claro"},
		{"id":"5107354","ufId":"51","descricao":"São José do Xingu"},
		{"id":"5107107","ufId":"51","descricao":"São José dos Quatro Marcos"},
		{"id":"5107404","ufId":"51","descricao":"São Pedro da Cipa"},
		{"id":"5107875","ufId":"51","descricao":"Sapezal"},
		{"id":"5107883","ufId":"51","descricao":"Serra Nova Dourada"},
		{"id":"5107909","ufId":"51","descricao":"Sinop"},
		{"id":"5107925","ufId":"51","descricao":"Sorriso"},
		{"id":"5107941","ufId":"51","descricao":"Tabaporã"},
		{"id":"5107958","ufId":"51","descricao":"Tangará da Serra"},
		{"id":"5108006","ufId":"51","descricao":"Tapurah"},
		{"id":"5108055","ufId":"51","descricao":"Terra Nova do Norte"},
		{"id":"5108105","ufId":"51","descricao":"Tesouro"},
		{"id":"5108204","ufId":"51","descricao":"Torixoréu"},
		{"id":"5108303","ufId":"51","descricao":"União do Sul"},
		{"id":"5108352","ufId":"51","descricao":"Vale de São Domingos"},
		{"id":"5108402","ufId":"51","descricao":"Várzea Grande"},
		{"id":"5108501","ufId":"51","descricao":"Vera"},
		{"id":"5105507","ufId":"51","descricao":"Vila Bela da Santíssima Trindade"},
		{"id":"5108600","ufId":"51","descricao":"Vila Rica"}
	],
	"52": [
		{"id":"5200050","ufId":"52","descricao":"Abadia de Goiás"},
		{"id":"5200100","ufId":"52","descricao":"Abadiânia"},
		{"id":"5200134","ufId":"52","descricao":"Acreúna"},
		{"id":"5200159","ufId":"52","descricao":"Adelândia"},
		{"id":"5200175","ufId":"52","descricao":"Água Fria de Goiás"},
		{"id":"5200209","ufId":"52","descricao":"Água Limpa"},
		{"id":"5200258","ufId":"52","descricao":"Águas Lindas de Goiás"},
		{"id":"5200308","ufId":"52","descricao":"Alexânia"},
		{"id":"5200506","ufId":"52","descricao":"Aloândia"},
		{"id":"5200555","ufId":"52","descricao":"Alto Horizonte"},
		{"id":"5200605","ufId":"52","descricao":"Alto Paraíso de Goiás"},
		{"id":"5200803","ufId":"52","descricao":"Alvorada do Norte"},
		{"id":"5200829","ufId":"52","descricao":"Amaralina"},
		{"id":"5200852","ufId":"52","descricao":"Americano do Brasil"},
		{"id":"5200902","ufId":"52","descricao":"Amorinópolis"},
		{"id":"5201108","ufId":"52","descricao":"Anápolis"},
		{"id":"5201207","ufId":"52","descricao":"Anhanguera"},
		{"id":"5201306","ufId":"52","descricao":"Anicuns"},
		{"id":"5201405","ufId":"52","descricao":"Aparecida de Goiânia"},
		{"id":"5201454","ufId":"52","descricao":"Aparecida do Rio Doce"},
		{"id":"5201504","ufId":"52","descricao":"Aporé"},
		{"id":"5201603","ufId":"52","descricao":"Araçu"},
		{"id":"5201702","ufId":"52","descricao":"Aragarças"},
		{"id":"5201801","ufId":"52","descricao":"Aragoiânia"},
		{"id":"5202155","ufId":"52","descricao":"Araguapaz"},
		{"id":"5202353","ufId":"52","descricao":"Arenópolis"},
		{"id":"5202502","ufId":"52","descricao":"Aruanã"},
		{"id":"5202601","ufId":"52","descricao":"Aurilândia"},
		{"id":"5202809","ufId":"52","descricao":"Avelinópolis"},
		{"id":"5203104","ufId":"52","descricao":"Baliza"},
		{"id":"5203203","ufId":"52","descricao":"Barro Alto"},
		{"id":"5203302","ufId":"52","descricao":"Bela Vista de Goiás"},
		{"id":"5203401","ufId":"52","descricao":"Bom Jardim de Goiás"},
		{"id":"5203500","ufId":"52","descricao":"Bom Jesus de Goiás"},
		{"id":"5203559","ufId":"52","descricao":"Bonfinópolis"},
		{"id":"5203575","ufId":"52","descricao":"Bonópolis"},
		{"id":"5203609","ufId":"52","descricao":"Brazabrantes"},
		{"id":"5203807","ufId":"52","descricao":"Britânia"},
		{"id":"5203906","ufId":"52","descricao":"Buriti Alegre"},
		{"id":"5203939","ufId":"52","descricao":"Buriti de Goiás"},
		{"id":"5203962","ufId":"52","descricao":"Buritinópolis"},
		{"id":"5204003","ufId":"52","descricao":"Cabeceiras"},
		{"id":"5204102","ufId":"52","descricao":"Cachoeira Alta"},
		{"id":"5204201","ufId":"52","descricao":"Cachoeira de Goiás"},
		{"id":"5204250","ufId":"52","descricao":"Cachoeira Dourada"},
		{"id":"5204300","ufId":"52","descricao":"Caçu"},
		{"id":"5204409","ufId":"52","descricao":"Caiapônia"},
		{"id":"5204508","ufId":"52","descricao":"Caldas Novas"},
		{"id":"5204557","ufId":"52","descricao":"Caldazinha"},
		{"id":"5204607","ufId":"52","descricao":"Campestre de Goiás"},
		{"id":"5204656","ufId":"52","descricao":"Campinaçu"},
		{"id":"5204706","ufId":"52","descricao":"Campinorte"},
		{"id":"5204805","ufId":"52","descricao":"Campo Alegre de Goiás"},
		{"id":"5204854","ufId":"52","descricao":"Campo Limpo de Goiás"},
		{"id":"5204904","ufId":"52","descricao":"Campos Belos"},
		{"id":"5204953","ufId":"52","descricao":"Campos Verdes"},
		{"id":"5205000","ufId":"52","descricao":"Carmo do Rio Verde"},
		{"id":"5205059","ufId":"52","descricao":"Castelândia"},
		{"id":"5205109","ufId":"52","descricao":"Catalão"},
		{"id":"5205208","ufId":"52","descricao":"Caturaí"},
		{"id":"5205307","ufId":"52","descricao":"Cavalcante"},
		{"id":"5205406","ufId":"52","descricao":"Ceres"},
		{"id":"5205455","ufId":"52","descricao":"Cezarina"},
		{"id":"5205471","ufId":"52","descricao":"Chapadão do Céu"},
		{"id":"5205497","ufId":"52","descricao":"Cidade Ocidental"},
		{"id":"5205513","ufId":"52","descricao":"Cocalzinho de Goiás"},
		{"id":"5205521","ufId":"52","descricao":"Colinas do Sul"},
		{"id":"5205703","ufId":"52","descricao":"Córrego do Ouro"},
		{"id":"5205802","ufId":"52","descricao":"Corumbá de Goiás"},
		{"id":"5205901","ufId":"52","descricao":"Corumbaíba"},
		{"id":"5206206","ufId":"52","descricao":"Cristalina"},
		{"id":"5206305","ufId":"52","descricao":"Cristianópolis"},
		{"id":"5206404","ufId":"52","descricao":"Crixás"},
		{"id":"5206503","ufId":"52","descricao":"Cromínia"},
		{"id":"5206602","ufId":"52","descricao":"Cumari"},
		{"id":"5206701","ufId":"52","descricao":"Damianópolis"},
		{"id":"5206800","ufId":"52","descricao":"Damolândia"},
		{"id":"5206909","ufId":"52","descricao":"Davinópolis"},
		{"id":"5207105","ufId":"52","descricao":"Diorama"},
		{"id":"5208301","ufId":"52","descricao":"Divinópolis de Goiás"},
		{"id":"5207253","ufId":"52","descricao":"Doverlândia"},
		{"id":"5207352","ufId":"52","descricao":"Edealina"},
		{"id":"5207402","ufId":"52","descricao":"Edéia"},
		{"id":"5207501","ufId":"52","descricao":"Estrela do Norte"},
		{"id":"5207535","ufId":"52","descricao":"Faina"},
		{"id":"5207600","ufId":"52","descricao":"Fazenda Nova"},
		{"id":"5207808","ufId":"52","descricao":"Firminópolis"},
		{"id":"5207907","ufId":"52","descricao":"Flores de Goiás"},
		{"id":"5208004","ufId":"52","descricao":"Formosa"},
		{"id":"5208103","ufId":"52","descricao":"Formoso"},
		{"id":"5208152","ufId":"52","descricao":"Gameleira de Goiás"},
		{"id":"5208400","ufId":"52","descricao":"Goianápolis"},
		{"id":"5208509","ufId":"52","descricao":"Goiandira"},
		{"id":"5208608","ufId":"52","descricao":"Goianésia"},
		{"id":"5208707","ufId":"52","descricao":"Goiânia"},
		{"id":"5208806","ufId":"52","descricao":"Goianira"},
		{"id":"5208905","ufId":"52","descricao":"Goiás"},
		{"id":"5209101","ufId":"52","descricao":"Goiatuba"},
		{"id":"5209150","ufId":"52","descricao":"Gouvelândia"},
		{"id":"5209200","ufId":"52","descricao":"Guapó"},
		{"id":"5209291","ufId":"52","descricao":"Guaraíta"},
		{"id":"5209408","ufId":"52","descricao":"Guarani de Goiás"},
		{"id":"5209457","ufId":"52","descricao":"Guarinos"},
		{"id":"5209606","ufId":"52","descricao":"Heitoraí"},
		{"id":"5209705","ufId":"52","descricao":"Hidrolândia"},
		{"id":"5209804","ufId":"52","descricao":"Hidrolina"},
		{"id":"5209903","ufId":"52","descricao":"Iaciara"},
		{"id":"5209937","ufId":"52","descricao":"Inaciolândia"},
		{"id":"5209952","ufId":"52","descricao":"Indiara"},
		{"id":"5210000","ufId":"52","descricao":"Inhumas"},
		{"id":"5210109","ufId":"52","descricao":"Ipameri"},
		{"id":"5210158","ufId":"52","descricao":"Ipiranga de Goiás"},
		{"id":"5210208","ufId":"52","descricao":"Iporá"},
		{"id":"5210307","ufId":"52","descricao":"Israelândia"},
		{"id":"5210406","ufId":"52","descricao":"Itaberaí"},
		{"id":"5210562","ufId":"52","descricao":"Itaguari"},
		{"id":"5210604","ufId":"52","descricao":"Itaguaru"},
		{"id":"5210802","ufId":"52","descricao":"Itajá"},
		{"id":"5210901","ufId":"52","descricao":"Itapaci"},
		{"id":"5211008","ufId":"52","descricao":"Itapirapuã"},
		{"id":"5211206","ufId":"52","descricao":"Itapuranga"},
		{"id":"5211305","ufId":"52","descricao":"Itarumã"},
		{"id":"5211404","ufId":"52","descricao":"Itauçu"},
		{"id":"5211503","ufId":"52","descricao":"Itumbiara"},
		{"id":"5211602","ufId":"52","descricao":"Ivolândia"},
		{"id":"5211701","ufId":"52","descricao":"Jandaia"},
		{"id":"5211800","ufId":"52","descricao":"Jaraguá"},
		{"id":"5211909","ufId":"52","descricao":"Jataí"},
		{"id":"5212006","ufId":"52","descricao":"Jaupaci"},
		{"id":"5212055","ufId":"52","descricao":"Jesúpolis"},
		{"id":"5212105","ufId":"52","descricao":"Joviânia"},
		{"id":"5212204","ufId":"52","descricao":"Jussara"},
		{"id":"5212253","ufId":"52","descricao":"Lagoa Santa"},
		{"id":"5212303","ufId":"52","descricao":"Leopoldo de Bulhões"},
		{"id":"5212501","ufId":"52","descricao":"Luziânia"},
		{"id":"5212600","ufId":"52","descricao":"Mairipotaba"},
		{"id":"5212709","ufId":"52","descricao":"Mambaí"},
		{"id":"5212808","ufId":"52","descricao":"Mara Rosa"},
		{"id":"5212907","ufId":"52","descricao":"Marzagão"},
		{"id":"5212956","ufId":"52","descricao":"Matrinchã"},
		{"id":"5213004","ufId":"52","descricao":"Maurilândia"},
		{"id":"5213053","ufId":"52","descricao":"Mimoso de Goiás"},
		{"id":"5213087","ufId":"52","descricao":"Minaçu"},
		{"id":"5213103","ufId":"52","descricao":"Mineiros"},
		{"id":"5213400","ufId":"52","descricao":"Moiporá"},
		{"id":"5213509","ufId":"52","descricao":"Monte Alegre de Goiás"},
		{"id":"5213707","ufId":"52","descricao":"Montes Claros de Goiás"},
		{"id":"5213756","ufId":"52","descricao":"Montividiu"},
		{"id":"5213772","ufId":"52","descricao":"Montividiu do Norte"},
		{"id":"5213806","ufId":"52","descricao":"Morrinhos"},
		{"id":"5213855","ufId":"52","descricao":"Morro Agudo de Goiás"},
		{"id":"5213905","ufId":"52","descricao":"Mossâmedes"},
		{"id":"5214002","ufId":"52","descricao":"Mozarlândia"},
		{"id":"5214051","ufId":"52","descricao":"Mundo Novo"},
		{"id":"5214101","ufId":"52","descricao":"Mutunópolis"},
		{"id":"5214408","ufId":"52","descricao":"Nazário"},
		{"id":"5214507","ufId":"52","descricao":"Nerópolis"},
		{"id":"5214606","ufId":"52","descricao":"Niquelândia"},
		{"id":"5214705","ufId":"52","descricao":"Nova América"},
		{"id":"5214804","ufId":"52","descricao":"Nova Aurora"},
		{"id":"5214838","ufId":"52","descricao":"Nova Crixás"},
		{"id":"5214861","ufId":"52","descricao":"Nova Glória"},
		{"id":"5214879","ufId":"52","descricao":"Nova Iguaçu de Goiás"},
		{"id":"5214903","ufId":"52","descricao":"Nova Roma"},
		{"id":"5215009","ufId":"52","descricao":"Nova Veneza"},
		{"id":"5215207","ufId":"52","descricao":"Novo Brasil"},
		{"id":"5215231","ufId":"52","descricao":"Novo Gama"},
		{"id":"5215256","ufId":"52","descricao":"Novo Planalto"},
		{"id":"5215306","ufId":"52","descricao":"Orizona"},
		{"id":"5215405","ufId":"52","descricao":"Ouro Verde de Goiás"},
		{"id":"5215504","ufId":"52","descricao":"Ouvidor"},
		{"id":"5215603","ufId":"52","descricao":"Padre Bernardo"},
		{"id":"5215652","ufId":"52","descricao":"Palestina de Goiás"},
		{"id":"5215702","ufId":"52","descricao":"Palmeiras de Goiás"},
		{"id":"5215801","ufId":"52","descricao":"Palmelo"},
		{"id":"5215900","ufId":"52","descricao":"Palminópolis"},
		{"id":"5216007","ufId":"52","descricao":"Panamá"},
		{"id":"5216304","ufId":"52","descricao":"Paranaiguara"},
		{"id":"5216403","ufId":"52","descricao":"Paraúna"},
		{"id":"5216452","ufId":"52","descricao":"Perolândia"},
		{"id":"5216809","ufId":"52","descricao":"Petrolina de Goiás"},
		{"id":"5216908","ufId":"52","descricao":"Pilar de Goiás"},
		{"id":"5217104","ufId":"52","descricao":"Piracanjuba"},
		{"id":"5217203","ufId":"52","descricao":"Piranhas"},
		{"id":"5217302","ufId":"52","descricao":"Pirenópolis"},
		{"id":"5217401","ufId":"52","descricao":"Pires do Rio"},
		{"id":"5217609","ufId":"52","descricao":"Planaltina"},
		{"id":"5217708","ufId":"52","descricao":"Pontalina"},
		{"id":"5218003","ufId":"52","descricao":"Porangatu"},
		{"id":"5218052","ufId":"52","descricao":"Porteirão"},
		{"id":"5218102","ufId":"52","descricao":"Portelândia"},
		{"id":"5218300","ufId":"52","descricao":"Posse"},
		{"id":"5218391","ufId":"52","descricao":"Professor Jamil"},
		{"id":"5218508","ufId":"52","descricao":"Quirinópolis"},
		{"id":"5218607","ufId":"52","descricao":"Rialma"},
		{"id":"5218706","ufId":"52","descricao":"Rianápolis"},
		{"id":"5218789","ufId":"52","descricao":"Rio Quente"},
		{"id":"5218805","ufId":"52","descricao":"Rio Verde"},
		{"id":"5218904","ufId":"52","descricao":"Rubiataba"},
		{"id":"5219001","ufId":"52","descricao":"Sanclerlândia"},
		{"id":"5219100","ufId":"52","descricao":"Santa Bárbara de Goiás"},
		{"id":"5219209","ufId":"52","descricao":"Santa Cruz de Goiás"},
		{"id":"5219258","ufId":"52","descricao":"Santa Fé de Goiás"},
		{"id":"5219308","ufId":"52","descricao":"Santa Helena de Goiás"},
		{"id":"5219357","ufId":"52","descricao":"Santa Isabel"},
		{"id":"5219407","ufId":"52","descricao":"Santa Rita do Araguaia"},
		{"id":"5219456","ufId":"52","descricao":"Santa Rita do Novo Destino"},
		{"id":"5219506","ufId":"52","descricao":"Santa Rosa de Goiás"},
		{"id":"5219605","ufId":"52","descricao":"Santa Tereza de Goiás"},
		{"id":"5219704","ufId":"52","descricao":"Santa Terezinha de Goiás"},
		{"id":"5219712","ufId":"52","descricao":"Santo Antônio da Barra"},
		{"id":"5219738","ufId":"52","descricao":"Santo Antônio de Goiás"},
		{"id":"5219753","ufId":"52","descricao":"Santo Antônio do Descoberto"},
		{"id":"5219803","ufId":"52","descricao":"São Domingos"},
		{"id":"5219902","ufId":"52","descricao":"São Francisco de Goiás"},
		{"id":"5220009","ufId":"52","descricao":"São João d'Aliança"},
		{"id":"5220058","ufId":"52","descricao":"São João da Paraúna"},
		{"id":"5220108","ufId":"52","descricao":"São Luís de Montes Belos"},
		{"id":"5220157","ufId":"52","descricao":"São Luiz do Norte"},
		{"id":"5220207","ufId":"52","descricao":"São Miguel do Araguaia"},
		{"id":"5220264","ufId":"52","descricao":"São Miguel do Passa Quatro"},
		{"id":"5220280","ufId":"52","descricao":"São Patrício"},
		{"id":"5220405","ufId":"52","descricao":"São Simão"},
		{"id":"5220454","ufId":"52","descricao":"Senador Canedo"},
		{"id":"5220504","ufId":"52","descricao":"Serranópolis"},
		{"id":"5220603","ufId":"52","descricao":"Silvânia"},
		{"id":"5220686","ufId":"52","descricao":"Simolândia"},
		{"id":"5220702","ufId":"52","descricao":"Sítio d'Abadia"},
		{"id":"5221007","ufId":"52","descricao":"Taquaral de Goiás"},
		{"id":"5221080","ufId":"52","descricao":"Teresina de Goiás"},
		{"id":"5221197","ufId":"52","descricao":"Terezópolis de Goiás"},
		{"id":"5221304","ufId":"52","descricao":"Três Ranchos"},
		{"id":"5221403","ufId":"52","descricao":"Trindade"},
		{"id":"5221452","ufId":"52","descricao":"Trombas"},
		{"id":"5221502","ufId":"52","descricao":"Turvânia"},
		{"id":"5221551","ufId":"52","descricao":"Turvelândia"},
		{"id":"5221577","ufId":"52","descricao":"Uirapuru"},
		{"id":"5221601","ufId":"52","descricao":"Uruaçu"},
		{"id":"5221700","ufId":"52","descricao":"Uruana"},
		{"id":"5221809","ufId":"52","descricao":"Urutaí"},
		{"id":"5221858","ufId":"52","descricao":"Valparaíso de Goiás"},
		{"id":"5221908","ufId":"52","descricao":"Varjão"},
		{"id":"5222005","ufId":"52","descricao":"Vianópolis"},
		{"id":"5222054","ufId":"52","descricao":"Vicentinópolis"},
		{"id":"5222203","ufId":"52","descricao":"Vila Boa"},
		{"id":"5222302","ufId":"52","descricao":"Vila Propício"}
	],
	"53": [
		{"id":"5300108","ufId":"53","descricao":"Brasília"}
	]
};

export const getCidadesByUfId = (ufId: string): CidadeLocal[] => CIDADES_POR_UF[ufId] ?? [];
